// AUTO-GENERATED by gatsby-node.js — do not edit
module.exports = {
  "config": {
    "siteId": "double-glazing-quotes-co-uk",
    "useTemplatePageContent": true,
    "maxQuotes": 4,
    "domain": "https://double-glazing-quotes.co.uk",
    "title": "Double Glazing Quotes",
    "tagline": "Free Quotes from Local Double Glazing Installers",
    "description": "Compare free, no-obligation quotes from local double glazing installers for replacement windows and doors, misted or blown sealed units and broken glass across the UK.",
    "trade": "double glazing",
    "tradeNoun": "double glazing installer",
    "logo": "/sites/double-glazing-quotes-co-uk/double-glazing-quotes-uk-logo.png",
    "ogImage": "/sites/double-glazing-quotes-co-uk/double-glazing-quotes-uk.jpg",
    "footerBlurb": "Helping UK homeowners find independent local installers and glaziers for new windows, doors and sealed unit repairs.",
    "siteIdInLeadsDoWork": "362",
    "siteTokenInLeadsDoWork": "348609719f1b05dba2b3c0ef77fee207",
    "formIdInLeadsDoWork": "35,76,294,375",
    "mainKeyword": "",
    "leadsWidget": {
      "id_site": "362",
      "id_form": "35",
      "sqn": "138424"
    },
    "proWidget": {
      "qwc_id_site": "362",
      "qwc_spn": "2546",
      "qwc_industry": "37"
    },
    "adsense": {
      "enabled": true,
      "clientId": "ca-pub-7344331352247981",
      "slots": {
        "sidebar": "4298666171",
        "inContent": "9359421160"
      }
    },
    "navLinks": [
      {
        "label": "Window Replacement",
        "path": "/double-glazed-window-replacement/"
      },
      {
        "label": "Misted Glazing",
        "path": "/misted-double-glazing-replacement/"
      },
      {
        "label": "uPVC Windows",
        "path": "/upvc-window-replacement/"
      },
      {
        "label": "Doors",
        "path": "/double-glazed-door-replacement/"
      },
      {
        "label": "Guides",
        "path": "/guides/"
      }
    ],
    "calculatorTiers": [
      "Small: one pane, one window or one door",
      "Typical: a few panes, a handful of windows or a front door",
      "Large: a whole-house order or a full set of patio doors"
    ]
  },
  "theme": {
    "navy": "#16212b",
    "blue": "#27465b",
    "teal": "#3589b0",
    "tealLight": "#e7f3f9",
    "accent": "#e5763a",
    "accentDark": "#bf5a22",
    "offWhite": "#f6f9fb",
    "fontDisplay": "Outfit",
    "fontBody": "Source Sans 3",
    "googleFonts": "https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;500;600;700&family=Outfit:wght@600;700;800&display=swap",
    "heroGradient": "linear-gradient(135deg, #16212b 0%, #27465b 55%, #3589b0 100%)"
  },
  "content": {
    "heroHeadlines": [
      "{service} in {town}, {county}",
      "{Compare|Get|Request} {service} Quotes in {town}",
      "{Local|Independent|Insured} Installers for {service} in {town}",
      "{service} Around {town}: {Free|No-Obligation} Quotes",
      "{Price up|Plan|Arrange} {service} in {town} with a Local Glazier"
    ],
    "heroSubheadlines": [
      "{Tell us which windows, doors or panes need attention|Describe the glazing job once} and {compare|weigh up} {up to four|several} {free|no-obligation} quotes from {independent|local} installers {covering|working in} {town} and {the rest of {county}|nearby parts of {county}}.",
      "{From a single foggy pane to a full set of new windows|Whether it's one blown unit or every frame in the house}, {homeowners in {town}|households around {town}} can {line up|request} prices for {service} without ringing round.",
      "{One short enquiry|A single online form} {puts your {service} job in front of|reaches} {window and door installers|local glaziers} who work across {county}. {It costs nothing to enquire|The enquiry is free}, and {you are under no pressure to accept|you decide whether to go ahead}."
    ],
    "introParas": [
      "Windows and doors do more work than most parts of a house: they keep weather out, let daylight in and have to open, close and lock thousands of times over their life. In {town}, {service} {enquiries often start|requests usually begin} with a specific trigger: {a pane that has turned permanently cloudy|a draught that the heating can't keep up with|a handle or hinge that finally gave up}.",
      "Local conditions in {county} ({climate}) {have a real bearing on|affect} how glazing performs. {Cold snaps show up failed seals quickly|Damp, chilly mornings make weak seals obvious}, and exposed elevations take the brunt of wind-driven rain, so {service} in {town} is as much about the fit, seals and drainage as the glass itself.",
      "{Many homes around {town}|Plenty of houses in {town}} still have windows fitted in the 1990s or early 2000s, when double glazing first became standard. {Getting a few quotes for {service}|Comparing prices for {service}} is the simplest way to find out whether a repair will do or whether the frames have reached the end of their useful life."
    ],
    "whyLocalParas": [
      "An installer who {regularly works in|already covers} {town} {will usually know|tends to know} the local housing stock ({which estates have awkward non-standard openings|where bay windows and stone reveals are common|which streets sit in a conservation area}), and that {feeds into|shapes} how accurately a survey and quote can be put together.",
      "{Using|Choosing} a {local|nearby} glazing firm {for {service}|near {town}} {makes follow-up visits easier|keeps return visits practical}: {a hinge adjustment after the first winter|a sticking lock a few months after fitting} is a short trip rather than a special journey, and {an aftercare call-out|a warranty check} is quicker to arrange."
    ],
    "symptomsListItems": [
      "{Condensation or fog trapped between the panes|Cloudy glass that won't wipe clear from either side|A milky film sealed inside the unit}",
      "{Cold draughts around closed frames|A chilly spot next to the window|Air moving past the closed sash}",
      "{Handles that are stiff or spin loose|Locks that no longer engage properly|Hinges that drop so the window catches}",
      "{Cracked, chipped or crazed glass|A crack spreading across a pane|Visible damage to the outer glass}",
      "{Yellowed or brittle uPVC frames|Rotting timber sills and frames|Perished or shrinking rubber seals} on older windows",
      "{A door that sticks, drops or lets in light at the edges|Gaps around the front or back door|A patio door that is hard to slide}"
    ],
    "howItWorksSteps": [
      {
        "title": "{Describe|Outline|Share} the glazing job",
        "body": "{Use|Fill in} the {short|quick} form to {say|explain} whether you need new windows, a new door or just replacement glass, and {give a rough count|say roughly how many openings are involved} for your {town} home."
      },
      {
        "title": "{Hear from|Get contacted by} {local|independent} installers",
        "body": "{Up to four|Several} {glazing firms|window and door installers} that cover {town} may {get in touch|contact you} to {ask about sizes and access|talk through the job} and {arrange a survey|book a measuring visit} before {pricing|quoting for} the {service} work."
      },
      {
        "title": "{Compare|Weigh up|Check} the quotes",
        "body": "{Look at|Check} {the glass specification, frame profile and guarantee|what each price includes, from the glass to the certificate} {side by side|in each quote}. {You don't have to accept any of them|There's no obligation to go ahead}, and {the firm you pick|your chosen installer} agrees the work directly with you."
      }
    ],
    "faqItems": [
      {
        "q": "How much does {service} cost in {town}?",
        "a": "{The price of|Pricing for} {service} in {town} {depends on|varies with} {the number and size of openings, the frame material and the glass specified|how many windows or units are involved and what they're made of}. {As a rough guide|Broadly speaking}, {homeowners|most households} in {county} {can expect to pay|should budget} {avgCost}. {A measured survey|A site visit} {gives|will give} you a {firm|reliable} {price|quote}."
      },
      {
        "q": "How long does {service} take?",
        "a": "{Fitting usually takes|On-site work typically takes} {timeframe} for {service} in {town}. {Most windows, doors and sealed units are made to measure|Glazing products are normally made to order}, so {allow for a gap between the survey and fitting day|expect a wait between measuring and installation} while {the order is manufactured|the units are made}."
      },
      {
        "q": "Do I need a certificate for {service}?",
        "a": "{Complete replacement windows and doors|Whole new frames} in England and Wales {must meet Building Regulations|fall under Building Regulations}, {and a firm registered with a competent person scheme such as FENSA can self-certify the work|so ask whether your installer can self-certify through a scheme such as FENSA}. {Replacing only the glass in an existing frame is generally treated as a repair|Swapping a sealed unit in a sound frame usually doesn't need notifying}, but {check with the installer|confirm this in writing}."
      },
      {
        "q": "Do I need planning permission for {service} in {town}?",
        "a": "{For most houses|In most cases}, {like-for-like replacement windows and doors|replacements of a similar appearance} in {town} {don't need|won't require} planning permission. {Flats, listed buildings and homes in a conservation area|Properties in conservation areas, listed homes and flats} {may need consent first|can have extra restrictions}, so {check with the council before ordering|confirm the position before you sign}."
      }
    ],
    "nearbyTownsIntro": [
      "We also {connect|match} {homeowners|households} with {service} {installers|specialists} in {nearby towns and villages across|other parts of} {county}:",
      "{Looking for|Need|Pricing up} {service} {in a nearby area|elsewhere in {county}}? {Installers in our network|Firms we work with} also {cover|serve}:"
    ],
    "ctaHeadlines": [
      "Get Your Free {service} Quotes",
      "Ready to Sort Out Those Windows?",
      "Compare {service} Prices in {town}"
    ],
    "ctaSubtext": [
      "{Fill in|Complete} our {quick|short} {form|enquiry} and {receive|get} {up to four|several} {free|no-obligation} quotes from {independent|local} {service} {installers|specialists} {covering|serving} {town}.",
      "{No obligation to go ahead|You don't have to accept any quote}. {Just compare proposals|Simply weigh up prices} from {local|insured} {window and door firms|glazing installers} in {county}."
    ],
    "countyIntros": [
      "{county} {homeowners|households} {replace windows and doors|arrange glazing work} for all sorts of reasons, and local conditions ({climate}) {soon expose|quickly show up} {draughty frames and failed seals|tired glazing}. {Whether you're in|Across} {a market town or a rural village|the county's towns and villages}, {finding|getting} {a reliable|an insured} {service} {installer|specialist} {doesn't have to mean ringing round|is simpler with one enquiry}.",
      "Given the local weather ({climate}), {county} {homes|properties} {soon reveal|quickly show} {windows that have lost their seal|glazing that is past its best}. {Our network of|We can introduce you to} {independent|local} {service} {installers|firms} {across the county|throughout {county}}, {so comparing quotes is straightforward|making it easy to compare prices}."
    ]
  },
  "services": [
    {
      "name": "Double Glazed Window Replacement",
      "slug": "double-glazed-window-replacement",
      "shortName": "double glazed window replacement",
      "keyword": "replace",
      "description": "Taking out old single glazing or tired first-generation double glazing and fitting new energy-rated windows in uPVC, aluminium or timber, with the paperwork building control expects.",
      "keywords": [
        "replacement double glazed windows",
        "new double glazing cost",
        "whole house window replacement",
        "A-rated replacement windows"
      ],
      "avgCost": "£550–£12,000",
      "timeframe": "1–4 days",
      "icon": "🪟",
      "id_form": "35",
      "jobProfile": {
        "cost": 5,
        "complexity": 5,
        "duration": 5,
        "dustiness": 4,
        "disturbance": 5
      }
    },
    {
      "name": "Misted Double Glazing Replacement",
      "slug": "misted-double-glazing-replacement",
      "shortName": "misted double glazing replacement",
      "keyword": "mist",
      "description": "Swapping cloudy, foggy panes that have condensation trapped between the glass for new sealed units, keeping the existing frames where they are still sound.",
      "keywords": [
        "misted double glazing repair",
        "condensation between window panes",
        "cloudy double glazing fix",
        "foggy window glass replacement"
      ],
      "avgCost": "£80–£450",
      "timeframe": "1–3 hours",
      "icon": "🌫️",
      "id_form": "76",
      "jobProfile": {
        "cost": 1,
        "complexity": 1,
        "duration": 1,
        "dustiness": 1,
        "disturbance": 1
      }
    },
    {
      "name": "Blown Double Glazed Unit Replacement",
      "slug": "blown-double-glazed-unit-replacement",
      "shortName": "blown unit replacement",
      "keyword": "blown",
      "description": "Measuring, ordering and fitting made-to-size sealed units where the edge seal has failed, including upgrades to warm-edge spacers, low-emissivity coatings and safety glass where required.",
      "keywords": [
        "blown double glazing unit",
        "replacement sealed units",
        "failed double glazing seal",
        "double glazed unit fitted price"
      ],
      "avgCost": "£100–£900",
      "timeframe": "2 hours–1 day",
      "icon": "🔲",
      "id_form": "76",
      "jobProfile": {
        "cost": 2,
        "complexity": 2,
        "duration": 2,
        "dustiness": 1,
        "disturbance": 2
      }
    },
    {
      "name": "Double Glazed Glass Replacement",
      "slug": "double-glazed-glass-replacement",
      "shortName": "double glazed glass replacement",
      "keyword": "glass",
      "description": "Replacing cracked, smashed or chipped double glazing, making openings safe in the meantime and fitting toughened, laminated, obscure or acoustic glass where it suits the location.",
      "keywords": [
        "broken double glazing replacement",
        "cracked window glass repair",
        "emergency glazier",
        "toughened glass replacement"
      ],
      "avgCost": "£120–£750",
      "timeframe": "2 hours–1 day",
      "icon": "🔨",
      "id_form": "76",
      "jobProfile": {
        "cost": 2,
        "complexity": 2,
        "duration": 2,
        "dustiness": 2,
        "disturbance": 3
      }
    },
    {
      "name": "uPVC Window Replacement",
      "slug": "upvc-window-replacement",
      "shortName": "uPVC window replacement",
      "keyword": "upvc",
      "description": "New uPVC casement, tilt-and-turn or sliding sash windows in white, woodgrain foil or coloured finishes, fitted into existing openings with modern locks and trickle vents.",
      "keywords": [
        "uPVC windows fitted",
        "uPVC window prices",
        "replacement uPVC casement windows",
        "uPVC sash windows cost"
      ],
      "avgCost": "£400–£8,000",
      "timeframe": "1–3 days",
      "icon": "🏠",
      "id_form": "35",
      "jobProfile": {
        "cost": 4,
        "complexity": 3,
        "duration": 4,
        "dustiness": 4,
        "disturbance": 4
      }
    },
    {
      "name": "Double Glazed Door Replacement",
      "slug": "double-glazed-door-replacement",
      "shortName": "double glazed door replacement",
      "keyword": "door",
      "description": "Replacing front, back, French or patio doors with double glazed uPVC, composite or aluminium doorsets, including thresholds, multi-point locks and safety glass.",
      "keywords": [
        "replacement uPVC doors",
        "double glazed front door cost",
        "French doors fitted",
        "patio door replacement"
      ],
      "avgCost": "£900–£4,000",
      "timeframe": "4 hours–2 days",
      "icon": "🚪",
      "id_form": "375",
      "jobProfile": {
        "cost": 3,
        "complexity": 3,
        "duration": 3,
        "dustiness": 3,
        "disturbance": 3
      }
    }
  ],
  "locations": [
    {
      "name": "Aberdeen City",
      "slug": "aberdeen-city",
      "region": "Scotland",
      "council_name": "Aberdeen City Council",
      "council_url": "https://www.aberdeencity.gov.uk/",
      "climate": "cool, windy North Sea climate",
      "population": "225,000",
      "towns": [
        {
          "name": "Aberdeen",
          "slug": "aberdeen",
          "postcode": "AB10",
          "nearby_areas": [
            "Cove Bay",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie",
            "Ellon",
            "Westhill"
          ]
        },
        {
          "name": "Dyce",
          "slug": "dyce",
          "postcode": "AB21",
          "nearby_areas": [
            "Bucksburn",
            "Bridge of Don",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        },
        {
          "name": "Cove Bay",
          "slug": "cove-bay",
          "postcode": "AB12",
          "nearby_areas": [
            "Aberdeen",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie",
            "Ellon",
            "Westhill"
          ]
        },
        {
          "name": "Bridge of Don",
          "slug": "bridge-of-don",
          "postcode": "AB23",
          "nearby_areas": [
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        },
        {
          "name": "Bucksburn",
          "slug": "bucksburn",
          "postcode": "AB21",
          "nearby_areas": [
            "Dyce",
            "Bridge of Don",
            "Cove Bay",
            "Aberdeen",
            "Inverurie",
            "Westhill",
            "Ellon"
          ]
        }
      ]
    },
    {
      "name": "Aberdeenshire",
      "slug": "aberdeenshire",
      "region": "Scotland",
      "council_name": "Aberdeenshire Council",
      "council_url": "https://www.aberdeenshire.gov.uk/",
      "climate": "cool, exposed and often windy",
      "population": "265,000",
      "towns": [
        {
          "name": "Peterhead",
          "slug": "peterhead",
          "postcode": "AB42",
          "nearby_areas": [
            "Banff",
            "Ellon",
            "Fraserburgh",
            "Turriff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn"
          ]
        },
        {
          "name": "Fraserburgh",
          "slug": "fraserburgh",
          "postcode": "AB43",
          "nearby_areas": [
            "Peterhead",
            "Banff",
            "Ellon",
            "Huntly",
            "Turriff",
            "Keith",
            "Aberdeen"
          ]
        },
        {
          "name": "Inverurie",
          "slug": "inverurie",
          "postcode": "AB51",
          "nearby_areas": [
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Westhill",
            "Turriff"
          ]
        },
        {
          "name": "Stonehaven",
          "slug": "stonehaven",
          "postcode": "AB39",
          "nearby_areas": [
            "Banchory",
            "Westhill",
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Brechin"
          ]
        },
        {
          "name": "Ellon",
          "slug": "ellon",
          "postcode": "AB41",
          "nearby_areas": [
            "Banff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn",
            "Dyce",
            "Bridge of Don",
            "Inverurie"
          ]
        },
        {
          "name": "Banchory",
          "slug": "banchory",
          "postcode": "AB31",
          "nearby_areas": [
            "Westhill",
            "Stonehaven",
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay"
          ]
        },
        {
          "name": "Banff",
          "slug": "banff",
          "postcode": "AB45",
          "nearby_areas": [
            "Ellon",
            "Aberdeen",
            "Cove Bay",
            "Turriff",
            "Bucksburn",
            "Dyce",
            "Bridge of Don"
          ]
        },
        {
          "name": "Turriff",
          "slug": "turriff",
          "postcode": "AB53",
          "nearby_areas": [
            "Huntly",
            "Keith",
            "Inverurie",
            "Aberdeen",
            "Cove Bay",
            "Banff",
            "Bucksburn"
          ]
        },
        {
          "name": "Huntly",
          "slug": "huntly",
          "postcode": "AB54",
          "nearby_areas": [
            "Turriff",
            "Keith",
            "Inverurie",
            "Banff",
            "Aberdeen",
            "Cove Bay",
            "Bucksburn"
          ]
        },
        {
          "name": "Westhill",
          "slug": "westhill",
          "postcode": "AB32",
          "nearby_areas": [
            "Inverurie",
            "Bridge of Don",
            "Bucksburn",
            "Dyce",
            "Cove Bay",
            "Aberdeen",
            "Banchory"
          ]
        }
      ]
    },
    {
      "name": "Anglesey",
      "slug": "anglesey",
      "region": "Wales",
      "council_name": "Isle of Anglesey County Council",
      "council_url": "https://www.anglesey.gov.wales/",
      "climate": "coastal Welsh climate with wind and rain",
      "population": "70,000",
      "towns": [
        {
          "name": "Holyhead",
          "slug": "holyhead",
          "postcode": "LL65",
          "nearby_areas": [
            "Llangefni",
            "Rhosneigr",
            "Amlwch",
            "Benllech",
            "Caernarfon",
            "Menai Bridge",
            "Beaumaris"
          ]
        },
        {
          "name": "Llangefni",
          "slug": "llangefni",
          "postcode": "LL77",
          "nearby_areas": [
            "Rhosneigr",
            "Amlwch",
            "Benllech",
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Caernarfon"
          ]
        },
        {
          "name": "Amlwch",
          "slug": "amlwch",
          "postcode": "LL68",
          "nearby_areas": [
            "Benllech",
            "Bangor",
            "Rhosneigr",
            "Menai Bridge",
            "Beaumaris",
            "Llangefni",
            "Pwllheli"
          ]
        },
        {
          "name": "Beaumaris",
          "slug": "beaumaris",
          "postcode": "LL58",
          "nearby_areas": [
            "Menai Bridge",
            "Bangor",
            "Pwllheli",
            "Benllech",
            "Amlwch",
            "Porthmadog",
            "Rhosneigr"
          ]
        },
        {
          "name": "Menai Bridge",
          "slug": "menai-bridge",
          "postcode": "LL59",
          "nearby_areas": [
            "Beaumaris",
            "Bangor",
            "Benllech",
            "Pwllheli",
            "Amlwch",
            "Porthmadog",
            "Rhosneigr"
          ]
        },
        {
          "name": "Benllech",
          "slug": "benllech",
          "postcode": "LL74",
          "nearby_areas": [
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Amlwch",
            "Pwllheli",
            "Rhosneigr",
            "Llangefni"
          ]
        },
        {
          "name": "Rhosneigr",
          "slug": "rhosneigr",
          "postcode": "LL64",
          "nearby_areas": [
            "Llangefni",
            "Amlwch",
            "Benllech",
            "Bangor",
            "Menai Bridge",
            "Beaumaris",
            "Caernarfon"
          ]
        }
      ]
    },
    {
      "name": "Angus",
      "slug": "angus",
      "region": "Scotland",
      "council_name": "Angus Council",
      "council_url": "https://www.angus.gov.uk/",
      "climate": "cool east coast weather and damp winters",
      "population": "115,000",
      "towns": [
        {
          "name": "Forfar",
          "slug": "forfar",
          "postcode": "DD8",
          "nearby_areas": [
            "Kirriemuir",
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Lochee",
            "Brechin",
            "Carnoustie"
          ]
        },
        {
          "name": "Arbroath",
          "slug": "arbroath",
          "postcode": "DD11",
          "nearby_areas": [
            "Carnoustie",
            "Montrose",
            "Broughty Ferry",
            "Monifieth",
            "Lochee",
            "Brechin",
            "Forfar"
          ]
        },
        {
          "name": "Montrose",
          "slug": "montrose",
          "postcode": "DD10",
          "nearby_areas": [
            "Broughty Ferry",
            "Monifieth",
            "Forfar",
            "Lochee",
            "Arbroath",
            "Brechin",
            "Carnoustie"
          ]
        },
        {
          "name": "Brechin",
          "slug": "brechin",
          "postcode": "DD9",
          "nearby_areas": [
            "Montrose",
            "Forfar",
            "Arbroath",
            "Broughty Ferry",
            "Monifieth",
            "Kirriemuir",
            "Carnoustie"
          ]
        },
        {
          "name": "Carnoustie",
          "slug": "carnoustie",
          "postcode": "DD7",
          "nearby_areas": [
            "Arbroath",
            "Lochee",
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Dundee",
            "Forfar"
          ]
        },
        {
          "name": "Kirriemuir",
          "slug": "kirriemuir",
          "postcode": "DD8",
          "nearby_areas": [
            "Forfar",
            "Montrose",
            "Broughty Ferry",
            "Monifieth",
            "Lochee",
            "Brechin",
            "Blairgowrie"
          ]
        }
      ]
    },
    {
      "name": "Argyll and Bute",
      "slug": "argyll-and-bute",
      "region": "Scotland",
      "council_name": "Argyll and Bute Council",
      "council_url": "https://www.argyll-bute.gov.uk/",
      "climate": "very wet Atlantic coastal climate",
      "population": "85,000",
      "towns": [
        {
          "name": "Oban",
          "slug": "oban",
          "postcode": "PA34",
          "nearby_areas": [
            "Lochgilphead",
            "Campbeltown",
            "Dunoon",
            "Fort William",
            "Rothesay",
            "Helensburgh",
            "Gourock"
          ]
        },
        {
          "name": "Dunoon",
          "slug": "dunoon",
          "postcode": "PA23",
          "nearby_areas": [
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip",
            "Greenock",
            "Port Glasgow",
            "Campbeltown"
          ]
        },
        {
          "name": "Helensburgh",
          "slug": "helensburgh",
          "postcode": "G84",
          "nearby_areas": [
            "Gourock",
            "Rothesay",
            "Inverkip",
            "Port Glasgow",
            "Kilmacolm",
            "Alexandria",
            "Balloch"
          ]
        },
        {
          "name": "Campbeltown",
          "slug": "campbeltown",
          "postcode": "PA28",
          "nearby_areas": [
            "Lochgilphead",
            "Dunoon",
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip",
            "Greenock"
          ]
        },
        {
          "name": "Rothesay",
          "slug": "rothesay",
          "postcode": "PA20",
          "nearby_areas": [
            "Gourock",
            "Helensburgh",
            "Dunoon",
            "Inverkip",
            "Port Glasgow",
            "Greenock",
            "Kilmacolm"
          ]
        },
        {
          "name": "Lochgilphead",
          "slug": "lochgilphead",
          "postcode": "PA31",
          "nearby_areas": [
            "Campbeltown",
            "Oban",
            "Dunoon",
            "Rothesay",
            "Helensburgh",
            "Gourock",
            "Inverkip"
          ]
        }
      ]
    },
    {
      "name": "Bedfordshire",
      "slug": "bedfordshire",
      "region": "East of England",
      "council_name": "Central Bedfordshire Council",
      "council_url": "https://www.centralbedfordshire.gov.uk/",
      "climate": "cool, fairly dry climate with damp winters",
      "population": "700,000",
      "towns": [
        {
          "name": "Luton",
          "slug": "luton",
          "postcode": "LU1",
          "nearby_areas": [
            "Dunstable",
            "Houghton Regis",
            "Harpenden",
            "Hitchin",
            "Stotfold",
            "Cheshunt",
            "Hemel Hempstead"
          ]
        },
        {
          "name": "Bedford",
          "slug": "bedford",
          "postcode": "MK40",
          "nearby_areas": [
            "Kempston",
            "Sandy",
            "Ampthill",
            "Flitwick",
            "Shefford",
            "Biggleswade",
            "Potton"
          ]
        },
        {
          "name": "Dunstable",
          "slug": "dunstable",
          "postcode": "LU6",
          "nearby_areas": [
            "Houghton Regis",
            "Luton",
            "Leighton Buzzard",
            "Harpenden",
            "Berkhamsted",
            "Hemel Hempstead",
            "Stotfold"
          ]
        },
        {
          "name": "Leighton Buzzard",
          "slug": "leighton-buzzard",
          "postcode": "LU7",
          "nearby_areas": [
            "Houghton Regis",
            "Dunstable",
            "Luton",
            "Aylesbury",
            "Woburn",
            "Milton Keynes",
            "Berkhamsted"
          ]
        },
        {
          "name": "Kempston",
          "slug": "kempston",
          "postcode": "MK42",
          "nearby_areas": [
            "Ampthill",
            "Flitwick",
            "Olney",
            "Bedford",
            "Newport Pagnell",
            "Bletchley",
            "Milton Keynes"
          ]
        },
        {
          "name": "Biggleswade",
          "slug": "biggleswade",
          "postcode": "SG18",
          "nearby_areas": [
            "Potton",
            "Sandy",
            "Arlesey",
            "Shefford",
            "Stotfold",
            "Royston",
            "Bedford"
          ]
        },
        {
          "name": "Flitwick",
          "slug": "flitwick",
          "postcode": "MK45",
          "nearby_areas": [
            "Ampthill",
            "Olney",
            "Kempston",
            "Newport Pagnell",
            "Bletchley",
            "Bedford",
            "Woburn"
          ]
        },
        {
          "name": "Sandy",
          "slug": "sandy",
          "postcode": "SG19",
          "nearby_areas": [
            "Biggleswade",
            "Potton",
            "Shefford",
            "St Neots",
            "Arlesey",
            "Bedford",
            "Stotfold"
          ]
        },
        {
          "name": "Ampthill",
          "slug": "ampthill",
          "postcode": "MK45",
          "nearby_areas": [
            "Flitwick",
            "Olney",
            "Kempston",
            "Newport Pagnell",
            "Bletchley",
            "Bedford",
            "Woburn"
          ]
        },
        {
          "name": "Shefford",
          "slug": "shefford",
          "postcode": "SG17",
          "nearby_areas": [
            "Arlesey",
            "Potton",
            "Biggleswade",
            "Sandy",
            "Stotfold",
            "Royston",
            "Letchworth Garden City"
          ]
        },
        {
          "name": "Houghton Regis",
          "slug": "houghton-regis",
          "postcode": "LU5",
          "nearby_areas": [
            "Dunstable",
            "Leighton Buzzard",
            "Luton",
            "Berkhamsted",
            "Harpenden",
            "Hemel Hempstead",
            "Stotfold"
          ]
        },
        {
          "name": "Arlesey",
          "slug": "arlesey",
          "postcode": "SG15",
          "nearby_areas": [
            "Potton",
            "Shefford",
            "Biggleswade",
            "Royston",
            "Stotfold",
            "Letchworth Garden City",
            "Hitchin"
          ]
        },
        {
          "name": "Stotfold",
          "slug": "stotfold",
          "postcode": "SG5",
          "nearby_areas": [
            "Letchworth Garden City",
            "Hitchin",
            "Royston",
            "Arlesey",
            "Stevenage",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Potton",
          "slug": "potton",
          "postcode": "SG19",
          "nearby_areas": [
            "Biggleswade",
            "Arlesey",
            "Shefford",
            "Sandy",
            "Royston",
            "Stotfold",
            "Letchworth Garden City"
          ]
        },
        {
          "name": "Woburn",
          "slug": "woburn",
          "postcode": "MK17",
          "nearby_areas": [
            "Bletchley",
            "Milton Keynes",
            "Winslow",
            "Newport Pagnell",
            "Ampthill",
            "Flitwick",
            "Buckingham"
          ]
        }
      ]
    },
    {
      "name": "Berkshire",
      "slug": "berkshire",
      "region": "South East England",
      "council_name": "Berkshire (unitary authorities)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "mild winters with regular rainfall",
      "population": "950,000",
      "towns": [
        {
          "name": "Reading",
          "slug": "reading",
          "postcode": "RG1",
          "nearby_areas": [
            "Pangbourne",
            "Twyford",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Bracknell",
            "Maidenhead"
          ]
        },
        {
          "name": "Slough",
          "slug": "slough",
          "postcode": "SL1",
          "nearby_areas": [
            "Windsor",
            "Cookham",
            "Maidenhead",
            "Gerrards Cross",
            "Egham",
            "Staines-upon-Thames",
            "Ascot"
          ]
        },
        {
          "name": "Bracknell",
          "slug": "bracknell",
          "postcode": "RG12",
          "nearby_areas": [
            "Ascot",
            "Crowthorne",
            "Wokingham",
            "Camberley",
            "Cookham",
            "Windsor",
            "Maidenhead"
          ]
        },
        {
          "name": "Maidenhead",
          "slug": "maidenhead",
          "postcode": "SL6",
          "nearby_areas": [
            "Cookham",
            "Marlow",
            "Slough",
            "Windsor",
            "Bracknell",
            "Beaconsfield",
            "Ascot"
          ]
        },
        {
          "name": "Wokingham",
          "slug": "wokingham",
          "postcode": "RG40",
          "nearby_areas": [
            "Crowthorne",
            "Bracknell",
            "Ascot",
            "Reading",
            "Camberley",
            "Twyford",
            "Pangbourne"
          ]
        },
        {
          "name": "Newbury",
          "slug": "newbury",
          "postcode": "RG14",
          "nearby_areas": [
            "Thatcham",
            "Hungerford",
            "Twyford",
            "Pangbourne",
            "Basingstoke",
            "Reading",
            "Wantage"
          ]
        },
        {
          "name": "Windsor",
          "slug": "windsor",
          "postcode": "SL4",
          "nearby_areas": [
            "Slough",
            "Cookham",
            "Egham",
            "Maidenhead",
            "Ascot",
            "Staines-upon-Thames",
            "Bracknell"
          ]
        },
        {
          "name": "Thatcham",
          "slug": "thatcham",
          "postcode": "RG19",
          "nearby_areas": [
            "Newbury",
            "Hungerford",
            "Twyford",
            "Pangbourne",
            "Reading",
            "Basingstoke",
            "Didcot"
          ]
        },
        {
          "name": "Crowthorne",
          "slug": "crowthorne",
          "postcode": "RG45",
          "nearby_areas": [
            "Wokingham",
            "Camberley",
            "Bracknell",
            "Ascot",
            "Farnborough",
            "Fleet",
            "Aldershot"
          ]
        },
        {
          "name": "Sandhurst",
          "slug": "sandhurst",
          "postcode": "GU47",
          "nearby_areas": [
            "Farnham",
            "Aldershot",
            "Farnborough",
            "Fleet",
            "Alton",
            "Petworth",
            "Godalming"
          ]
        },
        {
          "name": "Ascot",
          "slug": "ascot",
          "postcode": "SL5",
          "nearby_areas": [
            "Bracknell",
            "Windsor",
            "Crowthorne",
            "Egham",
            "Camberley",
            "Wokingham",
            "Cookham"
          ]
        },
        {
          "name": "Hungerford",
          "slug": "hungerford",
          "postcode": "RG17",
          "nearby_areas": [
            "Newbury",
            "Thatcham",
            "Marlborough",
            "Wantage",
            "Andover",
            "Faringdon",
            "Royal Wootton Bassett"
          ]
        },
        {
          "name": "Twyford",
          "slug": "twyford",
          "postcode": "RG10",
          "nearby_areas": [
            "Pangbourne",
            "Reading",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Thatcham",
            "Bracknell"
          ]
        },
        {
          "name": "Cookham",
          "slug": "cookham",
          "postcode": "SL6",
          "nearby_areas": [
            "Maidenhead",
            "Slough",
            "Windsor",
            "Marlow",
            "Ascot",
            "Bracknell",
            "Beaconsfield"
          ]
        },
        {
          "name": "Pangbourne",
          "slug": "pangbourne",
          "postcode": "RG8",
          "nearby_areas": [
            "Twyford",
            "Reading",
            "Wokingham",
            "Henley-on-Thames",
            "Crowthorne",
            "Thatcham",
            "Bracknell"
          ]
        }
      ]
    },
    {
      "name": "Blaenau Gwent",
      "slug": "blaenau-gwent",
      "region": "Wales",
      "council_name": "Blaenau Gwent County Borough Council",
      "council_url": "https://www.blaenau-gwent.gov.uk/",
      "climate": "wet valleys climate and cool winters",
      "population": "66,000",
      "towns": [
        {
          "name": "Ebbw Vale",
          "slug": "ebbw-vale",
          "postcode": "NP23",
          "nearby_areas": [
            "Tredegar",
            "Abertillery",
            "Abersychan",
            "Brynmawr",
            "Nantyglo",
            "Merthyr Tydfil",
            "Blackwood"
          ]
        },
        {
          "name": "Tredegar",
          "slug": "tredegar",
          "postcode": "NP22",
          "nearby_areas": [
            "Ebbw Vale",
            "Abertillery",
            "Merthyr Tydfil",
            "Blackwood",
            "Treharris",
            "Mountain Ash",
            "Brynmawr"
          ]
        },
        {
          "name": "Abertillery",
          "slug": "abertillery",
          "postcode": "NP13",
          "nearby_areas": [
            "Abersychan",
            "Ebbw Vale",
            "Pontypool",
            "Blackwood",
            "Tredegar",
            "Abergavenny",
            "Treharris"
          ]
        },
        {
          "name": "Brynmawr",
          "slug": "brynmawr",
          "postcode": "NP23",
          "nearby_areas": [
            "Nantyglo",
            "Blaenavon",
            "New Inn",
            "Abergavenny",
            "Ebbw Vale",
            "Malpas",
            "Newport"
          ]
        },
        {
          "name": "Blaina",
          "slug": "blaina",
          "postcode": "NP13",
          "nearby_areas": [
            "Raglan",
            "Usk",
            "Llandrindod Wells",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Builth Wells"
          ]
        },
        {
          "name": "Nantyglo",
          "slug": "nantyglo",
          "postcode": "NP23",
          "nearby_areas": [
            "Brynmawr",
            "Blaenavon",
            "New Inn",
            "Abergavenny",
            "Ebbw Vale",
            "Malpas",
            "Newport"
          ]
        }
      ]
    },
    {
      "name": "Bridgend",
      "slug": "bridgend",
      "region": "Wales",
      "council_name": "Bridgend County Borough Council",
      "council_url": "https://www.bridgend.gov.uk/",
      "climate": "mild coastal climate with regular rain",
      "population": "145,000",
      "towns": [
        {
          "name": "Bridgend",
          "slug": "bridgend",
          "postcode": "CF31",
          "nearby_areas": [
            "Ogmore Vale",
            "Porthcawl",
            "Pencoed",
            "Pyle",
            "Maesteg",
            "Roath",
            "Llantwit Major"
          ]
        },
        {
          "name": "Porthcawl",
          "slug": "porthcawl",
          "postcode": "CF36",
          "nearby_areas": [
            "Bridgend",
            "Maesteg",
            "Port Talbot",
            "Ogmore Vale",
            "Pencoed",
            "Pyle",
            "Llantwit Major"
          ]
        },
        {
          "name": "Maesteg",
          "slug": "maesteg",
          "postcode": "CF34",
          "nearby_areas": [
            "Port Talbot",
            "Pyle",
            "Pencoed",
            "Ogmore Vale",
            "Neath",
            "Bridgend",
            "Treorchy"
          ]
        },
        {
          "name": "Pencoed",
          "slug": "pencoed",
          "postcode": "CF35",
          "nearby_areas": [
            "Pyle",
            "Ogmore Vale",
            "Roath",
            "Tonypandy",
            "Porth",
            "Bridgend",
            "Radyr"
          ]
        },
        {
          "name": "Pyle",
          "slug": "pyle",
          "postcode": "CF33",
          "nearby_areas": [
            "Pencoed",
            "Ogmore Vale",
            "Roath",
            "Tonypandy",
            "Porth",
            "Bridgend",
            "Treorchy"
          ]
        },
        {
          "name": "Ogmore Vale",
          "slug": "ogmore-vale",
          "postcode": "CF32",
          "nearby_areas": [
            "Pencoed",
            "Pyle",
            "Roath",
            "Tonypandy",
            "Bridgend",
            "Porth",
            "Radyr"
          ]
        }
      ]
    },
    {
      "name": "Bristol",
      "slug": "bristol",
      "region": "South West England",
      "council_name": "Bristol City Council",
      "council_url": "https://www.bristol.gov.uk/",
      "climate": "mild and damp with Atlantic rainfall",
      "population": "480,000",
      "towns": [
        {
          "name": "Bristol",
          "slug": "bristol",
          "postcode": "BS1",
          "nearby_areas": [
            "Bedminster",
            "Knowle",
            "St George",
            "Redland",
            "Bishopston",
            "Horfield",
            "Clifton"
          ]
        },
        {
          "name": "Clifton",
          "slug": "clifton",
          "postcode": "BS8",
          "nearby_areas": [
            "Henleaze",
            "Bishopston",
            "Horfield",
            "Redland",
            "St George",
            "Knowle",
            "Kingswood"
          ]
        },
        {
          "name": "Bedminster",
          "slug": "bedminster",
          "postcode": "BS3",
          "nearby_areas": [
            "Knowle",
            "St George",
            "Redland",
            "Bristol",
            "Bishopston",
            "Horfield",
            "Clifton"
          ]
        },
        {
          "name": "Redland",
          "slug": "redland",
          "postcode": "BS6",
          "nearby_areas": [
            "Bishopston",
            "Horfield",
            "St George",
            "Clifton",
            "Knowle",
            "Henleaze",
            "Bedminster"
          ]
        },
        {
          "name": "Filton",
          "slug": "filton",
          "postcode": "BS34",
          "nearby_areas": [
            "Thornbury",
            "Yate",
            "Keynsham",
            "Portishead",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Fishponds",
          "slug": "fishponds",
          "postcode": "BS16",
          "nearby_areas": [
            "Nailsea",
            "Kingswood",
            "Yate",
            "Thornbury",
            "Filton",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Horfield",
          "slug": "horfield",
          "postcode": "BS7",
          "nearby_areas": [
            "Bishopston",
            "Clifton",
            "Redland",
            "Henleaze",
            "St George",
            "Knowle",
            "Bedminster"
          ]
        },
        {
          "name": "Kingswood",
          "slug": "kingswood",
          "postcode": "BS15",
          "nearby_areas": [
            "Fishponds",
            "Nailsea",
            "Yate",
            "Filton",
            "Thornbury",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Bishopston",
          "slug": "bishopston",
          "postcode": "BS7",
          "nearby_areas": [
            "Horfield",
            "Clifton",
            "Redland",
            "Henleaze",
            "St George",
            "Knowle",
            "Bedminster"
          ]
        },
        {
          "name": "Knowle",
          "slug": "knowle",
          "postcode": "BS4",
          "nearby_areas": [
            "St George",
            "Bedminster",
            "Redland",
            "Bishopston",
            "Horfield",
            "Clifton",
            "Henleaze"
          ]
        },
        {
          "name": "St George",
          "slug": "st-george",
          "postcode": "BS5",
          "nearby_areas": [
            "Redland",
            "Knowle",
            "Bishopston",
            "Horfield",
            "Bedminster",
            "Clifton",
            "Henleaze"
          ]
        },
        {
          "name": "Henleaze",
          "slug": "henleaze",
          "postcode": "BS9",
          "nearby_areas": [
            "Clifton",
            "Bishopston",
            "Horfield",
            "Redland",
            "St George",
            "Kingswood",
            "Fishponds"
          ]
        }
      ]
    },
    {
      "name": "Buckinghamshire",
      "slug": "buckinghamshire",
      "region": "South East England",
      "council_name": "Buckinghamshire Council",
      "council_url": "https://www.buckinghamshire.gov.uk/",
      "climate": "mild but damp winters and warm summers",
      "population": "850,000",
      "towns": [
        {
          "name": "Milton Keynes",
          "slug": "milton-keynes",
          "postcode": "MK9",
          "nearby_areas": [
            "Bletchley",
            "Newport Pagnell",
            "Woburn",
            "Winslow",
            "Olney",
            "Ampthill",
            "Flitwick"
          ]
        },
        {
          "name": "High Wycombe",
          "slug": "high-wycombe",
          "postcode": "HP11",
          "nearby_areas": [
            "Marlow",
            "Beaconsfield",
            "Amersham",
            "Princes Risborough",
            "Wendover",
            "Chesham",
            "Maidenhead"
          ]
        },
        {
          "name": "Aylesbury",
          "slug": "aylesbury",
          "postcode": "HP20",
          "nearby_areas": [
            "Wendover",
            "Princes Risborough",
            "Thame",
            "Chesham",
            "Leighton Buzzard",
            "Amersham",
            "High Wycombe"
          ]
        },
        {
          "name": "Amersham",
          "slug": "amersham",
          "postcode": "HP6",
          "nearby_areas": [
            "Chesham",
            "Beaconsfield",
            "Gerrards Cross",
            "High Wycombe",
            "Wendover",
            "Berkhamsted",
            "Rickmansworth"
          ]
        },
        {
          "name": "Chesham",
          "slug": "chesham",
          "postcode": "HP5",
          "nearby_areas": [
            "Amersham",
            "Berkhamsted",
            "Wendover",
            "Beaconsfield",
            "High Wycombe",
            "Hemel Hempstead",
            "Gerrards Cross"
          ]
        },
        {
          "name": "Marlow",
          "slug": "marlow",
          "postcode": "SL7",
          "nearby_areas": [
            "High Wycombe",
            "Maidenhead",
            "Beaconsfield",
            "Cookham",
            "Henley-on-Thames",
            "Gerrards Cross",
            "Slough"
          ]
        },
        {
          "name": "Buckingham",
          "slug": "buckingham",
          "postcode": "MK18",
          "nearby_areas": [
            "Winslow",
            "Brackley",
            "Woburn",
            "Milton Keynes",
            "Bletchley",
            "Bicester",
            "Towcester"
          ]
        },
        {
          "name": "Beaconsfield",
          "slug": "beaconsfield",
          "postcode": "HP9",
          "nearby_areas": [
            "Gerrards Cross",
            "High Wycombe",
            "Amersham",
            "Marlow",
            "Chesham",
            "Maidenhead",
            "Cookham"
          ]
        },
        {
          "name": "Bletchley",
          "slug": "bletchley",
          "postcode": "MK2",
          "nearby_areas": [
            "Milton Keynes",
            "Newport Pagnell",
            "Woburn",
            "Winslow",
            "Olney",
            "Ampthill",
            "Flitwick"
          ]
        },
        {
          "name": "Newport Pagnell",
          "slug": "newport-pagnell",
          "postcode": "MK16",
          "nearby_areas": [
            "Bletchley",
            "Milton Keynes",
            "Olney",
            "Ampthill",
            "Flitwick",
            "Woburn",
            "Kempston"
          ]
        },
        {
          "name": "Princes Risborough",
          "slug": "princes-risborough",
          "postcode": "HP27",
          "nearby_areas": [
            "Wendover",
            "Aylesbury",
            "Thame",
            "High Wycombe",
            "Chesham",
            "Amersham",
            "Marlow"
          ]
        },
        {
          "name": "Gerrards Cross",
          "slug": "gerrards-cross",
          "postcode": "SL9",
          "nearby_areas": [
            "Beaconsfield",
            "Rickmansworth",
            "Slough",
            "Amersham",
            "Chesham",
            "Cookham",
            "Windsor"
          ]
        },
        {
          "name": "Winslow",
          "slug": "winslow",
          "postcode": "MK18",
          "nearby_areas": [
            "Woburn",
            "Buckingham",
            "Milton Keynes",
            "Bletchley",
            "Newport Pagnell",
            "Towcester",
            "Olney"
          ]
        },
        {
          "name": "Olney",
          "slug": "olney",
          "postcode": "MK46",
          "nearby_areas": [
            "Ampthill",
            "Flitwick",
            "Newport Pagnell",
            "Kempston",
            "Bletchley",
            "Milton Keynes",
            "Woburn"
          ]
        },
        {
          "name": "Wendover",
          "slug": "wendover",
          "postcode": "HP22",
          "nearby_areas": [
            "Princes Risborough",
            "Chesham",
            "Aylesbury",
            "Amersham",
            "High Wycombe",
            "Berkhamsted",
            "Beaconsfield"
          ]
        }
      ]
    },
    {
      "name": "Caerphilly",
      "slug": "caerphilly",
      "region": "Wales",
      "council_name": "Caerphilly County Borough Council",
      "council_url": "https://www.caerphilly.gov.uk/",
      "climate": "wet valleys climate and mild winters",
      "population": "175,000",
      "towns": [
        {
          "name": "Caerphilly",
          "slug": "caerphilly",
          "postcode": "CF83",
          "nearby_areas": [
            "Ystrad Mynach",
            "Bargoed",
            "Blackwood",
            "Pontypridd",
            "Llantrisant",
            "Cowbridge",
            "Canton"
          ]
        },
        {
          "name": "Blackwood",
          "slug": "blackwood",
          "postcode": "NP12",
          "nearby_areas": [
            "Treharris",
            "Abertillery",
            "Caerphilly",
            "Pontypool",
            "Ystrad Mynach",
            "Abersychan",
            "Nelson"
          ]
        },
        {
          "name": "Bargoed",
          "slug": "bargoed",
          "postcode": "CF81",
          "nearby_areas": [
            "Ystrad Mynach",
            "Llantrisant",
            "Cowbridge",
            "Canton",
            "Llandaff",
            "Marshfield",
            "Whitchurch"
          ]
        },
        {
          "name": "Risca",
          "slug": "risca",
          "postcode": "NP11",
          "nearby_areas": [
            "Flint",
            "Connah's Quay",
            "Shotton",
            "Holywell",
            "Mold",
            "Buckley",
            "Gresford"
          ]
        },
        {
          "name": "Ystrad Mynach",
          "slug": "ystrad-mynach",
          "postcode": "CF82",
          "nearby_areas": [
            "Bargoed",
            "Llantrisant",
            "Cowbridge",
            "Caerphilly",
            "Canton",
            "Llandaff",
            "Pontypridd"
          ]
        },
        {
          "name": "Newbridge",
          "slug": "newbridge",
          "postcode": "NP11",
          "nearby_areas": [
            "Armadale",
            "Broxburn",
            "Bo'ness",
            "Livingston",
            "Whitburn",
            "Linlithgow",
            "Edinburgh"
          ]
        },
        {
          "name": "Nelson",
          "slug": "nelson",
          "postcode": "CF46",
          "nearby_areas": [
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Mountain Ash",
            "Porth",
            "Treharris",
            "Tonypandy"
          ]
        }
      ]
    },
    {
      "name": "Cambridgeshire",
      "slug": "cambridgeshire",
      "region": "East of England",
      "council_name": "Cambridgeshire County Council",
      "council_url": "https://www.cambridgeshire.gov.uk/",
      "climate": "relatively dry with cold easterly winds",
      "population": "900,000",
      "towns": [
        {
          "name": "Cambridge",
          "slug": "cambridge",
          "postcode": "CB1",
          "nearby_areas": [
            "Histon",
            "Sawston",
            "Soham",
            "Newmarket",
            "Haverhill",
            "Ely",
            "Saffron Walden"
          ]
        },
        {
          "name": "Peterborough",
          "slug": "peterborough",
          "postcode": "PE1",
          "nearby_areas": [
            "Whittlesey",
            "Yaxley",
            "Oundle",
            "Ketton",
            "Ryhall",
            "King's Lynn",
            "March"
          ]
        },
        {
          "name": "Huntingdon",
          "slug": "huntingdon",
          "postcode": "PE29",
          "nearby_areas": [
            "St Neots",
            "Chatteris",
            "Sandy",
            "Peterborough",
            "March",
            "Biggleswade",
            "Ely"
          ]
        },
        {
          "name": "Wisbech",
          "slug": "wisbech",
          "postcode": "PE13",
          "nearby_areas": [
            "St Ives",
            "Ramsey",
            "March",
            "King's Lynn",
            "Downham Market",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "St Neots",
          "slug": "st-neots",
          "postcode": "PE19",
          "nearby_areas": [
            "Sandy",
            "Huntingdon",
            "Biggleswade",
            "Bedford",
            "Potton",
            "Shefford",
            "Arlesey"
          ]
        },
        {
          "name": "Ely",
          "slug": "ely",
          "postcode": "CB7",
          "nearby_areas": [
            "Soham",
            "Chatteris",
            "March",
            "Cambridge",
            "Newmarket",
            "Histon",
            "Sawston"
          ]
        },
        {
          "name": "March",
          "slug": "march",
          "postcode": "PE15",
          "nearby_areas": [
            "King's Lynn",
            "Chatteris",
            "Wisbech",
            "St Ives",
            "Ely",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "Whittlesey",
          "slug": "whittlesey",
          "postcode": "PE7",
          "nearby_areas": [
            "Yaxley",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "St Ives",
            "King's Lynn"
          ]
        },
        {
          "name": "St Ives",
          "slug": "st-ives",
          "postcode": "PE27",
          "nearby_areas": [
            "Ramsey",
            "Wisbech",
            "King's Lynn",
            "Whittlesey",
            "Yaxley",
            "March",
            "Oundle"
          ]
        },
        {
          "name": "Chatteris",
          "slug": "chatteris",
          "postcode": "PE16",
          "nearby_areas": [
            "March",
            "Ely",
            "King's Lynn",
            "Huntingdon",
            "Peterborough",
            "Wisbech",
            "St Ives"
          ]
        },
        {
          "name": "Soham",
          "slug": "soham",
          "postcode": "CB7",
          "nearby_areas": [
            "Cambridge",
            "Newmarket",
            "Histon",
            "Sawston",
            "Ely",
            "Haverhill",
            "Chatteris"
          ]
        },
        {
          "name": "Ramsey",
          "slug": "ramsey",
          "postcode": "PE26",
          "nearby_areas": [
            "St Ives",
            "Wisbech",
            "Whittlesey",
            "Yaxley",
            "Spalding",
            "King's Lynn",
            "March"
          ]
        },
        {
          "name": "Yaxley",
          "slug": "yaxley",
          "postcode": "PE7",
          "nearby_areas": [
            "Whittlesey",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "St Ives",
            "King's Lynn"
          ]
        },
        {
          "name": "Sawston",
          "slug": "sawston",
          "postcode": "CB22",
          "nearby_areas": [
            "Histon",
            "Cambridge",
            "Newmarket",
            "Soham",
            "Haverhill",
            "Saffron Walden",
            "Ely"
          ]
        },
        {
          "name": "Histon",
          "slug": "histon",
          "postcode": "CB24",
          "nearby_areas": [
            "Sawston",
            "Cambridge",
            "Newmarket",
            "Soham",
            "Haverhill",
            "Saffron Walden",
            "Ely"
          ]
        }
      ]
    },
    {
      "name": "Cardiff",
      "slug": "cardiff",
      "region": "Wales",
      "council_name": "Cardiff Council",
      "council_url": "https://www.cardiff.gov.uk/",
      "climate": "mild, damp and coastal",
      "population": "370,000",
      "towns": [
        {
          "name": "Cardiff",
          "slug": "cardiff",
          "postcode": "CF10",
          "nearby_areas": [
            "Penarth",
            "Dinas Powys",
            "Caerphilly",
            "Barry",
            "Rhoose",
            "Ystrad Mynach",
            "Cowbridge"
          ]
        },
        {
          "name": "Roath",
          "slug": "roath",
          "postcode": "CF24",
          "nearby_areas": [
            "Ogmore Vale",
            "Radyr",
            "Tonypandy",
            "Pencoed",
            "Pyle",
            "Porth",
            "Whitchurch"
          ]
        },
        {
          "name": "Canton",
          "slug": "canton",
          "postcode": "CF5",
          "nearby_areas": [
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Llandaff",
          "slug": "llandaff",
          "postcode": "CF5",
          "nearby_areas": [
            "Canton",
            "Whitchurch",
            "Marshfield",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Whitchurch",
          "slug": "whitchurch",
          "postcode": "CF14",
          "nearby_areas": [
            "Marshfield",
            "Canton",
            "Llandaff",
            "Radyr",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Radyr",
          "slug": "radyr",
          "postcode": "CF15",
          "nearby_areas": [
            "Marshfield",
            "Whitchurch",
            "Canton",
            "Llandaff",
            "Llantrisant",
            "Roath",
            "Cowbridge"
          ]
        },
        {
          "name": "Penarth",
          "slug": "penarth",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Dinas Powys",
            "Barry",
            "Rhoose",
            "Caerphilly",
            "Cowbridge",
            "Llantrisant"
          ]
        }
      ]
    },
    {
      "name": "Carmarthenshire",
      "slug": "carmarthenshire",
      "region": "Wales",
      "council_name": "Carmarthenshire County Council",
      "council_url": "https://www.carmarthenshire.gov.wales/",
      "climate": "wet, mild and rural",
      "population": "190,000",
      "towns": [
        {
          "name": "Carmarthen",
          "slug": "carmarthen",
          "postcode": "SA31",
          "nearby_areas": [
            "Llanelli",
            "Ammanford",
            "Llandeilo",
            "Kidwelly",
            "Burry Port",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Llanelli",
          "slug": "llanelli",
          "postcode": "SA15",
          "nearby_areas": [
            "Llandeilo",
            "Burry Port",
            "Kidwelly",
            "Gorseinon",
            "Pontarddulais",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Ammanford",
          "slug": "ammanford",
          "postcode": "SA18",
          "nearby_areas": [
            "Kidwelly",
            "Llandeilo",
            "Burry Port",
            "Llanelli",
            "Cymmer",
            "Ystradgynlais",
            "Briton Ferry"
          ]
        },
        {
          "name": "Llandeilo",
          "slug": "llandeilo",
          "postcode": "SA19",
          "nearby_areas": [
            "Kidwelly",
            "Burry Port",
            "Llanelli",
            "Clydach",
            "Morriston",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Burry Port",
          "slug": "burry-port",
          "postcode": "SA16",
          "nearby_areas": [
            "Kidwelly",
            "Llandeilo",
            "Clydach",
            "Morriston",
            "Llanelli",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Kidwelly",
          "slug": "kidwelly",
          "postcode": "SA17",
          "nearby_areas": [
            "Llandeilo",
            "Burry Port",
            "Llanelli",
            "Clydach",
            "Morriston",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Newcastle Emlyn",
          "slug": "newcastle-emlyn",
          "postcode": "SA38",
          "nearby_areas": [
            "Fishguard",
            "Narberth",
            "Llanelli",
            "Lampeter",
            "Burry Port",
            "Llandeilo",
            "Tenby"
          ]
        }
      ]
    },
    {
      "name": "Ceredigion",
      "slug": "ceredigion",
      "region": "Wales",
      "council_name": "Ceredigion County Council",
      "council_url": "https://www.ceredigion.gov.uk/",
      "climate": "wet coastal and upland climate",
      "population": "72,000",
      "towns": [
        {
          "name": "Aberystwyth",
          "slug": "aberystwyth",
          "postcode": "SY23",
          "nearby_areas": [
            "Tregaron",
            "Llandrindod Wells",
            "Machynlleth",
            "Builth Wells",
            "Presteigne",
            "Carmarthen",
            "Newtown"
          ]
        },
        {
          "name": "Cardigan",
          "slug": "cardigan",
          "postcode": "SA43",
          "nearby_areas": [
            "Lampeter",
            "Aberaeron",
            "Bude",
            "Bideford",
            "Newcastle Emlyn",
            "Ilfracombe",
            "Barnstaple"
          ]
        },
        {
          "name": "Lampeter",
          "slug": "lampeter",
          "postcode": "SA48",
          "nearby_areas": [
            "Cardigan",
            "Aberaeron",
            "Newcastle Emlyn",
            "Bideford",
            "Bude",
            "Ilfracombe",
            "Fishguard"
          ]
        },
        {
          "name": "Aberaeron",
          "slug": "aberaeron",
          "postcode": "SA46",
          "nearby_areas": [
            "Cardigan",
            "Lampeter",
            "Bude",
            "Bideford",
            "Launceston",
            "Wadebridge",
            "New Quay"
          ]
        },
        {
          "name": "New Quay",
          "slug": "new-quay",
          "postcode": "SA45",
          "nearby_areas": [
            "Truro",
            "Wadebridge",
            "St Austell",
            "Redruth",
            "Bodmin",
            "Camborne",
            "Falmouth"
          ]
        },
        {
          "name": "Tregaron",
          "slug": "tregaron",
          "postcode": "SY25",
          "nearby_areas": [
            "Machynlleth",
            "Newtown",
            "Welshpool",
            "Llandrindod Wells",
            "Whitchurch",
            "Aberystwyth",
            "Rogerstone"
          ]
        }
      ]
    },
    {
      "name": "Cheshire",
      "slug": "cheshire",
      "region": "North West England",
      "council_name": "Cheshire (unitary authorities)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "damp Atlantic air and mild wet winters",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Chester",
          "slug": "chester",
          "postcode": "CH1",
          "nearby_areas": [
            "Ellesmere Port",
            "Bebington",
            "Buckley",
            "Connah's Quay",
            "Shotton",
            "Frodsham",
            "Holywell"
          ]
        },
        {
          "name": "Warrington",
          "slug": "warrington",
          "postcode": "WA1",
          "nearby_areas": [
            "St Helens",
            "Newton-le-Willows",
            "Widnes",
            "Runcorn",
            "Frodsham",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Crewe",
          "slug": "crewe",
          "postcode": "CW1",
          "nearby_areas": [
            "Nantwich",
            "Sandbach",
            "Middlewich",
            "Winsford",
            "Congleton",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Runcorn",
          "slug": "runcorn",
          "postcode": "WA7",
          "nearby_areas": [
            "Widnes",
            "Frodsham",
            "St Helens",
            "Warrington",
            "Prescot",
            "Ellesmere Port",
            "Newton-le-Willows"
          ]
        },
        {
          "name": "Widnes",
          "slug": "widnes",
          "postcode": "WA8",
          "nearby_areas": [
            "Runcorn",
            "Frodsham",
            "St Helens",
            "Prescot",
            "Warrington",
            "Newton-le-Willows",
            "Ellesmere Port"
          ]
        },
        {
          "name": "Macclesfield",
          "slug": "macclesfield",
          "postcode": "SK10",
          "nearby_areas": [
            "Cheadle",
            "Wilmslow",
            "Congleton",
            "Buxton",
            "Hyde",
            "Knutsford",
            "Stockport"
          ]
        },
        {
          "name": "Ellesmere Port",
          "slug": "ellesmere-port",
          "postcode": "CH65",
          "nearby_areas": [
            "Bebington",
            "Chester",
            "Frodsham",
            "Runcorn",
            "Widnes",
            "Birkenhead",
            "Liverpool"
          ]
        },
        {
          "name": "Northwich",
          "slug": "northwich",
          "postcode": "CW9",
          "nearby_areas": [
            "Winsford",
            "Middlewich",
            "Knutsford",
            "Frodsham",
            "Warrington",
            "St Helens",
            "Sandbach"
          ]
        },
        {
          "name": "Winsford",
          "slug": "winsford",
          "postcode": "CW7",
          "nearby_areas": [
            "Middlewich",
            "Northwich",
            "Crewe",
            "Sandbach",
            "Nantwich",
            "Knutsford",
            "Frodsham"
          ]
        },
        {
          "name": "Wilmslow",
          "slug": "wilmslow",
          "postcode": "SK9",
          "nearby_areas": [
            "Cheadle",
            "Knutsford",
            "Macclesfield",
            "Stockport",
            "Altrincham",
            "Buxton",
            "Sale"
          ]
        },
        {
          "name": "Congleton",
          "slug": "congleton",
          "postcode": "CW12",
          "nearby_areas": [
            "Sandbach",
            "Macclesfield",
            "Middlewich",
            "Crewe",
            "Leek",
            "Wilmslow",
            "Knutsford"
          ]
        },
        {
          "name": "Nantwich",
          "slug": "nantwich",
          "postcode": "CW5",
          "nearby_areas": [
            "Crewe",
            "Sandbach",
            "Winsford",
            "Middlewich",
            "Northwich",
            "Market Drayton",
            "Congleton"
          ]
        },
        {
          "name": "Knutsford",
          "slug": "knutsford",
          "postcode": "WA16",
          "nearby_areas": [
            "Wilmslow",
            "Northwich",
            "Altrincham",
            "Middlewich",
            "Winsford",
            "Sale",
            "Denton"
          ]
        },
        {
          "name": "Sandbach",
          "slug": "sandbach",
          "postcode": "CW11",
          "nearby_areas": [
            "Crewe",
            "Middlewich",
            "Congleton",
            "Winsford",
            "Nantwich",
            "Northwich",
            "Knutsford"
          ]
        },
        {
          "name": "Middlewich",
          "slug": "middlewich",
          "postcode": "CW10",
          "nearby_areas": [
            "Winsford",
            "Sandbach",
            "Northwich",
            "Crewe",
            "Knutsford",
            "Nantwich",
            "Congleton"
          ]
        },
        {
          "name": "Frodsham",
          "slug": "frodsham",
          "postcode": "WA6",
          "nearby_areas": [
            "Runcorn",
            "Widnes",
            "Ellesmere Port",
            "St Helens",
            "Warrington",
            "Northwich",
            "Chester"
          ]
        }
      ]
    },
    {
      "name": "City of Edinburgh",
      "slug": "city-of-edinburgh",
      "region": "Scotland",
      "council_name": "The City of Edinburgh Council",
      "council_url": "https://www.edinburgh.gov.uk/",
      "climate": "cool, windy and relatively dry for Scotland",
      "population": "520,000",
      "towns": [
        {
          "name": "Edinburgh",
          "slug": "edinburgh",
          "postcode": "EH1",
          "nearby_areas": [
            "Leith",
            "Newington",
            "Morningside",
            "Corstorphine",
            "Portobello",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Leith",
          "slug": "leith",
          "postcode": "EH6",
          "nearby_areas": [
            "Newington",
            "Morningside",
            "Corstorphine",
            "Portobello",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Portobello",
          "slug": "portobello",
          "postcode": "EH15",
          "nearby_areas": [
            "Corstorphine",
            "Bonnyrigg",
            "Morningside",
            "Loanhead",
            "Newington",
            "Musselburgh",
            "Dalkeith"
          ]
        },
        {
          "name": "Corstorphine",
          "slug": "corstorphine",
          "postcode": "EH12",
          "nearby_areas": [
            "Morningside",
            "Portobello",
            "Newington",
            "Bonnyrigg",
            "Leith",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Morningside",
          "slug": "morningside",
          "postcode": "EH10",
          "nearby_areas": [
            "Newington",
            "Corstorphine",
            "Portobello",
            "Leith",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        },
        {
          "name": "Newington",
          "slug": "newington",
          "postcode": "EH9",
          "nearby_areas": [
            "Morningside",
            "Corstorphine",
            "Leith",
            "Portobello",
            "Bonnyrigg",
            "Loanhead",
            "Musselburgh"
          ]
        }
      ]
    },
    {
      "name": "Clackmannanshire",
      "slug": "clackmannanshire",
      "region": "Scotland",
      "council_name": "Clackmannanshire Council",
      "council_url": "https://www.clacks.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "52,000",
      "towns": [
        {
          "name": "Alloa",
          "slug": "alloa",
          "postcode": "FK10",
          "nearby_areas": [
            "Clackmannan",
            "Bridge of Allan",
            "Alva",
            "Denny",
            "Dollar",
            "Callander",
            "Larbert"
          ]
        },
        {
          "name": "Tillicoultry",
          "slug": "tillicoultry",
          "postcode": "FK13",
          "nearby_areas": [
            "Alva",
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Bridge of Allan",
            "Denny"
          ]
        },
        {
          "name": "Alva",
          "slug": "alva",
          "postcode": "FK12",
          "nearby_areas": [
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Bridge of Allan",
            "Denny",
            "Larbert"
          ]
        },
        {
          "name": "Clackmannan",
          "slug": "clackmannan",
          "postcode": "FK10",
          "nearby_areas": [
            "Alloa",
            "Bridge of Allan",
            "Alva",
            "Denny",
            "Dollar",
            "Callander",
            "Larbert"
          ]
        },
        {
          "name": "Dollar",
          "slug": "dollar",
          "postcode": "FK14",
          "nearby_areas": [
            "Callander",
            "Alva",
            "Alloa",
            "Clackmannan",
            "Bridge of Allan",
            "Denny",
            "Larbert"
          ]
        }
      ]
    },
    {
      "name": "Conwy",
      "slug": "conwy",
      "region": "Wales",
      "council_name": "Conwy County Borough Council",
      "council_url": "https://www.conwy.gov.uk/",
      "climate": "wet coastal and mountain weather",
      "population": "115,000",
      "towns": [
        {
          "name": "Colwyn Bay",
          "slug": "colwyn-bay",
          "postcode": "LL29",
          "nearby_areas": [
            "Llanrwst",
            "Dolgellau",
            "Conwy",
            "Llandudno",
            "Blaenau Ffestiniog",
            "Barmouth",
            "Betws-y-Coed"
          ]
        },
        {
          "name": "Llandudno",
          "slug": "llandudno",
          "postcode": "LL30",
          "nearby_areas": [
            "Conwy",
            "Colwyn Bay",
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Barmouth",
            "Llanrwst",
            "Porthmadog"
          ]
        },
        {
          "name": "Conwy",
          "slug": "conwy",
          "postcode": "LL32",
          "nearby_areas": [
            "Barmouth",
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Llandudno",
            "Colwyn Bay",
            "Porthmadog",
            "Llanrwst"
          ]
        },
        {
          "name": "Abergele",
          "slug": "abergele",
          "postcode": "LL22",
          "nearby_areas": [
            "Betws-y-Coed",
            "Corwen",
            "Llanrwst",
            "Llangollen",
            "Rhyl",
            "Colwyn Bay",
            "Prestatyn"
          ]
        },
        {
          "name": "Llanrwst",
          "slug": "llanrwst",
          "postcode": "LL26",
          "nearby_areas": [
            "Betws-y-Coed",
            "Abergele",
            "Colwyn Bay",
            "Corwen",
            "Llangollen",
            "Dolgellau",
            "Blaenau Ffestiniog"
          ]
        },
        {
          "name": "Betws-y-Coed",
          "slug": "betws-y-coed",
          "postcode": "LL24",
          "nearby_areas": [
            "Abergele",
            "Llanrwst",
            "Corwen",
            "Llangollen",
            "Colwyn Bay",
            "Rhyl",
            "Dolgellau"
          ]
        }
      ]
    },
    {
      "name": "Cornwall",
      "slug": "cornwall",
      "region": "South West England",
      "council_name": "Cornwall Council",
      "council_url": "https://www.cornwall.gov.uk/",
      "climate": "mild, exposed coastal climate with high rainfall",
      "population": "580,000",
      "towns": [
        {
          "name": "Truro",
          "slug": "truro",
          "postcode": "TR1",
          "nearby_areas": [
            "Falmouth",
            "Redruth",
            "Newquay",
            "Camborne",
            "St Austell",
            "St Ives",
            "Helston"
          ]
        },
        {
          "name": "Falmouth",
          "slug": "falmouth",
          "postcode": "TR11",
          "nearby_areas": [
            "Truro",
            "Redruth",
            "Helston",
            "Camborne",
            "St Ives",
            "Hayle",
            "St Austell"
          ]
        },
        {
          "name": "St Austell",
          "slug": "st-austell",
          "postcode": "PL25",
          "nearby_areas": [
            "Bodmin",
            "Padstow",
            "Truro",
            "Wadebridge",
            "Newquay",
            "Looe",
            "Liskeard"
          ]
        },
        {
          "name": "Camborne",
          "slug": "camborne",
          "postcode": "TR14",
          "nearby_areas": [
            "St Ives",
            "Redruth",
            "Hayle",
            "Helston",
            "Falmouth",
            "Truro",
            "Penzance"
          ]
        },
        {
          "name": "Redruth",
          "slug": "redruth",
          "postcode": "TR15",
          "nearby_areas": [
            "Camborne",
            "St Ives",
            "Truro",
            "Falmouth",
            "Hayle",
            "Helston",
            "Newquay"
          ]
        },
        {
          "name": "Penzance",
          "slug": "penzance",
          "postcode": "TR18",
          "nearby_areas": [
            "Hayle",
            "St Ives",
            "Helston",
            "Camborne",
            "Redruth",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "Newquay",
          "slug": "newquay",
          "postcode": "TR7",
          "nearby_areas": [
            "Truro",
            "Wadebridge",
            "St Austell",
            "Redruth",
            "Bodmin",
            "Camborne",
            "Falmouth"
          ]
        },
        {
          "name": "Bodmin",
          "slug": "bodmin",
          "postcode": "PL31",
          "nearby_areas": [
            "Wadebridge",
            "Padstow",
            "St Austell",
            "Liskeard",
            "Fowey",
            "Looe",
            "Newquay"
          ]
        },
        {
          "name": "Saltash",
          "slug": "saltash",
          "postcode": "PL12",
          "nearby_areas": [
            "Torpoint",
            "Plymouth",
            "Fowey",
            "Looe",
            "Liskeard",
            "Tavistock",
            "Ivybridge"
          ]
        },
        {
          "name": "Helston",
          "slug": "helston",
          "postcode": "TR13",
          "nearby_areas": [
            "St Ives",
            "Camborne",
            "Hayle",
            "Redruth",
            "Falmouth",
            "Penzance",
            "Truro"
          ]
        },
        {
          "name": "Launceston",
          "slug": "launceston",
          "postcode": "PL15",
          "nearby_areas": [
            "Tavistock",
            "Liskeard",
            "Fowey",
            "Bude",
            "Padstow",
            "Saltash",
            "Okehampton"
          ]
        },
        {
          "name": "Liskeard",
          "slug": "liskeard",
          "postcode": "PL14",
          "nearby_areas": [
            "Fowey",
            "Padstow",
            "Looe",
            "Bodmin",
            "Saltash",
            "Torpoint",
            "Launceston"
          ]
        },
        {
          "name": "Hayle",
          "slug": "hayle",
          "postcode": "TR27",
          "nearby_areas": [
            "St Ives",
            "Camborne",
            "Penzance",
            "Helston",
            "Redruth",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "St Ives",
          "slug": "st-ives",
          "postcode": "TR26",
          "nearby_areas": [
            "Camborne",
            "Hayle",
            "Redruth",
            "Helston",
            "Penzance",
            "Falmouth",
            "Truro"
          ]
        },
        {
          "name": "Bude",
          "slug": "bude",
          "postcode": "EX23",
          "nearby_areas": [
            "Launceston",
            "Aberaeron",
            "Bideford",
            "Cardigan",
            "Wadebridge",
            "Padstow",
            "Bodmin"
          ]
        },
        {
          "name": "Wadebridge",
          "slug": "wadebridge",
          "postcode": "PL27",
          "nearby_areas": [
            "Bodmin",
            "Padstow",
            "St Austell",
            "Newquay",
            "Liskeard",
            "Fowey",
            "Truro"
          ]
        },
        {
          "name": "Fowey",
          "slug": "fowey",
          "postcode": "PL23",
          "nearby_areas": [
            "Liskeard",
            "Looe",
            "Padstow",
            "Saltash",
            "Torpoint",
            "Plymouth",
            "Launceston"
          ]
        },
        {
          "name": "Padstow",
          "slug": "padstow",
          "postcode": "PL28",
          "nearby_areas": [
            "Liskeard",
            "Bodmin",
            "Fowey",
            "Looe",
            "Wadebridge",
            "St Austell",
            "Launceston"
          ]
        },
        {
          "name": "Looe",
          "slug": "looe",
          "postcode": "PL13",
          "nearby_areas": [
            "Fowey",
            "Liskeard",
            "Padstow",
            "Saltash",
            "Torpoint",
            "Bodmin",
            "St Austell"
          ]
        },
        {
          "name": "Torpoint",
          "slug": "torpoint",
          "postcode": "PL11",
          "nearby_areas": [
            "Saltash",
            "Plymouth",
            "Fowey",
            "Looe",
            "Liskeard",
            "Ivybridge",
            "Tavistock"
          ]
        }
      ]
    },
    {
      "name": "County Antrim",
      "slug": "county-antrim",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet and coastal",
      "population": "620,000",
      "towns": [
        {
          "name": "Belfast",
          "slug": "belfast",
          "postcode": "BT1",
          "nearby_areas": [
            "Newtownabbey",
            "Antrim",
            "Lisburn",
            "Randalstown",
            "Warrenpoint",
            "Carrickfergus",
            "Holywood"
          ]
        },
        {
          "name": "Lisburn",
          "slug": "lisburn",
          "postcode": "BT28",
          "nearby_areas": [
            "Newtownabbey",
            "Belfast",
            "Warrenpoint",
            "Holywood",
            "Antrim",
            "Comber",
            "Carrickfergus"
          ]
        },
        {
          "name": "Antrim",
          "slug": "antrim",
          "postcode": "BT41",
          "nearby_areas": [
            "Randalstown",
            "Belfast",
            "Newtownabbey",
            "Ballymena",
            "Maghera",
            "Lisburn",
            "Dungiven"
          ]
        },
        {
          "name": "Ballymena",
          "slug": "ballymena",
          "postcode": "BT43",
          "nearby_areas": [
            "Randalstown",
            "Dungiven",
            "Maghera",
            "Derry",
            "Antrim",
            "Belfast",
            "Newtownabbey"
          ]
        },
        {
          "name": "Carrickfergus",
          "slug": "carrickfergus",
          "postcode": "BT38",
          "nearby_areas": [
            "Holywood",
            "Bangor",
            "Larne",
            "Newtownards",
            "Comber",
            "Donaghadee",
            "Lisburn"
          ]
        },
        {
          "name": "Larne",
          "slug": "larne",
          "postcode": "BT40",
          "nearby_areas": [
            "Carrickfergus",
            "Holywood",
            "Bangor",
            "Antrim",
            "Ballymena",
            "Belfast",
            "Donaghadee"
          ]
        },
        {
          "name": "Newtownabbey",
          "slug": "newtownabbey",
          "postcode": "BT36",
          "nearby_areas": [
            "Belfast",
            "Antrim",
            "Lisburn",
            "Randalstown",
            "Warrenpoint",
            "Carrickfergus",
            "Holywood"
          ]
        },
        {
          "name": "Ballymoney",
          "slug": "ballymoney",
          "postcode": "BT53",
          "nearby_areas": [
            "Coleraine",
            "Portrush",
            "Portstewart",
            "Ballymena",
            "Derry",
            "Limavady",
            "Dungiven"
          ]
        },
        {
          "name": "Portrush",
          "slug": "portrush",
          "postcode": "BT56",
          "nearby_areas": [
            "Portstewart",
            "Coleraine",
            "Ballymoney",
            "Limavady",
            "Ballymena",
            "Derry",
            "Dungiven"
          ]
        },
        {
          "name": "Randalstown",
          "slug": "randalstown",
          "postcode": "BT41",
          "nearby_areas": [
            "Antrim",
            "Maghera",
            "Dungiven",
            "Ballymena",
            "Belfast",
            "Newtownabbey",
            "Derry"
          ]
        }
      ]
    },
    {
      "name": "County Armagh",
      "slug": "county-armagh",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "mild, damp and rural",
      "population": "175,000",
      "towns": [
        {
          "name": "Armagh",
          "slug": "armagh",
          "postcode": "BT60",
          "nearby_areas": [
            "Dungannon",
            "Coalisland",
            "Banbridge",
            "Newry",
            "Keady",
            "Markethill",
            "Cookstown"
          ]
        },
        {
          "name": "Craigavon",
          "slug": "craigavon",
          "postcode": "BT64",
          "nearby_areas": [
            "Portadown",
            "Tandragee",
            "Ballinamallard",
            "Irvinestown",
            "Lurgan",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Portadown",
          "slug": "portadown",
          "postcode": "BT62",
          "nearby_areas": [
            "Tandragee",
            "Craigavon",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Lurgan",
          "slug": "lurgan",
          "postcode": "BT66",
          "nearby_areas": [
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Keady",
          "slug": "keady",
          "postcode": "BT60",
          "nearby_areas": [
            "Markethill",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Craigavon",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Tandragee",
          "slug": "tandragee",
          "postcode": "BT62",
          "nearby_areas": [
            "Portadown",
            "Craigavon",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Markethill",
          "slug": "markethill",
          "postcode": "BT60",
          "nearby_areas": [
            "Keady",
            "Lurgan",
            "Ballinamallard",
            "Irvinestown",
            "Craigavon",
            "Belleek",
            "Lisnaskea"
          ]
        }
      ]
    },
    {
      "name": "County Down",
      "slug": "county-down",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "mild, wet and coastal",
      "population": "540,000",
      "towns": [
        {
          "name": "Newry",
          "slug": "newry",
          "postcode": "BT34",
          "nearby_areas": [
            "Banbridge",
            "Armagh",
            "Warrenpoint",
            "Ballynahinch",
            "Downpatrick",
            "Dungannon",
            "Coalisland"
          ]
        },
        {
          "name": "Bangor",
          "slug": "bangor",
          "postcode": "BT20",
          "nearby_areas": [
            "Newtownards",
            "Donaghadee",
            "Holywood",
            "Comber",
            "Carrickfergus",
            "Larne",
            "Lisburn"
          ]
        },
        {
          "name": "Newtownards",
          "slug": "newtownards",
          "postcode": "BT23",
          "nearby_areas": [
            "Comber",
            "Bangor",
            "Holywood",
            "Donaghadee",
            "Carrickfergus",
            "Ballynahinch",
            "Lisburn"
          ]
        },
        {
          "name": "Downpatrick",
          "slug": "downpatrick",
          "postcode": "BT30",
          "nearby_areas": [
            "Ballynahinch",
            "Comber",
            "Newtownards",
            "Holywood",
            "Bangor",
            "Banbridge",
            "Donaghadee"
          ]
        },
        {
          "name": "Banbridge",
          "slug": "banbridge",
          "postcode": "BT32",
          "nearby_areas": [
            "Warrenpoint",
            "Newry",
            "Ballynahinch",
            "Armagh",
            "Lisburn",
            "Newtownabbey",
            "Downpatrick"
          ]
        },
        {
          "name": "Holywood",
          "slug": "holywood",
          "postcode": "BT18",
          "nearby_areas": [
            "Carrickfergus",
            "Newtownards",
            "Bangor",
            "Comber",
            "Donaghadee",
            "Lisburn",
            "Belfast"
          ]
        },
        {
          "name": "Comber",
          "slug": "comber",
          "postcode": "BT23",
          "nearby_areas": [
            "Newtownards",
            "Holywood",
            "Bangor",
            "Donaghadee",
            "Ballynahinch",
            "Carrickfergus",
            "Lisburn"
          ]
        },
        {
          "name": "Donaghadee",
          "slug": "donaghadee",
          "postcode": "BT21",
          "nearby_areas": [
            "Bangor",
            "Newtownards",
            "Comber",
            "Holywood",
            "Carrickfergus",
            "Larne",
            "Ballynahinch"
          ]
        },
        {
          "name": "Warrenpoint",
          "slug": "warrenpoint",
          "postcode": "BT34",
          "nearby_areas": [
            "Lisburn",
            "Newtownabbey",
            "Banbridge",
            "Belfast",
            "Ballynahinch",
            "Antrim",
            "Holywood"
          ]
        },
        {
          "name": "Ballynahinch",
          "slug": "ballynahinch",
          "postcode": "BT24",
          "nearby_areas": [
            "Downpatrick",
            "Comber",
            "Warrenpoint",
            "Lisburn",
            "Newtownards",
            "Banbridge",
            "Holywood"
          ]
        }
      ]
    },
    {
      "name": "County Durham",
      "slug": "county-durham",
      "region": "North East England",
      "council_name": "Durham County Council",
      "council_url": "https://www.durham.gov.uk/",
      "climate": "cold winters with wet upland conditions",
      "population": "870,000",
      "towns": [
        {
          "name": "Durham",
          "slug": "durham",
          "postcode": "DH1",
          "nearby_areas": [
            "Chester-le-Street",
            "Spennymoor",
            "Houghton-le-Spring",
            "Crook",
            "Bishop Auckland",
            "Stanley",
            "Peterlee"
          ]
        },
        {
          "name": "Darlington",
          "slug": "darlington",
          "postcode": "DL1",
          "nearby_areas": [
            "Newton Aycliffe",
            "Shildon",
            "Stockton-on-Tees",
            "Bishop Auckland",
            "Spennymoor",
            "Richmond",
            "Barnard Castle"
          ]
        },
        {
          "name": "Hartlepool",
          "slug": "hartlepool",
          "postcode": "TS24",
          "nearby_areas": [
            "Peterlee",
            "Stokesley",
            "Stockton-on-Tees",
            "Redcar",
            "Middlesbrough",
            "Seaham",
            "Newton Aycliffe"
          ]
        },
        {
          "name": "Stockton-on-Tees",
          "slug": "stockton-on-tees",
          "postcode": "TS18",
          "nearby_areas": [
            "Middlesbrough",
            "Hartlepool",
            "Stokesley",
            "Darlington",
            "Newton Aycliffe",
            "Redcar",
            "Peterlee"
          ]
        },
        {
          "name": "Chester-le-Street",
          "slug": "chester-le-street",
          "postcode": "DH3",
          "nearby_areas": [
            "Houghton-le-Spring",
            "Durham",
            "Stanley",
            "Crook",
            "Spennymoor",
            "Consett",
            "Washington"
          ]
        },
        {
          "name": "Bishop Auckland",
          "slug": "bishop-auckland",
          "postcode": "DL14",
          "nearby_areas": [
            "Shildon",
            "Spennymoor",
            "Crook",
            "Newton Aycliffe",
            "Durham",
            "Chester-le-Street",
            "Darlington"
          ]
        },
        {
          "name": "Consett",
          "slug": "consett",
          "postcode": "DH8",
          "nearby_areas": [
            "Stanley",
            "Houghton-le-Spring",
            "Chester-le-Street",
            "Prudhoe",
            "Crook",
            "Durham",
            "Corbridge"
          ]
        },
        {
          "name": "Peterlee",
          "slug": "peterlee",
          "postcode": "SR8",
          "nearby_areas": [
            "Seaham",
            "Hartlepool",
            "Durham",
            "Spennymoor",
            "Sunderland",
            "Chester-le-Street",
            "Stockton-on-Tees"
          ]
        },
        {
          "name": "Seaham",
          "slug": "seaham",
          "postcode": "SR7",
          "nearby_areas": [
            "Peterlee",
            "Sunderland",
            "Washington",
            "Durham",
            "Hartlepool",
            "Jarrow",
            "Chester-le-Street"
          ]
        },
        {
          "name": "Spennymoor",
          "slug": "spennymoor",
          "postcode": "DL16",
          "nearby_areas": [
            "Bishop Auckland",
            "Shildon",
            "Durham",
            "Crook",
            "Newton Aycliffe",
            "Chester-le-Street",
            "Houghton-le-Spring"
          ]
        },
        {
          "name": "Newton Aycliffe",
          "slug": "newton-aycliffe",
          "postcode": "DL5",
          "nearby_areas": [
            "Shildon",
            "Bishop Auckland",
            "Spennymoor",
            "Darlington",
            "Crook",
            "Stockton-on-Tees",
            "Durham"
          ]
        },
        {
          "name": "Barnard Castle",
          "slug": "barnard-castle",
          "postcode": "DL12",
          "nearby_areas": [
            "Bishop Auckland",
            "Shildon",
            "Crook",
            "Richmond",
            "Darlington",
            "Newton Aycliffe",
            "Spennymoor"
          ]
        },
        {
          "name": "Stanley",
          "slug": "stanley",
          "postcode": "DH9",
          "nearby_areas": [
            "Consett",
            "Houghton-le-Spring",
            "Chester-le-Street",
            "Crook",
            "Durham",
            "Prudhoe",
            "Gateshead"
          ]
        },
        {
          "name": "Shildon",
          "slug": "shildon",
          "postcode": "DL4",
          "nearby_areas": [
            "Bishop Auckland",
            "Newton Aycliffe",
            "Spennymoor",
            "Crook",
            "Darlington",
            "Durham",
            "Chester-le-Street"
          ]
        },
        {
          "name": "Crook",
          "slug": "crook",
          "postcode": "DL15",
          "nearby_areas": [
            "Bishop Auckland",
            "Spennymoor",
            "Shildon",
            "Chester-le-Street",
            "Durham",
            "Houghton-le-Spring",
            "Stanley"
          ]
        }
      ]
    },
    {
      "name": "County Fermanagh",
      "slug": "county-fermanagh",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "wet, mild and rural",
      "population": "65,000",
      "towns": [
        {
          "name": "Enniskillen",
          "slug": "enniskillen",
          "postcode": "BT74",
          "nearby_areas": [
            "Strabane",
            "Dungannon",
            "Castlederg",
            "Armagh",
            "Coalisland",
            "Fintona",
            "Omagh"
          ]
        },
        {
          "name": "Lisnaskea",
          "slug": "lisnaskea",
          "postcode": "BT92",
          "nearby_areas": [
            "Belleek",
            "Ballinamallard",
            "Irvinestown",
            "Lurgan",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Irvinestown",
          "slug": "irvinestown",
          "postcode": "BT94",
          "nearby_areas": [
            "Ballinamallard",
            "Belleek",
            "Lurgan",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Belleek",
          "slug": "belleek",
          "postcode": "BT93",
          "nearby_areas": [
            "Ballinamallard",
            "Irvinestown",
            "Lisnaskea",
            "Lurgan",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Ballinamallard",
          "slug": "ballinamallard",
          "postcode": "BT94",
          "nearby_areas": [
            "Irvinestown",
            "Belleek",
            "Lurgan",
            "Lisnaskea",
            "Craigavon",
            "Portadown",
            "Tandragee"
          ]
        }
      ]
    },
    {
      "name": "County Londonderry",
      "slug": "county-londonderry",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet and coastal",
      "population": "250,000",
      "towns": [
        {
          "name": "Derry",
          "slug": "derry",
          "postcode": "BT48",
          "nearby_areas": [
            "Dungiven",
            "Maghera",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee",
            "Randalstown"
          ]
        },
        {
          "name": "Coleraine",
          "slug": "coleraine",
          "postcode": "BT52",
          "nearby_areas": [
            "Portstewart",
            "Portrush",
            "Ballymoney",
            "Limavady",
            "Derry",
            "Dungiven",
            "Maghera"
          ]
        },
        {
          "name": "Limavady",
          "slug": "limavady",
          "postcode": "BT49",
          "nearby_areas": [
            "Coleraine",
            "Portstewart",
            "Portrush",
            "Ballymoney",
            "Derry",
            "Magherafelt",
            "Dungiven"
          ]
        },
        {
          "name": "Magherafelt",
          "slug": "magherafelt",
          "postcode": "BT45",
          "nearby_areas": [
            "Portadown",
            "Tandragee",
            "Craigavon",
            "Ballinamallard",
            "Irvinestown",
            "Belleek",
            "Lisnaskea"
          ]
        },
        {
          "name": "Portstewart",
          "slug": "portstewart",
          "postcode": "BT55",
          "nearby_areas": [
            "Portrush",
            "Coleraine",
            "Ballymoney",
            "Limavady",
            "Derry",
            "Dungiven",
            "Magherafelt"
          ]
        },
        {
          "name": "Maghera",
          "slug": "maghera",
          "postcode": "BT46",
          "nearby_areas": [
            "Dungiven",
            "Derry",
            "Randalstown",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee"
          ]
        },
        {
          "name": "Dungiven",
          "slug": "dungiven",
          "postcode": "BT47",
          "nearby_areas": [
            "Maghera",
            "Derry",
            "Randalstown",
            "Magherafelt",
            "Ballymena",
            "Portadown",
            "Tandragee"
          ]
        }
      ]
    },
    {
      "name": "County Tyrone",
      "slug": "county-tyrone",
      "region": "Northern Ireland",
      "council_name": "Local councils in Northern Ireland",
      "council_url": "https://www.nidirect.gov.uk/contacts/local-councils",
      "climate": "cool, wet inland climate",
      "population": "180,000",
      "towns": [
        {
          "name": "Omagh",
          "slug": "omagh",
          "postcode": "BT78",
          "nearby_areas": [
            "Fintona",
            "Cookstown",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Dungannon",
          "slug": "dungannon",
          "postcode": "BT70",
          "nearby_areas": [
            "Coalisland",
            "Cookstown",
            "Fintona",
            "Omagh",
            "Armagh",
            "Castlederg",
            "Keady"
          ]
        },
        {
          "name": "Cookstown",
          "slug": "cookstown",
          "postcode": "BT80",
          "nearby_areas": [
            "Fintona",
            "Omagh",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Strabane",
          "slug": "strabane",
          "postcode": "BT82",
          "nearby_areas": [
            "Castlederg",
            "Limavady",
            "Fintona",
            "Omagh",
            "Cookstown",
            "Dungannon",
            "Coalisland"
          ]
        },
        {
          "name": "Coalisland",
          "slug": "coalisland",
          "postcode": "BT71",
          "nearby_areas": [
            "Dungannon",
            "Cookstown",
            "Fintona",
            "Omagh",
            "Keady",
            "Markethill",
            "Lurgan"
          ]
        },
        {
          "name": "Fintona",
          "slug": "fintona",
          "postcode": "BT78",
          "nearby_areas": [
            "Omagh",
            "Cookstown",
            "Castlederg",
            "Lisnaskea",
            "Belleek",
            "Lurgan",
            "Ballinamallard"
          ]
        },
        {
          "name": "Castlederg",
          "slug": "castlederg",
          "postcode": "BT81",
          "nearby_areas": [
            "Fintona",
            "Omagh",
            "Cookstown",
            "Lisnaskea",
            "Belleek",
            "Ballinamallard",
            "Irvinestown"
          ]
        }
      ]
    },
    {
      "name": "Cumbria",
      "slug": "cumbria",
      "region": "North West England",
      "council_name": "Cumberland/Westmorland & Furness (unitary)",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "cool, wet and exposed in upland areas",
      "population": "500,000",
      "towns": [
        {
          "name": "Carlisle",
          "slug": "carlisle",
          "postcode": "CA1",
          "nearby_areas": [
            "Penrith",
            "Annan",
            "Keswick",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Barrow-in-Furness",
          "slug": "barrow-in-furness",
          "postcode": "LA14",
          "nearby_areas": [
            "Millom",
            "Ambleside",
            "Windermere",
            "Ulverston",
            "Grange-over-Sands",
            "Morecambe",
            "Fleetwood"
          ]
        },
        {
          "name": "Kendal",
          "slug": "kendal",
          "postcode": "LA9",
          "nearby_areas": [
            "Grange-over-Sands",
            "Ulverston",
            "Windermere",
            "Ambleside",
            "Morecambe",
            "Lancaster",
            "Millom"
          ]
        },
        {
          "name": "Workington",
          "slug": "workington",
          "postcode": "CA14",
          "nearby_areas": [
            "Maryport",
            "Whitehaven",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Keswick",
            "Carlisle",
            "Penrith"
          ]
        },
        {
          "name": "Whitehaven",
          "slug": "whitehaven",
          "postcode": "CA28",
          "nearby_areas": [
            "Workington",
            "Cockermouth",
            "Maryport",
            "Appleby-in-Westmorland",
            "Keswick",
            "Millom",
            "Ulverston"
          ]
        },
        {
          "name": "Penrith",
          "slug": "penrith",
          "postcode": "CA11",
          "nearby_areas": [
            "Carlisle",
            "Keswick",
            "Kendal",
            "Cockermouth",
            "Appleby-in-Westmorland",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Ulverston",
          "slug": "ulverston",
          "postcode": "LA12",
          "nearby_areas": [
            "Ambleside",
            "Windermere",
            "Grange-over-Sands",
            "Millom",
            "Barrow-in-Furness",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Windermere",
          "slug": "windermere",
          "postcode": "LA23",
          "nearby_areas": [
            "Ambleside",
            "Ulverston",
            "Grange-over-Sands",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Lancaster"
          ]
        },
        {
          "name": "Keswick",
          "slug": "keswick",
          "postcode": "CA12",
          "nearby_areas": [
            "Cockermouth",
            "Appleby-in-Westmorland",
            "Maryport",
            "Workington",
            "Whitehaven",
            "Penrith",
            "Carlisle"
          ]
        },
        {
          "name": "Cockermouth",
          "slug": "cockermouth",
          "postcode": "CA13",
          "nearby_areas": [
            "Appleby-in-Westmorland",
            "Keswick",
            "Maryport",
            "Workington",
            "Whitehaven",
            "Carlisle",
            "Penrith"
          ]
        },
        {
          "name": "Maryport",
          "slug": "maryport",
          "postcode": "CA15",
          "nearby_areas": [
            "Workington",
            "Appleby-in-Westmorland",
            "Cockermouth",
            "Keswick",
            "Whitehaven",
            "Carlisle",
            "Annan"
          ]
        },
        {
          "name": "Millom",
          "slug": "millom",
          "postcode": "LA18",
          "nearby_areas": [
            "Ulverston",
            "Barrow-in-Furness",
            "Ambleside",
            "Windermere",
            "Grange-over-Sands",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Ambleside",
          "slug": "ambleside",
          "postcode": "LA22",
          "nearby_areas": [
            "Windermere",
            "Ulverston",
            "Grange-over-Sands",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Lancaster"
          ]
        },
        {
          "name": "Grange-over-Sands",
          "slug": "grange-over-sands",
          "postcode": "LA11",
          "nearby_areas": [
            "Windermere",
            "Ulverston",
            "Ambleside",
            "Barrow-in-Furness",
            "Millom",
            "Morecambe",
            "Kendal"
          ]
        },
        {
          "name": "Appleby-in-Westmorland",
          "slug": "appleby-in-westmorland",
          "postcode": "CA16",
          "nearby_areas": [
            "Cockermouth",
            "Maryport",
            "Keswick",
            "Workington",
            "Whitehaven",
            "Carlisle",
            "Penrith"
          ]
        }
      ]
    },
    {
      "name": "Denbighshire",
      "slug": "denbighshire",
      "region": "Wales",
      "council_name": "Denbighshire County Council",
      "council_url": "https://www.denbighshire.gov.uk/",
      "climate": "wet uplands with coastal influence",
      "population": "95,000",
      "towns": [
        {
          "name": "Rhyl",
          "slug": "rhyl",
          "postcode": "LL18",
          "nearby_areas": [
            "Llangollen",
            "Prestatyn",
            "Corwen",
            "Abergele",
            "Betws-y-Coed",
            "Llanrwst",
            "Denbigh"
          ]
        },
        {
          "name": "Denbigh",
          "slug": "denbigh",
          "postcode": "LL16",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Gresford",
            "Ruthin",
            "Llangollen"
          ]
        },
        {
          "name": "Prestatyn",
          "slug": "prestatyn",
          "postcode": "LL19",
          "nearby_areas": [
            "Rhyl",
            "Llangollen",
            "Corwen",
            "Abergele",
            "Denbigh",
            "Betws-y-Coed",
            "Cefn Mawr"
          ]
        },
        {
          "name": "Ruthin",
          "slug": "ruthin",
          "postcode": "LL15",
          "nearby_areas": [
            "Gresford",
            "Denbigh",
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Mold"
          ]
        },
        {
          "name": "Corwen",
          "slug": "corwen",
          "postcode": "LL21",
          "nearby_areas": [
            "Llangollen",
            "Abergele",
            "Betws-y-Coed",
            "Rhyl",
            "Llanrwst",
            "Denbigh",
            "Prestatyn"
          ]
        },
        {
          "name": "Llangollen",
          "slug": "llangollen",
          "postcode": "LL20",
          "nearby_areas": [
            "Corwen",
            "Abergele",
            "Rhyl",
            "Betws-y-Coed",
            "Llanrwst",
            "Prestatyn",
            "Denbigh"
          ]
        }
      ]
    },
    {
      "name": "Derbyshire",
      "slug": "derbyshire",
      "region": "East Midlands",
      "council_name": "Derbyshire County Council",
      "council_url": "https://www.derbyshire.gov.uk/",
      "climate": "high moorland moisture and cold winters",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Derby",
          "slug": "derby",
          "postcode": "DE1",
          "nearby_areas": [
            "Burton upon Trent",
            "Bakewell",
            "Ripley",
            "Belper",
            "Ilkeston",
            "Heanor",
            "Swadlincote"
          ]
        },
        {
          "name": "Chesterfield",
          "slug": "chesterfield",
          "postcode": "S40",
          "nearby_areas": [
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Matlock",
            "Alfreton",
            "Dinnington",
            "Mansfield"
          ]
        },
        {
          "name": "Swadlincote",
          "slug": "swadlincote",
          "postcode": "DE11",
          "nearby_areas": [
            "Ashby-de-la-Zouch",
            "Coalville",
            "Derby",
            "Burton upon Trent",
            "Tamworth",
            "Lichfield",
            "Loughborough"
          ]
        },
        {
          "name": "Ilkeston",
          "slug": "ilkeston",
          "postcode": "DE7",
          "nearby_areas": [
            "Heanor",
            "Bakewell",
            "Nottingham",
            "Derby",
            "Belper",
            "Alfreton",
            "West Bridgford"
          ]
        },
        {
          "name": "Long Eaton",
          "slug": "long-eaton",
          "postcode": "NG10",
          "nearby_areas": [
            "Beeston",
            "Bingham",
            "Arnold",
            "Hucknall",
            "Ollerton",
            "Carlton",
            "West Bridgford"
          ]
        },
        {
          "name": "Glossop",
          "slug": "glossop",
          "postcode": "SK13",
          "nearby_areas": [
            "Hyde",
            "Buxton",
            "Ashton-under-Lyne",
            "Stockport",
            "Oldham",
            "Cheadle",
            "Manchester"
          ]
        },
        {
          "name": "Buxton",
          "slug": "buxton",
          "postcode": "SK17",
          "nearby_areas": [
            "Hyde",
            "Cheadle",
            "Stockport",
            "Glossop",
            "Wilmslow",
            "Macclesfield",
            "Ashton-under-Lyne"
          ]
        },
        {
          "name": "Ripley",
          "slug": "ripley",
          "postcode": "DE5",
          "nearby_areas": [
            "Belper",
            "Bakewell",
            "Burton upon Trent",
            "Derby",
            "Ashbourne",
            "Heanor",
            "Matlock"
          ]
        },
        {
          "name": "Matlock",
          "slug": "matlock",
          "postcode": "DE4",
          "nearby_areas": [
            "Alfreton",
            "Belper",
            "Chesterfield",
            "Ripley",
            "Bakewell",
            "Ashbourne",
            "Heanor"
          ]
        },
        {
          "name": "Belper",
          "slug": "belper",
          "postcode": "DE56",
          "nearby_areas": [
            "Bakewell",
            "Ripley",
            "Heanor",
            "Alfreton",
            "Derby",
            "Burton upon Trent",
            "Ilkeston"
          ]
        },
        {
          "name": "Heanor",
          "slug": "heanor",
          "postcode": "DE75",
          "nearby_areas": [
            "Ilkeston",
            "Bakewell",
            "Belper",
            "Alfreton",
            "Ripley",
            "Derby",
            "Nottingham"
          ]
        },
        {
          "name": "Alfreton",
          "slug": "alfreton",
          "postcode": "DE55",
          "nearby_areas": [
            "Heanor",
            "Bakewell",
            "Belper",
            "Matlock",
            "Ripley",
            "Ilkeston",
            "Mansfield"
          ]
        },
        {
          "name": "Ashbourne",
          "slug": "ashbourne",
          "postcode": "DE6",
          "nearby_areas": [
            "Ripley",
            "Belper",
            "Matlock",
            "Bakewell",
            "Uttoxeter",
            "Derby",
            "Burton upon Trent"
          ]
        },
        {
          "name": "Bolsover",
          "slug": "bolsover",
          "postcode": "S44",
          "nearby_areas": [
            "Penistone",
            "Stocksbridge",
            "Dinnington",
            "Sheffield",
            "Chesterfield",
            "Rotherham",
            "Hoyland"
          ]
        },
        {
          "name": "Bakewell",
          "slug": "bakewell",
          "postcode": "DE45",
          "nearby_areas": [
            "Belper",
            "Ripley",
            "Heanor",
            "Alfreton",
            "Derby",
            "Ilkeston",
            "Burton upon Trent"
          ]
        }
      ]
    },
    {
      "name": "Devon",
      "slug": "devon",
      "region": "South West England",
      "council_name": "Devon County Council",
      "council_url": "https://www.devon.gov.uk/",
      "climate": "mild, wet and windy coastal climate",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Plymouth",
          "slug": "plymouth",
          "postcode": "PL1",
          "nearby_areas": [
            "Torpoint",
            "Saltash",
            "Ivybridge",
            "Tavistock",
            "Fowey",
            "Looe",
            "Liskeard"
          ]
        },
        {
          "name": "Exeter",
          "slug": "exeter",
          "postcode": "EX1",
          "nearby_areas": [
            "Crediton",
            "Exmouth",
            "Dawlish",
            "Teignmouth",
            "Tiverton",
            "Sidmouth",
            "Newton Abbot"
          ]
        },
        {
          "name": "Torquay",
          "slug": "torquay",
          "postcode": "TQ1",
          "nearby_areas": [
            "Paignton",
            "Newton Abbot",
            "Teignmouth",
            "Totnes",
            "Dawlish",
            "Exmouth",
            "Kingsbridge"
          ]
        },
        {
          "name": "Paignton",
          "slug": "paignton",
          "postcode": "TQ3",
          "nearby_areas": [
            "Torquay",
            "Totnes",
            "Newton Abbot",
            "Teignmouth",
            "Dawlish",
            "Kingsbridge",
            "Exmouth"
          ]
        },
        {
          "name": "Barnstaple",
          "slug": "barnstaple",
          "postcode": "EX31",
          "nearby_areas": [
            "Bideford",
            "Ilfracombe",
            "Okehampton",
            "Crediton",
            "Tiverton",
            "Minehead",
            "Bude"
          ]
        },
        {
          "name": "Newton Abbot",
          "slug": "newton-abbot",
          "postcode": "TQ12",
          "nearby_areas": [
            "Teignmouth",
            "Torquay",
            "Paignton",
            "Dawlish",
            "Totnes",
            "Exmouth",
            "Exeter"
          ]
        },
        {
          "name": "Tiverton",
          "slug": "tiverton",
          "postcode": "EX16",
          "nearby_areas": [
            "Crediton",
            "Exeter",
            "Honiton",
            "Sidmouth",
            "Exmouth",
            "Taunton",
            "Dawlish"
          ]
        },
        {
          "name": "Bideford",
          "slug": "bideford",
          "postcode": "EX39",
          "nearby_areas": [
            "Barnstaple",
            "Ilfracombe",
            "Okehampton",
            "Bude",
            "Cardigan",
            "Crediton",
            "Lampeter"
          ]
        },
        {
          "name": "Exmouth",
          "slug": "exmouth",
          "postcode": "EX8",
          "nearby_areas": [
            "Dawlish",
            "Teignmouth",
            "Exeter",
            "Sidmouth",
            "Newton Abbot",
            "Torquay",
            "Paignton"
          ]
        },
        {
          "name": "Totnes",
          "slug": "totnes",
          "postcode": "TQ9",
          "nearby_areas": [
            "Paignton",
            "Torquay",
            "Newton Abbot",
            "Ivybridge",
            "Kingsbridge",
            "Teignmouth",
            "Dawlish"
          ]
        },
        {
          "name": "Teignmouth",
          "slug": "teignmouth",
          "postcode": "TQ14",
          "nearby_areas": [
            "Dawlish",
            "Newton Abbot",
            "Exmouth",
            "Torquay",
            "Paignton",
            "Totnes",
            "Exeter"
          ]
        },
        {
          "name": "Crediton",
          "slug": "crediton",
          "postcode": "EX17",
          "nearby_areas": [
            "Exeter",
            "Tiverton",
            "Okehampton",
            "Exmouth",
            "Dawlish",
            "Teignmouth",
            "Newton Abbot"
          ]
        },
        {
          "name": "Dawlish",
          "slug": "dawlish",
          "postcode": "EX7",
          "nearby_areas": [
            "Teignmouth",
            "Exmouth",
            "Newton Abbot",
            "Torquay",
            "Exeter",
            "Paignton",
            "Sidmouth"
          ]
        },
        {
          "name": "Okehampton",
          "slug": "okehampton",
          "postcode": "EX20",
          "nearby_areas": [
            "Tavistock",
            "Crediton",
            "Launceston",
            "Exeter",
            "Bideford",
            "Newton Abbot",
            "Barnstaple"
          ]
        },
        {
          "name": "Sidmouth",
          "slug": "sidmouth",
          "postcode": "EX10",
          "nearby_areas": [
            "Honiton",
            "Exmouth",
            "Dawlish",
            "Exeter",
            "Teignmouth",
            "Tiverton",
            "Newton Abbot"
          ]
        },
        {
          "name": "Honiton",
          "slug": "honiton",
          "postcode": "EX14",
          "nearby_areas": [
            "Sidmouth",
            "Chard",
            "Tiverton",
            "Exmouth",
            "Exeter",
            "Taunton",
            "Dawlish"
          ]
        },
        {
          "name": "Ivybridge",
          "slug": "ivybridge",
          "postcode": "PL21",
          "nearby_areas": [
            "Kingsbridge",
            "Plymouth",
            "Totnes",
            "Torpoint",
            "Saltash",
            "Tavistock",
            "Paignton"
          ]
        },
        {
          "name": "Kingsbridge",
          "slug": "kingsbridge",
          "postcode": "TQ7",
          "nearby_areas": [
            "Ivybridge",
            "Totnes",
            "Paignton",
            "Torquay",
            "Plymouth",
            "Newton Abbot",
            "Torpoint"
          ]
        },
        {
          "name": "Ilfracombe",
          "slug": "ilfracombe",
          "postcode": "EX34",
          "nearby_areas": [
            "Barnstaple",
            "Bideford",
            "Newcastle Emlyn",
            "Minehead",
            "Lampeter",
            "Porthcawl",
            "Cardigan"
          ]
        },
        {
          "name": "Tavistock",
          "slug": "tavistock",
          "postcode": "PL19",
          "nearby_areas": [
            "Saltash",
            "Plymouth",
            "Launceston",
            "Torpoint",
            "Okehampton",
            "Ivybridge",
            "Fowey"
          ]
        }
      ]
    },
    {
      "name": "Dorset",
      "slug": "dorset",
      "region": "South West England",
      "council_name": "Dorset Council",
      "council_url": "https://www.dorsetcouncil.gov.uk/",
      "climate": "mild coastal winters and sea air",
      "population": "800,000",
      "towns": [
        {
          "name": "Bournemouth",
          "slug": "bournemouth",
          "postcode": "BH1",
          "nearby_areas": [
            "Wimborne Minster",
            "Christchurch",
            "Poole",
            "Ferndown",
            "Swanage",
            "Wareham",
            "Verwood"
          ]
        },
        {
          "name": "Poole",
          "slug": "poole",
          "postcode": "BH15",
          "nearby_areas": [
            "Wimborne Minster",
            "Bournemouth",
            "Wareham",
            "Christchurch",
            "Ferndown",
            "Swanage",
            "Verwood"
          ]
        },
        {
          "name": "Weymouth",
          "slug": "weymouth",
          "postcode": "DT4",
          "nearby_areas": [
            "Dorchester",
            "Lyme Regis",
            "Bridport",
            "Wareham",
            "Blandford Forum",
            "Swanage",
            "Poole"
          ]
        },
        {
          "name": "Dorchester",
          "slug": "dorchester",
          "postcode": "DT1",
          "nearby_areas": [
            "Lyme Regis",
            "Weymouth",
            "Bridport",
            "Sherborne",
            "Yeovil",
            "Blandford Forum",
            "Wareham"
          ]
        },
        {
          "name": "Christchurch",
          "slug": "christchurch",
          "postcode": "BH23",
          "nearby_areas": [
            "Ferndown",
            "Wimborne Minster",
            "Bournemouth",
            "Poole",
            "Ringwood",
            "Verwood",
            "New Milton"
          ]
        },
        {
          "name": "Ferndown",
          "slug": "ferndown",
          "postcode": "BH22",
          "nearby_areas": [
            "Christchurch",
            "Wimborne Minster",
            "Verwood",
            "Bournemouth",
            "Ringwood",
            "Poole",
            "Blandford Forum"
          ]
        },
        {
          "name": "Wimborne Minster",
          "slug": "wimborne-minster",
          "postcode": "BH21",
          "nearby_areas": [
            "Bournemouth",
            "Poole",
            "Christchurch",
            "Ferndown",
            "Wareham",
            "Swanage",
            "Verwood"
          ]
        },
        {
          "name": "Bridport",
          "slug": "bridport",
          "postcode": "DT6",
          "nearby_areas": [
            "Lyme Regis",
            "Dorchester",
            "Crewkerne",
            "Chard",
            "Weymouth",
            "Yeovil",
            "Sherborne"
          ]
        },
        {
          "name": "Swanage",
          "slug": "swanage",
          "postcode": "BH19",
          "nearby_areas": [
            "Poole",
            "Bournemouth",
            "Wareham",
            "Wimborne Minster",
            "Christchurch",
            "Ferndown",
            "Verwood"
          ]
        },
        {
          "name": "Blandford Forum",
          "slug": "blandford-forum",
          "postcode": "DT11",
          "nearby_areas": [
            "Wareham",
            "Ferndown",
            "Poole",
            "Verwood",
            "Wimborne Minster",
            "Christchurch",
            "Bournemouth"
          ]
        },
        {
          "name": "Sherborne",
          "slug": "sherborne",
          "postcode": "DT9",
          "nearby_areas": [
            "Yeovil",
            "Lyme Regis",
            "Dorchester",
            "Crewkerne",
            "Blandford Forum",
            "Bridport",
            "Glastonbury"
          ]
        },
        {
          "name": "Gillingham",
          "slug": "gillingham",
          "postcode": "SP8",
          "nearby_areas": [
            "Andover",
            "Amesbury",
            "Salisbury",
            "Romsey",
            "Winchester",
            "Eastleigh",
            "Hungerford"
          ]
        },
        {
          "name": "Wareham",
          "slug": "wareham",
          "postcode": "BH20",
          "nearby_areas": [
            "Poole",
            "Swanage",
            "Wimborne Minster",
            "Bournemouth",
            "Blandford Forum",
            "Christchurch",
            "Ferndown"
          ]
        },
        {
          "name": "Verwood",
          "slug": "verwood",
          "postcode": "BH31",
          "nearby_areas": [
            "Ferndown",
            "Ringwood",
            "Christchurch",
            "Wimborne Minster",
            "Bournemouth",
            "Poole",
            "Blandford Forum"
          ]
        },
        {
          "name": "Lyme Regis",
          "slug": "lyme-regis",
          "postcode": "DT7",
          "nearby_areas": [
            "Dorchester",
            "Bridport",
            "Sherborne",
            "Weymouth",
            "Yeovil",
            "Crewkerne",
            "Blandford Forum"
          ]
        }
      ]
    },
    {
      "name": "Dumfries and Galloway",
      "slug": "dumfries-and-galloway",
      "region": "Scotland",
      "council_name": "Dumfries and Galloway Council",
      "council_url": "https://www.dumgal.gov.uk/",
      "climate": "wet, mild and rural",
      "population": "145,000",
      "towns": [
        {
          "name": "Dumfries",
          "slug": "dumfries",
          "postcode": "DG1",
          "nearby_areas": [
            "Lockerbie",
            "Annan",
            "Kirkcudbright",
            "Castle Douglas",
            "Maryport",
            "Newton Stewart",
            "Appleby-in-Westmorland"
          ]
        },
        {
          "name": "Stranraer",
          "slug": "stranraer",
          "postcode": "DG9",
          "nearby_areas": [
            "Newton Stewart",
            "Girvan",
            "Castle Douglas",
            "Donaghadee",
            "Kirkcudbright",
            "Bangor",
            "Larne"
          ]
        },
        {
          "name": "Annan",
          "slug": "annan",
          "postcode": "DG12",
          "nearby_areas": [
            "Dumfries",
            "Carlisle",
            "Maryport",
            "Keswick",
            "Appleby-in-Westmorland",
            "Lockerbie",
            "Cockermouth"
          ]
        },
        {
          "name": "Lockerbie",
          "slug": "lockerbie",
          "postcode": "DG11",
          "nearby_areas": [
            "Kirkcudbright",
            "Castle Douglas",
            "Dumfries",
            "Newton Stewart",
            "Annan",
            "Maryport",
            "Workington"
          ]
        },
        {
          "name": "Castle Douglas",
          "slug": "castle-douglas",
          "postcode": "DG7",
          "nearby_areas": [
            "Kirkcudbright",
            "Newton Stewart",
            "Lockerbie",
            "Dumfries",
            "Stranraer",
            "Girvan",
            "Cumnock"
          ]
        },
        {
          "name": "Kirkcudbright",
          "slug": "kirkcudbright",
          "postcode": "DG6",
          "nearby_areas": [
            "Castle Douglas",
            "Lockerbie",
            "Newton Stewart",
            "Dumfries",
            "Stranraer",
            "Annan",
            "Girvan"
          ]
        },
        {
          "name": "Newton Stewart",
          "slug": "newton-stewart",
          "postcode": "DG8",
          "nearby_areas": [
            "Castle Douglas",
            "Kirkcudbright",
            "Lockerbie",
            "Stranraer",
            "Girvan",
            "Dumfries",
            "Cumnock"
          ]
        }
      ]
    },
    {
      "name": "Dundee City",
      "slug": "dundee-city",
      "region": "Scotland",
      "council_name": "Dundee City Council",
      "council_url": "https://www.dundeecity.gov.uk/",
      "climate": "cool east coast climate",
      "population": "145,000",
      "towns": [
        {
          "name": "Dundee",
          "slug": "dundee",
          "postcode": "DD1",
          "nearby_areas": [
            "Lochee",
            "Broughty Ferry",
            "Monifieth",
            "Carnoustie",
            "Cupar",
            "St Andrews",
            "Forfar"
          ]
        },
        {
          "name": "Broughty Ferry",
          "slug": "broughty-ferry",
          "postcode": "DD5",
          "nearby_areas": [
            "Monifieth",
            "Lochee",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Kirriemuir",
            "Arbroath"
          ]
        },
        {
          "name": "Lochee",
          "slug": "lochee",
          "postcode": "DD2",
          "nearby_areas": [
            "Broughty Ferry",
            "Monifieth",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Dundee",
            "Kirriemuir"
          ]
        },
        {
          "name": "Monifieth",
          "slug": "monifieth",
          "postcode": "DD5",
          "nearby_areas": [
            "Broughty Ferry",
            "Lochee",
            "Montrose",
            "Forfar",
            "Carnoustie",
            "Kirriemuir",
            "Arbroath"
          ]
        }
      ]
    },
    {
      "name": "East Ayrshire",
      "slug": "east-ayrshire",
      "region": "Scotland",
      "council_name": "East Ayrshire Council",
      "council_url": "https://www.east-ayrshire.gov.uk/",
      "climate": "wet west coast inland climate",
      "population": "120,000",
      "towns": [
        {
          "name": "Kilmarnock",
          "slug": "kilmarnock",
          "postcode": "KA1",
          "nearby_areas": [
            "Stewarton",
            "Auchinleck",
            "Mauchline",
            "Maybole",
            "Dalmellington",
            "Irvine",
            "Stevenston"
          ]
        },
        {
          "name": "Cumnock",
          "slug": "cumnock",
          "postcode": "KA18",
          "nearby_areas": [
            "Auchinleck",
            "Kilmarnock",
            "Stewarton",
            "Dalmellington",
            "Mauchline",
            "Maybole",
            "Ayr"
          ]
        },
        {
          "name": "Stewarton",
          "slug": "stewarton",
          "postcode": "KA3",
          "nearby_areas": [
            "Mauchline",
            "Stevenston",
            "Prestwick",
            "Maybole",
            "Dalmellington",
            "Troon",
            "Ardrossan"
          ]
        },
        {
          "name": "Auchinleck",
          "slug": "auchinleck",
          "postcode": "KA18",
          "nearby_areas": [
            "Maybole",
            "Stewarton",
            "Dalmellington",
            "Mauchline",
            "Kilmarnock",
            "Prestwick",
            "Stevenston"
          ]
        },
        {
          "name": "Mauchline",
          "slug": "mauchline",
          "postcode": "KA5",
          "nearby_areas": [
            "Dalmellington",
            "Prestwick",
            "Stevenston",
            "Stewarton",
            "Troon",
            "Maybole",
            "Ardrossan"
          ]
        },
        {
          "name": "Dalmellington",
          "slug": "dalmellington",
          "postcode": "KA6",
          "nearby_areas": [
            "Mauchline",
            "Prestwick",
            "Stevenston",
            "Troon",
            "Maybole",
            "Stewarton",
            "Ardrossan"
          ]
        }
      ]
    },
    {
      "name": "East Dunbartonshire",
      "slug": "east-dunbartonshire",
      "region": "Scotland",
      "council_name": "East Dunbartonshire Council",
      "council_url": "https://www.eastdunbarton.gov.uk/",
      "climate": "cool, damp west central climate",
      "population": "110,000",
      "towns": [
        {
          "name": "Bearsden",
          "slug": "bearsden",
          "postcode": "G61",
          "nearby_areas": [
            "Milngavie",
            "Balfron",
            "Bishopbriggs",
            "Kilsyth",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        },
        {
          "name": "Milngavie",
          "slug": "milngavie",
          "postcode": "G62",
          "nearby_areas": [
            "Bearsden",
            "Balfron",
            "Bishopbriggs",
            "Kilsyth",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        },
        {
          "name": "Kirkintilloch",
          "slug": "kirkintilloch",
          "postcode": "G66",
          "nearby_areas": [
            "Lennoxtown",
            "Cumbernauld",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        },
        {
          "name": "Bishopbriggs",
          "slug": "bishopbriggs",
          "postcode": "G64",
          "nearby_areas": [
            "Kilsyth",
            "Balfron",
            "Kirkintilloch",
            "Lennoxtown",
            "Milngavie",
            "Bearsden",
            "Cumbernauld"
          ]
        },
        {
          "name": "Lennoxtown",
          "slug": "lennoxtown",
          "postcode": "G66",
          "nearby_areas": [
            "Kirkintilloch",
            "Cumbernauld",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        }
      ]
    },
    {
      "name": "East Lothian",
      "slug": "east-lothian",
      "region": "Scotland",
      "council_name": "East Lothian Council",
      "council_url": "https://www.eastlothian.gov.uk/",
      "climate": "cool, breezy and relatively dry",
      "population": "110,000",
      "towns": [
        {
          "name": "Musselburgh",
          "slug": "musselburgh",
          "postcode": "EH21",
          "nearby_areas": [
            "Loanhead",
            "Dalkeith",
            "Bonnyrigg",
            "Gorebridge",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Haddington",
          "slug": "haddington",
          "postcode": "EH41",
          "nearby_areas": [
            "Tranent",
            "North Berwick",
            "Prestonpans",
            "Dunbar",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Tranent",
          "slug": "tranent",
          "postcode": "EH33",
          "nearby_areas": [
            "Prestonpans",
            "Musselburgh",
            "Haddington",
            "Bonnyrigg",
            "Loanhead",
            "Portobello",
            "Dalkeith"
          ]
        },
        {
          "name": "North Berwick",
          "slug": "north-berwick",
          "postcode": "EH39",
          "nearby_areas": [
            "Haddington",
            "Dunbar",
            "Tranent",
            "Prestonpans",
            "Musselburgh",
            "Bonnyrigg",
            "Portobello"
          ]
        },
        {
          "name": "Dunbar",
          "slug": "dunbar",
          "postcode": "EH42",
          "nearby_areas": [
            "North Berwick",
            "Haddington",
            "Tranent",
            "Prestonpans",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead"
          ]
        },
        {
          "name": "Prestonpans",
          "slug": "prestonpans",
          "postcode": "EH32",
          "nearby_areas": [
            "Tranent",
            "Musselburgh",
            "Bonnyrigg",
            "Loanhead",
            "Portobello",
            "Corstorphine",
            "Dalkeith"
          ]
        }
      ]
    },
    {
      "name": "East Renfrewshire",
      "slug": "east-renfrewshire",
      "region": "Scotland",
      "council_name": "East Renfrewshire Council",
      "council_url": "https://www.eastrenfrewshire.gov.uk/",
      "climate": "cool, wet west central climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Giffnock",
          "slug": "giffnock",
          "postcode": "G46",
          "nearby_areas": [
            "Govan",
            "Pollokshields",
            "Shawlands",
            "Johnstone",
            "Dumbarton",
            "Renfrew",
            "Linwood"
          ]
        },
        {
          "name": "Newton Mearns",
          "slug": "newton-mearns",
          "postcode": "G77",
          "nearby_areas": [
            "Barrhead",
            "Clarkston",
            "Eaglesham",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Barrhead",
          "slug": "barrhead",
          "postcode": "G78",
          "nearby_areas": [
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Clarkston",
          "slug": "clarkston",
          "postcode": "G76",
          "nearby_areas": [
            "Eaglesham",
            "Newton Mearns",
            "Barrhead",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        },
        {
          "name": "Eaglesham",
          "slug": "eaglesham",
          "postcode": "G76",
          "nearby_areas": [
            "Clarkston",
            "Newton Mearns",
            "Barrhead",
            "East Kilbride",
            "Rutherglen",
            "Clydebank",
            "Cambuslang"
          ]
        }
      ]
    },
    {
      "name": "East Riding of Yorkshire",
      "slug": "east-riding-of-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "East Riding of Yorkshire Council",
      "council_url": "https://www.eastriding.gov.uk/",
      "climate": "cool coastal winds and damp winters",
      "population": "600,000",
      "towns": [
        {
          "name": "Hull",
          "slug": "hull",
          "postcode": "HU1",
          "nearby_areas": [
            "Hedon",
            "Cottingham",
            "Beverley",
            "Hessle",
            "Hornsea",
            "Withernsea",
            "Driffield"
          ]
        },
        {
          "name": "Beverley",
          "slug": "beverley",
          "postcode": "HU17",
          "nearby_areas": [
            "Cottingham",
            "Hedon",
            "Hull",
            "Hessle",
            "Driffield",
            "Hornsea",
            "Bridlington"
          ]
        },
        {
          "name": "Bridlington",
          "slug": "bridlington",
          "postcode": "YO15",
          "nearby_areas": [
            "Filey",
            "Driffield",
            "Hornsea",
            "Scarborough",
            "Beverley",
            "Pocklington",
            "Market Weighton"
          ]
        },
        {
          "name": "Goole",
          "slug": "goole",
          "postcode": "DN14",
          "nearby_areas": [
            "Howden",
            "Snaith",
            "Selby",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Hessle"
          ]
        },
        {
          "name": "Driffield",
          "slug": "driffield",
          "postcode": "YO25",
          "nearby_areas": [
            "Beverley",
            "Bridlington",
            "Hornsea",
            "Pocklington",
            "Market Weighton",
            "Cottingham",
            "Hull"
          ]
        },
        {
          "name": "Hessle",
          "slug": "hessle",
          "postcode": "HU13",
          "nearby_areas": [
            "Cottingham",
            "Hedon",
            "Hull",
            "Beverley",
            "Immingham",
            "Brigg",
            "Howden"
          ]
        },
        {
          "name": "Cottingham",
          "slug": "cottingham",
          "postcode": "HU16",
          "nearby_areas": [
            "Hedon",
            "Hessle",
            "Beverley",
            "Hull",
            "Hornsea",
            "Driffield",
            "Immingham"
          ]
        },
        {
          "name": "Hornsea",
          "slug": "hornsea",
          "postcode": "HU18",
          "nearby_areas": [
            "Hull",
            "Beverley",
            "Hedon",
            "Bridlington",
            "Driffield",
            "Cottingham",
            "Withernsea"
          ]
        },
        {
          "name": "Withernsea",
          "slug": "withernsea",
          "postcode": "HU19",
          "nearby_areas": [
            "Hull",
            "Hornsea",
            "Grimsby",
            "Cleethorpes",
            "Hedon",
            "Immingham",
            "Cottingham"
          ]
        },
        {
          "name": "Market Weighton",
          "slug": "market-weighton",
          "postcode": "YO43",
          "nearby_areas": [
            "Pocklington",
            "Malton",
            "Pickering",
            "Driffield",
            "Scarborough",
            "Filey",
            "Bridlington"
          ]
        },
        {
          "name": "Pocklington",
          "slug": "pocklington",
          "postcode": "YO42",
          "nearby_areas": [
            "Market Weighton",
            "Malton",
            "Pickering",
            "Driffield",
            "Scarborough",
            "Filey",
            "Bridlington"
          ]
        },
        {
          "name": "Howden",
          "slug": "howden",
          "postcode": "DN14",
          "nearby_areas": [
            "Snaith",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Goole",
            "Brigg",
            "Hessle"
          ]
        },
        {
          "name": "Snaith",
          "slug": "snaith",
          "postcode": "DN14",
          "nearby_areas": [
            "Howden",
            "Conisbrough",
            "Thorne",
            "Scunthorpe",
            "Goole",
            "Brigg",
            "Hessle"
          ]
        },
        {
          "name": "Hedon",
          "slug": "hedon",
          "postcode": "HU12",
          "nearby_areas": [
            "Hull",
            "Cottingham",
            "Hessle",
            "Beverley",
            "Hornsea",
            "Immingham",
            "Withernsea"
          ]
        }
      ]
    },
    {
      "name": "East Sussex",
      "slug": "east-sussex",
      "region": "South East England",
      "council_name": "East Sussex County Council",
      "council_url": "https://www.eastsussex.gov.uk/",
      "climate": "mild coastal conditions with sea winds",
      "population": "850,000",
      "towns": [
        {
          "name": "Brighton",
          "slug": "brighton",
          "postcode": "BN1",
          "nearby_areas": [
            "Hove",
            "Peacehaven",
            "Arundel",
            "Lewes",
            "Newhaven",
            "Seaford",
            "Shoreham-by-Sea"
          ]
        },
        {
          "name": "Hove",
          "slug": "hove",
          "postcode": "BN3",
          "nearby_areas": [
            "Brighton",
            "Peacehaven",
            "Arundel",
            "Lewes",
            "Newhaven",
            "Seaford",
            "Shoreham-by-Sea"
          ]
        },
        {
          "name": "Eastbourne",
          "slug": "eastbourne",
          "postcode": "BN21",
          "nearby_areas": [
            "Hailsham",
            "Seaford",
            "Bexhill-on-Sea",
            "Newhaven",
            "Peacehaven",
            "Rye",
            "Battle"
          ]
        },
        {
          "name": "Hastings",
          "slug": "hastings",
          "postcode": "TN34",
          "nearby_areas": [
            "Bexhill-on-Sea",
            "Battle",
            "Rye",
            "Eastbourne",
            "Hailsham",
            "Heathfield",
            "Ashford"
          ]
        },
        {
          "name": "Bexhill-on-Sea",
          "slug": "bexhill-on-sea",
          "postcode": "TN39",
          "nearby_areas": [
            "Hastings",
            "Battle",
            "Rye",
            "Hailsham",
            "Eastbourne",
            "Heathfield",
            "Ashford"
          ]
        },
        {
          "name": "Lewes",
          "slug": "lewes",
          "postcode": "BN7",
          "nearby_areas": [
            "Hove",
            "Brighton",
            "Peacehaven",
            "Newhaven",
            "Uckfield",
            "Seaford",
            "Burgess Hill"
          ]
        },
        {
          "name": "Uckfield",
          "slug": "uckfield",
          "postcode": "TN22",
          "nearby_areas": [
            "Heathfield",
            "Ashford",
            "Crowborough",
            "Lewes",
            "Hailsham",
            "Haywards Heath",
            "Burgess Hill"
          ]
        },
        {
          "name": "Crowborough",
          "slug": "crowborough",
          "postcode": "TN6",
          "nearby_areas": [
            "Heathfield",
            "Tunbridge Wells",
            "Ashford",
            "Uckfield",
            "East Grinstead",
            "Tonbridge",
            "Haywards Heath"
          ]
        },
        {
          "name": "Seaford",
          "slug": "seaford",
          "postcode": "BN25",
          "nearby_areas": [
            "Newhaven",
            "Peacehaven",
            "Hove",
            "Lewes",
            "Brighton",
            "Eastbourne",
            "Hailsham"
          ]
        },
        {
          "name": "Newhaven",
          "slug": "newhaven",
          "postcode": "BN9",
          "nearby_areas": [
            "Peacehaven",
            "Seaford",
            "Hove",
            "Brighton",
            "Lewes",
            "Hailsham",
            "Arundel"
          ]
        },
        {
          "name": "Rye",
          "slug": "rye",
          "postcode": "TN31",
          "nearby_areas": [
            "Battle",
            "Bexhill-on-Sea",
            "Hastings",
            "Hailsham",
            "Heathfield",
            "Ashford",
            "Eastbourne"
          ]
        },
        {
          "name": "Battle",
          "slug": "battle",
          "postcode": "TN33",
          "nearby_areas": [
            "Rye",
            "Bexhill-on-Sea",
            "Hastings",
            "Hailsham",
            "Heathfield",
            "Eastbourne",
            "Ashford"
          ]
        },
        {
          "name": "Heathfield",
          "slug": "heathfield",
          "postcode": "TN21",
          "nearby_areas": [
            "Ashford",
            "Crowborough",
            "Uckfield",
            "Tunbridge Wells",
            "Hailsham",
            "Rye",
            "Lewes"
          ]
        },
        {
          "name": "Hailsham",
          "slug": "hailsham",
          "postcode": "BN27",
          "nearby_areas": [
            "Eastbourne",
            "Rye",
            "Seaford",
            "Bexhill-on-Sea",
            "Uckfield",
            "Newhaven",
            "Heathfield"
          ]
        },
        {
          "name": "Peacehaven",
          "slug": "peacehaven",
          "postcode": "BN10",
          "nearby_areas": [
            "Newhaven",
            "Hove",
            "Brighton",
            "Seaford",
            "Lewes",
            "Arundel",
            "Hailsham"
          ]
        }
      ]
    },
    {
      "name": "Essex",
      "slug": "essex",
      "region": "East of England",
      "council_name": "Essex County Council",
      "council_url": "https://www.essex.gov.uk/",
      "climate": "cold easterly winds and high moisture",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Chelmsford",
          "slug": "chelmsford",
          "postcode": "CM1",
          "nearby_areas": [
            "Billericay",
            "Bishop's Stortford",
            "Witham",
            "Wickford",
            "Maldon",
            "Braintree",
            "Brentwood"
          ]
        },
        {
          "name": "Colchester",
          "slug": "colchester",
          "postcode": "CO1",
          "nearby_areas": [
            "Halstead",
            "Clacton-on-Sea",
            "Witham",
            "Sudbury",
            "Braintree",
            "Maldon",
            "Harwich"
          ]
        },
        {
          "name": "Southend-on-Sea",
          "slug": "southend-on-sea",
          "postcode": "SS1",
          "nearby_areas": [
            "Rayleigh",
            "Canvey Island",
            "Wickford",
            "Basildon",
            "Maldon",
            "Billericay",
            "Chelmsford"
          ]
        },
        {
          "name": "Basildon",
          "slug": "basildon",
          "postcode": "SS13",
          "nearby_areas": [
            "Wickford",
            "Billericay",
            "Rayleigh",
            "Canvey Island",
            "Brentwood",
            "Southend-on-Sea",
            "Grays"
          ]
        },
        {
          "name": "Harlow",
          "slug": "harlow",
          "postcode": "CM20",
          "nearby_areas": [
            "Epping",
            "Hertford",
            "Loughton",
            "Bishop's Stortford",
            "Ilford",
            "Brentwood",
            "Welwyn Garden City"
          ]
        },
        {
          "name": "Brentwood",
          "slug": "brentwood",
          "postcode": "CM14",
          "nearby_areas": [
            "Billericay",
            "Basildon",
            "Bishop's Stortford",
            "Wickford",
            "Epping",
            "Grays",
            "Loughton"
          ]
        },
        {
          "name": "Braintree",
          "slug": "braintree",
          "postcode": "CM7",
          "nearby_areas": [
            "Witham",
            "Chelmsford",
            "Maldon",
            "Sudbury",
            "Colchester",
            "Bishop's Stortford",
            "Saffron Walden"
          ]
        },
        {
          "name": "Clacton-on-Sea",
          "slug": "clacton-on-sea",
          "postcode": "CO15",
          "nearby_areas": [
            "Harwich",
            "Colchester",
            "Halstead",
            "Felixstowe",
            "Maldon",
            "Ipswich",
            "Witham"
          ]
        },
        {
          "name": "Witham",
          "slug": "witham",
          "postcode": "CM8",
          "nearby_areas": [
            "Maldon",
            "Braintree",
            "Chelmsford",
            "Colchester",
            "Wickford",
            "Rayleigh",
            "Billericay"
          ]
        },
        {
          "name": "Maldon",
          "slug": "maldon",
          "postcode": "CM9",
          "nearby_areas": [
            "Witham",
            "Chelmsford",
            "Rayleigh",
            "Wickford",
            "Braintree",
            "Southend-on-Sea",
            "Billericay"
          ]
        },
        {
          "name": "Grays",
          "slug": "grays",
          "postcode": "RM17",
          "nearby_areas": [
            "Romford",
            "Bexleyheath",
            "Gravesend",
            "Dartford",
            "Basildon",
            "Brentwood",
            "Billericay"
          ]
        },
        {
          "name": "Rayleigh",
          "slug": "rayleigh",
          "postcode": "SS6",
          "nearby_areas": [
            "Wickford",
            "Canvey Island",
            "Basildon",
            "Southend-on-Sea",
            "Billericay",
            "Maldon",
            "Chelmsford"
          ]
        },
        {
          "name": "Billericay",
          "slug": "billericay",
          "postcode": "CM12",
          "nearby_areas": [
            "Wickford",
            "Basildon",
            "Brentwood",
            "Chelmsford",
            "Rayleigh",
            "Bishop's Stortford",
            "Canvey Island"
          ]
        },
        {
          "name": "Wickford",
          "slug": "wickford",
          "postcode": "SS11",
          "nearby_areas": [
            "Basildon",
            "Rayleigh",
            "Billericay",
            "Canvey Island",
            "Chelmsford",
            "Brentwood",
            "Southend-on-Sea"
          ]
        },
        {
          "name": "Canvey Island",
          "slug": "canvey-island",
          "postcode": "SS8",
          "nearby_areas": [
            "Rayleigh",
            "Basildon",
            "Southend-on-Sea",
            "Wickford",
            "Billericay",
            "Grays",
            "Rochester"
          ]
        },
        {
          "name": "Loughton",
          "slug": "loughton",
          "postcode": "IG10",
          "nearby_areas": [
            "Ilford",
            "Epping",
            "Harlow",
            "Brentwood",
            "Bishop's Stortford",
            "Hertford",
            "Billericay"
          ]
        },
        {
          "name": "Epping",
          "slug": "epping",
          "postcode": "CM16",
          "nearby_areas": [
            "Loughton",
            "Harlow",
            "Ilford",
            "Bishop's Stortford",
            "Brentwood",
            "Hertford",
            "Billericay"
          ]
        },
        {
          "name": "Saffron Walden",
          "slug": "saffron-walden",
          "postcode": "CB10",
          "nearby_areas": [
            "Haverhill",
            "Sawston",
            "Histon",
            "Cambridge",
            "Braintree",
            "Harlow",
            "Newmarket"
          ]
        },
        {
          "name": "Halstead",
          "slug": "halstead",
          "postcode": "CO9",
          "nearby_areas": [
            "Colchester",
            "Sudbury",
            "Ipswich",
            "Clacton-on-Sea",
            "Harwich",
            "Hadleigh",
            "Witham"
          ]
        },
        {
          "name": "Harwich",
          "slug": "harwich",
          "postcode": "CO12",
          "nearby_areas": [
            "Felixstowe",
            "Ipswich",
            "Woodbridge",
            "Clacton-on-Sea",
            "Halstead",
            "Hadleigh",
            "Colchester"
          ]
        }
      ]
    },
    {
      "name": "Falkirk",
      "slug": "falkirk",
      "region": "Scotland",
      "council_name": "Falkirk Council",
      "council_url": "https://www.falkirk.gov.uk/",
      "climate": "cool, damp central belt climate",
      "population": "160,000",
      "towns": [
        {
          "name": "Falkirk",
          "slug": "falkirk",
          "postcode": "FK1",
          "nearby_areas": [
            "Grangemouth",
            "Larbert",
            "Stenhousemuir",
            "Denny",
            "Linlithgow",
            "Bathgate",
            "Bridge of Allan"
          ]
        },
        {
          "name": "Grangemouth",
          "slug": "grangemouth",
          "postcode": "FK3",
          "nearby_areas": [
            "Larbert",
            "Stenhousemuir",
            "Denny",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Falkirk"
          ]
        },
        {
          "name": "Bo'ness",
          "slug": "bo-ness",
          "postcode": "EH51",
          "nearby_areas": [
            "Armadale",
            "Whitburn",
            "Newbridge",
            "Broxburn",
            "Livingston",
            "Edinburgh",
            "Penicuik"
          ]
        },
        {
          "name": "Denny",
          "slug": "denny",
          "postcode": "FK6",
          "nearby_areas": [
            "Larbert",
            "Stenhousemuir",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Grangemouth",
            "Stirling"
          ]
        },
        {
          "name": "Larbert",
          "slug": "larbert",
          "postcode": "FK5",
          "nearby_areas": [
            "Stenhousemuir",
            "Denny",
            "Grangemouth",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Stirling"
          ]
        },
        {
          "name": "Stenhousemuir",
          "slug": "stenhousemuir",
          "postcode": "FK5",
          "nearby_areas": [
            "Larbert",
            "Denny",
            "Grangemouth",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Stirling"
          ]
        }
      ]
    },
    {
      "name": "Fife",
      "slug": "fife",
      "region": "Scotland",
      "council_name": "Fife Council",
      "council_url": "https://www.fife.gov.uk/",
      "climate": "cool coastal climate with damp winters",
      "population": "375,000",
      "towns": [
        {
          "name": "Dunfermline",
          "slug": "dunfermline",
          "postcode": "KY12",
          "nearby_areas": [
            "Linlithgow",
            "Kinross",
            "Broxburn",
            "Inverkeithing",
            "Rosyth",
            "Newbridge",
            "Anstruther"
          ]
        },
        {
          "name": "Kirkcaldy",
          "slug": "kirkcaldy",
          "postcode": "KY1",
          "nearby_areas": [
            "Cowdenbeath",
            "Leven",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Cupar"
          ]
        },
        {
          "name": "Glenrothes",
          "slug": "glenrothes",
          "postcode": "KY7",
          "nearby_areas": [
            "Cowdenbeath",
            "Leven",
            "Kirkcaldy",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Cupar"
          ]
        },
        {
          "name": "St Andrews",
          "slug": "st-andrews",
          "postcode": "KY16",
          "nearby_areas": [
            "Cupar",
            "Dundee",
            "Carnoustie",
            "Lochee",
            "Glenrothes",
            "Kirkcaldy",
            "Cowdenbeath"
          ]
        },
        {
          "name": "Cowdenbeath",
          "slug": "cowdenbeath",
          "postcode": "KY4",
          "nearby_areas": [
            "Kirkcaldy",
            "Leven",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Kinross"
          ]
        },
        {
          "name": "Leven",
          "slug": "leven",
          "postcode": "KY8",
          "nearby_areas": [
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Anstruther",
            "Inverkeithing",
            "Rosyth",
            "Kinross"
          ]
        },
        {
          "name": "Cupar",
          "slug": "cupar",
          "postcode": "KY15",
          "nearby_areas": [
            "St Andrews",
            "Kirkcaldy",
            "Cowdenbeath",
            "Glenrothes",
            "Leven",
            "Dundee",
            "Anstruther"
          ]
        },
        {
          "name": "Rosyth",
          "slug": "rosyth",
          "postcode": "KY11",
          "nearby_areas": [
            "Inverkeithing",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        },
        {
          "name": "Inverkeithing",
          "slug": "inverkeithing",
          "postcode": "KY11",
          "nearby_areas": [
            "Rosyth",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        },
        {
          "name": "Anstruther",
          "slug": "anstruther",
          "postcode": "KY10",
          "nearby_areas": [
            "Inverkeithing",
            "Rosyth",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Glenrothes",
            "Kinross"
          ]
        }
      ]
    },
    {
      "name": "Flintshire",
      "slug": "flintshire",
      "region": "Wales",
      "council_name": "Flintshire County Council",
      "council_url": "https://www.flintshire.gov.uk/",
      "climate": "mild, damp and coastal",
      "population": "160,000",
      "towns": [
        {
          "name": "Mold",
          "slug": "mold",
          "postcode": "CH7",
          "nearby_areas": [
            "Buckley",
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Flint",
            "Risca",
            "Ruthin"
          ]
        },
        {
          "name": "Flint",
          "slug": "flint",
          "postcode": "CH6",
          "nearby_areas": [
            "Risca",
            "Connah's Quay",
            "Shotton",
            "Holywell",
            "Mold",
            "Buckley",
            "Bebington"
          ]
        },
        {
          "name": "Connah's Quay",
          "slug": "connah-s-quay",
          "postcode": "CH5",
          "nearby_areas": [
            "Shotton",
            "Holywell",
            "Buckley",
            "Flint",
            "Mold",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Buckley",
          "slug": "buckley",
          "postcode": "CH7",
          "nearby_areas": [
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Mold",
            "Flint",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Holywell",
          "slug": "holywell",
          "postcode": "CH8",
          "nearby_areas": [
            "Connah's Quay",
            "Shotton",
            "Buckley",
            "Mold",
            "Flint",
            "Risca",
            "Chester"
          ]
        },
        {
          "name": "Shotton",
          "slug": "shotton",
          "postcode": "CH5",
          "nearby_areas": [
            "Connah's Quay",
            "Holywell",
            "Buckley",
            "Flint",
            "Mold",
            "Risca",
            "Chester"
          ]
        }
      ]
    },
    {
      "name": "Glasgow City",
      "slug": "glasgow-city",
      "region": "Scotland",
      "council_name": "Glasgow City Council",
      "council_url": "https://www.glasgow.gov.uk/",
      "climate": "wet west coast urban climate",
      "population": "635,000",
      "towns": [
        {
          "name": "Glasgow",
          "slug": "glasgow",
          "postcode": "G1",
          "nearby_areas": [
            "Partick",
            "Maryhill",
            "Erskine",
            "Dennistoun",
            "Pollokshields",
            "Shawlands",
            "Bishopton"
          ]
        },
        {
          "name": "Partick",
          "slug": "partick",
          "postcode": "G11",
          "nearby_areas": [
            "Maryhill",
            "Glasgow",
            "Erskine",
            "Dennistoun",
            "Bishopton",
            "Pollokshields",
            "Shawlands"
          ]
        },
        {
          "name": "Shawlands",
          "slug": "shawlands",
          "postcode": "G41",
          "nearby_areas": [
            "Pollokshields",
            "Giffnock",
            "Govan",
            "Dennistoun",
            "Johnstone",
            "Dumbarton",
            "Bishopton"
          ]
        },
        {
          "name": "Pollokshields",
          "slug": "pollokshields",
          "postcode": "G41",
          "nearby_areas": [
            "Shawlands",
            "Giffnock",
            "Govan",
            "Dennistoun",
            "Johnstone",
            "Dumbarton",
            "Bishopton"
          ]
        },
        {
          "name": "Maryhill",
          "slug": "maryhill",
          "postcode": "G20",
          "nearby_areas": [
            "Erskine",
            "Partick",
            "Dennistoun",
            "Bishopton",
            "Pollokshields",
            "Shawlands",
            "Giffnock"
          ]
        },
        {
          "name": "Dennistoun",
          "slug": "dennistoun",
          "postcode": "G31",
          "nearby_areas": [
            "Erskine",
            "Pollokshields",
            "Shawlands",
            "Bishopton",
            "Maryhill",
            "Giffnock",
            "Govan"
          ]
        },
        {
          "name": "Govan",
          "slug": "govan",
          "postcode": "G51",
          "nearby_areas": [
            "Dumbarton",
            "Giffnock",
            "Johnstone",
            "Renfrew",
            "Bearsden",
            "Linwood",
            "Pollokshields"
          ]
        }
      ]
    },
    {
      "name": "Gloucestershire",
      "slug": "gloucestershire",
      "region": "South West England",
      "council_name": "Gloucestershire County Council",
      "council_url": "https://www.gloucestershire.gov.uk/",
      "climate": "mild, damp winters with Cotswold exposure",
      "population": "950,000",
      "towns": [
        {
          "name": "Gloucester",
          "slug": "gloucester",
          "postcode": "GL1",
          "nearby_areas": [
            "Cheltenham",
            "Coleford",
            "Stroud",
            "Bishop's Cleeve",
            "Tewkesbury",
            "Cinderford",
            "Dursley"
          ]
        },
        {
          "name": "Cheltenham",
          "slug": "cheltenham",
          "postcode": "GL50",
          "nearby_areas": [
            "Bishop's Cleeve",
            "Tewkesbury",
            "Gloucester",
            "Chipping Campden",
            "Stroud",
            "Cirencester",
            "Coleford"
          ]
        },
        {
          "name": "Stroud",
          "slug": "stroud",
          "postcode": "GL5",
          "nearby_areas": [
            "Coleford",
            "Dursley",
            "Tetbury",
            "Gloucester",
            "Cirencester",
            "Cheltenham",
            "Bishop's Cleeve"
          ]
        },
        {
          "name": "Tewkesbury",
          "slug": "tewkesbury",
          "postcode": "GL20",
          "nearby_areas": [
            "Cheltenham",
            "Bishop's Cleeve",
            "Gloucester",
            "Pershore",
            "Droitwich Spa",
            "Chipping Campden",
            "Upton-upon-Severn"
          ]
        },
        {
          "name": "Cirencester",
          "slug": "cirencester",
          "postcode": "GL7",
          "nearby_areas": [
            "Tetbury",
            "Stroud",
            "Bishop's Cleeve",
            "Cheltenham",
            "Chipping Campden",
            "Gloucester",
            "Dursley"
          ]
        },
        {
          "name": "Dursley",
          "slug": "dursley",
          "postcode": "GL11",
          "nearby_areas": [
            "Coleford",
            "Stroud",
            "Lydney",
            "Tetbury",
            "Cinderford",
            "Gloucester",
            "Cirencester"
          ]
        },
        {
          "name": "Cinderford",
          "slug": "cinderford",
          "postcode": "GL14",
          "nearby_areas": [
            "Lydney",
            "Coleford",
            "Ross-on-Wye",
            "Monmouth",
            "Gloucester",
            "Dursley",
            "Stroud"
          ]
        },
        {
          "name": "Lydney",
          "slug": "lydney",
          "postcode": "GL15",
          "nearby_areas": [
            "Cinderford",
            "Dursley",
            "Coleford",
            "Chepstow",
            "Monmouth",
            "Stroud",
            "Gloucester"
          ]
        },
        {
          "name": "Coleford",
          "slug": "coleford",
          "postcode": "GL16",
          "nearby_areas": [
            "Stroud",
            "Dursley",
            "Cinderford",
            "Gloucester",
            "Lydney",
            "Tetbury",
            "Cheltenham"
          ]
        },
        {
          "name": "Bishop's Cleeve",
          "slug": "bishop-s-cleeve",
          "postcode": "GL52",
          "nearby_areas": [
            "Cheltenham",
            "Chipping Campden",
            "Tewkesbury",
            "Gloucester",
            "Cirencester",
            "Stroud",
            "Moreton-in-Marsh"
          ]
        },
        {
          "name": "Yate",
          "slug": "yate",
          "postcode": "BS37",
          "nearby_areas": [
            "Thornbury",
            "Filton",
            "Fishponds",
            "Nailsea",
            "Keynsham",
            "Portishead",
            "Kingswood"
          ]
        },
        {
          "name": "Thornbury",
          "slug": "thornbury",
          "postcode": "BS35",
          "nearby_areas": [
            "Filton",
            "Yate",
            "Keynsham",
            "Portishead",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Chipping Campden",
          "slug": "chipping-campden",
          "postcode": "GL55",
          "nearby_areas": [
            "Bishop's Cleeve",
            "Cheltenham",
            "Moreton-in-Marsh",
            "Tewkesbury",
            "Evesham",
            "Cirencester",
            "Gloucester"
          ]
        },
        {
          "name": "Moreton-in-Marsh",
          "slug": "moreton-in-marsh",
          "postcode": "GL56",
          "nearby_areas": [
            "Shipston-on-Stour",
            "Chipping Norton",
            "Chipping Campden",
            "Bishop's Cleeve",
            "Evesham",
            "Stratford-upon-Avon",
            "Cheltenham"
          ]
        },
        {
          "name": "Tetbury",
          "slug": "tetbury",
          "postcode": "GL8",
          "nearby_areas": [
            "Stroud",
            "Dursley",
            "Cirencester",
            "Coleford",
            "Gloucester",
            "Corsham",
            "Lydney"
          ]
        }
      ]
    },
    {
      "name": "Greater London",
      "slug": "greater-london",
      "region": "London",
      "council_name": "Greater London Authority",
      "council_url": "https://www.london.gov.uk/",
      "climate": "urban heat island with damp winters",
      "population": "9.1 million",
      "towns": [
        {
          "name": "Central London",
          "slug": "central-london",
          "postcode": "WC2N",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Westminster",
          "slug": "westminster",
          "postcode": "SW1A",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Camden",
          "slug": "camden",
          "postcode": "NW1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Islington",
          "slug": "islington",
          "postcode": "N1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hackney",
          "slug": "hackney",
          "postcode": "E8",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hammersmith",
          "slug": "hammersmith",
          "postcode": "W6",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Croydon",
          "slug": "croydon",
          "postcode": "CR0",
          "nearby_areas": [
            "Caterham",
            "Banstead",
            "Reigate",
            "Epsom",
            "Redhill",
            "Ashtead",
            "Leatherhead"
          ]
        },
        {
          "name": "Wimbledon",
          "slug": "wimbledon",
          "postcode": "SW19",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Ealing",
          "slug": "ealing",
          "postcode": "W5",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Harrow",
          "slug": "harrow",
          "postcode": "HA1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Ilford",
          "slug": "ilford",
          "postcode": "IG1",
          "nearby_areas": [
            "Loughton",
            "Epping",
            "Harlow",
            "Brentwood",
            "Bishop's Stortford",
            "Hertford",
            "Romford"
          ]
        },
        {
          "name": "Romford",
          "slug": "romford",
          "postcode": "RM1",
          "nearby_areas": [
            "Grays",
            "Bexleyheath",
            "Gravesend",
            "Dartford",
            "Basildon",
            "Rochester",
            "Brentwood"
          ]
        },
        {
          "name": "Bromley",
          "slug": "bromley",
          "postcode": "BR1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Kingston upon Thames",
          "slug": "kingston-upon-thames",
          "postcode": "KT1",
          "nearby_areas": [
            "Esher",
            "Walton-on-Thames",
            "Weybridge",
            "Addlestone",
            "Leatherhead",
            "Ashtead",
            "Epsom"
          ]
        },
        {
          "name": "Richmond",
          "slug": "richmond",
          "postcode": "TW9",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Enfield",
          "slug": "enfield",
          "postcode": "EN1",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Barnet",
          "slug": "barnet",
          "postcode": "EN5",
          "nearby_areas": [
            "Acton",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Walthamstow",
          "slug": "walthamstow",
          "postcode": "E17",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Lewisham",
          "slug": "lewisham",
          "postcode": "SE13",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Greenwich",
          "slug": "greenwich",
          "postcode": "SE10",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Peckham",
          "slug": "peckham",
          "postcode": "SE15",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Clapham",
          "slug": "clapham",
          "postcode": "SW4",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Ealing"
          ]
        },
        {
          "name": "Uxbridge",
          "slug": "uxbridge",
          "postcode": "UB8",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Hounslow",
          "slug": "hounslow",
          "postcode": "TW3",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Bexleyheath",
          "slug": "bexleyheath",
          "postcode": "DA6",
          "nearby_areas": [
            "Romford",
            "Grays",
            "Dartford",
            "Gravesend",
            "Rochester",
            "Chatham",
            "Brentwood"
          ]
        },
        {
          "name": "Woolwich",
          "slug": "woolwich",
          "postcode": "SE18",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Tottenham",
          "slug": "tottenham",
          "postcode": "N17",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Streatham",
          "slug": "streatham",
          "postcode": "SW16",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham"
          ]
        },
        {
          "name": "Acton",
          "slug": "acton",
          "postcode": "W3",
          "nearby_areas": [
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Chiswick",
            "Clapham",
            "Ealing"
          ]
        },
        {
          "name": "Chiswick",
          "slug": "chiswick",
          "postcode": "W4",
          "nearby_areas": [
            "Acton",
            "Barnet",
            "Bromley",
            "Camden",
            "Central London",
            "Clapham",
            "Ealing"
          ]
        }
      ]
    },
    {
      "name": "Greater Manchester",
      "slug": "greater-manchester",
      "region": "North West England",
      "council_name": "Greater Manchester Combined Authority",
      "council_url": "https://www.greatermanchester-ca.gov.uk/",
      "climate": "wet Atlantic weather and cool winters",
      "population": "2.9 million",
      "towns": [
        {
          "name": "Manchester",
          "slug": "manchester",
          "postcode": "M1",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Bolton",
          "slug": "bolton",
          "postcode": "BL1",
          "nearby_areas": [
            "Bury",
            "Ramsbottom",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Stockport",
          "slug": "stockport",
          "postcode": "SK1",
          "nearby_areas": [
            "Hyde",
            "Cheadle",
            "Buxton",
            "Ashton-under-Lyne",
            "Manchester",
            "Middleton",
            "Prestwich"
          ]
        },
        {
          "name": "Oldham",
          "slug": "oldham",
          "postcode": "OL1",
          "nearby_areas": [
            "Ashton-under-Lyne",
            "Rochdale",
            "Manchester",
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Salford"
          ]
        },
        {
          "name": "Rochdale",
          "slug": "rochdale",
          "postcode": "OL16",
          "nearby_areas": [
            "Oldham",
            "Bacup",
            "Todmorden",
            "Ashton-under-Lyne",
            "Bolton",
            "Bury",
            "Ramsbottom"
          ]
        },
        {
          "name": "Bury",
          "slug": "bury",
          "postcode": "BL9",
          "nearby_areas": [
            "Bolton",
            "Ramsbottom",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Wigan",
          "slug": "wigan",
          "postcode": "WN1",
          "nearby_areas": [
            "Leigh",
            "Skelmersdale",
            "Newton-le-Willows",
            "Chorley",
            "Formby",
            "Huyton",
            "Garstang"
          ]
        },
        {
          "name": "Salford",
          "slug": "salford",
          "postcode": "M5",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Manchester",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Altrincham",
          "slug": "altrincham",
          "postcode": "WA14",
          "nearby_areas": [
            "Sale",
            "Denton",
            "Stretford",
            "Eccles",
            "Prestwich",
            "Middleton",
            "Knutsford"
          ]
        },
        {
          "name": "Sale",
          "slug": "sale",
          "postcode": "M33",
          "nearby_areas": [
            "Denton",
            "Stretford",
            "Eccles",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Ashton-under-Lyne",
          "slug": "ashton-under-lyne",
          "postcode": "OL6",
          "nearby_areas": [
            "Oldham",
            "Manchester",
            "Stockport",
            "Bolton",
            "Bury",
            "Ramsbottom",
            "Hyde"
          ]
        },
        {
          "name": "Leigh",
          "slug": "leigh",
          "postcode": "WN7",
          "nearby_areas": [
            "Skelmersdale",
            "Wigan",
            "Formby",
            "Ormskirk",
            "Huyton",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "Stretford",
          "slug": "stretford",
          "postcode": "M32",
          "nearby_areas": [
            "Denton",
            "Eccles",
            "Sale",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Eccles",
          "slug": "eccles",
          "postcode": "M30",
          "nearby_areas": [
            "Stretford",
            "Denton",
            "Prestwich",
            "Sale",
            "Middleton",
            "Salford",
            "Altrincham"
          ]
        },
        {
          "name": "Prestwich",
          "slug": "prestwich",
          "postcode": "M25",
          "nearby_areas": [
            "Middleton",
            "Eccles",
            "Stretford",
            "Denton",
            "Sale",
            "Salford",
            "Bolton"
          ]
        },
        {
          "name": "Hyde",
          "slug": "hyde",
          "postcode": "SK14",
          "nearby_areas": [
            "Buxton",
            "Stockport",
            "Cheadle",
            "Glossop",
            "Ashton-under-Lyne",
            "Wilmslow",
            "Macclesfield"
          ]
        },
        {
          "name": "Denton",
          "slug": "denton",
          "postcode": "M34",
          "nearby_areas": [
            "Stretford",
            "Eccles",
            "Sale",
            "Prestwich",
            "Middleton",
            "Altrincham",
            "Salford"
          ]
        },
        {
          "name": "Cheadle",
          "slug": "cheadle",
          "postcode": "SK8",
          "nearby_areas": [
            "Wilmslow",
            "Buxton",
            "Hyde",
            "Stockport",
            "Macclesfield",
            "Altrincham",
            "Sale"
          ]
        },
        {
          "name": "Ramsbottom",
          "slug": "ramsbottom",
          "postcode": "BL0",
          "nearby_areas": [
            "Bolton",
            "Bury",
            "Manchester",
            "Salford",
            "Middleton",
            "Prestwich",
            "Eccles"
          ]
        },
        {
          "name": "Middleton",
          "slug": "middleton",
          "postcode": "M24",
          "nearby_areas": [
            "Prestwich",
            "Eccles",
            "Stretford",
            "Denton",
            "Sale",
            "Salford",
            "Bolton"
          ]
        }
      ]
    },
    {
      "name": "Gwynedd",
      "slug": "gwynedd",
      "region": "Wales",
      "council_name": "Cyngor Gwynedd",
      "council_url": "https://www.gwynedd.llyw.cymru/",
      "climate": "mountain rainfall and exposed coastal weather",
      "population": "120,000",
      "towns": [
        {
          "name": "Bangor",
          "slug": "bangor",
          "postcode": "LL57",
          "nearby_areas": [
            "Menai Bridge",
            "Beaumaris",
            "Benllech",
            "Pwllheli",
            "Amlwch",
            "Rhosneigr",
            "Porthmadog"
          ]
        },
        {
          "name": "Caernarfon",
          "slug": "caernarfon",
          "postcode": "LL55",
          "nearby_areas": [
            "Bangor",
            "Llangefni",
            "Rhosneigr",
            "Amlwch",
            "Pwllheli",
            "Beaumaris",
            "Menai Bridge"
          ]
        },
        {
          "name": "Porthmadog",
          "slug": "porthmadog",
          "postcode": "LL49",
          "nearby_areas": [
            "Pwllheli",
            "Barmouth",
            "Blaenau Ffestiniog",
            "Conwy",
            "Dolgellau",
            "Menai Bridge",
            "Beaumaris"
          ]
        },
        {
          "name": "Pwllheli",
          "slug": "pwllheli",
          "postcode": "LL53",
          "nearby_areas": [
            "Beaumaris",
            "Menai Bridge",
            "Bangor",
            "Benllech",
            "Porthmadog",
            "Amlwch",
            "Caernarfon"
          ]
        },
        {
          "name": "Blaenau Ffestiniog",
          "slug": "blaenau-ffestiniog",
          "postcode": "LL41",
          "nearby_areas": [
            "Dolgellau",
            "Barmouth",
            "Conwy",
            "Colwyn Bay",
            "Llandudno",
            "Porthmadog",
            "Llanrwst"
          ]
        },
        {
          "name": "Dolgellau",
          "slug": "dolgellau",
          "postcode": "LL40",
          "nearby_areas": [
            "Blaenau Ffestiniog",
            "Barmouth",
            "Conwy",
            "Colwyn Bay",
            "Llandudno",
            "Llanrwst",
            "Porthmadog"
          ]
        },
        {
          "name": "Barmouth",
          "slug": "barmouth",
          "postcode": "LL42",
          "nearby_areas": [
            "Blaenau Ffestiniog",
            "Dolgellau",
            "Conwy",
            "Colwyn Bay",
            "Porthmadog",
            "Llandudno",
            "Llanrwst"
          ]
        }
      ]
    },
    {
      "name": "Hampshire",
      "slug": "hampshire",
      "region": "South East England",
      "council_name": "Hampshire County Council",
      "council_url": "https://www.hants.gov.uk/",
      "climate": "mild coastal air with damp winters",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Southampton",
          "slug": "southampton",
          "postcode": "SO14",
          "nearby_areas": [
            "Eastleigh",
            "Romsey",
            "Fareham",
            "Winchester",
            "Lymington",
            "Cowes",
            "East Cowes"
          ]
        },
        {
          "name": "Portsmouth",
          "slug": "portsmouth",
          "postcode": "PO1",
          "nearby_areas": [
            "Gosport",
            "Waterlooville",
            "Fareham",
            "Havant",
            "Newport",
            "Emsworth",
            "Selsey"
          ]
        },
        {
          "name": "Basingstoke",
          "slug": "basingstoke",
          "postcode": "RG21",
          "nearby_areas": [
            "Fleet",
            "Thatcham",
            "Twyford",
            "Aldershot",
            "Farnborough",
            "Farnham",
            "Pangbourne"
          ]
        },
        {
          "name": "Winchester",
          "slug": "winchester",
          "postcode": "SO23",
          "nearby_areas": [
            "Eastleigh",
            "Romsey",
            "Southampton",
            "Andover",
            "Fareham",
            "Gillingham",
            "Basingstoke"
          ]
        },
        {
          "name": "Andover",
          "slug": "andover",
          "postcode": "SP10",
          "nearby_areas": [
            "Gillingham",
            "Winchester",
            "Amesbury",
            "Romsey",
            "Hungerford",
            "Newbury",
            "Eastleigh"
          ]
        },
        {
          "name": "Aldershot",
          "slug": "aldershot",
          "postcode": "GU11",
          "nearby_areas": [
            "Farnborough",
            "Farnham",
            "Sandhurst",
            "Fleet",
            "Camberley",
            "Godalming",
            "Guildford"
          ]
        },
        {
          "name": "Farnborough",
          "slug": "farnborough",
          "postcode": "GU14",
          "nearby_areas": [
            "Aldershot",
            "Fleet",
            "Camberley",
            "Farnham",
            "Sandhurst",
            "Crowthorne",
            "Guildford"
          ]
        },
        {
          "name": "Eastleigh",
          "slug": "eastleigh",
          "postcode": "SO50",
          "nearby_areas": [
            "Southampton",
            "Romsey",
            "Winchester",
            "Fareham",
            "Gosport",
            "Waterlooville",
            "Lymington"
          ]
        },
        {
          "name": "Fareham",
          "slug": "fareham",
          "postcode": "PO16",
          "nearby_areas": [
            "Gosport",
            "Portsmouth",
            "Waterlooville",
            "Newport",
            "Havant",
            "East Cowes",
            "Cowes"
          ]
        },
        {
          "name": "Gosport",
          "slug": "gosport",
          "postcode": "PO12",
          "nearby_areas": [
            "Portsmouth",
            "Newport",
            "Fareham",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Waterlooville"
          ]
        },
        {
          "name": "Havant",
          "slug": "havant",
          "postcode": "PO9",
          "nearby_areas": [
            "Emsworth",
            "Waterlooville",
            "Selsey",
            "Portsmouth",
            "Gosport",
            "Fareham",
            "Chichester"
          ]
        },
        {
          "name": "Waterlooville",
          "slug": "waterlooville",
          "postcode": "PO7",
          "nearby_areas": [
            "Havant",
            "Emsworth",
            "Portsmouth",
            "Fareham",
            "Gosport",
            "Selsey",
            "Petersfield"
          ]
        },
        {
          "name": "Fleet",
          "slug": "fleet",
          "postcode": "GU51",
          "nearby_areas": [
            "Farnborough",
            "Aldershot",
            "Farnham",
            "Camberley",
            "Sandhurst",
            "Crowthorne",
            "Wokingham"
          ]
        },
        {
          "name": "Petersfield",
          "slug": "petersfield",
          "postcode": "GU32",
          "nearby_areas": [
            "Waterlooville",
            "Midhurst",
            "Alton",
            "Havant",
            "Emsworth",
            "Petworth",
            "Haslemere"
          ]
        },
        {
          "name": "Lymington",
          "slug": "lymington",
          "postcode": "SO41",
          "nearby_areas": [
            "New Milton",
            "Cowes",
            "Southampton",
            "Ringwood",
            "East Cowes",
            "Romsey",
            "Eastleigh"
          ]
        },
        {
          "name": "Romsey",
          "slug": "romsey",
          "postcode": "SO51",
          "nearby_areas": [
            "Eastleigh",
            "Southampton",
            "Winchester",
            "Amesbury",
            "Andover",
            "Gillingham",
            "Lymington"
          ]
        },
        {
          "name": "Ringwood",
          "slug": "ringwood",
          "postcode": "BH24",
          "nearby_areas": [
            "Verwood",
            "Ferndown",
            "Christchurch",
            "New Milton",
            "Wimborne Minster",
            "Bournemouth",
            "Lymington"
          ]
        },
        {
          "name": "Alton",
          "slug": "alton",
          "postcode": "GU34",
          "nearby_areas": [
            "Petworth",
            "Haslemere",
            "Sandhurst",
            "Farnham",
            "Aldershot",
            "Petersfield",
            "Midhurst"
          ]
        },
        {
          "name": "New Milton",
          "slug": "new-milton",
          "postcode": "BH25",
          "nearby_areas": [
            "Lymington",
            "Ringwood",
            "Christchurch",
            "Bournemouth",
            "Ferndown",
            "Wimborne Minster",
            "Southampton"
          ]
        },
        {
          "name": "Emsworth",
          "slug": "emsworth",
          "postcode": "PO10",
          "nearby_areas": [
            "Havant",
            "Selsey",
            "Waterlooville",
            "Portsmouth",
            "Chichester",
            "Gosport",
            "Petersfield"
          ]
        }
      ]
    },
    {
      "name": "Herefordshire",
      "slug": "herefordshire",
      "region": "West Midlands",
      "council_name": "Herefordshire Council",
      "council_url": "https://www.herefordshire.gov.uk/",
      "climate": "rural damp winters and cool valleys",
      "population": "190,000",
      "towns": [
        {
          "name": "Hereford",
          "slug": "hereford",
          "postcode": "HR1",
          "nearby_areas": [
            "Hay-on-Wye",
            "Weobley",
            "Kington",
            "Bromyard",
            "Pembridge",
            "Ross-on-Wye",
            "Leominster"
          ]
        },
        {
          "name": "Leominster",
          "slug": "leominster",
          "postcode": "HR6",
          "nearby_areas": [
            "Pembridge",
            "Kington",
            "Weobley",
            "Ludlow",
            "Hay-on-Wye",
            "Hereford",
            "Bromyard"
          ]
        },
        {
          "name": "Ross-on-Wye",
          "slug": "ross-on-wye",
          "postcode": "HR9",
          "nearby_areas": [
            "Cinderford",
            "Ledbury",
            "Monmouth",
            "Bromyard",
            "Hereford",
            "Hay-on-Wye",
            "Weobley"
          ]
        },
        {
          "name": "Ledbury",
          "slug": "ledbury",
          "postcode": "HR8",
          "nearby_areas": [
            "Bromyard",
            "Weobley",
            "Hay-on-Wye",
            "Kington",
            "Ross-on-Wye",
            "Pembridge",
            "Hereford"
          ]
        },
        {
          "name": "Bromyard",
          "slug": "bromyard",
          "postcode": "HR7",
          "nearby_areas": [
            "Weobley",
            "Hay-on-Wye",
            "Kington",
            "Pembridge",
            "Hereford",
            "Ledbury",
            "Ross-on-Wye"
          ]
        },
        {
          "name": "Kington",
          "slug": "kington",
          "postcode": "HR5",
          "nearby_areas": [
            "Weobley",
            "Hay-on-Wye",
            "Pembridge",
            "Bromyard",
            "Hereford",
            "Leominster",
            "Ledbury"
          ]
        },
        {
          "name": "Hay-on-Wye",
          "slug": "hay-on-wye",
          "postcode": "HR3",
          "nearby_areas": [
            "Weobley",
            "Kington",
            "Bromyard",
            "Hereford",
            "Pembridge",
            "Ledbury",
            "Leominster"
          ]
        },
        {
          "name": "Pembridge",
          "slug": "pembridge",
          "postcode": "HR6",
          "nearby_areas": [
            "Kington",
            "Weobley",
            "Hay-on-Wye",
            "Bromyard",
            "Hereford",
            "Leominster",
            "Ledbury"
          ]
        },
        {
          "name": "Weobley",
          "slug": "weobley",
          "postcode": "HR4",
          "nearby_areas": [
            "Hay-on-Wye",
            "Kington",
            "Bromyard",
            "Pembridge",
            "Hereford",
            "Ledbury",
            "Leominster"
          ]
        },
        {
          "name": "Colwall",
          "slug": "colwall",
          "postcode": "WR13",
          "nearby_areas": [
            "Malvern",
            "Broadway",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        }
      ]
    },
    {
      "name": "Hertfordshire",
      "slug": "hertfordshire",
      "region": "East of England",
      "council_name": "Hertfordshire County Council",
      "council_url": "https://www.hertfordshire.gov.uk/",
      "climate": "mild, fairly dry with winter damp",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Watford",
          "slug": "watford",
          "postcode": "WD17",
          "nearby_areas": [
            "Borehamwood",
            "Rickmansworth",
            "St Albans",
            "Hemel Hempstead",
            "Cheshunt",
            "Hatfield",
            "Gerrards Cross"
          ]
        },
        {
          "name": "St Albans",
          "slug": "st-albans",
          "postcode": "AL1",
          "nearby_areas": [
            "Cheshunt",
            "Harpenden",
            "Hatfield",
            "Hemel Hempstead",
            "Welwyn Garden City",
            "Borehamwood",
            "Watford"
          ]
        },
        {
          "name": "Hemel Hempstead",
          "slug": "hemel-hempstead",
          "postcode": "HP1",
          "nearby_areas": [
            "Berkhamsted",
            "St Albans",
            "Harpenden",
            "Cheshunt",
            "Rickmansworth",
            "Chesham",
            "Watford"
          ]
        },
        {
          "name": "Stevenage",
          "slug": "stevenage",
          "postcode": "SG1",
          "nearby_areas": [
            "Letchworth Garden City",
            "Hitchin",
            "Royston",
            "Stotfold",
            "Welwyn Garden City",
            "Harpenden",
            "Hertford"
          ]
        },
        {
          "name": "Hertford",
          "slug": "hertford",
          "postcode": "SG14",
          "nearby_areas": [
            "Welwyn Garden City",
            "Hatfield",
            "Harlow",
            "Stevenage",
            "Cheshunt",
            "St Albans",
            "Epping"
          ]
        },
        {
          "name": "Hatfield",
          "slug": "hatfield",
          "postcode": "AL10",
          "nearby_areas": [
            "Welwyn Garden City",
            "Cheshunt",
            "St Albans",
            "Hertford",
            "Harpenden",
            "Borehamwood",
            "Stevenage"
          ]
        },
        {
          "name": "Welwyn Garden City",
          "slug": "welwyn-garden-city",
          "postcode": "AL8",
          "nearby_areas": [
            "Hatfield",
            "Cheshunt",
            "Hertford",
            "Harpenden",
            "St Albans",
            "Stevenage",
            "Hitchin"
          ]
        },
        {
          "name": "Bishop's Stortford",
          "slug": "bishop-s-stortford",
          "postcode": "CM23",
          "nearby_areas": [
            "Chelmsford",
            "Brentwood",
            "Billericay",
            "Epping",
            "Harlow",
            "Loughton",
            "Wickford"
          ]
        },
        {
          "name": "Hitchin",
          "slug": "hitchin",
          "postcode": "SG5",
          "nearby_areas": [
            "Stotfold",
            "Letchworth Garden City",
            "Royston",
            "Stevenage",
            "Arlesey",
            "Shefford",
            "Luton"
          ]
        },
        {
          "name": "Letchworth Garden City",
          "slug": "letchworth-garden-city",
          "postcode": "SG6",
          "nearby_areas": [
            "Stotfold",
            "Royston",
            "Hitchin",
            "Stevenage",
            "Arlesey",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Borehamwood",
          "slug": "borehamwood",
          "postcode": "WD6",
          "nearby_areas": [
            "Watford",
            "St Albans",
            "Hatfield",
            "Rickmansworth",
            "Cheshunt",
            "Welwyn Garden City",
            "Hemel Hempstead"
          ]
        },
        {
          "name": "Cheshunt",
          "slug": "cheshunt",
          "postcode": "EN8",
          "nearby_areas": [
            "St Albans",
            "Harpenden",
            "Hatfield",
            "Welwyn Garden City",
            "Hemel Hempstead",
            "Borehamwood",
            "Luton"
          ]
        },
        {
          "name": "Harpenden",
          "slug": "harpenden",
          "postcode": "AL5",
          "nearby_areas": [
            "Cheshunt",
            "St Albans",
            "Luton",
            "Welwyn Garden City",
            "Hatfield",
            "Hemel Hempstead",
            "Stevenage"
          ]
        },
        {
          "name": "Royston",
          "slug": "royston",
          "postcode": "SG8",
          "nearby_areas": [
            "Letchworth Garden City",
            "Stotfold",
            "Hitchin",
            "Arlesey",
            "Stevenage",
            "Shefford",
            "Potton"
          ]
        },
        {
          "name": "Rickmansworth",
          "slug": "rickmansworth",
          "postcode": "WD3",
          "nearby_areas": [
            "Watford",
            "Gerrards Cross",
            "Amersham",
            "Hemel Hempstead",
            "Borehamwood",
            "Chesham",
            "Berkhamsted"
          ]
        },
        {
          "name": "Berkhamsted",
          "slug": "berkhamsted",
          "postcode": "HP4",
          "nearby_areas": [
            "Hemel Hempstead",
            "Chesham",
            "Amersham",
            "Wendover",
            "Rickmansworth",
            "Harpenden",
            "St Albans"
          ]
        }
      ]
    },
    {
      "name": "Highland",
      "slug": "highland",
      "region": "Scotland",
      "council_name": "Highland Council",
      "council_url": "https://www.highland.gov.uk/",
      "climate": "cool, wet, mountainous and exposed",
      "population": "240,000",
      "towns": [
        {
          "name": "Inverness",
          "slug": "inverness",
          "postcode": "IV1",
          "nearby_areas": [
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Alness",
            "Fochabers",
            "Dingwall"
          ]
        },
        {
          "name": "Fort William",
          "slug": "fort-william",
          "postcode": "PH33",
          "nearby_areas": [
            "Oban",
            "Lochgilphead",
            "Aviemore",
            "Campbeltown",
            "Dingwall",
            "Dunoon",
            "Pitlochry"
          ]
        },
        {
          "name": "Nairn",
          "slug": "nairn",
          "postcode": "IV12",
          "nearby_areas": [
            "Inverness",
            "Portree",
            "Ullapool",
            "Forres",
            "Alness",
            "Fochabers",
            "Dingwall"
          ]
        },
        {
          "name": "Thurso",
          "slug": "thurso",
          "postcode": "KW14",
          "nearby_areas": [
            "Wick",
            "Dounby",
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Ullapool",
            "Portree"
          ]
        },
        {
          "name": "Wick",
          "slug": "wick",
          "postcode": "KW1",
          "nearby_areas": [
            "Thurso",
            "Dounby",
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Lossiemouth",
            "Ullapool"
          ]
        },
        {
          "name": "Aviemore",
          "slug": "aviemore",
          "postcode": "PH22",
          "nearby_areas": [
            "Pitlochry",
            "Aberfeldy",
            "Crieff",
            "Auchterarder",
            "Benbecula",
            "Brae",
            "Castlebay"
          ]
        },
        {
          "name": "Dingwall",
          "slug": "dingwall",
          "postcode": "IV15",
          "nearby_areas": [
            "Alness",
            "Inverness",
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Fochabers"
          ]
        },
        {
          "name": "Alness",
          "slug": "alness",
          "postcode": "IV17",
          "nearby_areas": [
            "Dingwall",
            "Inverness",
            "Nairn",
            "Portree",
            "Ullapool",
            "Forres",
            "Fochabers"
          ]
        },
        {
          "name": "Ullapool",
          "slug": "ullapool",
          "postcode": "IV26",
          "nearby_areas": [
            "Portree",
            "Forres",
            "Fochabers",
            "Nairn",
            "Inverness",
            "Elgin",
            "Lossiemouth"
          ]
        },
        {
          "name": "Portree",
          "slug": "portree",
          "postcode": "IV51",
          "nearby_areas": [
            "Ullapool",
            "Forres",
            "Nairn",
            "Inverness",
            "Fochabers",
            "Elgin",
            "Lossiemouth"
          ]
        }
      ]
    },
    {
      "name": "Inverclyde",
      "slug": "inverclyde",
      "region": "Scotland",
      "council_name": "Inverclyde Council",
      "council_url": "https://www.inverclyde.gov.uk/",
      "climate": "wet west coast climate",
      "population": "78,000",
      "towns": [
        {
          "name": "Greenock",
          "slug": "greenock",
          "postcode": "PA15",
          "nearby_areas": [
            "Inverkip",
            "Port Glasgow",
            "Kilmacolm",
            "Gourock",
            "Helensburgh",
            "Rothesay",
            "Alexandria"
          ]
        },
        {
          "name": "Port Glasgow",
          "slug": "port-glasgow",
          "postcode": "PA14",
          "nearby_areas": [
            "Inverkip",
            "Kilmacolm",
            "Greenock",
            "Alexandria",
            "Balloch",
            "Gourock",
            "Barrhead"
          ]
        },
        {
          "name": "Gourock",
          "slug": "gourock",
          "postcode": "PA19",
          "nearby_areas": [
            "Helensburgh",
            "Rothesay",
            "Inverkip",
            "Port Glasgow",
            "Greenock",
            "Kilmacolm",
            "Alexandria"
          ]
        },
        {
          "name": "Kilmacolm",
          "slug": "kilmacolm",
          "postcode": "PA13",
          "nearby_areas": [
            "Port Glasgow",
            "Alexandria",
            "Balloch",
            "Inverkip",
            "Barrhead",
            "Newton Mearns",
            "Clarkston"
          ]
        },
        {
          "name": "Inverkip",
          "slug": "inverkip",
          "postcode": "PA16",
          "nearby_areas": [
            "Port Glasgow",
            "Greenock",
            "Kilmacolm",
            "Gourock",
            "Helensburgh",
            "Alexandria",
            "Balloch"
          ]
        }
      ]
    },
    {
      "name": "Isle of Wight",
      "slug": "isle-of-wight",
      "region": "South East England",
      "council_name": "Isle of Wight Council",
      "council_url": "https://www.iow.gov.uk/",
      "climate": "mild maritime climate and coastal winds",
      "population": "140,000",
      "towns": [
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "PO30",
          "nearby_areas": [
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport",
            "East Cowes",
            "Cowes"
          ]
        },
        {
          "name": "Ryde",
          "slug": "ryde",
          "postcode": "PO33",
          "nearby_areas": [
            "Newport",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Sandown",
            "Gosport",
            "East Cowes"
          ]
        },
        {
          "name": "Cowes",
          "slug": "cowes",
          "postcode": "PO31",
          "nearby_areas": [
            "East Cowes",
            "Newport",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport"
          ]
        },
        {
          "name": "East Cowes",
          "slug": "east-cowes",
          "postcode": "PO32",
          "nearby_areas": [
            "Cowes",
            "Newport",
            "Ryde",
            "Bembridge",
            "Yarmouth",
            "Freshwater",
            "Gosport"
          ]
        },
        {
          "name": "Sandown",
          "slug": "sandown",
          "postcode": "PO36",
          "nearby_areas": [
            "Shanklin",
            "Freshwater",
            "Yarmouth",
            "Bembridge",
            "Ventnor",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Shanklin",
          "slug": "shanklin",
          "postcode": "PO37",
          "nearby_areas": [
            "Sandown",
            "Ventnor",
            "Freshwater",
            "Yarmouth",
            "Bembridge",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Ventnor",
          "slug": "ventnor",
          "postcode": "PO38",
          "nearby_areas": [
            "Shanklin",
            "Sandown",
            "Freshwater",
            "Bembridge",
            "Yarmouth",
            "Ryde",
            "Newport"
          ]
        },
        {
          "name": "Freshwater",
          "slug": "freshwater",
          "postcode": "PO40",
          "nearby_areas": [
            "Yarmouth",
            "Bembridge",
            "Ryde",
            "Sandown",
            "Newport",
            "Shanklin",
            "Ventnor"
          ]
        },
        {
          "name": "Yarmouth",
          "slug": "yarmouth",
          "postcode": "PO41",
          "nearby_areas": [
            "Freshwater",
            "Bembridge",
            "Ryde",
            "Newport",
            "Sandown",
            "Shanklin",
            "Gosport"
          ]
        },
        {
          "name": "Bembridge",
          "slug": "bembridge",
          "postcode": "PO35",
          "nearby_areas": [
            "Yarmouth",
            "Freshwater",
            "Ryde",
            "Newport",
            "Sandown",
            "Shanklin",
            "East Cowes"
          ]
        }
      ]
    },
    {
      "name": "Kent",
      "slug": "kent",
      "region": "South East England",
      "council_name": "Kent County Council",
      "council_url": "https://www.kent.gov.uk/",
      "climate": "coastal damp and sea winds",
      "population": "1.9 million",
      "towns": [
        {
          "name": "Maidstone",
          "slug": "maidstone",
          "postcode": "ME14",
          "nearby_areas": [
            "Gillingham",
            "Chatham",
            "Rochester",
            "Sittingbourne",
            "Tonbridge",
            "Gravesend",
            "Sevenoaks"
          ]
        },
        {
          "name": "Canterbury",
          "slug": "canterbury",
          "postcode": "CT1",
          "nearby_areas": [
            "Whitstable",
            "Herne Bay",
            "Faversham",
            "Deal",
            "Folkestone",
            "Dover",
            "Margate"
          ]
        },
        {
          "name": "Tunbridge Wells",
          "slug": "tunbridge-wells",
          "postcode": "TN1",
          "nearby_areas": [
            "Crowborough",
            "Heathfield",
            "Ashford",
            "Tonbridge",
            "Uckfield",
            "East Grinstead",
            "Sevenoaks"
          ]
        },
        {
          "name": "Ashford",
          "slug": "ashford",
          "postcode": "TN23",
          "nearby_areas": [
            "Heathfield",
            "Crowborough",
            "Tunbridge Wells",
            "Uckfield",
            "Hailsham",
            "Rye",
            "Tonbridge"
          ]
        },
        {
          "name": "Dartford",
          "slug": "dartford",
          "postcode": "DA1",
          "nearby_areas": [
            "Bexleyheath",
            "Grays",
            "Romford",
            "Gravesend",
            "Sevenoaks",
            "Rochester",
            "Chatham"
          ]
        },
        {
          "name": "Gravesend",
          "slug": "gravesend",
          "postcode": "DA11",
          "nearby_areas": [
            "Grays",
            "Romford",
            "Bexleyheath",
            "Dartford",
            "Rochester",
            "Chatham",
            "Basildon"
          ]
        },
        {
          "name": "Gillingham",
          "slug": "gillingham",
          "postcode": "ME7",
          "nearby_areas": [
            "Sittingbourne",
            "Chatham",
            "Rochester",
            "Maidstone",
            "Faversham",
            "Gravesend",
            "Canvey Island"
          ]
        },
        {
          "name": "Chatham",
          "slug": "chatham",
          "postcode": "ME4",
          "nearby_areas": [
            "Rochester",
            "Gillingham",
            "Maidstone",
            "Gravesend",
            "Sittingbourne",
            "Canvey Island",
            "Bexleyheath"
          ]
        },
        {
          "name": "Rochester",
          "slug": "rochester",
          "postcode": "ME1",
          "nearby_areas": [
            "Chatham",
            "Gillingham",
            "Gravesend",
            "Maidstone",
            "Sittingbourne",
            "Canvey Island",
            "Bexleyheath"
          ]
        },
        {
          "name": "Folkestone",
          "slug": "folkestone",
          "postcode": "CT20",
          "nearby_areas": [
            "Dover",
            "Deal",
            "Canterbury",
            "Faversham",
            "Herne Bay",
            "Whitstable",
            "Ramsgate"
          ]
        },
        {
          "name": "Dover",
          "slug": "dover",
          "postcode": "CT16",
          "nearby_areas": [
            "Folkestone",
            "Deal",
            "Canterbury",
            "Ramsgate",
            "Margate",
            "Herne Bay",
            "Whitstable"
          ]
        },
        {
          "name": "Margate",
          "slug": "margate",
          "postcode": "CT9",
          "nearby_areas": [
            "Ramsgate",
            "Deal",
            "Herne Bay",
            "Canterbury",
            "Whitstable",
            "Dover",
            "Faversham"
          ]
        },
        {
          "name": "Ramsgate",
          "slug": "ramsgate",
          "postcode": "CT11",
          "nearby_areas": [
            "Margate",
            "Deal",
            "Herne Bay",
            "Dover",
            "Canterbury",
            "Whitstable",
            "Folkestone"
          ]
        },
        {
          "name": "Sevenoaks",
          "slug": "sevenoaks",
          "postcode": "TN13",
          "nearby_areas": [
            "Tonbridge",
            "Dartford",
            "Tunbridge Wells",
            "Caterham",
            "Gravesend",
            "Maidstone",
            "Croydon"
          ]
        },
        {
          "name": "Tonbridge",
          "slug": "tonbridge",
          "postcode": "TN9",
          "nearby_areas": [
            "Sevenoaks",
            "Tunbridge Wells",
            "Crowborough",
            "Maidstone",
            "Ashford",
            "Heathfield",
            "East Grinstead"
          ]
        },
        {
          "name": "Sittingbourne",
          "slug": "sittingbourne",
          "postcode": "ME10",
          "nearby_areas": [
            "Gillingham",
            "Faversham",
            "Chatham",
            "Maidstone",
            "Rochester",
            "Whitstable",
            "Canterbury"
          ]
        },
        {
          "name": "Faversham",
          "slug": "faversham",
          "postcode": "ME13",
          "nearby_areas": [
            "Whitstable",
            "Sittingbourne",
            "Canterbury",
            "Herne Bay",
            "Gillingham",
            "Maidstone",
            "Chatham"
          ]
        },
        {
          "name": "Deal",
          "slug": "deal",
          "postcode": "CT14",
          "nearby_areas": [
            "Dover",
            "Ramsgate",
            "Margate",
            "Folkestone",
            "Canterbury",
            "Herne Bay",
            "Whitstable"
          ]
        },
        {
          "name": "Whitstable",
          "slug": "whitstable",
          "postcode": "CT5",
          "nearby_areas": [
            "Herne Bay",
            "Canterbury",
            "Faversham",
            "Sittingbourne",
            "Margate",
            "Gillingham",
            "Ramsgate"
          ]
        },
        {
          "name": "Herne Bay",
          "slug": "herne-bay",
          "postcode": "CT6",
          "nearby_areas": [
            "Whitstable",
            "Canterbury",
            "Faversham",
            "Margate",
            "Ramsgate",
            "Deal",
            "Sittingbourne"
          ]
        }
      ]
    },
    {
      "name": "Lancashire",
      "slug": "lancashire",
      "region": "North West England",
      "council_name": "Lancashire County Council",
      "council_url": "https://www.lancashire.gov.uk/",
      "climate": "persistent rain and high annual rainfall",
      "population": "1.5 million",
      "towns": [
        {
          "name": "Preston",
          "slug": "preston",
          "postcode": "PR1",
          "nearby_areas": [
            "Garstang",
            "Leyland",
            "Chorley",
            "Ormskirk",
            "Skelmersdale",
            "Leigh",
            "Southport"
          ]
        },
        {
          "name": "Blackpool",
          "slug": "blackpool",
          "postcode": "FY1",
          "nearby_areas": [
            "Lytham St Annes",
            "Fleetwood",
            "Southport",
            "Preston",
            "Garstang",
            "Leyland",
            "Ormskirk"
          ]
        },
        {
          "name": "Blackburn",
          "slug": "blackburn",
          "postcode": "BB1",
          "nearby_areas": [
            "Rawtenstall",
            "Accrington",
            "Nelson",
            "Burnley",
            "Darwen",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Burnley",
          "slug": "burnley",
          "postcode": "BB11",
          "nearby_areas": [
            "Nelson",
            "Rawtenstall",
            "Blackburn",
            "Colne",
            "Accrington",
            "Bacup",
            "Clitheroe"
          ]
        },
        {
          "name": "Lancaster",
          "slug": "lancaster",
          "postcode": "LA1",
          "nearby_areas": [
            "Morecambe",
            "Fleetwood",
            "Lytham St Annes",
            "Grange-over-Sands",
            "Windermere",
            "Ambleside",
            "Ulverston"
          ]
        },
        {
          "name": "Accrington",
          "slug": "accrington",
          "postcode": "BB5",
          "nearby_areas": [
            "Blackburn",
            "Rawtenstall",
            "Darwen",
            "Nelson",
            "Burnley",
            "Bacup",
            "Clitheroe"
          ]
        },
        {
          "name": "Chorley",
          "slug": "chorley",
          "postcode": "PR7",
          "nearby_areas": [
            "Leyland",
            "Garstang",
            "Preston",
            "Darwen",
            "Wigan",
            "Skelmersdale",
            "Leigh"
          ]
        },
        {
          "name": "Nelson",
          "slug": "nelson",
          "postcode": "BB9",
          "nearby_areas": [
            "Burnley",
            "Rawtenstall",
            "Blackburn",
            "Accrington",
            "Colne",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Morecambe",
          "slug": "morecambe",
          "postcode": "LA4",
          "nearby_areas": [
            "Lancaster",
            "Grange-over-Sands",
            "Fleetwood",
            "Windermere",
            "Ambleside",
            "Lytham St Annes",
            "Ulverston"
          ]
        },
        {
          "name": "Clitheroe",
          "slug": "clitheroe",
          "postcode": "BB7",
          "nearby_areas": [
            "Nelson",
            "Rawtenstall",
            "Blackburn",
            "Accrington",
            "Burnley",
            "Colne",
            "Darwen"
          ]
        },
        {
          "name": "Fleetwood",
          "slug": "fleetwood",
          "postcode": "FY7",
          "nearby_areas": [
            "Lytham St Annes",
            "Blackpool",
            "Morecambe",
            "Lancaster",
            "Barrow-in-Furness",
            "Windermere",
            "Ambleside"
          ]
        },
        {
          "name": "Leyland",
          "slug": "leyland",
          "postcode": "PR25",
          "nearby_areas": [
            "Chorley",
            "Garstang",
            "Preston",
            "Darwen",
            "Skelmersdale",
            "Leigh",
            "Ormskirk"
          ]
        },
        {
          "name": "Skelmersdale",
          "slug": "skelmersdale",
          "postcode": "WN8",
          "nearby_areas": [
            "Leigh",
            "Ormskirk",
            "Formby",
            "Huyton",
            "Wigan",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "Ormskirk",
          "slug": "ormskirk",
          "postcode": "L39",
          "nearby_areas": [
            "Skelmersdale",
            "Formby",
            "Huyton",
            "Leigh",
            "Garstang",
            "Preston",
            "Crosby"
          ]
        },
        {
          "name": "Colne",
          "slug": "colne",
          "postcode": "BB8",
          "nearby_areas": [
            "Burnley",
            "Nelson",
            "Clitheroe",
            "Rawtenstall",
            "Blackburn",
            "Bacup",
            "Accrington"
          ]
        },
        {
          "name": "Rawtenstall",
          "slug": "rawtenstall",
          "postcode": "BB4",
          "nearby_areas": [
            "Blackburn",
            "Accrington",
            "Nelson",
            "Burnley",
            "Darwen",
            "Clitheroe",
            "Bacup"
          ]
        },
        {
          "name": "Lytham St Annes",
          "slug": "lytham-st-annes",
          "postcode": "FY8",
          "nearby_areas": [
            "Fleetwood",
            "Blackpool",
            "Morecambe",
            "Lancaster",
            "Barrow-in-Furness",
            "Leyland",
            "Preston"
          ]
        },
        {
          "name": "Garstang",
          "slug": "garstang",
          "postcode": "PR3",
          "nearby_areas": [
            "Preston",
            "Leyland",
            "Chorley",
            "Ormskirk",
            "Skelmersdale",
            "Leigh",
            "Southport"
          ]
        },
        {
          "name": "Darwen",
          "slug": "darwen",
          "postcode": "BB3",
          "nearby_areas": [
            "Accrington",
            "Blackburn",
            "Rawtenstall",
            "Chorley",
            "Leyland",
            "Bacup",
            "Nelson"
          ]
        },
        {
          "name": "Bacup",
          "slug": "bacup",
          "postcode": "OL13",
          "nearby_areas": [
            "Todmorden",
            "Burnley",
            "Rochdale",
            "Accrington",
            "Blackburn",
            "Rawtenstall",
            "Nelson"
          ]
        }
      ]
    },
    {
      "name": "Leicestershire",
      "slug": "leicestershire",
      "region": "East Midlands",
      "council_name": "Leicestershire County Council",
      "council_url": "https://www.leicestershire.gov.uk/",
      "climate": "cool winters with moderate rainfall",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Leicester",
          "slug": "leicester",
          "postcode": "LE1",
          "nearby_areas": [
            "Blaby",
            "Broughton Astley",
            "Earl Shilton",
            "Syston",
            "Oadby",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Loughborough",
          "slug": "loughborough",
          "postcode": "LE11",
          "nearby_areas": [
            "Coalville",
            "Shepshed",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Blaby",
            "Oadby"
          ]
        },
        {
          "name": "Hinckley",
          "slug": "hinckley",
          "postcode": "LE10",
          "nearby_areas": [
            "Nuneaton",
            "Bedworth",
            "Atherstone",
            "Lutterworth",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester"
          ]
        },
        {
          "name": "Coalville",
          "slug": "coalville",
          "postcode": "LE67",
          "nearby_areas": [
            "Ashby-de-la-Zouch",
            "Loughborough",
            "Swadlincote",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester",
            "Blaby"
          ]
        },
        {
          "name": "Melton Mowbray",
          "slug": "melton-mowbray",
          "postcode": "LE13",
          "nearby_areas": [
            "Oakham",
            "Shepshed",
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham"
          ]
        },
        {
          "name": "Market Harborough",
          "slug": "market-harborough",
          "postcode": "LE16",
          "nearby_areas": [
            "Wigston",
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham"
          ]
        },
        {
          "name": "Wigston",
          "slug": "wigston",
          "postcode": "LE18",
          "nearby_areas": [
            "Syston",
            "Oadby",
            "Blaby",
            "Broughton Astley",
            "Earl Shilton",
            "Leicester",
            "Shepshed"
          ]
        },
        {
          "name": "Oadby",
          "slug": "oadby",
          "postcode": "LE2",
          "nearby_areas": [
            "Syston",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Ashby-de-la-Zouch",
          "slug": "ashby-de-la-zouch",
          "postcode": "LE65",
          "nearby_areas": [
            "Swadlincote",
            "Coalville",
            "Loughborough",
            "Derby",
            "Hinckley",
            "Tamworth",
            "Atherstone"
          ]
        },
        {
          "name": "Lutterworth",
          "slug": "lutterworth",
          "postcode": "LE17",
          "nearby_areas": [
            "Rugby",
            "Hinckley",
            "Wigston",
            "Market Harborough",
            "Broughton Astley",
            "Earl Shilton",
            "Blaby"
          ]
        },
        {
          "name": "Blaby",
          "slug": "blaby",
          "postcode": "LE8",
          "nearby_areas": [
            "Syston",
            "Oadby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Syston",
          "slug": "syston",
          "postcode": "LE7",
          "nearby_areas": [
            "Oadby",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Shepshed",
            "Wigston"
          ]
        },
        {
          "name": "Earl Shilton",
          "slug": "earl-shilton",
          "postcode": "LE9",
          "nearby_areas": [
            "Broughton Astley",
            "Leicester",
            "Blaby",
            "Syston",
            "Oadby",
            "Wigston",
            "Shepshed"
          ]
        },
        {
          "name": "Shepshed",
          "slug": "shepshed",
          "postcode": "LE12",
          "nearby_areas": [
            "Oadby",
            "Syston",
            "Blaby",
            "Leicester",
            "Broughton Astley",
            "Earl Shilton",
            "Wigston"
          ]
        },
        {
          "name": "Broughton Astley",
          "slug": "broughton-astley",
          "postcode": "LE9",
          "nearby_areas": [
            "Earl Shilton",
            "Leicester",
            "Blaby",
            "Syston",
            "Oadby",
            "Wigston",
            "Shepshed"
          ]
        }
      ]
    },
    {
      "name": "Lincolnshire",
      "slug": "lincolnshire",
      "region": "East Midlands",
      "council_name": "Lincolnshire County Council",
      "council_url": "https://www.lincolnshire.gov.uk/",
      "climate": "dry eastern climate with cold winds",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Lincoln",
          "slug": "lincoln",
          "postcode": "LN1",
          "nearby_areas": [
            "Gainsborough",
            "Sleaford",
            "Horncastle",
            "Market Rasen",
            "Retford",
            "Southwell",
            "Newark-on-Trent"
          ]
        },
        {
          "name": "Grimsby",
          "slug": "grimsby",
          "postcode": "DN31",
          "nearby_areas": [
            "Cleethorpes",
            "Immingham",
            "Louth",
            "Withernsea",
            "Brigg",
            "Market Rasen",
            "Mablethorpe"
          ]
        },
        {
          "name": "Scunthorpe",
          "slug": "scunthorpe",
          "postcode": "DN15",
          "nearby_areas": [
            "Conisbrough",
            "Thorne",
            "Howden",
            "Snaith",
            "Brigg",
            "Gainsborough",
            "Goole"
          ]
        },
        {
          "name": "Boston",
          "slug": "boston",
          "postcode": "PE21",
          "nearby_areas": [
            "Spalding",
            "Sleaford",
            "Horncastle",
            "Skegness",
            "Market Rasen",
            "Ramsey",
            "Bourne"
          ]
        },
        {
          "name": "Grantham",
          "slug": "grantham",
          "postcode": "NG31",
          "nearby_areas": [
            "Southwell",
            "Sleaford",
            "Newark-on-Trent",
            "Bourne",
            "Melton Mowbray",
            "Ollerton",
            "Beeston"
          ]
        },
        {
          "name": "Spalding",
          "slug": "spalding",
          "postcode": "PE11",
          "nearby_areas": [
            "Bourne",
            "Oundle",
            "Ketton",
            "Ryhall",
            "Whittlesey",
            "Yaxley",
            "Ramsey"
          ]
        },
        {
          "name": "Skegness",
          "slug": "skegness",
          "postcode": "PE25",
          "nearby_areas": [
            "Mablethorpe",
            "Boston",
            "Market Rasen",
            "Horncastle",
            "Louth",
            "Cleethorpes",
            "Spalding"
          ]
        },
        {
          "name": "Louth",
          "slug": "louth",
          "postcode": "LN11",
          "nearby_areas": [
            "Market Rasen",
            "Mablethorpe",
            "Horncastle",
            "Cleethorpes",
            "Grimsby",
            "Immingham",
            "Skegness"
          ]
        },
        {
          "name": "Stamford",
          "slug": "stamford",
          "postcode": "PE9",
          "nearby_areas": [
            "Bourne",
            "Ketton",
            "Ryhall",
            "Oakham",
            "Oundle",
            "Peterborough",
            "Corby"
          ]
        },
        {
          "name": "Sleaford",
          "slug": "sleaford",
          "postcode": "NG34",
          "nearby_areas": [
            "Grantham",
            "Bourne",
            "Boston",
            "Lincoln",
            "Spalding",
            "Southwell",
            "Horncastle"
          ]
        },
        {
          "name": "Gainsborough",
          "slug": "gainsborough",
          "postcode": "DN21",
          "nearby_areas": [
            "Retford",
            "Thorne",
            "Scunthorpe",
            "Conisbrough",
            "Lincoln",
            "Brigg",
            "Worksop"
          ]
        },
        {
          "name": "Bourne",
          "slug": "bourne",
          "postcode": "PE10",
          "nearby_areas": [
            "Stamford",
            "Spalding",
            "Ketton",
            "Ryhall",
            "Oundle",
            "Whittlesey",
            "Yaxley"
          ]
        },
        {
          "name": "Mablethorpe",
          "slug": "mablethorpe",
          "postcode": "LN12",
          "nearby_areas": [
            "Louth",
            "Skegness",
            "Market Rasen",
            "Horncastle",
            "Cleethorpes",
            "Grimsby",
            "Immingham"
          ]
        },
        {
          "name": "Market Rasen",
          "slug": "market-rasen",
          "postcode": "LN8",
          "nearby_areas": [
            "Horncastle",
            "Louth",
            "Mablethorpe",
            "Skegness",
            "Cleethorpes",
            "Lincoln",
            "Grimsby"
          ]
        },
        {
          "name": "Horncastle",
          "slug": "horncastle",
          "postcode": "LN9",
          "nearby_areas": [
            "Market Rasen",
            "Louth",
            "Boston",
            "Lincoln",
            "Mablethorpe",
            "Sleaford",
            "Skegness"
          ]
        },
        {
          "name": "Brigg",
          "slug": "brigg",
          "postcode": "DN20",
          "nearby_areas": [
            "Scunthorpe",
            "Conisbrough",
            "Thorne",
            "Immingham",
            "Howden",
            "Snaith",
            "Hessle"
          ]
        },
        {
          "name": "Immingham",
          "slug": "immingham",
          "postcode": "DN40",
          "nearby_areas": [
            "Grimsby",
            "Cleethorpes",
            "Brigg",
            "Hessle",
            "Hedon",
            "Hull",
            "Withernsea"
          ]
        },
        {
          "name": "Cleethorpes",
          "slug": "cleethorpes",
          "postcode": "DN35",
          "nearby_areas": [
            "Grimsby",
            "Immingham",
            "Louth",
            "Withernsea",
            "Mablethorpe",
            "Brigg",
            "Market Rasen"
          ]
        }
      ]
    },
    {
      "name": "Merseyside",
      "slug": "merseyside",
      "region": "North West England",
      "council_name": "Liverpool City Region Combined Authority (boroughs)",
      "council_url": "https://www.liverpoolcityregion-ca.gov.uk/",
      "climate": "coastal rain and mild winters",
      "population": "1.4 million",
      "towns": [
        {
          "name": "Liverpool",
          "slug": "liverpool",
          "postcode": "L1",
          "nearby_areas": [
            "Birkenhead",
            "Wallasey",
            "Bootle",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Prescot"
          ]
        },
        {
          "name": "Birkenhead",
          "slug": "birkenhead",
          "postcode": "CH41",
          "nearby_areas": [
            "Liverpool",
            "Wallasey",
            "Bootle",
            "Bebington",
            "Crosby",
            "Maghull",
            "Kirkby"
          ]
        },
        {
          "name": "St Helens",
          "slug": "st-helens",
          "postcode": "WA10",
          "nearby_areas": [
            "Warrington",
            "Widnes",
            "Runcorn",
            "Newton-le-Willows",
            "Frodsham",
            "Prescot",
            "Northwich"
          ]
        },
        {
          "name": "Southport",
          "slug": "southport",
          "postcode": "PR8",
          "nearby_areas": [
            "Ormskirk",
            "Preston",
            "Garstang",
            "Formby",
            "Huyton",
            "Skelmersdale",
            "Blackpool"
          ]
        },
        {
          "name": "Wallasey",
          "slug": "wallasey",
          "postcode": "CH44",
          "nearby_areas": [
            "Birkenhead",
            "Liverpool",
            "Bootle",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Huyton"
          ]
        },
        {
          "name": "Bootle",
          "slug": "bootle",
          "postcode": "L20",
          "nearby_areas": [
            "Crosby",
            "Maghull",
            "Kirkby",
            "Huyton",
            "Formby",
            "Prescot",
            "Liverpool"
          ]
        },
        {
          "name": "Crosby",
          "slug": "crosby",
          "postcode": "L23",
          "nearby_areas": [
            "Bootle",
            "Maghull",
            "Kirkby",
            "Huyton",
            "Formby",
            "Prescot",
            "Liverpool"
          ]
        },
        {
          "name": "Formby",
          "slug": "formby",
          "postcode": "L37",
          "nearby_areas": [
            "Huyton",
            "Crosby",
            "Maghull",
            "Kirkby",
            "Bootle",
            "Ormskirk",
            "Skelmersdale"
          ]
        },
        {
          "name": "Prescot",
          "slug": "prescot",
          "postcode": "L34",
          "nearby_areas": [
            "Kirkby",
            "Maghull",
            "Crosby",
            "Bootle",
            "Huyton",
            "Formby",
            "Widnes"
          ]
        },
        {
          "name": "Kirkby",
          "slug": "kirkby",
          "postcode": "L32",
          "nearby_areas": [
            "Maghull",
            "Huyton",
            "Crosby",
            "Bootle",
            "Prescot",
            "Formby",
            "Skelmersdale"
          ]
        },
        {
          "name": "Huyton",
          "slug": "huyton",
          "postcode": "L36",
          "nearby_areas": [
            "Maghull",
            "Formby",
            "Kirkby",
            "Crosby",
            "Bootle",
            "Prescot",
            "Skelmersdale"
          ]
        },
        {
          "name": "Maghull",
          "slug": "maghull",
          "postcode": "L31",
          "nearby_areas": [
            "Kirkby",
            "Huyton",
            "Crosby",
            "Bootle",
            "Formby",
            "Prescot",
            "Skelmersdale"
          ]
        },
        {
          "name": "Bebington",
          "slug": "bebington",
          "postcode": "CH63",
          "nearby_areas": [
            "Ellesmere Port",
            "Birkenhead",
            "Chester",
            "Liverpool",
            "Connah's Quay",
            "Shotton",
            "Flint"
          ]
        },
        {
          "name": "Newton-le-Willows",
          "slug": "newton-le-willows",
          "postcode": "WA12",
          "nearby_areas": [
            "Warrington",
            "St Helens",
            "Wigan",
            "Prescot",
            "Widnes",
            "Kirkby",
            "Maghull"
          ]
        }
      ]
    },
    {
      "name": "Merthyr Tydfil",
      "slug": "merthyr-tydfil",
      "region": "Wales",
      "council_name": "Merthyr Tydfil County Borough Council",
      "council_url": "https://www.merthyr.gov.uk/",
      "climate": "cool, wet valleys climate",
      "population": "58,000",
      "towns": [
        {
          "name": "Merthyr Tydfil",
          "slug": "merthyr-tydfil",
          "postcode": "CF47",
          "nearby_areas": [
            "Aberdare",
            "Mountain Ash",
            "Tredegar",
            "Treharris",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw"
          ]
        },
        {
          "name": "Treharris",
          "slug": "treharris",
          "postcode": "CF46",
          "nearby_areas": [
            "Mountain Ash",
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Pontypridd",
            "Blackwood"
          ]
        },
        {
          "name": "Dowlais",
          "slug": "dowlais",
          "postcode": "CF48",
          "nearby_areas": [
            "Aberfan",
            "Troedyrhiw",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        },
        {
          "name": "Aberfan",
          "slug": "aberfan",
          "postcode": "CF48",
          "nearby_areas": [
            "Dowlais",
            "Troedyrhiw",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        },
        {
          "name": "Troedyrhiw",
          "slug": "troedyrhiw",
          "postcode": "CF48",
          "nearby_areas": [
            "Aberfan",
            "Dowlais",
            "Nelson",
            "Porth",
            "Mountain Ash",
            "Tonypandy",
            "Treharris"
          ]
        }
      ]
    },
    {
      "name": "Midlothian",
      "slug": "midlothian",
      "region": "Scotland",
      "council_name": "Midlothian Council",
      "council_url": "https://www.midlothian.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Dalkeith",
          "slug": "dalkeith",
          "postcode": "EH22",
          "nearby_areas": [
            "Musselburgh",
            "Gorebridge",
            "Loanhead",
            "Bonnyrigg",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Bonnyrigg",
          "slug": "bonnyrigg",
          "postcode": "EH19",
          "nearby_areas": [
            "Loanhead",
            "Musselburgh",
            "Portobello",
            "Dalkeith",
            "Gorebridge",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Penicuik",
          "slug": "penicuik",
          "postcode": "EH26",
          "nearby_areas": [
            "Whitburn",
            "Gorebridge",
            "Dalkeith",
            "Loanhead",
            "Bonnyrigg",
            "Musselburgh",
            "Portobello"
          ]
        },
        {
          "name": "Loanhead",
          "slug": "loanhead",
          "postcode": "EH20",
          "nearby_areas": [
            "Bonnyrigg",
            "Musselburgh",
            "Dalkeith",
            "Portobello",
            "Gorebridge",
            "Corstorphine",
            "Morningside"
          ]
        },
        {
          "name": "Gorebridge",
          "slug": "gorebridge",
          "postcode": "EH23",
          "nearby_areas": [
            "Dalkeith",
            "Musselburgh",
            "Loanhead",
            "Bonnyrigg",
            "Portobello",
            "Corstorphine",
            "Morningside"
          ]
        }
      ]
    },
    {
      "name": "Monmouthshire",
      "slug": "monmouthshire",
      "region": "Wales",
      "council_name": "Monmouthshire County Council",
      "council_url": "https://www.monmouthshire.gov.uk/",
      "climate": "mild, damp rural climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Abergavenny",
          "slug": "abergavenny",
          "postcode": "NP7",
          "nearby_areas": [
            "Brynmawr",
            "Nantyglo",
            "Blaenavon",
            "New Inn",
            "Abersychan",
            "Abertillery",
            "Pontypool"
          ]
        },
        {
          "name": "Chepstow",
          "slug": "chepstow",
          "postcode": "NP16",
          "nearby_areas": [
            "Caldicot",
            "Lydney",
            "Monmouth",
            "Bristol",
            "Bedminster",
            "Knowle",
            "Dursley"
          ]
        },
        {
          "name": "Monmouth",
          "slug": "monmouth",
          "postcode": "NP25",
          "nearby_areas": [
            "Ross-on-Wye",
            "Cinderford",
            "Chepstow",
            "Lydney",
            "Abergavenny",
            "Caldicot",
            "Abersychan"
          ]
        },
        {
          "name": "Caldicot",
          "slug": "caldicot",
          "postcode": "NP26",
          "nearby_areas": [
            "Chepstow",
            "Knowle",
            "Bedminster",
            "St George",
            "Redland",
            "Bishopston",
            "Horfield"
          ]
        },
        {
          "name": "Usk",
          "slug": "usk",
          "postcode": "NP15",
          "nearby_areas": [
            "Raglan",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Blaina",
            "Malpas",
            "Newport"
          ]
        },
        {
          "name": "Raglan",
          "slug": "raglan",
          "postcode": "NP15",
          "nearby_areas": [
            "Usk",
            "Caerleon",
            "Langstone",
            "Cwmbran",
            "Blaina",
            "Malpas",
            "Newport"
          ]
        }
      ]
    },
    {
      "name": "Moray",
      "slug": "moray",
      "region": "Scotland",
      "council_name": "Moray Council",
      "council_url": "https://www.moray.gov.uk/",
      "climate": "cool north-east climate",
      "population": "95,000",
      "towns": [
        {
          "name": "Elgin",
          "slug": "elgin",
          "postcode": "IV30",
          "nearby_areas": [
            "Lossiemouth",
            "Fochabers",
            "Forres",
            "Ullapool",
            "Buckie",
            "Portree",
            "Nairn"
          ]
        },
        {
          "name": "Forres",
          "slug": "forres",
          "postcode": "IV36",
          "nearby_areas": [
            "Ullapool",
            "Portree",
            "Fochabers",
            "Nairn",
            "Elgin",
            "Inverness",
            "Lossiemouth"
          ]
        },
        {
          "name": "Buckie",
          "slug": "buckie",
          "postcode": "AB56",
          "nearby_areas": [
            "Lossiemouth",
            "Elgin",
            "Keith",
            "Fochabers",
            "Forres",
            "Huntly",
            "Ullapool"
          ]
        },
        {
          "name": "Lossiemouth",
          "slug": "lossiemouth",
          "postcode": "IV31",
          "nearby_areas": [
            "Elgin",
            "Fochabers",
            "Buckie",
            "Forres",
            "Ullapool",
            "Portree",
            "Nairn"
          ]
        },
        {
          "name": "Keith",
          "slug": "keith",
          "postcode": "AB55",
          "nearby_areas": [
            "Huntly",
            "Turriff",
            "Inverurie",
            "Buckie",
            "Banff",
            "Aberdeen",
            "Cove Bay"
          ]
        },
        {
          "name": "Fochabers",
          "slug": "fochabers",
          "postcode": "IV32",
          "nearby_areas": [
            "Elgin",
            "Forres",
            "Ullapool",
            "Lossiemouth",
            "Portree",
            "Nairn",
            "Inverness"
          ]
        }
      ]
    },
    {
      "name": "Na h-Eileanan Siar",
      "slug": "na-h-eileanan-siar",
      "region": "Scotland",
      "council_name": "Comhairle nan Eilean Siar",
      "council_url": "https://www.cne-siar.gov.uk/",
      "climate": "very windy Atlantic island climate",
      "population": "27,000",
      "towns": [
        {
          "name": "Stornoway",
          "slug": "stornoway",
          "postcode": "HS1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Tarbert",
          "slug": "tarbert",
          "postcode": "HS3",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Benbecula",
          "slug": "benbecula",
          "postcode": "HS7",
          "nearby_areas": [
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Lochboisdale",
          "slug": "lochboisdale",
          "postcode": "HS8",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Castlebay",
          "slug": "castlebay",
          "postcode": "HS9",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        }
      ]
    },
    {
      "name": "Neath Port Talbot",
      "slug": "neath-port-talbot",
      "region": "Wales",
      "council_name": "Neath Port Talbot Council",
      "council_url": "https://www.npt.gov.uk/",
      "climate": "wet coastal and valleys climate",
      "population": "140,000",
      "towns": [
        {
          "name": "Neath",
          "slug": "neath",
          "postcode": "SA11",
          "nearby_areas": [
            "Briton Ferry",
            "Glynneath",
            "Port Talbot",
            "Swansea",
            "Cymmer",
            "Maesteg",
            "Pontardawe"
          ]
        },
        {
          "name": "Port Talbot",
          "slug": "port-talbot",
          "postcode": "SA12",
          "nearby_areas": [
            "Neath",
            "Maesteg",
            "Briton Ferry",
            "Glynneath",
            "Swansea",
            "Cymmer",
            "Porthcawl"
          ]
        },
        {
          "name": "Pontardawe",
          "slug": "pontardawe",
          "postcode": "SA8",
          "nearby_areas": [
            "Ystradgynlais",
            "Cymmer",
            "Clydach",
            "Morriston",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais"
          ]
        },
        {
          "name": "Glynneath",
          "slug": "glynneath",
          "postcode": "SA11",
          "nearby_areas": [
            "Briton Ferry",
            "Swansea",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Neath",
            "Clydach"
          ]
        },
        {
          "name": "Briton Ferry",
          "slug": "briton-ferry",
          "postcode": "SA11",
          "nearby_areas": [
            "Glynneath",
            "Swansea",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Neath",
            "Clydach"
          ]
        },
        {
          "name": "Cymmer",
          "slug": "cymmer",
          "postcode": "SA13",
          "nearby_areas": [
            "Ystradgynlais",
            "Pontardawe",
            "Swansea",
            "Clydach",
            "Morriston",
            "Mumbles",
            "Gorseinon"
          ]
        }
      ]
    },
    {
      "name": "Newport",
      "slug": "newport",
      "region": "Wales",
      "council_name": "Newport City Council",
      "council_url": "https://www.newport.gov.uk/",
      "climate": "mild damp estuary climate",
      "population": "160,000",
      "towns": [
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "NP20",
          "nearby_areas": [
            "Malpas",
            "Cwmbran",
            "Caerleon",
            "Langstone",
            "Blaenavon",
            "New Inn",
            "Brynmawr"
          ]
        },
        {
          "name": "Caerleon",
          "slug": "caerleon",
          "postcode": "NP18",
          "nearby_areas": [
            "Langstone",
            "Cwmbran",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        },
        {
          "name": "Rogerstone",
          "slug": "rogerstone",
          "postcode": "NP10",
          "nearby_areas": [
            "Ellesmere",
            "Welshpool",
            "Whitchurch",
            "Oswestry",
            "Newtown",
            "Machynlleth",
            "Church Stretton"
          ]
        },
        {
          "name": "Malpas",
          "slug": "malpas",
          "postcode": "NP20",
          "nearby_areas": [
            "Newport",
            "Cwmbran",
            "Caerleon",
            "Langstone",
            "Blaenavon",
            "New Inn",
            "Brynmawr"
          ]
        },
        {
          "name": "Marshfield",
          "slug": "marshfield",
          "postcode": "CF3",
          "nearby_areas": [
            "Whitchurch",
            "Radyr",
            "Canton",
            "Llandaff",
            "Llantrisant",
            "Cowbridge",
            "Bargoed"
          ]
        },
        {
          "name": "Langstone",
          "slug": "langstone",
          "postcode": "NP18",
          "nearby_areas": [
            "Caerleon",
            "Cwmbran",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        }
      ]
    },
    {
      "name": "Norfolk",
      "slug": "norfolk",
      "region": "East of England",
      "council_name": "Norfolk County Council",
      "council_url": "https://www.norfolk.gov.uk/",
      "climate": "dry eastern weather with coastal winds",
      "population": "920,000",
      "towns": [
        {
          "name": "Norwich",
          "slug": "norwich",
          "postcode": "NR1",
          "nearby_areas": [
            "Aylsham",
            "Wymondham",
            "Holt",
            "North Walsham",
            "Attleborough",
            "Dereham",
            "Great Yarmouth"
          ]
        },
        {
          "name": "King's Lynn",
          "slug": "king-s-lynn",
          "postcode": "PE30",
          "nearby_areas": [
            "March",
            "St Ives",
            "Wisbech",
            "Chatteris",
            "Whittlesey",
            "Yaxley",
            "Peterborough"
          ]
        },
        {
          "name": "Great Yarmouth",
          "slug": "great-yarmouth",
          "postcode": "NR30",
          "nearby_areas": [
            "Lowestoft",
            "Beccles",
            "Norwich",
            "North Walsham",
            "Holt",
            "Aylsham",
            "Wymondham"
          ]
        },
        {
          "name": "Thetford",
          "slug": "thetford",
          "postcode": "IP24",
          "nearby_areas": [
            "Eye",
            "Bury St Edmunds",
            "Attleborough",
            "Mildenhall",
            "Diss",
            "Swaffham",
            "Dereham"
          ]
        },
        {
          "name": "Dereham",
          "slug": "dereham",
          "postcode": "NR19",
          "nearby_areas": [
            "Wymondham",
            "Swaffham",
            "Fakenham",
            "Aylsham",
            "Attleborough",
            "Norwich",
            "Holt"
          ]
        },
        {
          "name": "Wymondham",
          "slug": "wymondham",
          "postcode": "NR18",
          "nearby_areas": [
            "Aylsham",
            "Dereham",
            "Norwich",
            "Holt",
            "Attleborough",
            "Fakenham",
            "North Walsham"
          ]
        },
        {
          "name": "North Walsham",
          "slug": "north-walsham",
          "postcode": "NR28",
          "nearby_areas": [
            "Holt",
            "Cromer",
            "Sheringham",
            "Aylsham",
            "Norwich",
            "Wymondham",
            "Great Yarmouth"
          ]
        },
        {
          "name": "Attleborough",
          "slug": "attleborough",
          "postcode": "NR17",
          "nearby_areas": [
            "Diss",
            "Wymondham",
            "Dereham",
            "Thetford",
            "Aylsham",
            "Norwich",
            "Eye"
          ]
        },
        {
          "name": "Diss",
          "slug": "diss",
          "postcode": "IP22",
          "nearby_areas": [
            "Eye",
            "Attleborough",
            "Mildenhall",
            "Saxmundham",
            "Thetford",
            "Stowmarket",
            "Aldeburgh"
          ]
        },
        {
          "name": "Fakenham",
          "slug": "fakenham",
          "postcode": "NR21",
          "nearby_areas": [
            "Dereham",
            "Swaffham",
            "Wymondham",
            "Sheringham",
            "Aylsham",
            "Holt",
            "Cromer"
          ]
        },
        {
          "name": "Cromer",
          "slug": "cromer",
          "postcode": "NR27",
          "nearby_areas": [
            "Sheringham",
            "North Walsham",
            "Holt",
            "Aylsham",
            "Wymondham",
            "Fakenham",
            "Norwich"
          ]
        },
        {
          "name": "Downham Market",
          "slug": "downham-market",
          "postcode": "PE38",
          "nearby_areas": [
            "Wisbech",
            "Swaffham",
            "March",
            "King's Lynn",
            "St Ives",
            "Ely",
            "Ramsey"
          ]
        },
        {
          "name": "Swaffham",
          "slug": "swaffham",
          "postcode": "PE37",
          "nearby_areas": [
            "Dereham",
            "Downham Market",
            "Fakenham",
            "Thetford",
            "Attleborough",
            "Wymondham",
            "Aylsham"
          ]
        },
        {
          "name": "Sheringham",
          "slug": "sheringham",
          "postcode": "NR26",
          "nearby_areas": [
            "Cromer",
            "North Walsham",
            "Holt",
            "Fakenham",
            "Aylsham",
            "Wymondham",
            "Dereham"
          ]
        },
        {
          "name": "Holt",
          "slug": "holt",
          "postcode": "NR25",
          "nearby_areas": [
            "North Walsham",
            "Aylsham",
            "Cromer",
            "Norwich",
            "Wymondham",
            "Sheringham",
            "Dereham"
          ]
        },
        {
          "name": "Aylsham",
          "slug": "aylsham",
          "postcode": "NR11",
          "nearby_areas": [
            "Wymondham",
            "Norwich",
            "Holt",
            "Dereham",
            "North Walsham",
            "Attleborough",
            "Cromer"
          ]
        }
      ]
    },
    {
      "name": "North Ayrshire",
      "slug": "north-ayrshire",
      "region": "Scotland",
      "council_name": "North Ayrshire Council",
      "council_url": "https://www.north-ayrshire.gov.uk/",
      "climate": "wet west coast climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Irvine",
          "slug": "irvine",
          "postcode": "KA12",
          "nearby_areas": [
            "Kilwinning",
            "Stevenston",
            "Ardrossan",
            "Saltcoats",
            "Stewarton",
            "Prestwick",
            "Troon"
          ]
        },
        {
          "name": "Kilwinning",
          "slug": "kilwinning",
          "postcode": "KA13",
          "nearby_areas": [
            "Irvine",
            "Saltcoats",
            "Ardrossan",
            "Stevenston",
            "Stewarton",
            "Prestwick",
            "Troon"
          ]
        },
        {
          "name": "Saltcoats",
          "slug": "saltcoats",
          "postcode": "KA21",
          "nearby_areas": [
            "Kilwinning",
            "Irvine",
            "Ardrossan",
            "Stevenston",
            "Troon",
            "Prestwick",
            "Stewarton"
          ]
        },
        {
          "name": "Ardrossan",
          "slug": "ardrossan",
          "postcode": "KA22",
          "nearby_areas": [
            "Troon",
            "Stevenston",
            "Prestwick",
            "Mauchline",
            "Dalmellington",
            "Stewarton",
            "Irvine"
          ]
        },
        {
          "name": "Largs",
          "slug": "largs",
          "postcode": "KA30",
          "nearby_areas": [
            "Saltcoats",
            "Kilwinning",
            "Greenock",
            "Port Glasgow",
            "Inverkip",
            "Irvine",
            "Kilmacolm"
          ]
        },
        {
          "name": "Stevenston",
          "slug": "stevenston",
          "postcode": "KA20",
          "nearby_areas": [
            "Prestwick",
            "Mauchline",
            "Troon",
            "Dalmellington",
            "Stewarton",
            "Ardrossan",
            "Maybole"
          ]
        }
      ]
    },
    {
      "name": "North Lanarkshire",
      "slug": "north-lanarkshire",
      "region": "Scotland",
      "council_name": "North Lanarkshire Council",
      "council_url": "https://www.northlanarkshire.gov.uk/",
      "climate": "cool, wet central belt climate",
      "population": "340,000",
      "towns": [
        {
          "name": "Motherwell",
          "slug": "motherwell",
          "postcode": "ML1",
          "nearby_areas": [
            "Bellshill",
            "Wishaw",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "Coatbridge",
          "slug": "coatbridge",
          "postcode": "ML5",
          "nearby_areas": [
            "Airdrie",
            "Bellshill",
            "Motherwell",
            "Biggar",
            "Lanark",
            "Wishaw",
            "Larkhall"
          ]
        },
        {
          "name": "Airdrie",
          "slug": "airdrie",
          "postcode": "ML6",
          "nearby_areas": [
            "Biggar",
            "Lanark",
            "Coatbridge",
            "Bellshill",
            "Motherwell",
            "Larkhall",
            "Wishaw"
          ]
        },
        {
          "name": "Cumbernauld",
          "slug": "cumbernauld",
          "postcode": "G67",
          "nearby_areas": [
            "Kirkintilloch",
            "Lennoxtown",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Cambuslang",
            "Clydebank"
          ]
        },
        {
          "name": "Wishaw",
          "slug": "wishaw",
          "postcode": "ML2",
          "nearby_areas": [
            "Motherwell",
            "Bellshill",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Hamilton",
            "Biggar"
          ]
        },
        {
          "name": "Bellshill",
          "slug": "bellshill",
          "postcode": "ML4",
          "nearby_areas": [
            "Motherwell",
            "Wishaw",
            "Coatbridge",
            "Larkhall",
            "Airdrie",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "Kilsyth",
          "slug": "kilsyth",
          "postcode": "G65",
          "nearby_areas": [
            "Kirkintilloch",
            "Lennoxtown",
            "Bishopbriggs",
            "Cumbernauld",
            "Balfron",
            "Milngavie",
            "Bearsden"
          ]
        }
      ]
    },
    {
      "name": "North Yorkshire",
      "slug": "north-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "North Yorkshire Council",
      "council_url": "https://www.northyorkshire.gov.uk/",
      "climate": "upland rainfall, cold winters and coastal winds",
      "population": "1.2 million",
      "towns": [
        {
          "name": "York",
          "slug": "york",
          "postcode": "YO1",
          "nearby_areas": [
            "Selby",
            "Knaresborough",
            "Malton",
            "Harrogate",
            "Ripon",
            "Thirsk",
            "Goole"
          ]
        },
        {
          "name": "Middlesbrough",
          "slug": "middlesbrough",
          "postcode": "TS1",
          "nearby_areas": [
            "Stockton-on-Tees",
            "Stokesley",
            "Redcar",
            "Hartlepool",
            "Darlington",
            "Peterlee",
            "Newton Aycliffe"
          ]
        },
        {
          "name": "Harrogate",
          "slug": "harrogate",
          "postcode": "HG1",
          "nearby_areas": [
            "Knaresborough",
            "Ripon",
            "Otley",
            "Morley",
            "Ilkley",
            "Leeds",
            "Settle"
          ]
        },
        {
          "name": "Scarborough",
          "slug": "scarborough",
          "postcode": "YO11",
          "nearby_areas": [
            "Filey",
            "Pocklington",
            "Market Weighton",
            "Pickering",
            "Whitby",
            "Bridlington",
            "Malton"
          ]
        },
        {
          "name": "Redcar",
          "slug": "redcar",
          "postcode": "TS10",
          "nearby_areas": [
            "Stokesley",
            "Middlesbrough",
            "Hartlepool",
            "Stockton-on-Tees",
            "Peterlee",
            "Whitby",
            "Seaham"
          ]
        },
        {
          "name": "Northallerton",
          "slug": "northallerton",
          "postcode": "DL7",
          "nearby_areas": [
            "Thirsk",
            "Richmond",
            "Ripon",
            "Darlington",
            "Middlesbrough",
            "Stockton-on-Tees",
            "Stokesley"
          ]
        },
        {
          "name": "Skipton",
          "slug": "skipton",
          "postcode": "BD23",
          "nearby_areas": [
            "Settle",
            "Keighley",
            "Ilkley",
            "Morley",
            "Colne",
            "Otley",
            "Shipley"
          ]
        },
        {
          "name": "Richmond",
          "slug": "richmond",
          "postcode": "DL10",
          "nearby_areas": [
            "Northallerton",
            "Darlington",
            "Barnard Castle",
            "Shildon",
            "Thirsk",
            "Newton Aycliffe",
            "Ripon"
          ]
        },
        {
          "name": "Ripon",
          "slug": "ripon",
          "postcode": "HG4",
          "nearby_areas": [
            "Knaresborough",
            "Harrogate",
            "Thirsk",
            "Northallerton",
            "Richmond",
            "Morley",
            "Ilkley"
          ]
        },
        {
          "name": "Whitby",
          "slug": "whitby",
          "postcode": "YO21",
          "nearby_areas": [
            "Scarborough",
            "Pickering",
            "Redcar",
            "Stokesley",
            "Filey",
            "Malton",
            "Middlesbrough"
          ]
        },
        {
          "name": "Selby",
          "slug": "selby",
          "postcode": "YO8",
          "nearby_areas": [
            "Goole",
            "York",
            "Pontefract",
            "Castleford",
            "Howden",
            "Snaith",
            "Doncaster"
          ]
        },
        {
          "name": "Malton",
          "slug": "malton",
          "postcode": "YO17",
          "nearby_areas": [
            "Market Weighton",
            "Pocklington",
            "Pickering",
            "York",
            "Scarborough",
            "Driffield",
            "Filey"
          ]
        },
        {
          "name": "Thirsk",
          "slug": "thirsk",
          "postcode": "YO7",
          "nearby_areas": [
            "Northallerton",
            "Ripon",
            "Knaresborough",
            "Harrogate",
            "Richmond",
            "York",
            "Pickering"
          ]
        },
        {
          "name": "Knaresborough",
          "slug": "knaresborough",
          "postcode": "HG5",
          "nearby_areas": [
            "Harrogate",
            "Ripon",
            "Otley",
            "York",
            "Thirsk",
            "Leeds",
            "Morley"
          ]
        },
        {
          "name": "Filey",
          "slug": "filey",
          "postcode": "YO14",
          "nearby_areas": [
            "Scarborough",
            "Bridlington",
            "Driffield",
            "Pocklington",
            "Market Weighton",
            "Pickering",
            "Malton"
          ]
        },
        {
          "name": "Pickering",
          "slug": "pickering",
          "postcode": "YO18",
          "nearby_areas": [
            "Malton",
            "Market Weighton",
            "Pocklington",
            "Scarborough",
            "Whitby",
            "Filey",
            "Thirsk"
          ]
        },
        {
          "name": "Settle",
          "slug": "settle",
          "postcode": "BD24",
          "nearby_areas": [
            "Keighley",
            "Ilkley",
            "Morley",
            "Skipton",
            "Shipley",
            "Otley",
            "Bradford"
          ]
        },
        {
          "name": "Stokesley",
          "slug": "stokesley",
          "postcode": "TS9",
          "nearby_areas": [
            "Redcar",
            "Middlesbrough",
            "Hartlepool",
            "Stockton-on-Tees",
            "Peterlee",
            "Newton Aycliffe",
            "Darlington"
          ]
        }
      ]
    },
    {
      "name": "Northamptonshire",
      "slug": "northamptonshire",
      "region": "East Midlands",
      "council_name": "North Northamptonshire/West Northamptonshire",
      "council_url": "https://www.gov.uk/find-local-council",
      "climate": "cool winters with moderate rainfall",
      "population": "790,000",
      "towns": [
        {
          "name": "Northampton",
          "slug": "northampton",
          "postcode": "NN1",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Kettering",
          "slug": "kettering",
          "postcode": "NN16",
          "nearby_areas": [
            "Wellingborough",
            "Corby",
            "Rushden",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Market Harborough"
          ]
        },
        {
          "name": "Corby",
          "slug": "corby",
          "postcode": "NN17",
          "nearby_areas": [
            "Kettering",
            "Market Harborough",
            "Wellingborough",
            "Oakham",
            "Rushden",
            "Stamford",
            "Cottesmore"
          ]
        },
        {
          "name": "Wellingborough",
          "slug": "wellingborough",
          "postcode": "NN8",
          "nearby_areas": [
            "Rushden",
            "Higham Ferrers",
            "Irthlingborough",
            "Raunds",
            "Kettering",
            "Moulton",
            "Northampton"
          ]
        },
        {
          "name": "Rushden",
          "slug": "rushden",
          "postcode": "NN10",
          "nearby_areas": [
            "Wellingborough",
            "Kettering",
            "Higham Ferrers",
            "Irthlingborough",
            "Raunds",
            "Moulton",
            "Olney"
          ]
        },
        {
          "name": "Daventry",
          "slug": "daventry",
          "postcode": "NN11",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Rugby",
            "Northampton",
            "Towcester",
            "Moulton",
            "Irthlingborough"
          ]
        },
        {
          "name": "Towcester",
          "slug": "towcester",
          "postcode": "NN12",
          "nearby_areas": [
            "Desborough",
            "Thrapston",
            "Northampton",
            "Brackley",
            "Moulton",
            "Winslow",
            "Irthlingborough"
          ]
        },
        {
          "name": "Brackley",
          "slug": "brackley",
          "postcode": "NN13",
          "nearby_areas": [
            "Buckingham",
            "Towcester",
            "Banbury",
            "Bicester",
            "Winslow",
            "Daventry",
            "Woburn"
          ]
        },
        {
          "name": "Desborough",
          "slug": "desborough",
          "postcode": "NN14",
          "nearby_areas": [
            "Thrapston",
            "Northampton",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Raunds",
          "slug": "raunds",
          "postcode": "NN9",
          "nearby_areas": [
            "Irthlingborough",
            "Higham Ferrers",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Higham Ferrers",
          "slug": "higham-ferrers",
          "postcode": "NN10",
          "nearby_areas": [
            "Irthlingborough",
            "Raunds",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Irthlingborough",
          "slug": "irthlingborough",
          "postcode": "NN9",
          "nearby_areas": [
            "Raunds",
            "Higham Ferrers",
            "Moulton",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        },
        {
          "name": "Oundle",
          "slug": "oundle",
          "postcode": "PE8",
          "nearby_areas": [
            "Whittlesey",
            "Yaxley",
            "Ketton",
            "Ryhall",
            "Peterborough",
            "Spalding",
            "Bourne"
          ]
        },
        {
          "name": "Thrapston",
          "slug": "thrapston",
          "postcode": "NN14",
          "nearby_areas": [
            "Desborough",
            "Northampton",
            "Moulton",
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Towcester"
          ]
        },
        {
          "name": "Moulton",
          "slug": "moulton",
          "postcode": "NN3",
          "nearby_areas": [
            "Irthlingborough",
            "Raunds",
            "Higham Ferrers",
            "Northampton",
            "Desborough",
            "Thrapston",
            "Wellingborough"
          ]
        }
      ]
    },
    {
      "name": "Northumberland",
      "slug": "northumberland",
      "region": "North East England",
      "council_name": "Northumberland Council",
      "council_url": "https://www.northumberland.gov.uk/",
      "climate": "cool, exposed and wet in upland areas",
      "population": "320,000",
      "towns": [
        {
          "name": "Blyth",
          "slug": "blyth",
          "postcode": "NE24",
          "nearby_areas": [
            "Ponteland",
            "Blaydon",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Whitley Bay"
          ]
        },
        {
          "name": "Cramlington",
          "slug": "cramlington",
          "postcode": "NE23",
          "nearby_areas": [
            "Blaydon",
            "Ponteland",
            "Blyth",
            "Bedlington",
            "Ashington",
            "North Shields",
            "Tynemouth"
          ]
        },
        {
          "name": "Ashington",
          "slug": "ashington",
          "postcode": "NE63",
          "nearby_areas": [
            "Morpeth",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Newbiggin-by-the-Sea",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Hexham",
          "slug": "hexham",
          "postcode": "NE46",
          "nearby_areas": [
            "Prudhoe",
            "Corbridge",
            "Consett",
            "Haltwhistle",
            "Stanley",
            "Morpeth",
            "Ponteland"
          ]
        },
        {
          "name": "Morpeth",
          "slug": "morpeth",
          "postcode": "NE61",
          "nearby_areas": [
            "Ashington",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Cramlington",
            "Newbiggin-by-the-Sea",
            "Ponteland"
          ]
        },
        {
          "name": "Berwick-upon-Tweed",
          "slug": "berwick-upon-tweed",
          "postcode": "TD15",
          "nearby_areas": [
            "Eyemouth",
            "Kelso",
            "Alnwick",
            "Melrose",
            "Dunbar",
            "Jedburgh",
            "Haddington"
          ]
        },
        {
          "name": "Alnwick",
          "slug": "alnwick",
          "postcode": "NE66",
          "nearby_areas": [
            "Amble",
            "Rothbury",
            "Morpeth",
            "Ashington",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington"
          ]
        },
        {
          "name": "Prudhoe",
          "slug": "prudhoe",
          "postcode": "NE42",
          "nearby_areas": [
            "Corbridge",
            "Haltwhistle",
            "Consett",
            "Stanley",
            "Hexham",
            "Gateshead",
            "Newcastle upon Tyne"
          ]
        },
        {
          "name": "Ponteland",
          "slug": "ponteland",
          "postcode": "NE20",
          "nearby_areas": [
            "Blyth",
            "Blaydon",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Bedlington"
          ]
        },
        {
          "name": "Bedlington",
          "slug": "bedlington",
          "postcode": "NE22",
          "nearby_areas": [
            "Ashington",
            "Cramlington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Ponteland",
            "Blaydon",
            "Amble"
          ]
        },
        {
          "name": "Amble",
          "slug": "amble",
          "postcode": "NE65",
          "nearby_areas": [
            "Rothbury",
            "Ashington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Haltwhistle",
          "slug": "haltwhistle",
          "postcode": "NE49",
          "nearby_areas": [
            "Corbridge",
            "Ponteland",
            "Newcastle upon Tyne",
            "Blyth",
            "Cramlington",
            "Prudhoe",
            "Blaydon"
          ]
        },
        {
          "name": "Rothbury",
          "slug": "rothbury",
          "postcode": "NE65",
          "nearby_areas": [
            "Amble",
            "Ashington",
            "Morpeth",
            "Newbiggin-by-the-Sea",
            "Bedlington",
            "Cramlington",
            "Ponteland"
          ]
        },
        {
          "name": "Corbridge",
          "slug": "corbridge",
          "postcode": "NE45",
          "nearby_areas": [
            "Haltwhistle",
            "Prudhoe",
            "Newcastle upon Tyne",
            "Gateshead",
            "Ponteland",
            "Blyth",
            "Cramlington"
          ]
        },
        {
          "name": "Newbiggin-by-the-Sea",
          "slug": "newbiggin-by-the-sea",
          "postcode": "NE64",
          "nearby_areas": [
            "Ashington",
            "Amble",
            "Rothbury",
            "Bedlington",
            "Morpeth",
            "Cramlington",
            "Ponteland"
          ]
        }
      ]
    },
    {
      "name": "Nottinghamshire",
      "slug": "nottinghamshire",
      "region": "East Midlands",
      "council_name": "Nottinghamshire County Council",
      "council_url": "https://www.nottinghamshire.gov.uk/",
      "climate": "cool damp winters and moderate rainfall",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Nottingham",
          "slug": "nottingham",
          "postcode": "NG1",
          "nearby_areas": [
            "West Bridgford",
            "Carlton",
            "Arnold",
            "Ilkeston",
            "Beeston",
            "Bingham",
            "Long Eaton"
          ]
        },
        {
          "name": "Mansfield",
          "slug": "mansfield",
          "postcode": "NG18",
          "nearby_areas": [
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Hucknall",
            "Alfreton",
            "Bingham",
            "Worksop",
            "Beeston"
          ]
        },
        {
          "name": "Worksop",
          "slug": "worksop",
          "postcode": "S80",
          "nearby_areas": [
            "Retford",
            "Mansfield",
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Dinnington",
            "Chesterfield"
          ]
        },
        {
          "name": "Newark-on-Trent",
          "slug": "newark-on-trent",
          "postcode": "NG24",
          "nearby_areas": [
            "Southwell",
            "Ollerton",
            "Beeston",
            "Bingham",
            "Long Eaton",
            "Hucknall",
            "Arnold"
          ]
        },
        {
          "name": "Sutton-in-Ashfield",
          "slug": "sutton-in-ashfield",
          "postcode": "NG17",
          "nearby_areas": [
            "Kirkby-in-Ashfield",
            "Hucknall",
            "Bingham",
            "Beeston",
            "Mansfield",
            "Long Eaton",
            "Arnold"
          ]
        },
        {
          "name": "Beeston",
          "slug": "beeston",
          "postcode": "NG9",
          "nearby_areas": [
            "Long Eaton",
            "Bingham",
            "Arnold",
            "Carlton",
            "Hucknall",
            "Ollerton",
            "West Bridgford"
          ]
        },
        {
          "name": "Arnold",
          "slug": "arnold",
          "postcode": "NG5",
          "nearby_areas": [
            "Carlton",
            "Beeston",
            "West Bridgford",
            "Long Eaton",
            "Bingham",
            "Hucknall",
            "Nottingham"
          ]
        },
        {
          "name": "Retford",
          "slug": "retford",
          "postcode": "DN22",
          "nearby_areas": [
            "Worksop",
            "Gainsborough",
            "Mansfield",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Hucknall",
            "Bingham"
          ]
        },
        {
          "name": "West Bridgford",
          "slug": "west-bridgford",
          "postcode": "NG2",
          "nearby_areas": [
            "Carlton",
            "Nottingham",
            "Arnold",
            "Beeston",
            "Long Eaton",
            "Bingham",
            "Hucknall"
          ]
        },
        {
          "name": "Hucknall",
          "slug": "hucknall",
          "postcode": "NG15",
          "nearby_areas": [
            "Bingham",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield",
            "Beeston",
            "Long Eaton",
            "Ollerton",
            "Arnold"
          ]
        },
        {
          "name": "Kirkby-in-Ashfield",
          "slug": "kirkby-in-ashfield",
          "postcode": "NG17",
          "nearby_areas": [
            "Sutton-in-Ashfield",
            "Hucknall",
            "Bingham",
            "Beeston",
            "Mansfield",
            "Long Eaton",
            "Arnold"
          ]
        },
        {
          "name": "Carlton",
          "slug": "carlton",
          "postcode": "NG4",
          "nearby_areas": [
            "Arnold",
            "West Bridgford",
            "Beeston",
            "Long Eaton",
            "Bingham",
            "Nottingham",
            "Hucknall"
          ]
        },
        {
          "name": "Southwell",
          "slug": "southwell",
          "postcode": "NG25",
          "nearby_areas": [
            "Newark-on-Trent",
            "Ollerton",
            "Beeston",
            "Bingham",
            "Long Eaton",
            "Arnold",
            "Hucknall"
          ]
        },
        {
          "name": "Bingham",
          "slug": "bingham",
          "postcode": "NG13",
          "nearby_areas": [
            "Hucknall",
            "Long Eaton",
            "Beeston",
            "Ollerton",
            "Arnold",
            "Kirkby-in-Ashfield",
            "Sutton-in-Ashfield"
          ]
        },
        {
          "name": "Ollerton",
          "slug": "ollerton",
          "postcode": "NG22",
          "nearby_areas": [
            "Bingham",
            "Newark-on-Trent",
            "Beeston",
            "Long Eaton",
            "Hucknall",
            "Southwell",
            "Arnold"
          ]
        }
      ]
    },
    {
      "name": "Orkney Islands",
      "slug": "orkney-islands",
      "region": "Scotland",
      "council_name": "Orkney Islands Council",
      "council_url": "https://www.orkney.gov.uk/",
      "climate": "cool, windy maritime island climate",
      "population": "22,000",
      "towns": [
        {
          "name": "Kirkwall",
          "slug": "kirkwall",
          "postcode": "KW15",
          "nearby_areas": [
            "Stromness",
            "Dounby",
            "Finstown",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Stromness",
          "slug": "stromness",
          "postcode": "KW16",
          "nearby_areas": [
            "Dounby",
            "Finstown",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Dounby",
          "slug": "dounby",
          "postcode": "KW17",
          "nearby_areas": [
            "Finstown",
            "Stromness",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        },
        {
          "name": "Finstown",
          "slug": "finstown",
          "postcode": "KW17",
          "nearby_areas": [
            "Dounby",
            "Stromness",
            "Kirkwall",
            "Thurso",
            "Wick",
            "Lossiemouth",
            "Buckie"
          ]
        }
      ]
    },
    {
      "name": "Oxfordshire",
      "slug": "oxfordshire",
      "region": "South East England",
      "council_name": "Oxfordshire County Council",
      "council_url": "https://www.oxfordshire.gov.uk/",
      "climate": "mild, inland climate with winter damp",
      "population": "750,000",
      "towns": [
        {
          "name": "Oxford",
          "slug": "oxford",
          "postcode": "OX1",
          "nearby_areas": [
            "Abingdon",
            "Kidlington",
            "Woodstock",
            "Witney",
            "Didcot",
            "Bicester",
            "Wallingford"
          ]
        },
        {
          "name": "Banbury",
          "slug": "banbury",
          "postcode": "OX16",
          "nearby_areas": [
            "Brackley",
            "Chipping Norton",
            "Bicester",
            "Shipston-on-Stour",
            "Kidlington",
            "Buckingham",
            "Woodstock"
          ]
        },
        {
          "name": "Bicester",
          "slug": "bicester",
          "postcode": "OX26",
          "nearby_areas": [
            "Kidlington",
            "Buckingham",
            "Brackley",
            "Oxford",
            "Woodstock",
            "Abingdon",
            "Thame"
          ]
        },
        {
          "name": "Abingdon",
          "slug": "abingdon",
          "postcode": "OX14",
          "nearby_areas": [
            "Woodstock",
            "Oxford",
            "Kidlington",
            "Witney",
            "Didcot",
            "Bicester",
            "Carterton"
          ]
        },
        {
          "name": "Didcot",
          "slug": "didcot",
          "postcode": "OX11",
          "nearby_areas": [
            "Wallingford",
            "Wantage",
            "Oxford",
            "Abingdon",
            "Woodstock",
            "Kidlington",
            "Thame"
          ]
        },
        {
          "name": "Witney",
          "slug": "witney",
          "postcode": "OX28",
          "nearby_areas": [
            "Carterton",
            "Woodstock",
            "Abingdon",
            "Kidlington",
            "Faringdon",
            "Oxford",
            "Chipping Norton"
          ]
        },
        {
          "name": "Kidlington",
          "slug": "kidlington",
          "postcode": "OX5",
          "nearby_areas": [
            "Woodstock",
            "Abingdon",
            "Oxford",
            "Bicester",
            "Witney",
            "Carterton",
            "Chipping Norton"
          ]
        },
        {
          "name": "Henley-on-Thames",
          "slug": "henley-on-thames",
          "postcode": "RG9",
          "nearby_areas": [
            "Marlow",
            "Reading",
            "Pangbourne",
            "Twyford",
            "Maidenhead",
            "High Wycombe",
            "Wallingford"
          ]
        },
        {
          "name": "Thame",
          "slug": "thame",
          "postcode": "OX9",
          "nearby_areas": [
            "Princes Risborough",
            "Aylesbury",
            "Wendover",
            "Wallingford",
            "Oxford",
            "Bicester",
            "Kidlington"
          ]
        },
        {
          "name": "Wallingford",
          "slug": "wallingford",
          "postcode": "OX10",
          "nearby_areas": [
            "Didcot",
            "Henley-on-Thames",
            "Oxford",
            "Thame",
            "Pangbourne",
            "Wantage",
            "Twyford"
          ]
        },
        {
          "name": "Carterton",
          "slug": "carterton",
          "postcode": "OX18",
          "nearby_areas": [
            "Witney",
            "Faringdon",
            "Woodstock",
            "Abingdon",
            "Chipping Norton",
            "Kidlington",
            "Wantage"
          ]
        },
        {
          "name": "Chipping Norton",
          "slug": "chipping-norton",
          "postcode": "OX7",
          "nearby_areas": [
            "Moreton-in-Marsh",
            "Witney",
            "Shipston-on-Stour",
            "Banbury",
            "Carterton",
            "Woodstock",
            "Kidlington"
          ]
        },
        {
          "name": "Faringdon",
          "slug": "faringdon",
          "postcode": "SN7",
          "nearby_areas": [
            "Carterton",
            "Wantage",
            "Witney",
            "Woodstock",
            "Abingdon",
            "Didcot",
            "Oxford"
          ]
        },
        {
          "name": "Wantage",
          "slug": "wantage",
          "postcode": "OX12",
          "nearby_areas": [
            "Didcot",
            "Faringdon",
            "Wallingford",
            "Abingdon",
            "Oxford",
            "Witney",
            "Carterton"
          ]
        },
        {
          "name": "Woodstock",
          "slug": "woodstock",
          "postcode": "OX20",
          "nearby_areas": [
            "Abingdon",
            "Kidlington",
            "Witney",
            "Oxford",
            "Carterton",
            "Bicester",
            "Chipping Norton"
          ]
        }
      ]
    },
    {
      "name": "Pembrokeshire",
      "slug": "pembrokeshire",
      "region": "Wales",
      "council_name": "Pembrokeshire County Council",
      "council_url": "https://www.pembrokeshire.gov.uk/",
      "climate": "mild, wet and coastal",
      "population": "125,000",
      "towns": [
        {
          "name": "Haverfordwest",
          "slug": "haverfordwest",
          "postcode": "SA61",
          "nearby_areas": [
            "Milford Haven",
            "Pembroke",
            "St Davids",
            "Tenby",
            "Narberth",
            "Fishguard",
            "Carmarthen"
          ]
        },
        {
          "name": "Milford Haven",
          "slug": "milford-haven",
          "postcode": "SA73",
          "nearby_areas": [
            "Pembroke",
            "Haverfordwest",
            "Tenby",
            "St Davids",
            "Narberth",
            "Fishguard",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Pembroke",
          "slug": "pembroke",
          "postcode": "SA71",
          "nearby_areas": [
            "Tenby",
            "St Davids",
            "Narberth",
            "Milford Haven",
            "Fishguard",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Tenby",
          "slug": "tenby",
          "postcode": "SA70",
          "nearby_areas": [
            "St Davids",
            "Narberth",
            "Pembroke",
            "Fishguard",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Fishguard",
          "slug": "fishguard",
          "postcode": "SA65",
          "nearby_areas": [
            "Narberth",
            "Tenby",
            "St Davids",
            "Pembroke",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "Narberth",
          "slug": "narberth",
          "postcode": "SA67",
          "nearby_areas": [
            "Fishguard",
            "Tenby",
            "St Davids",
            "Pembroke",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        },
        {
          "name": "St Davids",
          "slug": "st-davids",
          "postcode": "SA62",
          "nearby_areas": [
            "Tenby",
            "Narberth",
            "Pembroke",
            "Fishguard",
            "Milford Haven",
            "Haverfordwest",
            "Newcastle Emlyn"
          ]
        }
      ]
    },
    {
      "name": "Perth and Kinross",
      "slug": "perth-and-kinross",
      "region": "Scotland",
      "council_name": "Perth and Kinross Council",
      "council_url": "https://www.pkc.gov.uk/",
      "climate": "cool, damp with upland rainfall",
      "population": "150,000",
      "towns": [
        {
          "name": "Perth",
          "slug": "perth",
          "postcode": "PH1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Blairgowrie",
          "slug": "blairgowrie",
          "postcode": "PH10",
          "nearby_areas": [
            "Perth",
            "Kirriemuir",
            "Aberfeldy",
            "Pitlochry",
            "Dundee",
            "Forfar",
            "Lochee"
          ]
        },
        {
          "name": "Crieff",
          "slug": "crieff",
          "postcode": "PH7",
          "nearby_areas": [
            "Auchterarder",
            "Pitlochry",
            "Aberfeldy",
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick"
          ]
        },
        {
          "name": "Pitlochry",
          "slug": "pitlochry",
          "postcode": "PH16",
          "nearby_areas": [
            "Aberfeldy",
            "Crieff",
            "Aviemore",
            "Auchterarder",
            "Perth",
            "Benbecula",
            "Brae"
          ]
        },
        {
          "name": "Kinross",
          "slug": "kinross",
          "postcode": "KY13",
          "nearby_areas": [
            "Inverkeithing",
            "Rosyth",
            "Anstruther",
            "Leven",
            "Cowdenbeath",
            "Kirkcaldy",
            "Dunfermline"
          ]
        },
        {
          "name": "Auchterarder",
          "slug": "auchterarder",
          "postcode": "PH3",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        },
        {
          "name": "Aberfeldy",
          "slug": "aberfeldy",
          "postcode": "PH15",
          "nearby_areas": [
            "Pitlochry",
            "Crieff",
            "Aviemore",
            "Perth",
            "Benbecula",
            "Brae",
            "Castlebay"
          ]
        }
      ]
    },
    {
      "name": "Powys",
      "slug": "powys",
      "region": "Wales",
      "council_name": "Powys County Council",
      "council_url": "https://en.powys.gov.uk/",
      "climate": "upland rainfall and cold rural winters",
      "population": "135,000",
      "towns": [
        {
          "name": "Llandrindod Wells",
          "slug": "llandrindod-wells",
          "postcode": "LD1",
          "nearby_areas": [
            "Builth Wells",
            "Presteigne",
            "Blaina",
            "Raglan",
            "Usk",
            "Brecon",
            "Caerleon"
          ]
        },
        {
          "name": "Newtown",
          "slug": "newtown",
          "postcode": "SY16",
          "nearby_areas": [
            "Welshpool",
            "Machynlleth",
            "Whitchurch",
            "Ellesmere",
            "Rogerstone",
            "Church Stretton",
            "Craven Arms"
          ]
        },
        {
          "name": "Brecon",
          "slug": "brecon",
          "postcode": "LD3",
          "nearby_areas": [
            "Presteigne",
            "Builth Wells",
            "Tredegar",
            "Merthyr Tydfil",
            "Ebbw Vale",
            "Brynmawr",
            "Nantyglo"
          ]
        },
        {
          "name": "Welshpool",
          "slug": "welshpool",
          "postcode": "SY21",
          "nearby_areas": [
            "Whitchurch",
            "Newtown",
            "Ellesmere",
            "Rogerstone",
            "Machynlleth",
            "Church Stretton",
            "Craven Arms"
          ]
        },
        {
          "name": "Ystradgynlais",
          "slug": "ystradgynlais",
          "postcode": "SA9",
          "nearby_areas": [
            "Cymmer",
            "Pontardawe",
            "Clydach",
            "Morriston",
            "Swansea",
            "Mumbles",
            "Gorseinon"
          ]
        },
        {
          "name": "Machynlleth",
          "slug": "machynlleth",
          "postcode": "SY20",
          "nearby_areas": [
            "Newtown",
            "Welshpool",
            "Tregaron",
            "Whitchurch",
            "Rogerstone",
            "Ellesmere",
            "Church Stretton"
          ]
        },
        {
          "name": "Builth Wells",
          "slug": "builth-wells",
          "postcode": "LD2",
          "nearby_areas": [
            "Presteigne",
            "Llandrindod Wells",
            "Brecon",
            "Blaina",
            "Raglan",
            "Usk",
            "Cwmbran"
          ]
        },
        {
          "name": "Presteigne",
          "slug": "presteigne",
          "postcode": "LD8",
          "nearby_areas": [
            "Builth Wells",
            "Brecon",
            "Llandrindod Wells",
            "Blaina",
            "Malpas",
            "Newport",
            "Cwmbran"
          ]
        }
      ]
    },
    {
      "name": "Renfrewshire",
      "slug": "renfrewshire",
      "region": "Scotland",
      "council_name": "Renfrewshire Council",
      "council_url": "https://www.renfrewshire.gov.uk/",
      "climate": "wet west central climate",
      "population": "180,000",
      "towns": [
        {
          "name": "Paisley",
          "slug": "paisley",
          "postcode": "PA1",
          "nearby_areas": [
            "Cumbernauld",
            "Kirkintilloch",
            "Lennoxtown",
            "Kilsyth",
            "Bishopbriggs",
            "Balfron",
            "Clydebank"
          ]
        },
        {
          "name": "Renfrew",
          "slug": "renfrew",
          "postcode": "PA4",
          "nearby_areas": [
            "Linwood",
            "Johnstone",
            "Dumbarton",
            "Govan",
            "Bearsden",
            "Milngavie",
            "Paisley"
          ]
        },
        {
          "name": "Johnstone",
          "slug": "johnstone",
          "postcode": "PA5",
          "nearby_areas": [
            "Renfrew",
            "Dumbarton",
            "Govan",
            "Linwood",
            "Giffnock",
            "Bearsden",
            "Pollokshields"
          ]
        },
        {
          "name": "Linwood",
          "slug": "linwood",
          "postcode": "PA3",
          "nearby_areas": [
            "Renfrew",
            "Paisley",
            "Bearsden",
            "Dumbarton",
            "Milngavie",
            "Balfron",
            "Bishopbriggs"
          ]
        },
        {
          "name": "Erskine",
          "slug": "erskine",
          "postcode": "PA8",
          "nearby_areas": [
            "Bishopton",
            "Dennistoun",
            "Maryhill",
            "Pollokshields",
            "Shawlands",
            "Partick",
            "Giffnock"
          ]
        },
        {
          "name": "Bishopton",
          "slug": "bishopton",
          "postcode": "PA7",
          "nearby_areas": [
            "Erskine",
            "Dennistoun",
            "Pollokshields",
            "Shawlands",
            "Johnstone",
            "Giffnock",
            "Renfrew"
          ]
        }
      ]
    },
    {
      "name": "Rhondda Cynon Taf",
      "slug": "rhondda-cynon-taf",
      "region": "Wales",
      "council_name": "Rhondda Cynon Taf County Borough Council",
      "council_url": "https://www.rctcbc.gov.uk/",
      "climate": "wet valleys climate and cool winters",
      "population": "240,000",
      "towns": [
        {
          "name": "Pontypridd",
          "slug": "pontypridd",
          "postcode": "CF37",
          "nearby_areas": [
            "Porth",
            "Bargoed",
            "Marshfield",
            "Ystrad Mynach",
            "Canton",
            "Llandaff",
            "Radyr"
          ]
        },
        {
          "name": "Aberdare",
          "slug": "aberdare",
          "postcode": "CF44",
          "nearby_areas": [
            "Mountain Ash",
            "Merthyr Tydfil",
            "Treorchy",
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw"
          ]
        },
        {
          "name": "Tonypandy",
          "slug": "tonypandy",
          "postcode": "CF40",
          "nearby_areas": [
            "Porth",
            "Roath",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Treorchy",
            "Pyle"
          ]
        },
        {
          "name": "Porth",
          "slug": "porth",
          "postcode": "CF39",
          "nearby_areas": [
            "Tonypandy",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Pontypridd",
            "Roath",
            "Nelson"
          ]
        },
        {
          "name": "Mountain Ash",
          "slug": "mountain-ash",
          "postcode": "CF45",
          "nearby_areas": [
            "Nelson",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Aberdare",
            "Treharris",
            "Merthyr Tydfil"
          ]
        },
        {
          "name": "Treorchy",
          "slug": "treorchy",
          "postcode": "CF42",
          "nearby_areas": [
            "Tonypandy",
            "Aberdare",
            "Aberfan",
            "Dowlais",
            "Troedyrhiw",
            "Porth",
            "Mountain Ash"
          ]
        },
        {
          "name": "Llantrisant",
          "slug": "llantrisant",
          "postcode": "CF72",
          "nearby_areas": [
            "Cowbridge",
            "Canton",
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Bargoed",
            "Radyr"
          ]
        }
      ]
    },
    {
      "name": "Rutland",
      "slug": "rutland",
      "region": "East Midlands",
      "council_name": "Rutland County Council",
      "council_url": "https://www.rutland.gov.uk/",
      "climate": "cool, rural and fairly dry",
      "population": "40,000",
      "towns": [
        {
          "name": "Oakham",
          "slug": "oakham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine"
          ]
        },
        {
          "name": "Uppingham",
          "slug": "uppingham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Ketton",
          "slug": "ketton",
          "postcode": "PE9",
          "nearby_areas": [
            "Ryhall",
            "Oundle",
            "Whittlesey",
            "Yaxley",
            "Peterborough",
            "Bourne",
            "Spalding"
          ]
        },
        {
          "name": "Cottesmore",
          "slug": "cottesmore",
          "postcode": "LE15",
          "nearby_areas": [
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Ryhall",
          "slug": "ryhall",
          "postcode": "PE9",
          "nearby_areas": [
            "Ketton",
            "Oundle",
            "Whittlesey",
            "Yaxley",
            "Peterborough",
            "Bourne",
            "Spalding"
          ]
        },
        {
          "name": "Empingham",
          "slug": "empingham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Whissendine",
          "slug": "whissendine",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Shepshed"
          ]
        },
        {
          "name": "Greetham",
          "slug": "greetham",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Exton",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Exton",
          "slug": "exton",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Edith Weston",
            "Empingham",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        },
        {
          "name": "Edith Weston",
          "slug": "edith-weston",
          "postcode": "LE15",
          "nearby_areas": [
            "Cottesmore",
            "Empingham",
            "Exton",
            "Greetham",
            "Uppingham",
            "Whissendine",
            "Shepshed"
          ]
        }
      ]
    },
    {
      "name": "Scottish Borders",
      "slug": "scottish-borders",
      "region": "Scotland",
      "council_name": "Scottish Borders Council",
      "council_url": "https://www.scotborders.gov.uk/",
      "climate": "cool upland climate with wet winters",
      "population": "115,000",
      "towns": [
        {
          "name": "Galashiels",
          "slug": "galashiels",
          "postcode": "TD1",
          "nearby_areas": [
            "Jedburgh",
            "Melrose",
            "Hawick",
            "Kelso",
            "Peebles",
            "Eyemouth",
            "Penicuik"
          ]
        },
        {
          "name": "Hawick",
          "slug": "hawick",
          "postcode": "TD9",
          "nearby_areas": [
            "Jedburgh",
            "Galashiels",
            "Melrose",
            "Kelso",
            "Peebles",
            "Eyemouth",
            "Penicuik"
          ]
        },
        {
          "name": "Peebles",
          "slug": "peebles",
          "postcode": "EH45",
          "nearby_areas": [
            "Penicuik",
            "Galashiels",
            "Whitburn",
            "Gorebridge",
            "Dalkeith",
            "Musselburgh",
            "Loanhead"
          ]
        },
        {
          "name": "Kelso",
          "slug": "kelso",
          "postcode": "TD5",
          "nearby_areas": [
            "Melrose",
            "Eyemouth",
            "Jedburgh",
            "Galashiels",
            "Hawick",
            "Berwick-upon-Tweed",
            "Peebles"
          ]
        },
        {
          "name": "Jedburgh",
          "slug": "jedburgh",
          "postcode": "TD8",
          "nearby_areas": [
            "Melrose",
            "Kelso",
            "Galashiels",
            "Hawick",
            "Eyemouth",
            "Peebles",
            "Haddington"
          ]
        },
        {
          "name": "Melrose",
          "slug": "melrose",
          "postcode": "TD6",
          "nearby_areas": [
            "Jedburgh",
            "Kelso",
            "Galashiels",
            "Eyemouth",
            "Hawick",
            "Peebles",
            "Berwick-upon-Tweed"
          ]
        },
        {
          "name": "Eyemouth",
          "slug": "eyemouth",
          "postcode": "TD14",
          "nearby_areas": [
            "Kelso",
            "Melrose",
            "Jedburgh",
            "Berwick-upon-Tweed",
            "Galashiels",
            "Hawick",
            "Dunbar"
          ]
        }
      ]
    },
    {
      "name": "Shetland Islands",
      "slug": "shetland-islands",
      "region": "Scotland",
      "council_name": "Shetland Islands Council",
      "council_url": "https://www.shetland.gov.uk/",
      "climate": "cool, very windy maritime climate",
      "population": "23,000",
      "towns": [
        {
          "name": "Lerwick",
          "slug": "lerwick",
          "postcode": "ZE1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Scalloway",
          "slug": "scalloway",
          "postcode": "ZE1",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Brae",
          "slug": "brae",
          "postcode": "ZE2",
          "nearby_areas": [
            "Benbecula",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway",
            "Sullom Voe"
          ]
        },
        {
          "name": "Sullom Voe",
          "slug": "sullom-voe",
          "postcode": "ZE2",
          "nearby_areas": [
            "Benbecula",
            "Brae",
            "Castlebay",
            "Lerwick",
            "Lochboisdale",
            "Scalloway",
            "Stornoway"
          ]
        }
      ]
    },
    {
      "name": "Shropshire",
      "slug": "shropshire",
      "region": "West Midlands",
      "council_name": "Shropshire Council",
      "council_url": "https://www.shropshire.gov.uk/",
      "climate": "rural rainfall and cool upland winters",
      "population": "500,000",
      "towns": [
        {
          "name": "Shrewsbury",
          "slug": "shrewsbury",
          "postcode": "SY1",
          "nearby_areas": [
            "Much Wenlock",
            "Church Stretton",
            "Wellington",
            "Newport",
            "Ellesmere",
            "Craven Arms",
            "Telford"
          ]
        },
        {
          "name": "Telford",
          "slug": "telford",
          "postcode": "TF3",
          "nearby_areas": [
            "Much Wenlock",
            "Wellington",
            "Broseley",
            "Newport",
            "Bridgnorth",
            "Shrewsbury",
            "Bilston"
          ]
        },
        {
          "name": "Oswestry",
          "slug": "oswestry",
          "postcode": "SY11",
          "nearby_areas": [
            "Rogerstone",
            "Ellesmere",
            "Whitchurch",
            "Wrexham",
            "Shrewsbury",
            "Welshpool",
            "Church Stretton"
          ]
        },
        {
          "name": "Ludlow",
          "slug": "ludlow",
          "postcode": "SY8",
          "nearby_areas": [
            "Leominster",
            "Craven Arms",
            "Church Stretton",
            "Bridgnorth",
            "Pembridge",
            "Bewdley",
            "Broseley"
          ]
        },
        {
          "name": "Bridgnorth",
          "slug": "bridgnorth",
          "postcode": "WV16",
          "nearby_areas": [
            "Broseley",
            "Bilston",
            "Telford",
            "Much Wenlock",
            "Cleobury Mortimer",
            "Kingswinford",
            "Wellington"
          ]
        },
        {
          "name": "Market Drayton",
          "slug": "market-drayton",
          "postcode": "TF9",
          "nearby_areas": [
            "Newport",
            "Wellington",
            "Nantwich",
            "Much Wenlock",
            "Telford",
            "Stoke-on-Trent",
            "Crewe"
          ]
        },
        {
          "name": "Whitchurch",
          "slug": "whitchurch",
          "postcode": "SY13",
          "nearby_areas": [
            "Ellesmere",
            "Welshpool",
            "Newtown",
            "Rogerstone",
            "Church Stretton",
            "Craven Arms",
            "Machynlleth"
          ]
        },
        {
          "name": "Newport",
          "slug": "newport",
          "postcode": "TF10",
          "nearby_areas": [
            "Wellington",
            "Much Wenlock",
            "Telford",
            "Market Drayton",
            "Broseley",
            "Shrewsbury",
            "Bridgnorth"
          ]
        },
        {
          "name": "Wellington",
          "slug": "wellington",
          "postcode": "TF1",
          "nearby_areas": [
            "Much Wenlock",
            "Telford",
            "Newport",
            "Broseley",
            "Shrewsbury",
            "Bridgnorth",
            "Market Drayton"
          ]
        },
        {
          "name": "Ellesmere",
          "slug": "ellesmere",
          "postcode": "SY12",
          "nearby_areas": [
            "Whitchurch",
            "Welshpool",
            "Rogerstone",
            "Newtown",
            "Church Stretton",
            "Craven Arms",
            "Oswestry"
          ]
        },
        {
          "name": "Church Stretton",
          "slug": "church-stretton",
          "postcode": "SY6",
          "nearby_areas": [
            "Craven Arms",
            "Whitchurch",
            "Ellesmere",
            "Shrewsbury",
            "Welshpool",
            "Newtown",
            "Ludlow"
          ]
        },
        {
          "name": "Much Wenlock",
          "slug": "much-wenlock",
          "postcode": "TF13",
          "nearby_areas": [
            "Wellington",
            "Telford",
            "Newport",
            "Broseley",
            "Bridgnorth",
            "Shrewsbury",
            "Market Drayton"
          ]
        },
        {
          "name": "Cleobury Mortimer",
          "slug": "cleobury-mortimer",
          "postcode": "DY14",
          "nearby_areas": [
            "Kidderminster",
            "Bewdley",
            "Stourport-on-Severn",
            "Dudley",
            "Stourbridge",
            "Kingswinford",
            "Brierley Hill"
          ]
        },
        {
          "name": "Craven Arms",
          "slug": "craven-arms",
          "postcode": "SY7",
          "nearby_areas": [
            "Church Stretton",
            "Whitchurch",
            "Ellesmere",
            "Shrewsbury",
            "Ludlow",
            "Welshpool",
            "Newtown"
          ]
        },
        {
          "name": "Broseley",
          "slug": "broseley",
          "postcode": "TF12",
          "nearby_areas": [
            "Telford",
            "Much Wenlock",
            "Bridgnorth",
            "Wellington",
            "Newport",
            "Bilston",
            "Shrewsbury"
          ]
        }
      ]
    },
    {
      "name": "Somerset",
      "slug": "somerset",
      "region": "South West England",
      "council_name": "Somerset Council",
      "council_url": "https://www.somerset.gov.uk/",
      "climate": "mild, damp winters with coastal exposure",
      "population": "980,000",
      "towns": [
        {
          "name": "Bath",
          "slug": "bath",
          "postcode": "BA1",
          "nearby_areas": [
            "Bradford-on-Avon",
            "Radstock",
            "Trowbridge",
            "Corsham",
            "Frome",
            "Westbury",
            "Melksham"
          ]
        },
        {
          "name": "Weston-super-Mare",
          "slug": "weston-super-mare",
          "postcode": "BS23",
          "nearby_areas": [
            "Keynsham",
            "Portishead",
            "Filton",
            "Thornbury",
            "Nailsea",
            "Yate",
            "Fishponds"
          ]
        },
        {
          "name": "Taunton",
          "slug": "taunton",
          "postcode": "TA1",
          "nearby_areas": [
            "Bridgwater",
            "Chard",
            "Burnham-on-Sea",
            "Crewkerne",
            "Honiton",
            "Glastonbury",
            "Tiverton"
          ]
        },
        {
          "name": "Yeovil",
          "slug": "yeovil",
          "postcode": "BA20",
          "nearby_areas": [
            "Sherborne",
            "Crewkerne",
            "Lyme Regis",
            "Glastonbury",
            "Chard",
            "Dorchester",
            "Bridport"
          ]
        },
        {
          "name": "Bridgwater",
          "slug": "bridgwater",
          "postcode": "TA6",
          "nearby_areas": [
            "Burnham-on-Sea",
            "Taunton",
            "Glastonbury",
            "Weston-super-Mare",
            "Wells",
            "Chard",
            "Crewkerne"
          ]
        },
        {
          "name": "Frome",
          "slug": "frome",
          "postcode": "BA11",
          "nearby_areas": [
            "Westbury",
            "Radstock",
            "Warminster",
            "Trowbridge",
            "Bradford-on-Avon",
            "Shepton Mallet",
            "Bath"
          ]
        },
        {
          "name": "Wells",
          "slug": "wells",
          "postcode": "BA5",
          "nearby_areas": [
            "Shepton Mallet",
            "Glastonbury",
            "Radstock",
            "Frome",
            "Burnham-on-Sea",
            "Westbury",
            "Nailsea"
          ]
        },
        {
          "name": "Burnham-on-Sea",
          "slug": "burnham-on-sea",
          "postcode": "TA8",
          "nearby_areas": [
            "Bridgwater",
            "Weston-super-Mare",
            "Keynsham",
            "Portishead",
            "Nailsea",
            "Glastonbury",
            "Filton"
          ]
        },
        {
          "name": "Chard",
          "slug": "chard",
          "postcode": "TA20",
          "nearby_areas": [
            "Crewkerne",
            "Taunton",
            "Honiton",
            "Bridport",
            "Yeovil",
            "Bridgwater",
            "Sidmouth"
          ]
        },
        {
          "name": "Minehead",
          "slug": "minehead",
          "postcode": "TA24",
          "nearby_areas": [
            "Llantwit Major",
            "Taunton",
            "Burnham-on-Sea",
            "Bridgwater",
            "Tiverton",
            "Weston-super-Mare",
            "Barry"
          ]
        },
        {
          "name": "Glastonbury",
          "slug": "glastonbury",
          "postcode": "BA6",
          "nearby_areas": [
            "Wells",
            "Shepton Mallet",
            "Bridgwater",
            "Burnham-on-Sea",
            "Yeovil",
            "Radstock",
            "Frome"
          ]
        },
        {
          "name": "Shepton Mallet",
          "slug": "shepton-mallet",
          "postcode": "BA4",
          "nearby_areas": [
            "Wells",
            "Glastonbury",
            "Radstock",
            "Frome",
            "Westbury",
            "Bath",
            "Yeovil"
          ]
        },
        {
          "name": "Radstock",
          "slug": "radstock",
          "postcode": "BA3",
          "nearby_areas": [
            "Frome",
            "Westbury",
            "Bath",
            "Shepton Mallet",
            "Wells",
            "Bradford-on-Avon",
            "Trowbridge"
          ]
        },
        {
          "name": "Nailsea",
          "slug": "nailsea",
          "postcode": "BS48",
          "nearby_areas": [
            "Fishponds",
            "Kingswood",
            "Yate",
            "Thornbury",
            "Filton",
            "Portishead",
            "Keynsham"
          ]
        },
        {
          "name": "Portishead",
          "slug": "portishead",
          "postcode": "BS20",
          "nearby_areas": [
            "Keynsham",
            "Filton",
            "Thornbury",
            "Yate",
            "Fishponds",
            "Nailsea",
            "Kingswood"
          ]
        },
        {
          "name": "Clevedon",
          "slug": "clevedon",
          "postcode": "BS21",
          "nearby_areas": [
            "Portishead",
            "Kingswood",
            "Fishponds",
            "Nailsea",
            "Yate",
            "Thornbury",
            "Keynsham"
          ]
        },
        {
          "name": "Keynsham",
          "slug": "keynsham",
          "postcode": "BS31",
          "nearby_areas": [
            "Filton",
            "Thornbury",
            "Yate",
            "Portishead",
            "Nailsea",
            "Fishponds",
            "Kingswood"
          ]
        },
        {
          "name": "Crewkerne",
          "slug": "crewkerne",
          "postcode": "TA18",
          "nearby_areas": [
            "Chard",
            "Yeovil",
            "Bridport",
            "Sherborne",
            "Lyme Regis",
            "Taunton",
            "Dorchester"
          ]
        }
      ]
    },
    {
      "name": "South Ayrshire",
      "slug": "south-ayrshire",
      "region": "Scotland",
      "council_name": "South Ayrshire Council",
      "council_url": "https://www.south-ayrshire.gov.uk/",
      "climate": "wet, mild west coast climate",
      "population": "112,000",
      "towns": [
        {
          "name": "Ayr",
          "slug": "ayr",
          "postcode": "KA7",
          "nearby_areas": [
            "Maybole",
            "Dalmellington",
            "Troon",
            "Prestwick",
            "Mauchline",
            "Auchinleck",
            "Stevenston"
          ]
        },
        {
          "name": "Prestwick",
          "slug": "prestwick",
          "postcode": "KA9",
          "nearby_areas": [
            "Stevenston",
            "Troon",
            "Mauchline",
            "Dalmellington",
            "Ardrossan",
            "Stewarton",
            "Maybole"
          ]
        },
        {
          "name": "Troon",
          "slug": "troon",
          "postcode": "KA10",
          "nearby_areas": [
            "Prestwick",
            "Stevenston",
            "Ardrossan",
            "Dalmellington",
            "Mauchline",
            "Stewarton",
            "Maybole"
          ]
        },
        {
          "name": "Girvan",
          "slug": "girvan",
          "postcode": "KA26",
          "nearby_areas": [
            "Ayr",
            "Troon",
            "Prestwick",
            "Maybole",
            "Dalmellington",
            "Ardrossan",
            "Mauchline"
          ]
        },
        {
          "name": "Maybole",
          "slug": "maybole",
          "postcode": "KA19",
          "nearby_areas": [
            "Mauchline",
            "Stewarton",
            "Dalmellington",
            "Prestwick",
            "Stevenston",
            "Troon",
            "Auchinleck"
          ]
        }
      ]
    },
    {
      "name": "South Lanarkshire",
      "slug": "south-lanarkshire",
      "region": "Scotland",
      "council_name": "South Lanarkshire Council",
      "council_url": "https://www.southlanarkshire.gov.uk/",
      "climate": "cool, wet central belt and upland climate",
      "population": "320,000",
      "towns": [
        {
          "name": "Hamilton",
          "slug": "hamilton",
          "postcode": "ML3",
          "nearby_areas": [
            "Wishaw",
            "Motherwell",
            "Bellshill",
            "Larkhall",
            "Coatbridge",
            "Biggar",
            "Lanark"
          ]
        },
        {
          "name": "East Kilbride",
          "slug": "east-kilbride",
          "postcode": "G74",
          "nearby_areas": [
            "Rutherglen",
            "Clydebank",
            "Clarkston",
            "Eaglesham",
            "Cambuslang",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Rutherglen",
          "slug": "rutherglen",
          "postcode": "G73",
          "nearby_areas": [
            "East Kilbride",
            "Cambuslang",
            "Clydebank",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Cambuslang",
          "slug": "cambuslang",
          "postcode": "G72",
          "nearby_areas": [
            "Rutherglen",
            "Clydebank",
            "East Kilbride",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Lanark",
          "slug": "lanark",
          "postcode": "ML11",
          "nearby_areas": [
            "Biggar",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell",
            "Wishaw"
          ]
        },
        {
          "name": "Carluke",
          "slug": "carluke",
          "postcode": "ML8",
          "nearby_areas": [
            "Lanark",
            "Biggar",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell"
          ]
        },
        {
          "name": "Larkhall",
          "slug": "larkhall",
          "postcode": "ML9",
          "nearby_areas": [
            "Bellshill",
            "Motherwell",
            "Coatbridge",
            "Wishaw",
            "Biggar",
            "Lanark",
            "Airdrie"
          ]
        },
        {
          "name": "Biggar",
          "slug": "biggar",
          "postcode": "ML12",
          "nearby_areas": [
            "Lanark",
            "Airdrie",
            "Coatbridge",
            "Larkhall",
            "Bellshill",
            "Motherwell",
            "Wishaw"
          ]
        }
      ]
    },
    {
      "name": "South Yorkshire",
      "slug": "south-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "South Yorkshire Council",
      "council_url": "https://www.southyorkshire.gov.uk/",
      "climate": "cool, wet winters and upland rain",
      "population": "1.4 million",
      "towns": [
        {
          "name": "Sheffield",
          "slug": "sheffield",
          "postcode": "S1",
          "nearby_areas": [
            "Dinnington",
            "Penistone",
            "Stocksbridge",
            "Bolsover",
            "Rotherham",
            "Hoyland",
            "Wombwell"
          ]
        },
        {
          "name": "Doncaster",
          "slug": "doncaster",
          "postcode": "DN1",
          "nearby_areas": [
            "Mexborough",
            "Wath upon Dearne",
            "Maltby",
            "Hoyland",
            "Wombwell",
            "Rotherham",
            "Barnsley"
          ]
        },
        {
          "name": "Rotherham",
          "slug": "rotherham",
          "postcode": "S60",
          "nearby_areas": [
            "Hoyland",
            "Wombwell",
            "Wath upon Dearne",
            "Maltby",
            "Dinnington",
            "Mexborough",
            "Sheffield"
          ]
        },
        {
          "name": "Barnsley",
          "slug": "barnsley",
          "postcode": "S70",
          "nearby_areas": [
            "Maltby",
            "Wombwell",
            "Wath upon Dearne",
            "Mexborough",
            "Rotherham",
            "Hoyland",
            "Wakefield"
          ]
        },
        {
          "name": "Mexborough",
          "slug": "mexborough",
          "postcode": "S64",
          "nearby_areas": [
            "Wath upon Dearne",
            "Maltby",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Doncaster",
            "Barnsley"
          ]
        },
        {
          "name": "Wombwell",
          "slug": "wombwell",
          "postcode": "S73",
          "nearby_areas": [
            "Maltby",
            "Wath upon Dearne",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Penistone",
          "slug": "penistone",
          "postcode": "S36",
          "nearby_areas": [
            "Stocksbridge",
            "Bolsover",
            "Dinnington",
            "Sheffield",
            "Rotherham",
            "Chesterfield",
            "Hoyland"
          ]
        },
        {
          "name": "Maltby",
          "slug": "maltby",
          "postcode": "S66",
          "nearby_areas": [
            "Wath upon Dearne",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Dinnington",
          "slug": "dinnington",
          "postcode": "S25",
          "nearby_areas": [
            "Bolsover",
            "Penistone",
            "Stocksbridge",
            "Sheffield",
            "Rotherham",
            "Hoyland",
            "Wombwell"
          ]
        },
        {
          "name": "Stocksbridge",
          "slug": "stocksbridge",
          "postcode": "S36",
          "nearby_areas": [
            "Penistone",
            "Bolsover",
            "Dinnington",
            "Sheffield",
            "Rotherham",
            "Chesterfield",
            "Hoyland"
          ]
        },
        {
          "name": "Hoyland",
          "slug": "hoyland",
          "postcode": "S74",
          "nearby_areas": [
            "Wombwell",
            "Rotherham",
            "Wath upon Dearne",
            "Maltby",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Thorne",
          "slug": "thorne",
          "postcode": "DN8",
          "nearby_areas": [
            "Conisbrough",
            "Scunthorpe",
            "Howden",
            "Snaith",
            "Brigg",
            "Gainsborough",
            "Goole"
          ]
        },
        {
          "name": "Wath upon Dearne",
          "slug": "wath-upon-dearne",
          "postcode": "S63",
          "nearby_areas": [
            "Maltby",
            "Wombwell",
            "Hoyland",
            "Rotherham",
            "Mexborough",
            "Dinnington",
            "Sheffield"
          ]
        },
        {
          "name": "Conisbrough",
          "slug": "conisbrough",
          "postcode": "DN12",
          "nearby_areas": [
            "Thorne",
            "Scunthorpe",
            "Howden",
            "Snaith",
            "Brigg",
            "Goole",
            "Gainsborough"
          ]
        }
      ]
    },
    {
      "name": "Staffordshire",
      "slug": "staffordshire",
      "region": "West Midlands",
      "council_name": "Staffordshire County Council",
      "council_url": "https://www.staffordshire.gov.uk/",
      "climate": "cool winters and steady rainfall",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Stoke-on-Trent",
          "slug": "stoke-on-trent",
          "postcode": "ST1",
          "nearby_areas": [
            "Newcastle-under-Lyme",
            "Biddulph",
            "Cheadle",
            "Penkridge",
            "Stone",
            "Leek",
            "Congleton"
          ]
        },
        {
          "name": "Stafford",
          "slug": "stafford",
          "postcode": "ST16",
          "nearby_areas": [
            "Rugeley",
            "Penkridge",
            "Cannock",
            "Stone",
            "Burntwood",
            "Biddulph",
            "Newcastle-under-Lyme"
          ]
        },
        {
          "name": "Burton upon Trent",
          "slug": "burton-upon-trent",
          "postcode": "DE14",
          "nearby_areas": [
            "Derby",
            "Ripley",
            "Bakewell",
            "Belper",
            "Heanor",
            "Ilkeston",
            "Ashbourne"
          ]
        },
        {
          "name": "Cannock",
          "slug": "cannock",
          "postcode": "WS11",
          "nearby_areas": [
            "Burntwood",
            "Rugeley",
            "Willenhall",
            "Walsall",
            "Lichfield",
            "Stafford",
            "Wolverhampton"
          ]
        },
        {
          "name": "Tamworth",
          "slug": "tamworth",
          "postcode": "B79",
          "nearby_areas": [
            "Lichfield",
            "Atherstone",
            "Polesworth",
            "Burntwood",
            "Rugeley",
            "Swadlincote",
            "Nuneaton"
          ]
        },
        {
          "name": "Lichfield",
          "slug": "lichfield",
          "postcode": "WS13",
          "nearby_areas": [
            "Burntwood",
            "Tamworth",
            "Rugeley",
            "Cannock",
            "Walsall",
            "Polesworth",
            "Willenhall"
          ]
        },
        {
          "name": "Leek",
          "slug": "leek",
          "postcode": "ST13",
          "nearby_areas": [
            "Cheadle",
            "Newcastle-under-Lyme",
            "Biddulph",
            "Stoke-on-Trent",
            "Congleton",
            "Stone",
            "Penkridge"
          ]
        },
        {
          "name": "Newcastle-under-Lyme",
          "slug": "newcastle-under-lyme",
          "postcode": "ST5",
          "nearby_areas": [
            "Biddulph",
            "Cheadle",
            "Penkridge",
            "Stone",
            "Stoke-on-Trent",
            "Leek",
            "Uttoxeter"
          ]
        },
        {
          "name": "Rugeley",
          "slug": "rugeley",
          "postcode": "WS15",
          "nearby_areas": [
            "Burntwood",
            "Cannock",
            "Lichfield",
            "Stafford",
            "Uttoxeter",
            "Stone",
            "Penkridge"
          ]
        },
        {
          "name": "Uttoxeter",
          "slug": "uttoxeter",
          "postcode": "ST14",
          "nearby_areas": [
            "Stone",
            "Penkridge",
            "Cheadle",
            "Biddulph",
            "Rugeley",
            "Newcastle-under-Lyme",
            "Ashbourne"
          ]
        },
        {
          "name": "Stone",
          "slug": "stone",
          "postcode": "ST15",
          "nearby_areas": [
            "Penkridge",
            "Cheadle",
            "Biddulph",
            "Newcastle-under-Lyme",
            "Uttoxeter",
            "Stafford",
            "Stoke-on-Trent"
          ]
        },
        {
          "name": "Burntwood",
          "slug": "burntwood",
          "postcode": "WS7",
          "nearby_areas": [
            "Cannock",
            "Lichfield",
            "Rugeley",
            "Walsall",
            "Willenhall",
            "Tamworth",
            "Wednesbury"
          ]
        },
        {
          "name": "Cheadle",
          "slug": "cheadle",
          "postcode": "ST10",
          "nearby_areas": [
            "Biddulph",
            "Newcastle-under-Lyme",
            "Stone",
            "Penkridge",
            "Stoke-on-Trent",
            "Uttoxeter",
            "Leek"
          ]
        },
        {
          "name": "Penkridge",
          "slug": "penkridge",
          "postcode": "ST19",
          "nearby_areas": [
            "Stone",
            "Biddulph",
            "Cheadle",
            "Newcastle-under-Lyme",
            "Uttoxeter",
            "Stafford",
            "Stoke-on-Trent"
          ]
        },
        {
          "name": "Biddulph",
          "slug": "biddulph",
          "postcode": "ST8",
          "nearby_areas": [
            "Cheadle",
            "Newcastle-under-Lyme",
            "Penkridge",
            "Stone",
            "Stoke-on-Trent",
            "Uttoxeter",
            "Leek"
          ]
        }
      ]
    },
    {
      "name": "Stirling",
      "slug": "stirling",
      "region": "Scotland",
      "council_name": "Stirling Council",
      "council_url": "https://www.stirling.gov.uk/",
      "climate": "cool, wet and upland influenced",
      "population": "95,000",
      "towns": [
        {
          "name": "Stirling",
          "slug": "stirling",
          "postcode": "FK8",
          "nearby_areas": [
            "Bridge of Allan",
            "Denny",
            "Alloa",
            "Clackmannan",
            "Callander",
            "Larbert",
            "Stenhousemuir"
          ]
        },
        {
          "name": "Bridge of Allan",
          "slug": "bridge-of-allan",
          "postcode": "FK9",
          "nearby_areas": [
            "Alloa",
            "Clackmannan",
            "Denny",
            "Larbert",
            "Stenhousemuir",
            "Stirling",
            "Callander"
          ]
        },
        {
          "name": "Dunblane",
          "slug": "dunblane",
          "postcode": "FK15",
          "nearby_areas": [
            "Callander",
            "Stirling",
            "Dollar",
            "Bridge of Allan",
            "Alloa",
            "Clackmannan",
            "Alva"
          ]
        },
        {
          "name": "Callander",
          "slug": "callander",
          "postcode": "FK17",
          "nearby_areas": [
            "Dollar",
            "Alloa",
            "Clackmannan",
            "Alva",
            "Bridge of Allan",
            "Stirling",
            "Denny"
          ]
        },
        {
          "name": "Balfron",
          "slug": "balfron",
          "postcode": "G63",
          "nearby_areas": [
            "Bishopbriggs",
            "Milngavie",
            "Kilsyth",
            "Bearsden",
            "Kirkintilloch",
            "Lennoxtown",
            "Cumbernauld"
          ]
        }
      ]
    },
    {
      "name": "Suffolk",
      "slug": "suffolk",
      "region": "East of England",
      "council_name": "Suffolk County Council",
      "council_url": "https://www.suffolk.gov.uk/",
      "climate": "dry eastern climate with coastal winds",
      "population": "760,000",
      "towns": [
        {
          "name": "Ipswich",
          "slug": "ipswich",
          "postcode": "IP1",
          "nearby_areas": [
            "Hadleigh",
            "Woodbridge",
            "Aldeburgh",
            "Saxmundham",
            "Felixstowe",
            "Stowmarket",
            "Harwich"
          ]
        },
        {
          "name": "Lowestoft",
          "slug": "lowestoft",
          "postcode": "NR32",
          "nearby_areas": [
            "Beccles",
            "Great Yarmouth",
            "Norwich",
            "Aylsham",
            "North Walsham",
            "Diss",
            "Holt"
          ]
        },
        {
          "name": "Bury St Edmunds",
          "slug": "bury-st-edmunds",
          "postcode": "IP33",
          "nearby_areas": [
            "Mildenhall",
            "Eye",
            "Stowmarket",
            "Newmarket",
            "Thetford",
            "Sudbury",
            "Haverhill"
          ]
        },
        {
          "name": "Felixstowe",
          "slug": "felixstowe",
          "postcode": "IP11",
          "nearby_areas": [
            "Harwich",
            "Woodbridge",
            "Ipswich",
            "Hadleigh",
            "Clacton-on-Sea",
            "Aldeburgh",
            "Halstead"
          ]
        },
        {
          "name": "Haverhill",
          "slug": "haverhill",
          "postcode": "CB9",
          "nearby_areas": [
            "Sawston",
            "Histon",
            "Saffron Walden",
            "Cambridge",
            "Newmarket",
            "Sudbury",
            "Soham"
          ]
        },
        {
          "name": "Stowmarket",
          "slug": "stowmarket",
          "postcode": "IP14",
          "nearby_areas": [
            "Saxmundham",
            "Aldeburgh",
            "Mildenhall",
            "Hadleigh",
            "Eye",
            "Ipswich",
            "Bury St Edmunds"
          ]
        },
        {
          "name": "Newmarket",
          "slug": "newmarket",
          "postcode": "CB8",
          "nearby_areas": [
            "Cambridge",
            "Soham",
            "Histon",
            "Sawston",
            "Haverhill",
            "Bury St Edmunds",
            "Ely"
          ]
        },
        {
          "name": "Sudbury",
          "slug": "sudbury",
          "postcode": "CO10",
          "nearby_areas": [
            "Halstead",
            "Haverhill",
            "Colchester",
            "Bury St Edmunds",
            "Braintree",
            "Stowmarket",
            "Ipswich"
          ]
        },
        {
          "name": "Woodbridge",
          "slug": "woodbridge",
          "postcode": "IP12",
          "nearby_areas": [
            "Hadleigh",
            "Ipswich",
            "Felixstowe",
            "Aldeburgh",
            "Harwich",
            "Saxmundham",
            "Stowmarket"
          ]
        },
        {
          "name": "Beccles",
          "slug": "beccles",
          "postcode": "NR34",
          "nearby_areas": [
            "Lowestoft",
            "Great Yarmouth",
            "Norwich",
            "Diss",
            "Aylsham",
            "Attleborough",
            "Eye"
          ]
        },
        {
          "name": "Saxmundham",
          "slug": "saxmundham",
          "postcode": "IP17",
          "nearby_areas": [
            "Aldeburgh",
            "Stowmarket",
            "Hadleigh",
            "Mildenhall",
            "Eye",
            "Ipswich",
            "Woodbridge"
          ]
        },
        {
          "name": "Aldeburgh",
          "slug": "aldeburgh",
          "postcode": "IP15",
          "nearby_areas": [
            "Saxmundham",
            "Hadleigh",
            "Stowmarket",
            "Ipswich",
            "Mildenhall",
            "Woodbridge",
            "Eye"
          ]
        },
        {
          "name": "Mildenhall",
          "slug": "mildenhall",
          "postcode": "IP28",
          "nearby_areas": [
            "Eye",
            "Stowmarket",
            "Saxmundham",
            "Aldeburgh",
            "Bury St Edmunds",
            "Diss",
            "Hadleigh"
          ]
        },
        {
          "name": "Hadleigh",
          "slug": "hadleigh",
          "postcode": "IP7",
          "nearby_areas": [
            "Aldeburgh",
            "Ipswich",
            "Saxmundham",
            "Woodbridge",
            "Stowmarket",
            "Felixstowe",
            "Mildenhall"
          ]
        },
        {
          "name": "Eye",
          "slug": "eye",
          "postcode": "IP23",
          "nearby_areas": [
            "Mildenhall",
            "Diss",
            "Stowmarket",
            "Saxmundham",
            "Aldeburgh",
            "Bury St Edmunds",
            "Thetford"
          ]
        }
      ]
    },
    {
      "name": "Surrey",
      "slug": "surrey",
      "region": "South East England",
      "council_name": "Surrey County Council",
      "council_url": "https://www.surreycc.gov.uk/",
      "climate": "mild and damp winters",
      "population": "1.2 million",
      "towns": [
        {
          "name": "Guildford",
          "slug": "guildford",
          "postcode": "GU1",
          "nearby_areas": [
            "Godalming",
            "Woking",
            "Aldershot",
            "Farnborough",
            "Farnham",
            "Addlestone",
            "Dorking"
          ]
        },
        {
          "name": "Woking",
          "slug": "woking",
          "postcode": "GU21",
          "nearby_areas": [
            "Addlestone",
            "Guildford",
            "Weybridge",
            "Walton-on-Thames",
            "Egham",
            "Camberley",
            "Staines-upon-Thames"
          ]
        },
        {
          "name": "Redhill",
          "slug": "redhill",
          "postcode": "RH1",
          "nearby_areas": [
            "Reigate",
            "Dorking",
            "Crawley",
            "Leatherhead",
            "Ashtead",
            "Caterham",
            "Banstead"
          ]
        },
        {
          "name": "Reigate",
          "slug": "reigate",
          "postcode": "RH2",
          "nearby_areas": [
            "Redhill",
            "Dorking",
            "Banstead",
            "Caterham",
            "Ashtead",
            "Leatherhead",
            "Epsom"
          ]
        },
        {
          "name": "Epsom",
          "slug": "epsom",
          "postcode": "KT18",
          "nearby_areas": [
            "Ashtead",
            "Banstead",
            "Leatherhead",
            "Esher",
            "Kingston upon Thames",
            "Reigate",
            "Dorking"
          ]
        },
        {
          "name": "Camberley",
          "slug": "camberley",
          "postcode": "GU15",
          "nearby_areas": [
            "Crowthorne",
            "Farnborough",
            "Bracknell",
            "Ascot",
            "Fleet",
            "Wokingham",
            "Aldershot"
          ]
        },
        {
          "name": "Farnham",
          "slug": "farnham",
          "postcode": "GU9",
          "nearby_areas": [
            "Sandhurst",
            "Aldershot",
            "Fleet",
            "Farnborough",
            "Alton",
            "Godalming",
            "Camberley"
          ]
        },
        {
          "name": "Leatherhead",
          "slug": "leatherhead",
          "postcode": "KT22",
          "nearby_areas": [
            "Ashtead",
            "Epsom",
            "Dorking",
            "Esher",
            "Banstead",
            "Kingston upon Thames",
            "Reigate"
          ]
        },
        {
          "name": "Dorking",
          "slug": "dorking",
          "postcode": "RH4",
          "nearby_areas": [
            "Leatherhead",
            "Ashtead",
            "Reigate",
            "Redhill",
            "Epsom",
            "Banstead",
            "Esher"
          ]
        },
        {
          "name": "Staines-upon-Thames",
          "slug": "staines-upon-thames",
          "postcode": "TW18",
          "nearby_areas": [
            "Egham",
            "Addlestone",
            "Weybridge",
            "Walton-on-Thames",
            "Hounslow",
            "Windsor",
            "Slough"
          ]
        },
        {
          "name": "Walton-on-Thames",
          "slug": "walton-on-thames",
          "postcode": "KT12",
          "nearby_areas": [
            "Weybridge",
            "Esher",
            "Kingston upon Thames",
            "Addlestone",
            "Staines-upon-Thames",
            "Hounslow",
            "Egham"
          ]
        },
        {
          "name": "Esher",
          "slug": "esher",
          "postcode": "KT10",
          "nearby_areas": [
            "Kingston upon Thames",
            "Walton-on-Thames",
            "Weybridge",
            "Epsom",
            "Ashtead",
            "Leatherhead",
            "Addlestone"
          ]
        },
        {
          "name": "Weybridge",
          "slug": "weybridge",
          "postcode": "KT13",
          "nearby_areas": [
            "Addlestone",
            "Walton-on-Thames",
            "Esher",
            "Kingston upon Thames",
            "Staines-upon-Thames",
            "Egham",
            "Woking"
          ]
        },
        {
          "name": "Godalming",
          "slug": "godalming",
          "postcode": "GU7",
          "nearby_areas": [
            "Guildford",
            "Haslemere",
            "Sandhurst",
            "Farnham",
            "Aldershot",
            "Petworth",
            "Woking"
          ]
        },
        {
          "name": "Egham",
          "slug": "egham",
          "postcode": "TW20",
          "nearby_areas": [
            "Staines-upon-Thames",
            "Windsor",
            "Addlestone",
            "Weybridge",
            "Ascot",
            "Walton-on-Thames",
            "Slough"
          ]
        },
        {
          "name": "Addlestone",
          "slug": "addlestone",
          "postcode": "KT15",
          "nearby_areas": [
            "Weybridge",
            "Walton-on-Thames",
            "Staines-upon-Thames",
            "Woking",
            "Egham",
            "Esher",
            "Kingston upon Thames"
          ]
        },
        {
          "name": "Caterham",
          "slug": "caterham",
          "postcode": "CR3",
          "nearby_areas": [
            "Croydon",
            "Banstead",
            "Reigate",
            "Epsom",
            "Redhill",
            "Ashtead",
            "Leatherhead"
          ]
        },
        {
          "name": "Haslemere",
          "slug": "haslemere",
          "postcode": "GU27",
          "nearby_areas": [
            "Petworth",
            "Alton",
            "Godalming",
            "Midhurst",
            "Sandhurst",
            "Farnham",
            "Guildford"
          ]
        },
        {
          "name": "Ashtead",
          "slug": "ashtead",
          "postcode": "KT21",
          "nearby_areas": [
            "Leatherhead",
            "Epsom",
            "Banstead",
            "Esher",
            "Dorking",
            "Kingston upon Thames",
            "Reigate"
          ]
        },
        {
          "name": "Banstead",
          "slug": "banstead",
          "postcode": "SM7",
          "nearby_areas": [
            "Epsom",
            "Ashtead",
            "Leatherhead",
            "Reigate",
            "Caterham",
            "Croydon",
            "Esher"
          ]
        }
      ]
    },
    {
      "name": "Swansea",
      "slug": "swansea",
      "region": "Wales",
      "council_name": "Swansea Council",
      "council_url": "https://www.swansea.gov.uk/",
      "climate": "mild, wet and coastal",
      "population": "245,000",
      "towns": [
        {
          "name": "Swansea",
          "slug": "swansea",
          "postcode": "SA1",
          "nearby_areas": [
            "Briton Ferry",
            "Glynneath",
            "Cymmer",
            "Ystradgynlais",
            "Pontardawe",
            "Clydach",
            "Morriston"
          ]
        },
        {
          "name": "Mumbles",
          "slug": "mumbles",
          "postcode": "SA3",
          "nearby_areas": [
            "Gorseinon",
            "Pontarddulais",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Gorseinon",
          "slug": "gorseinon",
          "postcode": "SA4",
          "nearby_areas": [
            "Pontarddulais",
            "Mumbles",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Morriston",
          "slug": "morriston",
          "postcode": "SA6",
          "nearby_areas": [
            "Clydach",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Pontarddulais",
          "slug": "pontarddulais",
          "postcode": "SA4",
          "nearby_areas": [
            "Gorseinon",
            "Mumbles",
            "Clydach",
            "Morriston",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        },
        {
          "name": "Clydach",
          "slug": "clydach",
          "postcode": "SA6",
          "nearby_areas": [
            "Morriston",
            "Mumbles",
            "Gorseinon",
            "Pontarddulais",
            "Pontardawe",
            "Ystradgynlais",
            "Cymmer"
          ]
        }
      ]
    },
    {
      "name": "Torfaen",
      "slug": "torfaen",
      "region": "Wales",
      "council_name": "Torfaen County Borough Council",
      "council_url": "https://www.torfaen.gov.uk/",
      "climate": "wet valleys climate",
      "population": "92,000",
      "towns": [
        {
          "name": "Cwmbran",
          "slug": "cwmbran",
          "postcode": "NP44",
          "nearby_areas": [
            "Caerleon",
            "Langstone",
            "Malpas",
            "Newport",
            "Raglan",
            "Usk",
            "Blaenavon"
          ]
        },
        {
          "name": "Pontypool",
          "slug": "pontypool",
          "postcode": "NP4",
          "nearby_areas": [
            "Abersychan",
            "Abertillery",
            "Blackwood",
            "Abergavenny",
            "Ebbw Vale",
            "Tredegar",
            "Caerphilly"
          ]
        },
        {
          "name": "Blaenavon",
          "slug": "blaenavon",
          "postcode": "NP4",
          "nearby_areas": [
            "New Inn",
            "Brynmawr",
            "Nantyglo",
            "Malpas",
            "Newport",
            "Abergavenny",
            "Cwmbran"
          ]
        },
        {
          "name": "Abersychan",
          "slug": "abersychan",
          "postcode": "NP4",
          "nearby_areas": [
            "Pontypool",
            "Abertillery",
            "Abergavenny",
            "Blackwood",
            "Ebbw Vale",
            "Tredegar",
            "Brynmawr"
          ]
        },
        {
          "name": "New Inn",
          "slug": "new-inn",
          "postcode": "NP4",
          "nearby_areas": [
            "Blaenavon",
            "Brynmawr",
            "Nantyglo",
            "Malpas",
            "Newport",
            "Abergavenny",
            "Cwmbran"
          ]
        }
      ]
    },
    {
      "name": "Tyne and Wear",
      "slug": "tyne-and-wear",
      "region": "North East England",
      "council_name": "Tyne and Wear Council",
      "council_url": "https://www.tyneandwear.gov.uk/",
      "climate": "cool, coastal and windy",
      "population": "1.1 million",
      "towns": [
        {
          "name": "Newcastle upon Tyne",
          "slug": "newcastle-upon-tyne",
          "postcode": "NE1",
          "nearby_areas": [
            "Gateshead",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Hebburn",
            "Jarrow",
            "Blaydon"
          ]
        },
        {
          "name": "Sunderland",
          "slug": "sunderland",
          "postcode": "SR1",
          "nearby_areas": [
            "Washington",
            "Seaham",
            "Jarrow",
            "South Shields",
            "Hebburn",
            "Wallsend",
            "Tynemouth"
          ]
        },
        {
          "name": "Gateshead",
          "slug": "gateshead",
          "postcode": "NE8",
          "nearby_areas": [
            "Newcastle upon Tyne",
            "Hebburn",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Washington",
            "Jarrow"
          ]
        },
        {
          "name": "South Shields",
          "slug": "south-shields",
          "postcode": "NE33",
          "nearby_areas": [
            "Jarrow",
            "Whitley Bay",
            "Hebburn",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "Sunderland"
          ]
        },
        {
          "name": "North Shields",
          "slug": "north-shields",
          "postcode": "NE29",
          "nearby_areas": [
            "Tynemouth",
            "Wallsend",
            "Hebburn",
            "Blyth",
            "Jarrow",
            "Ponteland",
            "Blaydon"
          ]
        },
        {
          "name": "Tynemouth",
          "slug": "tynemouth",
          "postcode": "NE30",
          "nearby_areas": [
            "North Shields",
            "Wallsend",
            "Hebburn",
            "Jarrow",
            "Blyth",
            "Newcastle upon Tyne",
            "Ponteland"
          ]
        },
        {
          "name": "Washington",
          "slug": "washington",
          "postcode": "NE37",
          "nearby_areas": [
            "Hebburn",
            "Gateshead",
            "Sunderland",
            "Jarrow",
            "Wallsend",
            "Newcastle upon Tyne",
            "Tynemouth"
          ]
        },
        {
          "name": "Wallsend",
          "slug": "wallsend",
          "postcode": "NE28",
          "nearby_areas": [
            "Tynemouth",
            "Hebburn",
            "North Shields",
            "Jarrow",
            "Newcastle upon Tyne",
            "South Shields",
            "Gateshead"
          ]
        },
        {
          "name": "Whitley Bay",
          "slug": "whitley-bay",
          "postcode": "NE26",
          "nearby_areas": [
            "South Shields",
            "North Shields",
            "Jarrow",
            "Tynemouth",
            "Wallsend",
            "Blyth",
            "Blaydon"
          ]
        },
        {
          "name": "Jarrow",
          "slug": "jarrow",
          "postcode": "NE32",
          "nearby_areas": [
            "Hebburn",
            "Wallsend",
            "South Shields",
            "Tynemouth",
            "North Shields",
            "Whitley Bay",
            "Newcastle upon Tyne"
          ]
        },
        {
          "name": "Blaydon",
          "slug": "blaydon",
          "postcode": "NE21",
          "nearby_areas": [
            "Ponteland",
            "Blyth",
            "Cramlington",
            "North Shields",
            "Tynemouth",
            "Wallsend",
            "Whitley Bay"
          ]
        },
        {
          "name": "Hebburn",
          "slug": "hebburn",
          "postcode": "NE31",
          "nearby_areas": [
            "Jarrow",
            "Wallsend",
            "Tynemouth",
            "North Shields",
            "South Shields",
            "Newcastle upon Tyne",
            "Gateshead"
          ]
        },
        {
          "name": "Houghton-le-Spring",
          "slug": "houghton-le-spring",
          "postcode": "DH4",
          "nearby_areas": [
            "Chester-le-Street",
            "Stanley",
            "Durham",
            "Consett",
            "Crook",
            "Washington",
            "Spennymoor"
          ]
        }
      ]
    },
    {
      "name": "Vale of Glamorgan",
      "slug": "vale-of-glamorgan",
      "region": "Wales",
      "council_name": "Vale of Glamorgan Council",
      "council_url": "https://www.valeofglamorgan.gov.uk/",
      "climate": "mild coastal climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Barry",
          "slug": "barry",
          "postcode": "CF62",
          "nearby_areas": [
            "Rhoose",
            "Cowbridge",
            "Llantrisant",
            "Dinas Powys",
            "Canton",
            "Llandaff",
            "Whitchurch"
          ]
        },
        {
          "name": "Penarth",
          "slug": "penarth",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Dinas Powys",
            "Barry",
            "Rhoose",
            "Cowbridge",
            "Caerphilly",
            "Llantrisant"
          ]
        },
        {
          "name": "Cowbridge",
          "slug": "cowbridge",
          "postcode": "CF71",
          "nearby_areas": [
            "Llantrisant",
            "Canton",
            "Llandaff",
            "Whitchurch",
            "Marshfield",
            "Bargoed",
            "Radyr"
          ]
        },
        {
          "name": "Llantwit Major",
          "slug": "llantwit-major",
          "postcode": "CF61",
          "nearby_areas": [
            "Barry",
            "Rhoose",
            "Bridgend",
            "Cowbridge",
            "Dinas Powys",
            "Porthcawl",
            "Llantrisant"
          ]
        },
        {
          "name": "Dinas Powys",
          "slug": "dinas-powys",
          "postcode": "CF64",
          "nearby_areas": [
            "Cardiff",
            "Penarth",
            "Barry",
            "Rhoose",
            "Cowbridge",
            "Llantrisant",
            "Ystrad Mynach"
          ]
        },
        {
          "name": "Rhoose",
          "slug": "rhoose",
          "postcode": "CF62",
          "nearby_areas": [
            "Barry",
            "Cowbridge",
            "Llantrisant",
            "Dinas Powys",
            "Canton",
            "Llandaff",
            "Whitchurch"
          ]
        }
      ]
    },
    {
      "name": "Warwickshire",
      "slug": "warwickshire",
      "region": "West Midlands",
      "council_name": "Warwickshire County Council",
      "council_url": "https://www.warwickshire.gov.uk/",
      "climate": "mild inland climate with winter damp",
      "population": "600,000",
      "towns": [
        {
          "name": "Warwick",
          "slug": "warwick",
          "postcode": "CV34",
          "nearby_areas": [
            "Southam",
            "Leamington Spa",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Solihull"
          ]
        },
        {
          "name": "Nuneaton",
          "slug": "nuneaton",
          "postcode": "CV11",
          "nearby_areas": [
            "Bedworth",
            "Atherstone",
            "Hinckley",
            "Coventry",
            "Kenilworth",
            "Rugby",
            "Tamworth"
          ]
        },
        {
          "name": "Rugby",
          "slug": "rugby",
          "postcode": "CV21",
          "nearby_areas": [
            "Lutterworth",
            "Daventry",
            "Bedworth",
            "Coventry",
            "Kenilworth",
            "Nuneaton",
            "Southam"
          ]
        },
        {
          "name": "Leamington Spa",
          "slug": "leamington-spa",
          "postcode": "CV32",
          "nearby_areas": [
            "Southam",
            "Warwick",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Shipston-on-Stour"
          ]
        },
        {
          "name": "Stratford-upon-Avon",
          "slug": "stratford-upon-avon",
          "postcode": "CV37",
          "nearby_areas": [
            "Alcester",
            "Leamington Spa",
            "Warwick",
            "Southam",
            "Shipston-on-Stour",
            "Kenilworth",
            "Evesham"
          ]
        },
        {
          "name": "Bedworth",
          "slug": "bedworth",
          "postcode": "CV12",
          "nearby_areas": [
            "Nuneaton",
            "Coventry",
            "Hinckley",
            "Atherstone",
            "Kenilworth",
            "Rugby",
            "Lutterworth"
          ]
        },
        {
          "name": "Atherstone",
          "slug": "atherstone",
          "postcode": "CV9",
          "nearby_areas": [
            "Nuneaton",
            "Bedworth",
            "Tamworth",
            "Hinckley",
            "Polesworth",
            "Coventry",
            "Ashby-de-la-Zouch"
          ]
        },
        {
          "name": "Kenilworth",
          "slug": "kenilworth",
          "postcode": "CV8",
          "nearby_areas": [
            "Southam",
            "Warwick",
            "Coventry",
            "Leamington Spa",
            "Bedworth",
            "Solihull",
            "Stratford-upon-Avon"
          ]
        },
        {
          "name": "Alcester",
          "slug": "alcester",
          "postcode": "B49",
          "nearby_areas": [
            "Stratford-upon-Avon",
            "Redditch",
            "Coleshill",
            "Evesham",
            "Broadway",
            "Colwall",
            "Malvern"
          ]
        },
        {
          "name": "Shipston-on-Stour",
          "slug": "shipston-on-stour",
          "postcode": "CV36",
          "nearby_areas": [
            "Moreton-in-Marsh",
            "Stratford-upon-Avon",
            "Chipping Norton",
            "Leamington Spa",
            "Alcester",
            "Banbury",
            "Warwick"
          ]
        },
        {
          "name": "Southam",
          "slug": "southam",
          "postcode": "CV47",
          "nearby_areas": [
            "Warwick",
            "Leamington Spa",
            "Kenilworth",
            "Stratford-upon-Avon",
            "Coventry",
            "Alcester",
            "Solihull"
          ]
        },
        {
          "name": "Coleshill",
          "slug": "coleshill",
          "postcode": "B46",
          "nearby_areas": [
            "Redditch",
            "Bromsgrove",
            "Solihull",
            "Alcester",
            "Oldbury",
            "Halesowen",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Polesworth",
          "slug": "polesworth",
          "postcode": "B78",
          "nearby_areas": [
            "Birmingham",
            "Sutton Coldfield",
            "Smethwick",
            "West Bromwich",
            "Oldbury",
            "Walsall",
            "Wednesbury"
          ]
        }
      ]
    },
    {
      "name": "West Dunbartonshire",
      "slug": "west-dunbartonshire",
      "region": "Scotland",
      "council_name": "West Dunbartonshire Council",
      "council_url": "https://www.west-dunbarton.gov.uk/",
      "climate": "wet west central climate",
      "population": "88,000",
      "towns": [
        {
          "name": "Clydebank",
          "slug": "clydebank",
          "postcode": "G81",
          "nearby_areas": [
            "Rutherglen",
            "Cambuslang",
            "East Kilbride",
            "Clarkston",
            "Eaglesham",
            "Newton Mearns",
            "Barrhead"
          ]
        },
        {
          "name": "Dumbarton",
          "slug": "dumbarton",
          "postcode": "G82",
          "nearby_areas": [
            "Govan",
            "Renfrew",
            "Linwood",
            "Johnstone",
            "Bearsden",
            "Milngavie",
            "Balfron"
          ]
        },
        {
          "name": "Alexandria",
          "slug": "alexandria",
          "postcode": "G83",
          "nearby_areas": [
            "Balloch",
            "Barrhead",
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "Clydebank",
            "East Kilbride"
          ]
        },
        {
          "name": "Balloch",
          "slug": "balloch",
          "postcode": "G83",
          "nearby_areas": [
            "Alexandria",
            "Barrhead",
            "Newton Mearns",
            "Clarkston",
            "Eaglesham",
            "Clydebank",
            "East Kilbride"
          ]
        }
      ]
    },
    {
      "name": "West Lothian",
      "slug": "west-lothian",
      "region": "Scotland",
      "council_name": "West Lothian Council",
      "council_url": "https://www.westlothian.gov.uk/",
      "climate": "cool, damp central Scotland climate",
      "population": "185,000",
      "towns": [
        {
          "name": "Livingston",
          "slug": "livingston",
          "postcode": "EH54",
          "nearby_areas": [
            "Broxburn",
            "Armadale",
            "Bathgate",
            "Newbridge",
            "Linlithgow",
            "Bo'ness",
            "Whitburn"
          ]
        },
        {
          "name": "Bathgate",
          "slug": "bathgate",
          "postcode": "EH48",
          "nearby_areas": [
            "Livingston",
            "Linlithgow",
            "Broxburn",
            "Armadale",
            "Falkirk",
            "Newbridge",
            "Bo'ness"
          ]
        },
        {
          "name": "Linlithgow",
          "slug": "linlithgow",
          "postcode": "EH49",
          "nearby_areas": [
            "Bathgate",
            "Broxburn",
            "Livingston",
            "Falkirk",
            "Armadale",
            "Newbridge",
            "Dunfermline"
          ]
        },
        {
          "name": "Broxburn",
          "slug": "broxburn",
          "postcode": "EH52",
          "nearby_areas": [
            "Newbridge",
            "Armadale",
            "Livingston",
            "Bo'ness",
            "Linlithgow",
            "Bathgate",
            "Whitburn"
          ]
        },
        {
          "name": "Whitburn",
          "slug": "whitburn",
          "postcode": "EH47",
          "nearby_areas": [
            "Bo'ness",
            "Armadale",
            "Penicuik",
            "Edinburgh",
            "Leith",
            "Newbridge",
            "Newington"
          ]
        },
        {
          "name": "Armadale",
          "slug": "armadale",
          "postcode": "EH48",
          "nearby_areas": [
            "Bo'ness",
            "Newbridge",
            "Broxburn",
            "Whitburn",
            "Livingston",
            "Linlithgow",
            "Edinburgh"
          ]
        }
      ]
    },
    {
      "name": "West Midlands",
      "slug": "west-midlands",
      "region": "West Midlands",
      "council_name": "West Midlands Combined Authority (area)",
      "council_url": "https://www.wmca.org.uk/",
      "climate": "urban climate with damp winters",
      "population": "2.9 million",
      "towns": [
        {
          "name": "Birmingham",
          "slug": "birmingham",
          "postcode": "B1",
          "nearby_areas": [
            "Sutton Coldfield",
            "Oldbury",
            "Smethwick",
            "Polesworth",
            "West Bromwich",
            "Solihull",
            "Wednesbury"
          ]
        },
        {
          "name": "Coventry",
          "slug": "coventry",
          "postcode": "CV1",
          "nearby_areas": [
            "Kenilworth",
            "Bedworth",
            "Nuneaton",
            "Southam",
            "Warwick",
            "Solihull",
            "Leamington Spa"
          ]
        },
        {
          "name": "Wolverhampton",
          "slug": "wolverhampton",
          "postcode": "WV1",
          "nearby_areas": [
            "Willenhall",
            "Bilston",
            "Tipton",
            "Wednesbury",
            "Walsall",
            "Kingswinford",
            "Brierley Hill"
          ]
        },
        {
          "name": "Dudley",
          "slug": "dudley",
          "postcode": "DY1",
          "nearby_areas": [
            "Stourbridge",
            "Brierley Hill",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "Cleobury Mortimer",
            "Bilston"
          ]
        },
        {
          "name": "Walsall",
          "slug": "walsall",
          "postcode": "WS1",
          "nearby_areas": [
            "Wednesbury",
            "Willenhall",
            "West Bromwich",
            "Tipton",
            "Wolverhampton",
            "Smethwick",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Solihull",
          "slug": "solihull",
          "postcode": "B91",
          "nearby_areas": [
            "Birmingham",
            "Sutton Coldfield",
            "Coleshill",
            "Oldbury",
            "Polesworth",
            "Smethwick",
            "Kenilworth"
          ]
        },
        {
          "name": "West Bromwich",
          "slug": "west-bromwich",
          "postcode": "B70",
          "nearby_areas": [
            "Smethwick",
            "Wednesbury",
            "Tipton",
            "Sutton Coldfield",
            "Oldbury",
            "Walsall",
            "Birmingham"
          ]
        },
        {
          "name": "Sutton Coldfield",
          "slug": "sutton-coldfield",
          "postcode": "B72",
          "nearby_areas": [
            "Oldbury",
            "Smethwick",
            "Birmingham",
            "West Bromwich",
            "Halesowen",
            "Wednesbury",
            "Tipton"
          ]
        },
        {
          "name": "Stourbridge",
          "slug": "stourbridge",
          "postcode": "DY8",
          "nearby_areas": [
            "Dudley",
            "Brierley Hill",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "Cleobury Mortimer",
            "Oldbury"
          ]
        },
        {
          "name": "Halesowen",
          "slug": "halesowen",
          "postcode": "B63",
          "nearby_areas": [
            "Brierley Hill",
            "Oldbury",
            "Stourbridge",
            "Smethwick",
            "Dudley",
            "Sutton Coldfield",
            "West Bromwich"
          ]
        },
        {
          "name": "Brierley Hill",
          "slug": "brierley-hill",
          "postcode": "DY5",
          "nearby_areas": [
            "Stourbridge",
            "Dudley",
            "Kingswinford",
            "Halesowen",
            "Tipton",
            "West Bromwich",
            "Smethwick"
          ]
        },
        {
          "name": "Smethwick",
          "slug": "smethwick",
          "postcode": "B66",
          "nearby_areas": [
            "Sutton Coldfield",
            "Oldbury",
            "West Bromwich",
            "Birmingham",
            "Wednesbury",
            "Halesowen",
            "Tipton"
          ]
        },
        {
          "name": "Oldbury",
          "slug": "oldbury",
          "postcode": "B68",
          "nearby_areas": [
            "Sutton Coldfield",
            "Smethwick",
            "Birmingham",
            "West Bromwich",
            "Halesowen",
            "Tipton",
            "Wednesbury"
          ]
        },
        {
          "name": "Tipton",
          "slug": "tipton",
          "postcode": "DY4",
          "nearby_areas": [
            "Wednesbury",
            "West Bromwich",
            "Willenhall",
            "Brierley Hill",
            "Wolverhampton",
            "Kingswinford",
            "Smethwick"
          ]
        },
        {
          "name": "Willenhall",
          "slug": "willenhall",
          "postcode": "WV12",
          "nearby_areas": [
            "Wednesbury",
            "Wolverhampton",
            "Walsall",
            "Tipton",
            "West Bromwich",
            "Bilston",
            "Smethwick"
          ]
        },
        {
          "name": "Bilston",
          "slug": "bilston",
          "postcode": "WV14",
          "nearby_areas": [
            "Wolverhampton",
            "Kingswinford",
            "Tipton",
            "Brierley Hill",
            "Willenhall",
            "Dudley",
            "Stourbridge"
          ]
        },
        {
          "name": "Kingswinford",
          "slug": "kingswinford",
          "postcode": "DY6",
          "nearby_areas": [
            "Brierley Hill",
            "Dudley",
            "Stourbridge",
            "Tipton",
            "Bilston",
            "Halesowen",
            "Wolverhampton"
          ]
        },
        {
          "name": "Wednesbury",
          "slug": "wednesbury",
          "postcode": "WS10",
          "nearby_areas": [
            "Tipton",
            "West Bromwich",
            "Willenhall",
            "Walsall",
            "Smethwick",
            "Wolverhampton",
            "Sutton Coldfield"
          ]
        }
      ]
    },
    {
      "name": "West Sussex",
      "slug": "west-sussex",
      "region": "South East England",
      "council_name": "West Sussex County Council",
      "council_url": "https://www.westsussex.gov.uk/",
      "climate": "mild coastal conditions and damp winters",
      "population": "900,000",
      "towns": [
        {
          "name": "Crawley",
          "slug": "crawley",
          "postcode": "RH10",
          "nearby_areas": [
            "Horsham",
            "Redhill",
            "Haywards Heath",
            "East Grinstead",
            "Burgess Hill",
            "Reigate",
            "Dorking"
          ]
        },
        {
          "name": "Worthing",
          "slug": "worthing",
          "postcode": "BN11",
          "nearby_areas": [
            "Shoreham-by-Sea",
            "Steyning",
            "Littlehampton",
            "Arundel",
            "Bognor Regis",
            "Burgess Hill",
            "Brighton"
          ]
        },
        {
          "name": "Chichester",
          "slug": "chichester",
          "postcode": "PO19",
          "nearby_areas": [
            "Bognor Regis",
            "Selsey",
            "Emsworth",
            "Havant",
            "Midhurst",
            "Littlehampton",
            "Waterlooville"
          ]
        },
        {
          "name": "Horsham",
          "slug": "horsham",
          "postcode": "RH12",
          "nearby_areas": [
            "Crawley",
            "Redhill",
            "Haywards Heath",
            "Burgess Hill",
            "Steyning",
            "Dorking",
            "East Grinstead"
          ]
        },
        {
          "name": "Bognor Regis",
          "slug": "bognor-regis",
          "postcode": "PO21",
          "nearby_areas": [
            "Chichester",
            "Littlehampton",
            "Selsey",
            "Worthing",
            "Emsworth",
            "Midhurst",
            "Havant"
          ]
        },
        {
          "name": "Littlehampton",
          "slug": "littlehampton",
          "postcode": "BN17",
          "nearby_areas": [
            "Bognor Regis",
            "Worthing",
            "Chichester",
            "Steyning",
            "Shoreham-by-Sea",
            "Midhurst",
            "Arundel"
          ]
        },
        {
          "name": "Haywards Heath",
          "slug": "haywards-heath",
          "postcode": "RH16",
          "nearby_areas": [
            "Burgess Hill",
            "Crawley",
            "East Grinstead",
            "Uckfield",
            "Horsham",
            "Lewes",
            "Steyning"
          ]
        },
        {
          "name": "Burgess Hill",
          "slug": "burgess-hill",
          "postcode": "RH15",
          "nearby_areas": [
            "Haywards Heath",
            "Lewes",
            "Steyning",
            "Crawley",
            "Arundel",
            "Shoreham-by-Sea",
            "Hove"
          ]
        },
        {
          "name": "East Grinstead",
          "slug": "east-grinstead",
          "postcode": "RH19",
          "nearby_areas": [
            "Haywards Heath",
            "Crawley",
            "Crowborough",
            "Redhill",
            "Caterham",
            "Tunbridge Wells",
            "Burgess Hill"
          ]
        },
        {
          "name": "Shoreham-by-Sea",
          "slug": "shoreham-by-sea",
          "postcode": "BN43",
          "nearby_areas": [
            "Steyning",
            "Worthing",
            "Arundel",
            "Brighton",
            "Hove",
            "Burgess Hill",
            "Littlehampton"
          ]
        },
        {
          "name": "Midhurst",
          "slug": "midhurst",
          "postcode": "GU29",
          "nearby_areas": [
            "Petworth",
            "Haslemere",
            "Petersfield",
            "Alton",
            "Chichester",
            "Bognor Regis",
            "Emsworth"
          ]
        },
        {
          "name": "Petworth",
          "slug": "petworth",
          "postcode": "GU28",
          "nearby_areas": [
            "Haslemere",
            "Alton",
            "Sandhurst",
            "Midhurst",
            "Godalming",
            "Farnham",
            "Aldershot"
          ]
        },
        {
          "name": "Arundel",
          "slug": "arundel",
          "postcode": "BN18",
          "nearby_areas": [
            "Brighton",
            "Hove",
            "Shoreham-by-Sea",
            "Peacehaven",
            "Lewes",
            "Steyning",
            "Worthing"
          ]
        },
        {
          "name": "Steyning",
          "slug": "steyning",
          "postcode": "BN44",
          "nearby_areas": [
            "Shoreham-by-Sea",
            "Worthing",
            "Arundel",
            "Burgess Hill",
            "Littlehampton",
            "Horsham",
            "Haywards Heath"
          ]
        },
        {
          "name": "Selsey",
          "slug": "selsey",
          "postcode": "PO20",
          "nearby_areas": [
            "Emsworth",
            "Havant",
            "Chichester",
            "Portsmouth",
            "Waterlooville",
            "Gosport",
            "Bognor Regis"
          ]
        }
      ]
    },
    {
      "name": "West Yorkshire",
      "slug": "west-yorkshire",
      "region": "Yorkshire and the Humber",
      "council_name": "West Yorkshire Council",
      "council_url": "https://www.westyorkshire.gov.uk/",
      "climate": "wet winters and Pennine rainfall",
      "population": "2.4 million",
      "towns": [
        {
          "name": "Leeds",
          "slug": "leeds",
          "postcode": "LS1",
          "nearby_areas": [
            "Batley",
            "Dewsbury",
            "Wakefield",
            "Cleckheaton",
            "Bradford",
            "Castleford",
            "Otley"
          ]
        },
        {
          "name": "Bradford",
          "slug": "bradford",
          "postcode": "BD1",
          "nearby_areas": [
            "Shipley",
            "Cleckheaton",
            "Halifax",
            "Otley",
            "Brighouse",
            "Batley",
            "Keighley"
          ]
        },
        {
          "name": "Wakefield",
          "slug": "wakefield",
          "postcode": "WF1",
          "nearby_areas": [
            "Dewsbury",
            "Batley",
            "Castleford",
            "Pontefract",
            "Leeds",
            "Cleckheaton",
            "Barnsley"
          ]
        },
        {
          "name": "Huddersfield",
          "slug": "huddersfield",
          "postcode": "HD1",
          "nearby_areas": [
            "Brighouse",
            "Cleckheaton",
            "Halifax",
            "Dewsbury",
            "Batley",
            "Bradford",
            "Shipley"
          ]
        },
        {
          "name": "Halifax",
          "slug": "halifax",
          "postcode": "HX1",
          "nearby_areas": [
            "Brighouse",
            "Shipley",
            "Cleckheaton",
            "Huddersfield",
            "Bradford",
            "Hebden Bridge",
            "Batley"
          ]
        },
        {
          "name": "Keighley",
          "slug": "keighley",
          "postcode": "BD21",
          "nearby_areas": [
            "Settle",
            "Ilkley",
            "Morley",
            "Shipley",
            "Otley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Dewsbury",
          "slug": "dewsbury",
          "postcode": "WF12",
          "nearby_areas": [
            "Batley",
            "Cleckheaton",
            "Wakefield",
            "Brighouse",
            "Huddersfield",
            "Leeds",
            "Bradford"
          ]
        },
        {
          "name": "Batley",
          "slug": "batley",
          "postcode": "WF17",
          "nearby_areas": [
            "Dewsbury",
            "Cleckheaton",
            "Wakefield",
            "Brighouse",
            "Leeds",
            "Bradford",
            "Huddersfield"
          ]
        },
        {
          "name": "Castleford",
          "slug": "castleford",
          "postcode": "WF10",
          "nearby_areas": [
            "Pontefract",
            "Wakefield",
            "Leeds",
            "Batley",
            "Dewsbury",
            "Selby",
            "Barnsley"
          ]
        },
        {
          "name": "Pontefract",
          "slug": "pontefract",
          "postcode": "WF8",
          "nearby_areas": [
            "Castleford",
            "Wakefield",
            "Leeds",
            "Selby",
            "Dewsbury",
            "Batley",
            "Barnsley"
          ]
        },
        {
          "name": "Brighouse",
          "slug": "brighouse",
          "postcode": "HD6",
          "nearby_areas": [
            "Cleckheaton",
            "Halifax",
            "Huddersfield",
            "Dewsbury",
            "Batley",
            "Bradford",
            "Shipley"
          ]
        },
        {
          "name": "Morley",
          "slug": "morley",
          "postcode": "LS27",
          "nearby_areas": [
            "Ilkley",
            "Otley",
            "Keighley",
            "Settle",
            "Shipley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Shipley",
          "slug": "shipley",
          "postcode": "BD18",
          "nearby_areas": [
            "Bradford",
            "Keighley",
            "Halifax",
            "Otley",
            "Cleckheaton",
            "Brighouse",
            "Morley"
          ]
        },
        {
          "name": "Ilkley",
          "slug": "ilkley",
          "postcode": "LS29",
          "nearby_areas": [
            "Morley",
            "Otley",
            "Keighley",
            "Settle",
            "Shipley",
            "Bradford",
            "Skipton"
          ]
        },
        {
          "name": "Otley",
          "slug": "otley",
          "postcode": "LS21",
          "nearby_areas": [
            "Morley",
            "Ilkley",
            "Bradford",
            "Shipley",
            "Keighley",
            "Settle",
            "Leeds"
          ]
        },
        {
          "name": "Cleckheaton",
          "slug": "cleckheaton",
          "postcode": "BD19",
          "nearby_areas": [
            "Brighouse",
            "Batley",
            "Dewsbury",
            "Bradford",
            "Halifax",
            "Huddersfield",
            "Shipley"
          ]
        },
        {
          "name": "Todmorden",
          "slug": "todmorden",
          "postcode": "OL14",
          "nearby_areas": [
            "Hebden Bridge",
            "Bacup",
            "Rochdale",
            "Burnley",
            "Halifax",
            "Colne",
            "Brighouse"
          ]
        },
        {
          "name": "Hebden Bridge",
          "slug": "hebden-bridge",
          "postcode": "HX7",
          "nearby_areas": [
            "Todmorden",
            "Halifax",
            "Shipley",
            "Keighley",
            "Brighouse",
            "Bacup",
            "Bradford"
          ]
        }
      ]
    },
    {
      "name": "Wiltshire",
      "slug": "wiltshire",
      "region": "South West England",
      "council_name": "Wiltshire Council",
      "council_url": "https://www.wiltshire.gov.uk/",
      "climate": "mild, inland with damp winters",
      "population": "750,000",
      "towns": [
        {
          "name": "Swindon",
          "slug": "swindon",
          "postcode": "SN1",
          "nearby_areas": [
            "Royal Wootton Bassett",
            "Pewsey",
            "Calne",
            "Chippenham",
            "Marlborough",
            "Devizes",
            "Melksham"
          ]
        },
        {
          "name": "Salisbury",
          "slug": "salisbury",
          "postcode": "SP1",
          "nearby_areas": [
            "Amesbury",
            "Gillingham",
            "Verwood",
            "Romsey",
            "Ringwood",
            "Warminster",
            "Andover"
          ]
        },
        {
          "name": "Trowbridge",
          "slug": "trowbridge",
          "postcode": "BA14",
          "nearby_areas": [
            "Bradford-on-Avon",
            "Melksham",
            "Westbury",
            "Warminster",
            "Corsham",
            "Frome",
            "Bath"
          ]
        },
        {
          "name": "Chippenham",
          "slug": "chippenham",
          "postcode": "SN15",
          "nearby_areas": [
            "Calne",
            "Pewsey",
            "Devizes",
            "Swindon",
            "Melksham",
            "Royal Wootton Bassett",
            "Corsham"
          ]
        },
        {
          "name": "Warminster",
          "slug": "warminster",
          "postcode": "BA12",
          "nearby_areas": [
            "Westbury",
            "Frome",
            "Trowbridge",
            "Bradford-on-Avon",
            "Melksham",
            "Devizes",
            "Radstock"
          ]
        },
        {
          "name": "Melksham",
          "slug": "melksham",
          "postcode": "SN12",
          "nearby_areas": [
            "Corsham",
            "Trowbridge",
            "Bradford-on-Avon",
            "Devizes",
            "Chippenham",
            "Calne",
            "Bath"
          ]
        },
        {
          "name": "Devizes",
          "slug": "devizes",
          "postcode": "SN10",
          "nearby_areas": [
            "Chippenham",
            "Calne",
            "Melksham",
            "Pewsey",
            "Swindon",
            "Trowbridge",
            "Corsham"
          ]
        },
        {
          "name": "Calne",
          "slug": "calne",
          "postcode": "SN11",
          "nearby_areas": [
            "Chippenham",
            "Pewsey",
            "Swindon",
            "Devizes",
            "Royal Wootton Bassett",
            "Melksham",
            "Corsham"
          ]
        },
        {
          "name": "Marlborough",
          "slug": "marlborough",
          "postcode": "SN8",
          "nearby_areas": [
            "Royal Wootton Bassett",
            "Swindon",
            "Pewsey",
            "Hungerford",
            "Calne",
            "Chippenham",
            "Devizes"
          ]
        },
        {
          "name": "Corsham",
          "slug": "corsham",
          "postcode": "SN13",
          "nearby_areas": [
            "Melksham",
            "Bradford-on-Avon",
            "Chippenham",
            "Calne",
            "Trowbridge",
            "Bath",
            "Devizes"
          ]
        },
        {
          "name": "Westbury",
          "slug": "westbury",
          "postcode": "BA13",
          "nearby_areas": [
            "Frome",
            "Warminster",
            "Radstock",
            "Trowbridge",
            "Bradford-on-Avon",
            "Bath",
            "Shepton Mallet"
          ]
        },
        {
          "name": "Amesbury",
          "slug": "amesbury",
          "postcode": "SP4",
          "nearby_areas": [
            "Salisbury",
            "Gillingham",
            "Andover",
            "Romsey",
            "Winchester",
            "Eastleigh",
            "Verwood"
          ]
        },
        {
          "name": "Royal Wootton Bassett",
          "slug": "royal-wootton-bassett",
          "postcode": "SN4",
          "nearby_areas": [
            "Swindon",
            "Pewsey",
            "Calne",
            "Marlborough",
            "Chippenham",
            "Devizes",
            "Melksham"
          ]
        },
        {
          "name": "Bradford-on-Avon",
          "slug": "bradford-on-avon",
          "postcode": "BA15",
          "nearby_areas": [
            "Trowbridge",
            "Melksham",
            "Bath",
            "Corsham",
            "Westbury",
            "Frome",
            "Warminster"
          ]
        },
        {
          "name": "Pewsey",
          "slug": "pewsey",
          "postcode": "SN9",
          "nearby_areas": [
            "Swindon",
            "Royal Wootton Bassett",
            "Calne",
            "Chippenham",
            "Devizes",
            "Marlborough",
            "Melksham"
          ]
        }
      ]
    },
    {
      "name": "Worcestershire",
      "slug": "worcestershire",
      "region": "West Midlands",
      "council_name": "Worcestershire Council",
      "council_url": "https://www.worcestershire.gov.uk/",
      "climate": "mild damp winters and river valley mist",
      "population": "600,000",
      "towns": [
        {
          "name": "Worcester",
          "slug": "worcester",
          "postcode": "WR1",
          "nearby_areas": [
            "Pershore",
            "Upton-upon-Severn",
            "Droitwich Spa",
            "Tenbury Wells",
            "Malvern",
            "Broadway",
            "Stourport-on-Severn"
          ]
        },
        {
          "name": "Redditch",
          "slug": "redditch",
          "postcode": "B97",
          "nearby_areas": [
            "Coleshill",
            "Bromsgrove",
            "Alcester",
            "Solihull",
            "Halesowen",
            "Oldbury",
            "Sutton Coldfield"
          ]
        },
        {
          "name": "Kidderminster",
          "slug": "kidderminster",
          "postcode": "DY10",
          "nearby_areas": [
            "Cleobury Mortimer",
            "Bewdley",
            "Stourport-on-Severn",
            "Stourbridge",
            "Dudley",
            "Bromsgrove",
            "Kingswinford"
          ]
        },
        {
          "name": "Bromsgrove",
          "slug": "bromsgrove",
          "postcode": "B60",
          "nearby_areas": [
            "Redditch",
            "Coleshill",
            "Kidderminster",
            "Halesowen",
            "Stourport-on-Severn",
            "Cleobury Mortimer",
            "Stourbridge"
          ]
        },
        {
          "name": "Malvern",
          "slug": "malvern",
          "postcode": "WR14",
          "nearby_areas": [
            "Tenbury Wells",
            "Colwall",
            "Droitwich Spa",
            "Broadway",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        },
        {
          "name": "Evesham",
          "slug": "evesham",
          "postcode": "WR11",
          "nearby_areas": [
            "Broadway",
            "Malvern",
            "Colwall",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore"
          ]
        },
        {
          "name": "Droitwich Spa",
          "slug": "droitwich-spa",
          "postcode": "WR9",
          "nearby_areas": [
            "Tenbury Wells",
            "Upton-upon-Severn",
            "Malvern",
            "Colwall",
            "Pershore",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Stourport-on-Severn",
          "slug": "stourport-on-severn",
          "postcode": "DY13",
          "nearby_areas": [
            "Bewdley",
            "Kidderminster",
            "Cleobury Mortimer",
            "Bromsgrove",
            "Worcester",
            "Stourbridge",
            "Dudley"
          ]
        },
        {
          "name": "Pershore",
          "slug": "pershore",
          "postcode": "WR10",
          "nearby_areas": [
            "Upton-upon-Severn",
            "Droitwich Spa",
            "Tenbury Wells",
            "Malvern",
            "Colwall",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Bewdley",
          "slug": "bewdley",
          "postcode": "DY12",
          "nearby_areas": [
            "Stourport-on-Severn",
            "Kidderminster",
            "Cleobury Mortimer",
            "Dudley",
            "Stourbridge",
            "Bromsgrove",
            "Kingswinford"
          ]
        },
        {
          "name": "Upton-upon-Severn",
          "slug": "upton-upon-severn",
          "postcode": "WR8",
          "nearby_areas": [
            "Droitwich Spa",
            "Tenbury Wells",
            "Pershore",
            "Malvern",
            "Colwall",
            "Broadway",
            "Evesham"
          ]
        },
        {
          "name": "Tenbury Wells",
          "slug": "tenbury-wells",
          "postcode": "WR15",
          "nearby_areas": [
            "Malvern",
            "Droitwich Spa",
            "Colwall",
            "Upton-upon-Severn",
            "Broadway",
            "Pershore",
            "Evesham"
          ]
        },
        {
          "name": "Broadway",
          "slug": "broadway",
          "postcode": "WR12",
          "nearby_areas": [
            "Colwall",
            "Malvern",
            "Tenbury Wells",
            "Droitwich Spa",
            "Upton-upon-Severn",
            "Pershore",
            "Evesham"
          ]
        }
      ]
    },
    {
      "name": "Wrexham",
      "slug": "wrexham",
      "region": "Wales",
      "council_name": "Wrexham County Borough Council",
      "council_url": "https://www.wrexham.gov.uk/",
      "climate": "cool, damp border climate",
      "population": "135,000",
      "towns": [
        {
          "name": "Wrexham",
          "slug": "wrexham",
          "postcode": "LL11",
          "nearby_areas": [
            "Buckley",
            "Mold",
            "Holywell",
            "Connah's Quay",
            "Shotton",
            "Chester",
            "Ruthin"
          ]
        },
        {
          "name": "Chirk",
          "slug": "chirk",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Rhosllanerchrugog",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Ruabon",
          "slug": "ruabon",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Gresford",
          "slug": "gresford",
          "postcode": "LL12",
          "nearby_areas": [
            "Denbigh",
            "Cefn Mawr",
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Ruthin",
            "Llangollen"
          ]
        },
        {
          "name": "Rhosllanerchrugog",
          "slug": "rhosllanerchrugog",
          "postcode": "LL14",
          "nearby_areas": [
            "Cefn Mawr",
            "Chirk",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        },
        {
          "name": "Cefn Mawr",
          "slug": "cefn-mawr",
          "postcode": "LL14",
          "nearby_areas": [
            "Chirk",
            "Rhosllanerchrugog",
            "Ruabon",
            "Denbigh",
            "Gresford",
            "Llangollen",
            "Corwen"
          ]
        }
      ]
    }
  ],
  "guides": [
    {
      "slug": "blown-double-glazed-unit-replacement-cost",
      "type": "cost-guide",
      "title": "Blown Double Glazed Unit Replacement Cost UK: Price Guide",
      "metaDescription": "Replacing a blown double glazed unit typically costs £100–£200 for one standard clear unit and £500–£900 or more for several units with upgrades, fitted.",
      "targetKeyword": "double glazed unit replacement cost",
      "pillarSlugs": [
        "blown-double-glazed-unit-replacement"
      ],
      "relatedGuideSlugs": [
        "double-glazing-problems-explained",
        "best-glass-for-double-glazing-compared",
        "misted-double-glazing-replacement-cost"
      ],
      "readingTime": "5 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/blown-double-glazed-unit-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/blown-double-glazed-unit-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a sealed glazing unit in cross-section with a gap in its edge seal, a measuring tape beside it and a coin tag"
      },
      "imagePrompt": "Photograph of a glazier's workbench with a new sealed double glazed unit standing on its edge next to a tape measure and a notepad, the old unit with a visible edge seal gap leaning behind, workshop daylight. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "A blown double glazed unit typically costs £100–£200 to replace when it's one standard clear unit, and £500–£900 or more when several units are done together with upgrades such as safety glass or upper-floor access. Across all jobs the usual range is £100–£900, fitted."
        },
        {
          "type": "p",
          "text": "\"Blown\" means the edge seal has failed, so the sealed cavity between the two panes is no longer sealed. This guide is about ordering and specifying the replacement. If you're mainly asking what that cloudiness costs to put right, our [misted double glazing cost guide](/guides/misted-double-glazing-replacement-cost/) covers the same job from the symptom side. The glass itself is what a [blown double glazed unit replacement](/blown-double-glazed-unit-replacement/) swaps."
        },
        {
          "type": "h2",
          "text": "Typical prices by job size"
        },
        {
          "type": "table",
          "caption": "Typical UK blown double glazed unit replacement costs, fitted",
          "headers": [
            "Job size",
            "Typical cost"
          ],
          "rows": [
            [
              "One standard clear unit, internally beaded",
              "£100–£200"
            ],
            [
              "Two or three units, or one large or toughened unit",
              "£200–£500"
            ],
            [
              "Several units with upgrades or upper-floor access",
              "£500–£900+"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "Why the specification matters"
        },
        {
          "type": "p",
          "text": "Every replacement unit is made to measure, so the price depends on what you ask the glazier to put in it. The unit can match what you had, or it can be better. Common choices include:"
        },
        {
          "type": "list",
          "items": [
            "Warm-edge spacers. These replace the old aluminium spacer bar and reduce the cold edge around the pane, which helps with condensation at the glass edge.",
            "Low-emissivity (low-E) coating. A thin coating that cuts heat loss through the glass. Many modern units already include it.",
            "Toughened or laminated glass. Needed in certain positions, such as low-level panes and glass next to doors, and worth considering where security matters.",
            "Obscure glass. For bathrooms and other rooms where you want light without a view in.",
            "Argon fill. A gas filling in the cavity that improves insulation compared with plain air."
          ]
        },
        {
          "type": "p",
          "text": "Each one adds to the price, but a unit that performs better than your old one is often worth the small extra if the frame will stay for years yet. Our guide to [double glazing problems explained](/guides/double-glazing-problems-explained/) helps you decide whether the frame deserves that investment."
        },
        {
          "type": "h2",
          "text": "What else changes the price"
        },
        {
          "type": "list",
          "items": [
            "Unit size and weight. Large units need more people and sometimes a suction lifter.",
            "Beading. Internally beaded glass comes out from indoors. Externally beaded glass is harder to get at, so it takes longer and costs more.",
            "Access. Upper floors and flats can need ladders, scaffold towers or extra labour.",
            "Quantity. Several units in one visit cost much less per unit than separate call-outs."
          ]
        },
        {
          "type": "callout",
          "label": "Measure before you order",
          "text": "Replacement units are made to the exact size of the old one, less a small tolerance. A good glazier measures on site and takes the order from their own figures. Be wary of quotes based on photos or your own measurements alone, because a unit that is a few millimetres off can't be returned."
        },
        {
          "type": "p",
          "text": "If several panes have failed across the house, or the frames are tired as well, compare a unit swap with a full [double glazed window replacement](/double-glazed-window-replacement/). The [double glazing cost calculator](/guides/double-glazing-cost-calculator/) will show you both ranges side by side."
        }
      ],
      "faq": [
        {
          "q": "How much does it cost to replace a blown double glazing unit?",
          "a": "One standard clear unit typically costs £100–£200 fitted. Two or three units, or a large or toughened unit, typically costs £200–£500."
        },
        {
          "q": "Can a blown unit be repaired instead of replaced?",
          "a": "Once the seal has failed, the usual fix is a new sealed unit. Defogging services exist, but they don't restore the original seal, so ask about the guarantee before choosing one."
        },
        {
          "q": "Can I upgrade to a better specification when I replace it?",
          "a": "Yes. Warm-edge spacers, low-E coatings and gas fills are common upgrades. As long as the frame can hold the thickness, a new unit can perform better than the one it replaces."
        },
        {
          "q": "How long should a new sealed unit last?",
          "a": "Many units last 20 years or more, though it depends on quality and exposure. Ask for a written guarantee on both the unit and the fitting."
        }
      ]
    },
    {
      "slug": "buying-a-house-with-old-double-glazing",
      "type": "how-to",
      "title": "Buying a House with Old Double Glazing: What to Check Before You Complete",
      "metaDescription": "Check for misted panes, worn frames and missing FENSA or building control certificates before you buy, and use any faults to negotiate the price.",
      "targetKeyword": "buying a house old windows",
      "pillarSlugs": [
        "double-glazed-window-replacement",
        "upvc-window-replacement",
        "blown-double-glazed-unit-replacement",
        "double-glazed-door-replacement"
      ],
      "relatedGuideSlugs": [
        "signs-your-double-glazing-needs-replacing",
        "window-replacement-regulations-fensa-guide",
        "double-glazing-problems-explained"
      ],
      "readingTime": "7 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/buying-a-house-with-old-double-glazing-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/buying-a-house-with-old-double-glazing-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a house with a for-sale board, a house key and a stack of papers beside a window with one cloudy pane"
      },
      "imagePrompt": "Photograph of a semi-detached house with a for-sale board in the front garden, original 1990s white uPVC windows and a front door visible, overcast daylight. Landscape 1200x630, no people, no readable text on the sign, no house numbers, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Windows and doors are easy to overlook on a viewing, and expensive to deal with afterwards. A house full of tired frames or misted panes can add several thousand pounds to what you need to spend in the first year. This guide covers what to look at, what paperwork to ask for, and how to use what you find."
        },
        {
          "type": "h2",
          "text": "What to check on a viewing"
        },
        {
          "type": "list",
          "items": [
            "Misted panes. Look at every window in daylight, from inside and outside. Moisture between the layers means a failed sealed unit. One or two is a modest cost. Many suggests the whole house is at that stage.",
            "Opening and closing. Open and shut each window and door. Dropped casements, stiff locks and handles that need force point to tired hardware.",
            "Frame condition. Press sills and bottom rails of timber frames for softness. In uPVC, look for yellowing, brittleness and cracked welds.",
            "Draughts and seals. Look for perished or missing gaskets, and feel for air around closed windows.",
            "Doors. Check the front and back doors for dropping, sticking, damaged glass and a lock that works smoothly.",
            "Trickle vents and escape. Check that bedroom windows can still be opened wide enough to climb out of."
          ]
        },
        {
          "type": "p",
          "text": "If you find faults, our guide to [double glazing problems explained](/guides/double-glazing-problems-explained/) helps you work out what each one means, and our [signs your double glazing needs replacing](/guides/signs-your-double-glazing-needs-replacing/) checklist helps you score the windows one by one."
        },
        {
          "type": "h2",
          "text": "The paperwork to ask for"
        },
        {
          "type": "p",
          "text": "In England and Wales, replacement windows and doors fitted since 2002 should have a certificate showing they complied with the Building Regulations. That is usually a [FENSA](https://www.fensa.org.uk/) or similar competent person scheme certificate, or a building control completion certificate. Your solicitor should ask the seller for it, and for guarantees on the windows. If the seller can't produce a certificate, ask your solicitor how that will be handled, since a missing certificate can come up when you later come to sell."
        },
        {
          "type": "callout",
          "label": "Ask about the guarantee as well",
          "text": "A certificate shows the work met the regulations. A guarantee covers faults with the product. Ask whether any guarantee on the windows is still in force and whether it passes to a new owner."
        },
        {
          "type": "h2",
          "text": "Putting a price on what you find"
        },
        {
          "type": "table",
          "caption": "Typical costs to budget for common findings",
          "headers": [
            "What you find",
            "Typical cost",
            "Where to read more"
          ],
          "rows": [
            [
              "A few misted panes",
              "£80–£450",
              "[Misted glazing cost guide](/guides/misted-double-glazing-replacement-cost/)"
            ],
            [
              "Several failed units, some needing safety glass",
              "£500–£900+",
              "[Blown unit cost guide](/guides/blown-double-glazed-unit-replacement-cost/)"
            ],
            [
              "Tired frames throughout the house",
              "£2,000–£12,000+",
              "[Window replacement cost guide](/guides/double-glazed-window-replacement-cost/)"
            ],
            [
              "A tired back or front door",
              "£900–£4,000",
              "[Door replacement cost guide](/guides/double-glazed-door-replacement-cost/)"
            ]
          ]
        },
        {
          "type": "p",
          "text": "Get the figures into your negotiation. A realistic written estimate for the work is much more persuasive than a general complaint about old windows. The [double glazing cost calculator](/guides/double-glazing-cost-calculator/) can help you work out a range quickly, and a survey may flag the same issues."
        },
        {
          "type": "h2",
          "text": "After you move in"
        },
        {
          "type": "p",
          "text": "There's no need to replace everything straight away. Fix anything that affects security, safety or weatherproofing first: broken glass, locks that don't work and rotten frames. The rest can wait until you've decided on your budget and your plans for the house, particularly if you're thinking about an extension or redecorating. When you're ready, [double glazed window replacement](/double-glazed-window-replacement/) is the page to start from, or [uPVC window replacement](/upvc-window-replacement/) if you want the lowest-cost option."
        }
      ],
      "howTo": {
        "title": "How to check the double glazing when viewing a house",
        "totalTime": "PT20M",
        "steps": [
          {
            "name": "Check every pane for moisture",
            "text": "In daylight, look at each window from inside and outside for moisture or a cloudy film between the panes."
          },
          {
            "name": "Operate every window and door",
            "text": "Open, close and lock each one. Note any that drop, stick or need force."
          },
          {
            "name": "Inspect the frames",
            "text": "Press timber sills for softness and look for yellowed, brittle or cracked uPVC."
          },
          {
            "name": "Ask for the certificates",
            "text": "Ask the seller, through your solicitor, for FENSA or building control certificates and any guarantees."
          },
          {
            "name": "Cost the faults",
            "text": "Put a realistic estimate on the problems and use it in your price negotiation."
          }
        ]
      },
      "faq": [
        {
          "q": "Should old double glazing put me off buying a house?",
          "a": "Not usually. It's a cost to plan for, not a reason to walk away. Get an idea of the likely bill and factor it into your offer."
        },
        {
          "q": "What certificate should I ask for?",
          "a": "For replacement windows and doors in England and Wales, a FENSA or other competent person scheme certificate, or a building control completion certificate. Your solicitor can ask the seller for it."
        },
        {
          "q": "Does a missing certificate matter?",
          "a": "It can come up when you sell, because buyers' solicitors often ask for one. Ask your own solicitor how it should be dealt with before you exchange."
        },
        {
          "q": "Can I use faulty windows to negotiate the price?",
          "a": "Yes. A realistic written estimate for the work is a stronger basis for a lower offer than a general comment that the windows are old."
        }
      ]
    },
    {
      "slug": "double-glazed-door-replacement-cost",
      "type": "cost-guide",
      "title": "Double Glazed Door Replacement Cost UK: Price Guide",
      "metaDescription": "Replacing a double glazed door typically costs £900–£1,500 for a uPVC back door and £2,600–£4,000 or more for a front door with side panels or sliding patio doors, fitted.",
      "targetKeyword": "double glazed door replacement cost",
      "pillarSlugs": [
        "double-glazed-door-replacement"
      ],
      "relatedGuideSlugs": [
        "composite-vs-upvc-front-doors",
        "best-locks-and-security-for-windows-and-doors",
        "double-glazing-cost-calculator"
      ],
      "readingTime": "6 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-door-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-door-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a front door with a glazed panel and a side window, a door key and a coin tag with rising price bars"
      },
      "imagePrompt": "Photograph of a new composite front door in deep grey with a small glazed panel and matching side window on a brick house, brushed steel handle, soft morning light. Landscape 1200x630, no people, no readable text, no house numbers, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Replacing a double glazed door in the UK typically costs £900–£1,500 for a uPVC back or side door, and £2,600–£4,000 or more for a front door with side panels or a set of sliding patio doors. The usual range across all door types is £900–£4,000, fitted."
        },
        {
          "type": "p",
          "text": "The type of door matters more to the price than almost anything else, because \"door\" can mean a plain back door or a large sliding set. This guide covers what a [double glazed door replacement](/double-glazed-door-replacement/) costs by door type and what else affects the quote."
        },
        {
          "type": "h2",
          "text": "Typical prices by door type"
        },
        {
          "type": "table",
          "caption": "Typical UK double glazed door replacement costs, supplied and fitted",
          "headers": [
            "Door type",
            "Typical cost"
          ],
          "rows": [
            [
              "uPVC back or side door",
              "£900–£1,500"
            ],
            [
              "Composite front door, or uPVC French doors",
              "£1,300–£2,600"
            ],
            [
              "Front door with side panels, or sliding patio doors",
              "£2,600–£4,000+"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "What changes the price"
        },
        {
          "type": "list",
          "items": [
            "Material. uPVC is typically cheapest. Composite doors, which have a solid core and a tougher skin, cost more. Aluminium is usually dearer again.",
            "Size and configuration. Side panels, fanlights and French or sliding patio sets all add glass and frame.",
            "Glazing. Doors need safety glass. Decorative, obscure or leaded panels cost extra.",
            "Locks. A multi-point lock is standard on most modern doors. Higher-security cylinders and locks add to the price.",
            "Threshold. A low or level threshold for step-free access can cost more than a standard one.",
            "Colour and hardware. Dual-colour finishes, premium handles and letterboxes all push the price up."
          ]
        },
        {
          "type": "callout",
          "label": "Front doors are often a security decision",
          "text": "The lock matters as much as the leaf. Ask what lock and cylinder come as standard, and whether the cylinder is of a type designed to resist snapping. A cheap door with a basic cylinder is not a bargain if it is the weak point in your home."
        },
        {
          "type": "h2",
          "text": "What a fair quote should include"
        },
        {
          "type": "list",
          "items": [
            "The door material, style and finish, with the frame and threshold specified",
            "The glazing, including safety glass and any decorative panels",
            "The lock, cylinder and handles",
            "Removal and disposal of the old door and frame",
            "Making good inside and out, such as plastering, sealing and any step or threshold work",
            "Certification where it applies, plus written guarantees on the door, glass and hardware"
          ]
        },
        {
          "type": "p",
          "text": "If you're replacing windows at the same time, many installers will price the door as part of the order, which can reduce the overall cost. Our [double glazed window replacement cost guide](/guides/double-glazed-window-replacement-cost/) covers the window side. For a quick range across both, use the [double glazing cost calculator](/guides/double-glazing-cost-calculator/). If you're not sure whether a door actually needs replacing, a sagging leaf or a stiff lock can sometimes be adjusted, which is something our guide to [signs your double glazing needs replacing](/guides/signs-your-double-glazing-needs-replacing/) covers."
        }
      ],
      "faq": [
        {
          "q": "How much does a new double glazed door cost?",
          "a": "A uPVC back or side door typically costs £900–£1,500 fitted. A composite front door or uPVC French doors cost £1,300–£2,600, and large sliding patio doors can reach £4,000 or more."
        },
        {
          "q": "Is a composite door worth the extra money?",
          "a": "Composite doors typically cost more than uPVC, but they have a solid core and are usually more robust and better insulated. For a front door that takes more wear, many homeowners find the extra worthwhile."
        },
        {
          "q": "Can a new door be fitted in one day?",
          "a": "Many standard replacements take half a day to a day. Patio doors, side panels or a damaged frame can take longer."
        },
        {
          "q": "Do I need safety glass in a new door?",
          "a": "Glass in and next to doors is generally required to be safety glass under the Building Regulations. Your installer should specify it in the quote."
        }
      ]
    },
    {
      "slug": "double-glazed-glass-replacement-cost",
      "type": "cost-guide",
      "title": "Double Glazed Glass Replacement Cost UK: Price Guide",
      "metaDescription": "Replacing broken double glazed glass typically costs £120–£220 for a small cracked pane and £450–£750 or more for a patio door unit or emergency boarding, fitted.",
      "targetKeyword": "broken double glazing replacement cost",
      "pillarSlugs": [
        "double-glazed-glass-replacement"
      ],
      "relatedGuideSlugs": [
        "broken-double-glazing-what-to-do",
        "best-glass-for-double-glazing-compared",
        "double-glazing-cost-calculator"
      ],
      "readingTime": "5 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-glass-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-glass-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a window pane with a star-shaped crack radiating from one corner, beside a coin tag and three rising price bars"
      },
      "imagePrompt": "Photograph of a white-framed window with a single cracked pane, a spider-web crack spreading from one corner, strips of tape across it, soft daylight outside. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Replacing broken double glazed glass in the UK typically costs £120–£220 for a small cracked pane in clear glass, and £450–£750 or more for a patio door unit or when emergency boarding is needed on top of the new glass. The usual range across the whole job is £120–£750, fitted."
        },
        {
          "type": "p",
          "text": "Broken glass is usually more urgent than a misted pane, so price tends to get less attention than speed. It's still worth understanding what you're paying for. This guide sets out what a [double glazed glass replacement](/double-glazed-glass-replacement/) costs and what changes the figure."
        },
        {
          "type": "h2",
          "text": "Typical prices by job size"
        },
        {
          "type": "table",
          "caption": "Typical UK double glazed glass replacement costs, fitted",
          "headers": [
            "Job size",
            "Typical cost"
          ],
          "rows": [
            [
              "Small cracked window pane, clear glass",
              "£120–£220"
            ],
            [
              "Door panel or larger pane in toughened or obscure glass",
              "£220–£450"
            ],
            [
              "Patio door unit, or emergency boarding plus replacement",
              "£450–£750+"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "What changes the price"
        },
        {
          "type": "list",
          "items": [
            "Glass type. Standard clear glass is cheapest. Toughened glass, which breaks into small pieces, and laminated glass, which holds together when cracked, both cost more. Obscure and patterned glass sit in between.",
            "Safety requirements. Glass in doors and low-level panes next to them is required to be safety glass, so a replacement there is rarely the cheapest option.",
            "Size. Patio door units are large and heavy, which is why they sit at the top of the range.",
            "Emergency call-outs. Out-of-hours work, or a same-day visit, usually carries a premium. If the opening has to be boarded up first, that is a separate charge.",
            "Is it the glass or the unit? Double glazing is two panes. If only the outer pane is cracked, the whole sealed unit is normally still replaced, not just one sheet."
          ]
        },
        {
          "type": "h2",
          "text": "Making it safe first"
        },
        {
          "type": "p",
          "text": "If the glass is smashed, the first job is keeping people and pets away from loose pieces and securing the opening. A good glazier will board it up the same day if they can't fit new glass quickly. Take photos of the damage before anything is cleared, in case you want to make an insurance claim."
        },
        {
          "type": "callout",
          "label": "Cracked glass can fail suddenly",
          "text": "A cracked pane that looks stable can break completely when it warms up, closes against a draught or catches a knock. Don't leave a cracked pane in a door or low window for weeks. Tape and a warning note are a short-term measure, not a repair."
        },
        {
          "type": "h2",
          "text": "What a fair quote should include"
        },
        {
          "type": "list",
          "items": [
            "The glass type and thickness, with safety glass named where it's required",
            "Whether the price covers the old glass being removed and the area cleaned up",
            "Any boarding-up or emergency charge, shown separately",
            "The guarantee on the new unit and the fitting",
            "Timing: when the glass will be ordered and when it will be fitted"
          ]
        },
        {
          "type": "p",
          "text": "If the break followed an attempted entry, ask the glazier about laminated glass and a better lock at the same time. If you're unsure whether the fault is a crack or an old failed seal, our guide to [double glazing problems explained](/guides/double-glazing-problems-explained/) will help. For a quick figure by job size, use the [double glazing cost calculator](/guides/double-glazing-cost-calculator/)."
        }
      ],
      "faq": [
        {
          "q": "How much does it cost to replace a cracked double glazed pane?",
          "a": "A small cracked pane in clear glass typically costs £120–£220 fitted. Toughened, obscure or larger panes cost more, up to £450 for a door panel."
        },
        {
          "q": "Can I leave a cracked pane until later?",
          "a": "It's best not to. Cracks tend to spread, and the glass can fail suddenly. In a door or low window, it's also a safety and security risk."
        },
        {
          "q": "Is broken double glazing covered by home insurance?",
          "a": "Many buildings insurance policies cover accidental breakage, though terms and excesses vary. Check your policy wording, and take photos before any clean-up if you plan to claim."
        },
        {
          "q": "Should I choose laminated glass after a break-in?",
          "a": "Laminated glass is harder to get through because it holds together when broken. It costs more than standard glass, so it's worth asking the glazier to quote both."
        }
      ]
    },
    {
      "slug": "double-glazed-window-replacement-cost",
      "type": "cost-guide",
      "title": "Double Glazed Window Replacement Cost UK: Price Guide",
      "metaDescription": "Replacing double glazed windows in the UK typically costs £550–£1,200 for a single casement and £2,000–£5,500 for three to five openings or a bay, fitted.",
      "targetKeyword": "double glazing replacement cost",
      "pillarSlugs": [
        "double-glazed-window-replacement"
      ],
      "relatedGuideSlugs": [
        "upvc-vs-aluminium-vs-timber-windows",
        "double-glazing-cost-calculator",
        "window-replacement-regulations-fensa-guide"
      ],
      "readingTime": "6 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-window-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazed-window-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a house front with three white window frames and a bay, beside a coin tag and three price bars of rising height"
      },
      "imagePrompt": "Photograph of a brick terraced house front with a row of freshly fitted white casement windows and a small bay, soft overcast daylight, a short ladder leaning below one window. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Fitting a new double glazed window in the UK typically costs between £550 and £1,200 for a single standard casement, and between £2,000 and £5,500 for three to five openings or a bay. Whole-house orders with premium frames can run to £12,000 or more. These are supply-and-fit figures, and they cover the frame, the glass, fitting and taking the old window away."
        },
        {
          "type": "p",
          "text": "The spread is wide because \"a window\" can mean very different things. A small white uPVC casement and a large aluminium picture window have almost nothing in common apart from the glass. This guide breaks down what moves the price so you can read quotes for your [double glazed window replacement](/double-glazed-window-replacement/) with some confidence."
        },
        {
          "type": "h2",
          "text": "Typical prices by job size"
        },
        {
          "type": "table",
          "caption": "Typical UK double glazed window replacement costs, supplied and fitted",
          "headers": [
            "Job size",
            "Typical cost"
          ],
          "rows": [
            [
              "Single standard casement window",
              "£550–£1,200"
            ],
            [
              "Several windows or a bay (3–5 openings)",
              "£2,000–£5,500"
            ],
            [
              "Larger order, premium frames and more openings",
              "£5,500–£12,000+"
            ]
          ]
        },
        {
          "type": "p",
          "text": "Per window, bigger orders tend to work out cheaper, because the installer's survey, delivery and call-out costs are shared across more openings. Replacing one window at a time almost always costs more per window than doing the front of the house in one go."
        },
        {
          "type": "h2",
          "text": "What moves a quote up or down"
        },
        {
          "type": "list",
          "items": [
            "Frame material. uPVC sits at the lower end of the range. Aluminium and engineered timber push towards the top. If you haven't settled on a material yet, our [uPVC window replacement cost guide](/guides/upvc-window-replacement-cost/) prices the cheapest option on its own.",
            "Size and style. Bays, large fixed panes and tilt-and-turn windows cost more than standard casements. Sash styles cost more again.",
            "Glass specification. Acoustic, laminated or toughened glass adds to the price. Safety glass is required in some positions, such as low-level panes and next to doors.",
            "Colour and finish. White is the baseline. Woodgrain foils and coloured frames are dearer.",
            "Access and making good. Upper floors, flats without parking and rotten reveals that need repair before the new frame goes in all add time."
          ]
        },
        {
          "type": "h2",
          "text": "What a fair quote should include"
        },
        {
          "type": "p",
          "text": "Two quotes with the same headline price can cover quite different jobs. Before comparing, check that each one names:"
        },
        {
          "type": "list",
          "items": [
            "Every window listed separately, with its size, style, frame material and colour",
            "The glass specification, including the U-value or window energy rating",
            "Whether trickle vents, new cills and internal and external making good are included",
            "Who registers the work with a competent person scheme or building control, and who pays for it",
            "Disposal of the old frames",
            "How long the frames, sealed units and hardware are guaranteed for, and who stands behind the guarantee"
          ]
        },
        {
          "type": "callout",
          "label": "Ask about certification",
          "text": "In England and Wales, replacing whole windows is controlled work under the Building Regulations. An installer registered with a scheme such as [FENSA](https://www.fensa.org.uk/) can self-certify the job. If they aren't registered, building control has to be involved, which costs extra. Ask which route the quote assumes before you sign."
        },
        {
          "type": "h2",
          "text": "When replacing the whole window isn't necessary"
        },
        {
          "type": "p",
          "text": "If the frames are sound and only the glass has failed, you don't need a full window. A cloudy pane with moisture trapped inside can be fixed by swapping the sealed unit, which is much cheaper. Our [misted double glazing replacement cost guide](/guides/misted-double-glazing-replacement-cost/) and [blown unit replacement cost guide](/guides/blown-double-glazed-unit-replacement-cost/) price those jobs. If you aren't sure which one applies, start with [double glazing problems explained](/guides/double-glazing-problems-explained/)."
        },
        {
          "type": "p",
          "text": "For a quick range by job size, try the [double glazing cost calculator](/guides/double-glazing-cost-calculator/). Once you have a rough figure, quotes from two or three local installers will show you where your property sits in the range."
        }
      ],
      "faq": [
        {
          "q": "How much does it cost to replace one double glazed window?",
          "a": "A single standard casement typically costs £550–£1,200 supplied and fitted. A larger window, a different frame material or a tricky position can take it higher."
        },
        {
          "q": "Is it cheaper to replace all my windows at once?",
          "a": "Usually, per window. The survey, delivery and fitting visit are shared across the whole order, so a full house of windows typically works out cheaper per opening than doing them one at a time."
        },
        {
          "q": "Does the price include removing the old windows?",
          "a": "Most quotes include taking out and disposing of the old frames, but it isn't universal. Check that disposal and making good inside and out are written into the quote."
        },
        {
          "q": "Why do window quotes for the same house vary so much?",
          "a": "Installers may be pricing different frame materials, glass specifications or finishing. Ask each one to list every window with its size, style and glass, and the gap between quotes usually makes more sense."
        }
      ]
    },
    {
      "slug": "double-glazing-cost-calculator",
      "type": "calculator",
      "title": "Double Glazing Cost Calculator: Estimate Windows, Doors and Glass Repairs",
      "metaDescription": "Pick your job type and size to get an instant UK price range for double glazed windows, doors, sealed units and broken glass.",
      "targetKeyword": "double glazing cost calculator",
      "pillarSlugs": [
        "double-glazed-window-replacement",
        "misted-double-glazing-replacement",
        "blown-double-glazed-unit-replacement",
        "double-glazed-glass-replacement",
        "upvc-window-replacement",
        "double-glazed-door-replacement"
      ],
      "relatedGuideSlugs": [
        "double-glazed-window-replacement-cost",
        "upvc-window-replacement-cost",
        "double-glazing-problems-explained"
      ],
      "readingTime": "3 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazing-cost-calculator-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazing-cost-calculator-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a calculator beside a small window frame and a measuring tape, with three price bars of rising height"
      },
      "imagePrompt": "Photograph of a desk calculator and a tape measure lying on a windowsill beside a new white window frame, notepad and pencil nearby, soft daylight. Landscape 1200x630, no people, no readable text or numbers on any screen, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Choose the job and roughly how big it is. The calculator below then shows a typical UK price range. It covers all six services on this site, from a single misted pane to a full set of replacement windows. Each range comes from the typical costs we publish for that service."
        },
        {
          "type": "h2",
          "text": "Choosing small, typical or large"
        },
        {
          "type": "p",
          "text": "The same three sizes apply to every service. Small means one pane, one window or one door. Typical means a few panes, a handful of windows or a bay, or a single front door. Large means a whole-house order, a set of patio doors or an upgraded specification. Here is what that looks like for each service:"
        },
        {
          "type": "table",
          "caption": "What small, typical and large mean for each service",
          "headers": [
            "Service",
            "Small",
            "Typical",
            "Large"
          ],
          "rows": [
            [
              "[Window replacement](/double-glazed-window-replacement/)",
              "One standard casement",
              "Three to five openings or a bay",
              "Larger order, premium frames"
            ],
            [
              "[Misted glazing](/misted-double-glazing-replacement/)",
              "One small or medium pane",
              "One large pane or two medium",
              "Three or four panes in one visit"
            ],
            [
              "[Blown units](/blown-double-glazed-unit-replacement/)",
              "One standard clear unit",
              "Two or three units, or one toughened",
              "Several units with upgrades"
            ],
            [
              "[Glass replacement](/double-glazed-glass-replacement/)",
              "Small cracked pane",
              "Door panel or larger pane",
              "Patio door unit or emergency boarding"
            ],
            [
              "[uPVC windows](/upvc-window-replacement/)",
              "Single white casement",
              "Three to five windows or a bay",
              "Larger order, coloured or sash styles"
            ],
            [
              "[Doors](/double-glazed-door-replacement/)",
              "uPVC back or side door",
              "Composite front door or French doors",
              "Side panels or sliding patio doors"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "Reading the result"
        },
        {
          "type": "p",
          "text": "Window and door prices include the frame, the glass and the fitting. Glass-only prices cover the sealed unit and fitting, not the frame. If you have more than one fault, run the calculator for each and add the results. A mix of misted panes and a tired back door, for example, is two separate lines."
        },
        {
          "type": "p",
          "text": "If you can't decide between swapping glass and replacing the whole window, compare the two ranges side by side. Our [misted double glazing cost guide](/guides/misted-double-glazing-replacement-cost/) and [window replacement cost guide](/guides/double-glazed-window-replacement-cost/) explain what's behind each range."
        },
        {
          "type": "callout",
          "label": "An estimate, not a quote",
          "text": "The calculator can't see your home. Access, glass type, frame material, finish and the condition of the surrounding brickwork all change the final price. Use the range to judge whether quotes are in the right area, then ask for itemised written quotes from local installers."
        }
      ],
      "faq": [
        {
          "q": "How accurate is the double glazing cost calculator?",
          "a": "It gives a typical range for each job size, based on the average costs we publish for each service. Real quotes can fall outside it where access is difficult or you choose a premium specification."
        },
        {
          "q": "Does the estimate include VAT?",
          "a": "The ranges are guide figures for supply and fitting. Check whether each quote you receive is shown with or without VAT, so you can compare like with like."
        },
        {
          "q": "My job doesn't fit the three sizes. Which should I pick?",
          "a": "Pick the closest and treat the result as a rough bracket. If you need two different things, such as new windows and a glass repair, run the calculator once for each and add the results."
        }
      ]
    },
    {
      "slug": "double-glazing-problems-explained",
      "type": "how-to",
      "title": "Double Glazing Problems Explained: Misted, Blown, Cracked or Worn Out?",
      "metaDescription": "Work out which double glazing fault you have, from cloudy panes to cracked glass and tired frames, and which repair or replacement fits it.",
      "targetKeyword": "double glazing problems",
      "pillarSlugs": [
        "double-glazed-window-replacement",
        "misted-double-glazing-replacement",
        "blown-double-glazed-unit-replacement",
        "double-glazed-glass-replacement",
        "upvc-window-replacement",
        "double-glazed-door-replacement"
      ],
      "relatedGuideSlugs": [
        "signs-your-double-glazing-needs-replacing",
        "condensation-on-windows-inside-between-outside",
        "double-glazing-cost-calculator"
      ],
      "readingTime": "8 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazing-problems-explained-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/double-glazing-problems-explained-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a magnifying glass over a window pane, with a cloudy pane, a cracked pane and a clear pane lined up beside it"
      },
      "imagePrompt": "Photograph of three adjacent window panes in white frames, one clear, one cloudy with moisture between the layers and one with a spreading crack, soft overcast daylight. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "\"My double glazing has gone wrong\" covers a lot of ground. Misted glass, a cracked pane, a window that won't close and a front door that drops on its hinges all have different causes and different costs. Most of them start with a simple question: is the problem in the glass, or in the frame? This guide works through the common faults so you can match yours to the right service."
        },
        {
          "type": "h2",
          "text": "Start with where you can see the problem"
        },
        {
          "type": "table",
          "caption": "What you can see, and what it usually means",
          "headers": [
            "What you notice",
            "Most likely fault",
            "Where to look next"
          ],
          "rows": [
            [
              "Cloudy or foggy glass with moisture trapped between the panes",
              "The sealed unit's edge seal has failed",
              "[Misted double glazing replacement](/misted-double-glazing-replacement/)"
            ],
            [
              "Same, plus you want better insulation or safety glass",
              "A failed sealed unit that can be upgraded",
              "[Blown double glazed unit replacement](/blown-double-glazed-unit-replacement/)"
            ],
            [
              "A crack, chip or smashed pane",
              "Broken glass",
              "[Double glazed glass replacement](/double-glazed-glass-replacement/)"
            ],
            [
              "Draughts, soft or rotten frames, or windows that won't shut",
              "The frame has reached the end of its life",
              "[Double glazed window replacement](/double-glazed-window-replacement/) or [uPVC window replacement](/upvc-window-replacement/)"
            ],
            [
              "A door that drops, sticks or won't lock",
              "Worn hinges, a dropped door, or a failing multi-point lock",
              "[Double glazed door replacement](/double-glazed-door-replacement/)"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "Glass problems"
        },
        {
          "type": "h3",
          "text": "Moisture between the panes"
        },
        {
          "type": "p",
          "text": "Misting between the layers means the sealed unit is no longer sealed. Damp air has got into the cavity and now condenses on the cooler pane. It's usually a gradual failure of the edge seal, and it's why you can wipe the glass on both faces and the cloudiness stays. \"Misted\" and \"blown\" describe the same fault. A new sealed unit is the normal fix, and the frame is usually kept. Our [misted double glazing cost guide](/guides/misted-double-glazing-replacement-cost/) and [blown unit cost guide](/guides/blown-double-glazed-unit-replacement-cost/) explain the price. If the moisture is on a face of the glass instead, that is ordinary condensation, which is a ventilation question rather than a glass fault."
        },
        {
          "type": "h3",
          "text": "Cracks and breaks"
        },
        {
          "type": "p",
          "text": "A cracked pane can look stable and still fail suddenly, especially in a door or a low window. Thermal stress is a frequent cause: strong sun on part of a pane, or a cold pane next to a radiator. The repair is a new pane, usually as a full sealed unit. See the [glass replacement cost guide](/guides/double-glazed-glass-replacement-cost/)."
        },
        {
          "type": "h2",
          "text": "Frame problems"
        },
        {
          "type": "p",
          "text": "If the glass is clear and only the window behaves badly, look at the frame. Typical signs are draughts around a closed window, hinges that have dropped so the sash has to be lifted to shut, perished seals, rotten timber cills, and uPVC that has gone brittle, yellowed or cracked at the welds. Hardware can sometimes be replaced, but when several things are wrong at once, a new window is usually the better spend. The [window replacement cost guide](/guides/double-glazed-window-replacement-cost/) and the [uPVC window cost guide](/guides/upvc-window-replacement-cost/) show what that involves."
        },
        {
          "type": "h2",
          "text": "Door problems"
        },
        {
          "type": "p",
          "text": "Doors take more wear than windows. A door that has dropped and drags on the threshold, a lock that has to be lifted or forced, and a leaf that has delaminated or warped are all common. A locksmith or the installer can often adjust hinges and replace a lock. If the door and frame are tired, a replacement is more sensible. See the [door replacement cost guide](/guides/double-glazed-door-replacement-cost/)."
        },
        {
          "type": "callout",
          "label": "A quick test for misted glass",
          "text": "Wipe the inside face, then the outside face. If the cloudiness doesn't move, it's between the panes and the unit has failed. If it wipes off, you've got ordinary condensation, which is a ventilation question, not a glass fault."
        },
        {
          "type": "h2",
          "text": "A simple order for working it out"
        },
        {
          "type": "list",
          "ordered": true,
          "items": [
            "Look at the glass in good light. Is there moisture inside the layers, a crack, or neither?",
            "Check the frame: shut the window or door and feel for draughts, look at the seals, press the cill and bottom rail for softness.",
            "Try the hardware: handles, hinges and locks should work without lifting or force.",
            "Count how many faults there are and where. One bad pane in a good frame is a glass job. Several problems in one frame usually point to replacing the frame.",
            "Get itemised written quotes. The [double glazing cost calculator](/guides/double-glazing-cost-calculator/) gives you a range to compare them against."
          ]
        },
        {
          "type": "p",
          "text": "If the picture still isn't clear, our [signs your double glazing needs replacing](/guides/signs-your-double-glazing-needs-replacing/) checklist is a good next step."
        }
      ],
      "howTo": {
        "title": "How to work out which double glazing fault you have",
        "totalTime": "PT15M",
        "steps": [
          {
            "name": "Look at the glass",
            "text": "In good light, check for moisture trapped between the layers, a crack or chip, or neither."
          },
          {
            "name": "Wipe both faces",
            "text": "Wipe the inside and then the outside face. If the cloudiness stays, it is between the panes and the sealed unit has failed."
          },
          {
            "name": "Check the frame",
            "text": "Close the window or door and feel for draughts. Look at the seals, and press the cill and bottom rail for soft or rotten wood."
          },
          {
            "name": "Test the hardware",
            "text": "Operate the handles, hinges and locks. They should work without lifting or force."
          },
          {
            "name": "Match the fault to a service",
            "text": "Glass faults point to a sealed unit or glass replacement. Several frame or hardware faults usually point to replacing the window or door."
          }
        ]
      },
      "faq": [
        {
          "q": "How do I tell if my double glazing has failed?",
          "a": "Moisture or a cloudy film between the two panes that you can't wipe off is the classic sign. Condensation on the inside or outside face is different and doesn't mean the unit has failed."
        },
        {
          "q": "Is misted glass the same as a blown unit?",
          "a": "Yes, they describe the same problem. \"Misted\" is what you see, and \"blown\" is the seal failure behind it. The fix is a new sealed unit."
        },
        {
          "q": "Can I just replace the glass and keep my frames?",
          "a": "Often, yes. If the frame is sound, a new sealed unit costs much less than a new window. If the frame is also worn, replacing the whole window can be better value."
        },
        {
          "q": "Who should I call first?",
          "a": "For a single glass fault, a glazier. For frames, doors or several faults at once, a double glazing installer who can survey the whole property. Free quotes from local installers make a good starting point."
        }
      ]
    },
    {
      "slug": "misted-double-glazing-replacement-cost",
      "type": "cost-guide",
      "title": "Misted Double Glazing Repair Cost UK: Price Guide",
      "metaDescription": "Replacing misted double glazing typically costs £80–£150 for one small or medium pane and £280–£450 for three or four panes in one visit, fitted.",
      "targetKeyword": "misted double glazing repair cost",
      "pillarSlugs": [
        "misted-double-glazing-replacement"
      ],
      "relatedGuideSlugs": [
        "double-glazing-problems-explained",
        "condensation-on-windows-inside-between-outside",
        "blown-double-glazed-unit-replacement-cost"
      ],
      "readingTime": "5 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/misted-double-glazing-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/misted-double-glazing-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a window with one cloudy pane covered in moisture droplets beside a clear pane, with a coin tag and three rising price bars"
      },
      "imagePrompt": "Photograph of a white uPVC window with one pane cloudy from moisture trapped between the layers of glass and the neighbouring pane crystal clear, soft daylight, garden blurred beyond. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Replacing misted double glazing typically costs £80–£150 for one small or medium pane, and £280–£450 or more when three or four panes are done in the same visit. That's for a new sealed unit, fitted into the frame you already have. The usual range for the whole job runs from £80 to £450."
        },
        {
          "type": "p",
          "text": "Misting is cheap to fix compared with replacing a window. The frame stays, and only the glass unit changes. This guide covers what a [misted double glazing replacement](/misted-double-glazing-replacement/) costs, what changes the price and what to check on a quote."
        },
        {
          "type": "h2",
          "text": "Typical prices by job size"
        },
        {
          "type": "table",
          "caption": "Typical UK misted double glazing replacement costs, fitted",
          "headers": [
            "Job size",
            "Typical cost"
          ],
          "rows": [
            [
              "One small or medium pane",
              "£80–£150"
            ],
            [
              "One large pane, or two medium panes",
              "£150–£280"
            ],
            [
              "Three or four panes in one visit",
              "£280–£450+"
            ]
          ]
        },
        {
          "type": "p",
          "text": "Most of the price is the made-to-measure unit itself. The glazier's visit is the other big part, which is why a second or third pane in the same visit costs much less than the first."
        },
        {
          "type": "h2",
          "text": "What changes the price"
        },
        {
          "type": "list",
          "items": [
            "Pane size. Larger units cost more to make and need two people to lift.",
            "Glass type. Plain clear glass is the baseline. Obscure, toughened, laminated, Georgian-bar or leaded units cost more, and some positions legally need safety glass.",
            "How the glass is held in. If the glazing beads are on the inside, the job is quick. Externally beaded glass is slower to work on.",
            "Number of panes. Booking everything in one visit is the cheapest way to deal with several misted units.",
            "Height. Upper-floor windows may need access equipment."
          ]
        },
        {
          "type": "h2",
          "text": "Is a repair cheaper than replacement?"
        },
        {
          "type": "p",
          "text": "Some companies offer to clear the moisture without replacing the unit, usually by drilling small holes, drying the cavity and fitting vents. Results vary, and the seal that let moisture in is still failing, so many installers recommend a new sealed unit. If you're weighing the two, ask what guarantee comes with each option before comparing prices."
        },
        {
          "type": "callout",
          "label": "Check the frames first",
          "text": "A new sealed unit is only worth buying if the frame around it is sound. If the hinges are failing, the seals are perished or the frame is rotten, a full [double glazed window replacement](/double-glazed-window-replacement/) may make more sense than paying for glass and replacing the frame a year later."
        },
        {
          "type": "h2",
          "text": "What a fair quote should include"
        },
        {
          "type": "list",
          "items": [
            "The number of panes and the size and position of each",
            "The glass type, including any safety or obscure requirement",
            "Whether the unit is a standard or energy-efficient specification, such as warm-edge spacers",
            "Removal of the old unit and the glazing beads refitted or replaced",
            "A written guarantee on the new unit and the fitting"
          ]
        },
        {
          "type": "p",
          "text": "Misted units are easy to confuse with other glass faults. If the cloudiness is on the inside or outside surface rather than between the layers, you may not need a new unit at all. Our guide to [double glazing problems explained](/guides/double-glazing-problems-explained/) helps you tell the faults apart. Where the glass has failed at the edge seal for a reason other than age, the [blown unit replacement cost guide](/guides/blown-double-glazed-unit-replacement-cost/) covers the specification side, and the [double glazing cost calculator](/guides/double-glazing-cost-calculator/) gives a quick range."
        }
      ],
      "faq": [
        {
          "q": "How much does it cost to fix one misted double glazing pane?",
          "a": "One small or medium pane typically costs £80–£150 fitted. A large pane or special glass such as toughened or obscure costs more."
        },
        {
          "q": "Is misted double glazing the same as a blown unit?",
          "a": "They're the same fault described two ways. \"Misted\" is what you see. \"Blown\" is what a glazier says when the edge seal has failed and let moist air in. The repair is a new sealed unit either way."
        },
        {
          "q": "Do I have to replace the whole window if one pane is misted?",
          "a": "Not usually. If the frame is in good condition, only the sealed unit needs replacing, which costs a fraction of a new window."
        },
        {
          "q": "Does one misted pane make my home colder?",
          "a": "It can reduce the insulation of that pane, because the sealed cavity no longer holds gas or dry air. The effect is modest for a single pane, but it's a sign the seal has failed."
        }
      ]
    },
    {
      "slug": "signs-your-double-glazing-needs-replacing",
      "type": "how-to",
      "title": "Signs Your Double Glazing Needs Replacing: A Homeowner's Checklist",
      "metaDescription": "Draughts, soft sills, brittle uPVC and dropped casements are the main signs your double glazing needs replacing; this checklist helps you score your windows.",
      "targetKeyword": "signs you need new windows",
      "pillarSlugs": [
        "double-glazed-window-replacement",
        "upvc-window-replacement",
        "misted-double-glazing-replacement",
        "double-glazed-door-replacement"
      ],
      "relatedGuideSlugs": [
        "double-glazing-problems-explained",
        "buying-a-house-with-old-double-glazing",
        "double-glazing-cost-calculator"
      ],
      "readingTime": "6 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/signs-your-double-glazing-needs-replacing-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/signs-your-double-glazing-needs-replacing-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a clipboard with ticked checklist rows, a window frame with a tired dropped sash and a small thermometer"
      },
      "imagePrompt": "Photograph of an old white uPVC window with a yellowed frame and a dropped casement, a hand-drawn checklist on a clipboard resting on the windowsill, soft daylight. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "Windows rarely fail all at once. They wear out in small ways: a draught you stop noticing, a handle that needs a shove, a pane that mists in winter. The question isn't whether you can put up with one problem. It's whether the sum of them means it's time to replace. This checklist helps you tell."
        },
        {
          "type": "h2",
          "text": "Signs that point to the frame"
        },
        {
          "type": "list",
          "items": [
            "You can feel cold air around a window that's shut and locked.",
            "Timber sills or bottom rails are soft, split or flaking when you press them with a screwdriver tip.",
            "The uPVC has gone yellow, chalky or brittle, or the corner welds have cracked.",
            "Casements have dropped on their hinges and you have to lift them to close.",
            "Gaskets and seals are perished, hard or missing in places.",
            "Locks and hinges are worn, and the old hardware is no longer made.",
            "Upstairs windows are too small or awkward to climb out of in an emergency."
          ]
        },
        {
          "type": "h2",
          "text": "Signs that point to the glass"
        },
        {
          "type": "list",
          "items": [
            "Moisture or a cloudy film trapped between the panes that you can't wipe away.",
            "Condensation that keeps returning at the edges of the glass.",
            "Single glazing, or double glazing with wide aluminium spacer bars from decades ago.",
            "A crack or chip that hasn't spread yet but sits near an edge."
          ]
        },
        {
          "type": "p",
          "text": "Glass-only problems are often fixable without touching the frame. A cloudy pane costs far less to put right than a new window. See our [misted double glazing replacement](/misted-double-glazing-replacement/) page for how that works, and the [double glazing problems explained](/guides/double-glazing-problems-explained/) guide if you aren't sure which fault you have."
        },
        {
          "type": "h2",
          "text": "Scoring your windows"
        },
        {
          "type": "p",
          "text": "Give each window a point for every sign from the frame list. As a rough guide:"
        },
        {
          "type": "table",
          "caption": "What your score suggests",
          "headers": [
            "Score per window",
            "What it usually means"
          ],
          "rows": [
            [
              "0–1",
              "Probably repairable. Adjust the hinges, replace a seal or swap a single pane."
            ],
            [
              "2–3",
              "Worth getting quotes. A repair may still be viable, but compare it with replacement."
            ],
            [
              "4 or more",
              "The frame has probably reached the end of its life. Replacement is likely better value."
            ]
          ]
        },
        {
          "type": "callout",
          "label": "Look at the whole house",
          "text": "If most windows score 2 or more, replacing them together is usually cheaper per opening than doing a few every year. If only one or two fail, repair those and re-check the rest in a year."
        },
        {
          "type": "h2",
          "text": "Doors count too"
        },
        {
          "type": "p",
          "text": "A back or front door that drops, drags, won't lock smoothly or lets in light around the edges is showing the same kind of wear. Handles and hinges can often be adjusted, but a warped leaf or failed frame is a replacement job. The [double glazed door replacement](/double-glazed-door-replacement/) page covers what's involved."
        },
        {
          "type": "h2",
          "text": "What to do next"
        },
        {
          "type": "list",
          "ordered": true,
          "items": [
            "Walk the house with the lists above and note each window's score.",
            "Photograph the worst problems. They help installers give accurate quotes.",
            "Get two or three itemised written quotes. The [double glazing cost calculator](/guides/double-glazing-cost-calculator/) gives you a figure to compare them against.",
            "If you're buying a property rather than living in one, see our guide on [buying a house with old double glazing](/guides/buying-a-house-with-old-double-glazing/)."
          ]
        }
      ],
      "howTo": {
        "title": "How to check whether your windows need replacing",
        "totalTime": "PT30M",
        "steps": [
          {
            "name": "Check for draughts",
            "text": "Close and lock each window, then feel around the frame and sash edges for moving air on a windy day."
          },
          {
            "name": "Press the timber and look at the uPVC",
            "text": "Press sills and bottom rails with a screwdriver tip to find soft wood. Look for yellowing, brittleness or cracked welds in uPVC."
          },
          {
            "name": "Test opening and locking",
            "text": "Each casement should open, close and lock without lifting or force."
          },
          {
            "name": "Look at the glass",
            "text": "Note any moisture between the panes, cracks near the edges or condensation that keeps returning."
          },
          {
            "name": "Score and compare",
            "text": "Add up the signs per window and get written quotes for the windows that score highest."
          }
        ]
      },
      "faq": [
        {
          "q": "How long do double glazed windows last?",
          "a": "Many last 20 to 30 years, though it depends on quality, exposure and upkeep. Frames, seals, hardware and sealed units can wear out at different times."
        },
        {
          "q": "Should I replace all my windows at once?",
          "a": "If most are showing the same wear, doing them together is typically cheaper per opening and gives a consistent finish. If only one or two have failed, repair those first."
        },
        {
          "q": "Is a draught always a sign the window needs replacing?",
          "a": "Not always. Perished seals or loose hardware can cause draughts and are often fixable. If the frame itself is warped or rotten, replacement makes more sense."
        },
        {
          "q": "Will new windows stop condensation?",
          "a": "They can reduce condensation on the glass, but moisture in the room still needs somewhere to go. Good ventilation matters as much as the windows."
        }
      ]
    },
    {
      "slug": "upvc-window-replacement-cost",
      "type": "cost-guide",
      "title": "uPVC Window Replacement Cost UK: Price Guide",
      "metaDescription": "New uPVC windows typically cost £400–£900 for a single white casement and £1,500–£4,500 for three to five windows or a bay, supplied and fitted.",
      "targetKeyword": "upvc windows cost",
      "pillarSlugs": [
        "upvc-window-replacement"
      ],
      "relatedGuideSlugs": [
        "upvc-vs-aluminium-vs-timber-windows",
        "best-window-styles-for-replacement-compared",
        "double-glazing-cost-calculator"
      ],
      "readingTime": "6 min read",
      "publishedDate": "2026-10-27",
      "updatedDate": "2026-10-27",
      "heroImage": {
        "src": "/sites/double-glazing-quotes-co-uk/guides/images/upvc-window-replacement-cost-hero.webp",
        "srcSmall": "/sites/double-glazing-quotes-co-uk/guides/images/upvc-window-replacement-cost-hero-600.webp",
        "width": 1200,
        "height": 630,
        "alt": "Illustration of a white uPVC casement window with a cutaway showing the hollow chambers of the frame, next to a coin tag and rising price bars"
      },
      "imagePrompt": "Photograph of a newly fitted white uPVC casement window on a rendered house, one sash slightly open to show the hinge and handle, bright neutral daylight. Landscape 1200x630, no people, no readable text, no brand logos.",
      "blocks": [
        {
          "type": "p",
          "text": "New uPVC windows typically cost £400–£900 for a single white casement, and £1,500–£4,500 for three to five windows or one bay. A larger order, or one with coloured foils and sashes, can reach £4,500–£8,000 or more. All of these are supplied and fitted."
        },
        {
          "type": "p",
          "text": "uPVC is the default choice for UK replacement windows, mainly because it is the cheapest frame material that needs little upkeep. This guide covers what you'll pay for [uPVC window replacement](/upvc-window-replacement/) and what moves the price. If you're still choosing between uPVC, aluminium and timber, our [double glazed window replacement cost guide](/guides/double-glazed-window-replacement-cost/) covers the wider range."
        },
        {
          "type": "h2",
          "text": "Typical prices by job size"
        },
        {
          "type": "table",
          "caption": "Typical UK uPVC window replacement costs, supplied and fitted",
          "headers": [
            "Job size",
            "Typical cost"
          ],
          "rows": [
            [
              "Single white uPVC casement",
              "£400–£900"
            ],
            [
              "Three to five windows, or one uPVC bay",
              "£1,500–£4,500"
            ],
            [
              "Larger order, whole-house scope",
              "£4,500–£8,000+"
            ]
          ]
        },
        {
          "type": "h2",
          "text": "What changes the price"
        },
        {
          "type": "list",
          "items": [
            "Style. Standard casements are cheapest. Tilt-and-turn windows, fixed panes, bays and uPVC sliding sashes cost more.",
            "Finish. White is the baseline. Woodgrain foils and coloured frames, inside, outside or both, add a premium.",
            "Glass. Standard sealed units are the starting point. Acoustic, laminated and toughened glass cost extra, and the glass specification has a noticeable effect on the heat loss figure.",
            "Frame profile. Slimmer, higher-grade profiles and multi-chamber designs vary in price.",
            "Hardware. Locks, restrictors, trickle vents and handle finishes are small items that add up across a whole house.",
            "Making good. New cills, plastering and external sealing are sometimes extras."
          ]
        },
        {
          "type": "callout",
          "label": "Compare like with like",
          "text": "Ask every installer for the same specification: frame profile, glass build-up, finish and hardware for each window. A cheap quote often reflects a thinner profile, a plainer glass unit or fewer inclusions, not a better deal."
        },
        {
          "type": "h2",
          "text": "What a fair quote should include"
        },
        {
          "type": "list",
          "items": [
            "Each window with its size, style, opening arrangement and finish",
            "The frame brand or system, glass make-up and energy rating",
            "Locks and security features, plus trickle vents",
            "Removal and disposal of the old windows",
            "Certification, either through a competent person scheme such as [FENSA](https://www.fensa.org.uk/) or through building control",
            "Written guarantees on the frames, the sealed units and the hardware"
          ]
        },
        {
          "type": "h2",
          "text": "Is uPVC the right choice?"
        },
        {
          "type": "p",
          "text": "For most houses, yes. uPVC is durable, doesn't need painting and is generally the lowest-cost route to a good-performing window. It may not suit period homes, conservation areas or properties where slim sightlines matter. If you're not sure, our [double glazing problems explained](/guides/double-glazing-problems-explained/) guide can help you work out whether you need new frames at all, and the [double glazing cost calculator](/guides/double-glazing-cost-calculator/) will give you a quick range."
        }
      ],
      "faq": [
        {
          "q": "How much do uPVC windows cost to fit?",
          "a": "A single white casement typically costs £400–£900 fitted. For three to five windows or one bay, expect £1,500–£4,500 as a guide."
        },
        {
          "q": "Are uPVC windows cheaper than aluminium or timber?",
          "a": "Usually, yes. uPVC is typically the lowest-priced frame material for a comparable size, while aluminium and engineered timber tend to cost more."
        },
        {
          "q": "Do coloured uPVC windows cost more?",
          "a": "Yes. Woodgrain foils and coloured finishes carry a premium over standard white, and the amount depends on whether the colour is on one side or both."
        },
        {
          "q": "How long do uPVC windows last?",
          "a": "Many last 20 to 30 years or longer, depending on quality, exposure and how well they were fitted. Ask for written guarantees on the frame, glass and hardware."
        }
      ]
    }
  ],
  "youtube": [
    "https://www.youtube.com/watch?v=hR73-jH4JNA",
    "https://www.youtube.com/watch?v=4DP9-K7XFE8",
    "https://www.youtube.com/watch?v=7NT-2fqYpwE",
    "https://www.youtube.com/watch?v=0AbVCjMffZU",
    "https://www.youtube.com/watch?v=ZyQh2B1PcRU",
    "https://www.youtube.com/watch?v=laarBybIns8",
    "https://www.youtube.com/watch?v=4hEw1vog1Qk",
    "https://www.youtube.com/watch?v=OPAQAFwlwDo",
    "https://www.youtube.com/watch?v=TgmGvPmYm-w",
    "https://www.youtube.com/watch?v=XikWavpuBOU",
    "https://www.youtube.com/watch?v=NERMAwW3ER4",
    "https://www.youtube.com/watch?v=b9ynOxt_M5s",
    "https://www.youtube.com/watch?v=InE2bxPnefg",
    "https://www.youtube.com/watch?v=LmTdFErNvfE",
    "https://www.youtube.com/watch?v=dn7uGIdAC2Y",
    "https://www.youtube.com/watch?v=-Pu2R-PgRfI",
    "https://www.youtube.com/watch?v=L1sOeaqQVjg",
    "https://www.youtube.com/watch?v=c8kip-gPuXw",
    "https://www.youtube.com/watch?v=L-KTH6vu7Ao",
    "https://www.youtube.com/watch?v=Np5nC2CjPDU",
    "https://www.youtube.com/watch?v=OHzBzbNWK5M",
    "https://www.youtube.com/watch?v=sCTc_DFNTlQ",
    "https://www.youtube.com/watch?v=pSI6UMo47DY",
    "https://www.youtube.com/watch?v=aa3H8mP_Jco",
    "https://www.youtube.com/watch?v=CANwQli1bh8"
  ],
  "templates": {
    "about": "<article class=\"about-content\">\n<h2>A way to find the right glazing business for your job</h2>\n<p>Replacing one cloudy pane should not mean starting a whole-house window order. Equally, a home with rotten frames needs more than new glass. Double Glazing Quotes helps homeowners explain what they need and reach independent businesses that handle that kind of work.</p>\n<p>At double-glazing-quotes.co.uk, one online enquiry can lead to up to four quotations from local installers or glaziers. It is free for homeowners to enquire, and there is no obligation to choose a firm. The number of responses depends on your postcode, the work involved and contractor availability.</p>\n<img src=\"/sites/double-glazing-quotes-co-uk/images/glazing-surveyor-homeowner-window-discussion-uk.jpg\" alt=\"Homeowner and glazing surveyor discussing a white casement window\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n<h2>What we help you arrange</h2>\n<p>Our six services cover complete double glazed window replacement, uPVC windows, misted glazing, blown sealed units, damaged glass and double glazed doors. Within those jobs there are plenty of decisions: keeping a timber frame, matching bathroom privacy glass, choosing a casement rather than a sliding sash, or fitting a French doorset with a suitable threshold.</p>\n<p>Misted and blown glazing often describe the same edge-seal failure. The first is what you see; the second describes the fault. You do not need to work out which term to use before enquiring. Describe the cloudiness, cracked pane, sticking opener or draught, and the responding firm can investigate.</p>\n<h2>Where our role ends</h2>\n<p>We provide a matching service. We do not manufacture glass, supply frames, employ installers or carry out the work. The company you appoint measures the openings, recommends the specification and gives you its own quotation. You agree the contract, payment schedule, fitting arrangements and aftercare with that business.</p>\n<p>Glazing companies can pay for customer enquiries through Leads Do Work. That funds the introduction service; it does not oblige a homeowner to buy windows or make a particular firm the best choice for the job.</p>\n<h2>What to check before appointing someone</h2>\n<p>Companies joining the network are asked to provide relevant insurance details and references. Ask the firm you are considering for current documents and examples of similar work. A sealed-unit repair, a timber sash replacement and a large aluminium doorset need different experience.</p>\n<ul>\n<li>Ask who will survey and fit the work, and who you contact if a new unit mists or a handle needs adjusting.</li>\n<li>For replacement frames, confirm the frame system, opening style, whole-window energy performance and glass specification.</li>\n<li>For glass-only jobs, check the unit thickness, any safety-glass requirement and whether the existing beads and gaskets can be reused.</li>\n<li>Ask which making-good, waste removal and access arrangements are included.</li>\n<li>Get the guarantee terms for glass, hardware and fitting separately, including exclusions and any insurance backing.</li>\n</ul>\n<h2>Paperwork should match the actual work</h2>\n<p>For relevant replacement window and door work in England and Wales, a registered installer may use a competent person scheme; building control is another route. Check the route before ordering. The <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a> explains how self-certification works. Scotland and Northern Ireland have separate systems.</p>\n<p>A glass-only repair does not normally receive the same certificate as a complete window replacement. <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. Safety glazing and listed-building restrictions still deserve attention, even for a small repair.</p>\n<h2>Start with what you can see</h2>\n<p>You can give a useful description without taking a window apart. Count the affected openings, mention their floor level and say whether the problem is in the glass, frame or lock. Photographs from a safe position help a glazier decide what to look at during the survey. The firm's own measurements should be used for manufacturing.</p>\n<p><a href=\"/free-quotes/\">Send your glazing enquiry</a> when you are ready to compare options. If you fit windows or replace sealed units, our <a href=\"/job-leads/\">contractor page</a> explains how to browse enquiries for your trade and area.</p>\n</article>\n",
    "blown-double-glazed-unit-replacement-county": "<article class=\"blown-double-glazed-unit-replacement-county-content\">\n<h2>{Blown Double Glazed Unit Replacement across [COUNTY]|Compare blown sealed-unit replacement quotes across [COUNTY]|Arrange blown sealed-unit replacement across [COUNTY]}</h2>\n<p>{A blown unit has lost the integrity of its edge seal, allowing moisture into the glass cavity.|When a glazier describes double glazing as blown, they usually mean a failed sealed unit rather than a broken window frame.|Internal haze or staining can prompt a closer check of the sealed unit and its edge seal.} {The replacement must fit the existing glazing rebate, beads and support arrangement.|A made-to-measure unit is specified to suit the frame that will stay in place.|Glass size alone is not enough: the glazier also checks unit thickness, weight and compatibility.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent sealed-unit specialists may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about blown sealed-unit replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Condensation, haze or deposits within the cavity after the seal has failed.</li>\n<li>A previously identified failed unit that is due for replacement.</li>\n<li>Several units requiring a coordinated order with matching spacer and glass details.</li>\n<li>A compatible glass upgrade while the unit is being replaced, without changing sound frames.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>The order should identify each pane, cavity, spacer and overall thickness. Low-E glass, argon fill and warm-edge spacers may be options within the existing system. Acoustic laminates add weight, and a thicker unit needs suitable beads and frame capacity. Loose gaskets, rattling glass or distorted reflections warrant inspection but do not alone establish edge-seal failure.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Assess the failed unit and check frame drainage, beads, gaskets and available rebate depth.|Inspect the glass and its supporting frame to identify the fault and any related drainage problem.}</li>\n<li>{Take manufacturing dimensions and agree the exact glass build-up with the supplier.|Measure size and thickness and specify coatings, spacer finish and safety glass as appropriate.}</li>\n<li>{Arrange safe lifting and access before removing the old unit and preparing its support points.|Plan handling for the weight of the glass, protect surrounding finishes and remove the failed unit.}</li>\n<li>{Position the new unit on compatible setting and location blocks without obstructing drainage.|Glaze to the frame system requirements so the unit is supported and the rebate can drain.}</li>\n<li>{Refit sound beads or approved replacements, adjust the sash and record the product guarantee.|Check beads, gaskets, opening and locking, clean the area and remove the old unit for disposal.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for blown sealed-unit replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for blown unit replacement is <strong>£100–£900</strong>. {A standard unit can sit near the lower end, while several replacements or specialist glass increase the total.|The broad range covers small straightforward units as well as larger orders with upgrades or harder access.} Ask for each unit to be itemised. The misted-glazing service describes much of the same work, not a second fee.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Note the number of units, visible dimensions, frame material and floor level. Describe any leaded pattern, Georgian bars, tint or privacy glass that needs matching. Ask the glazier to check compatibility before approving an insulation or acoustic upgrade.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>A replacement unit should have a written product guarantee and clear fitting terms. Report a loose bead or blocked drainage route to the installer. Avoid applying solvents or sealants to the unit edge without the manufacturer's advice.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 2 hours–1 day, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about blown sealed-unit replacement.|Before arranging blown sealed-unit replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about blown sealed-unit replacement|Before booking blown sealed-unit replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request blown sealed-unit replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent sealed-unit specialists covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Is a blown unit different from misted glazing?</h3>\n<p>The terms often refer to the same problem. Blown describes the failed edge seal, while misted describes moisture visible between the panes. One enquiry can cover the fault.</p>\n<h3>Can a new unit be thicker than the original?</h3>\n<p>Only if the frame system, beads, gaskets and supporting hardware can accommodate it. The glazier must confirm compatibility before a different thickness or heavier glass is ordered.</p>\n<h3>Will changing the unit fix a draught around the sash?</h3>\n<p>Not by itself. Draughts around an opener can involve hinges, weather seals or locking adjustments. Ask for those faults to be assessed separately from the sealed glass unit.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request blown sealed-unit replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent sealed-unit specialists covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is a blown unit different from misted glazing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The terms often refer to the same problem. Blown describes the failed edge seal, while misted describes moisture visible between the panes. One enquiry can cover the fault.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can a new unit be thicker than the original?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Only if the frame system, beads, gaskets and supporting hardware can accommodate it. The glazier must confirm compatibility before a different thickness or heavier glass is ordered.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will changing the unit fix a draught around the sash?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not by itself. Draughts around an opener can involve hinges, weather seals or locking adjustments. Ask for those faults to be assessed separately from the sealed glass unit.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request blown sealed-unit replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable sealed-unit specialists covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "blown-double-glazed-unit-replacement-town": "<article class=\"blown-double-glazed-unit-replacement-town-content\">\n<h2>{Blown Double Glazed Unit Replacement in [TOWN]|Compare blown sealed-unit replacement quotes in [TOWN]|Arrange blown sealed-unit replacement in [TOWN]}</h2>\n<p>{A blown unit has lost the integrity of its edge seal, allowing moisture into the glass cavity.|When a glazier describes double glazing as blown, they usually mean a failed sealed unit rather than a broken window frame.|Internal haze or staining can prompt a closer check of the sealed unit and its edge seal.} {The replacement must fit the existing glazing rebate, beads and support arrangement.|A made-to-measure unit is specified to suit the frame that will stay in place.|Glass size alone is not enough: the glazier also checks unit thickness, weight and compatibility.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent sealed-unit specialists may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about blown sealed-unit replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Condensation, haze or deposits within the cavity after the seal has failed.</li>\n<li>A previously identified failed unit that is due for replacement.</li>\n<li>Several units requiring a coordinated order with matching spacer and glass details.</li>\n<li>A compatible glass upgrade while the unit is being replaced, without changing sound frames.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>The order should identify each pane, cavity, spacer and overall thickness. Low-E glass, argon fill and warm-edge spacers may be options within the existing system. Acoustic laminates add weight, and a thicker unit needs suitable beads and frame capacity. Loose gaskets, rattling glass or distorted reflections warrant inspection but do not alone establish edge-seal failure.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Assess the failed unit and check frame drainage, beads, gaskets and available rebate depth.|Inspect the glass and its supporting frame to identify the fault and any related drainage problem.}</li>\n<li>{Take manufacturing dimensions and agree the exact glass build-up with the supplier.|Measure size and thickness and specify coatings, spacer finish and safety glass as appropriate.}</li>\n<li>{Arrange safe lifting and access before removing the old unit and preparing its support points.|Plan handling for the weight of the glass, protect surrounding finishes and remove the failed unit.}</li>\n<li>{Position the new unit on compatible setting and location blocks without obstructing drainage.|Glaze to the frame system requirements so the unit is supported and the rebate can drain.}</li>\n<li>{Refit sound beads or approved replacements, adjust the sash and record the product guarantee.|Check beads, gaskets, opening and locking, clean the area and remove the old unit for disposal.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for blown sealed-unit replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for blown unit replacement is <strong>£100–£900</strong>. {A standard unit can sit near the lower end, while several replacements or specialist glass increase the total.|The broad range covers small straightforward units as well as larger orders with upgrades or harder access.} Ask for each unit to be itemised. The misted-glazing service describes much of the same work, not a second fee.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Note the number of units, visible dimensions, frame material and floor level. Describe any leaded pattern, Georgian bars, tint or privacy glass that needs matching. Ask the glazier to check compatibility before approving an insulation or acoustic upgrade.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>A replacement unit should have a written product guarantee and clear fitting terms. Report a loose bead or blocked drainage route to the installer. Avoid applying solvents or sealants to the unit edge without the manufacturer's advice.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 2 hours–1 day, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about blown sealed-unit replacement.|Before arranging blown sealed-unit replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about blown sealed-unit replacement|Before booking blown sealed-unit replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request blown sealed-unit replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent sealed-unit specialists covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Is a blown unit different from misted glazing?</h3>\n<p>The terms often refer to the same problem. Blown describes the failed edge seal, while misted describes moisture visible between the panes. One enquiry can cover the fault.</p>\n<h3>Can a new unit be thicker than the original?</h3>\n<p>Only if the frame system, beads, gaskets and supporting hardware can accommodate it. The glazier must confirm compatibility before a different thickness or heavier glass is ordered.</p>\n<h3>Will changing the unit fix a draught around the sash?</h3>\n<p>Not by itself. Draughts around an opener can involve hinges, weather seals or locking adjustments. Ask for those faults to be assessed separately from the sealed glass unit.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request blown sealed-unit replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent sealed-unit specialists covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is a blown unit different from misted glazing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The terms often refer to the same problem. Blown describes the failed edge seal, while misted describes moisture visible between the panes. One enquiry can cover the fault.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can a new unit be thicker than the original?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Only if the frame system, beads, gaskets and supporting hardware can accommodate it. The glazier must confirm compatibility before a different thickness or heavier glass is ordered.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will changing the unit fix a draught around the sash?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not by itself. Draughts around an opener can involve hinges, weather seals or locking adjustments. Ask for those faults to be assessed separately from the sealed glass unit.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request blown sealed-unit replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable sealed-unit specialists covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "blown-double-glazed-unit-replacement": "<article class=\"service-overview\">\n    <h2>What Is Blown Double Glazed Unit Replacement?</h2>\n    <p>Blown double glazed unit replacement is the trade term for swapping a sealed glass unit that has lost its airtight seal (a \"blown\" unit) for a new one built to the same size and thickness. A sealed unit is two (or three) panes held apart by a spacer bar and bonded with a primary and secondary sealant. Once that bond fails, moisture can enter the cavity and thermal performance may deteriorate. The usual lasting repair is a compatible replacement sealed unit.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/replacement-sealed-glass-unit-workshop-uk.jpg\" alt=\"Replacement sealed glass unit supported in a padded rack on a workshop bench\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>Because the work is about ordering and fitting the right unit, it is also {a good moment|an ideal opportunity} to upgrade what's in the frame: modern units can be specified with better coatings, warmer spacers, a different glass type or a thicker cavity if the frame allows.</p>\n\n    <h2>Signs That Need a Glazier's Assessment</h2>\n    <ul>\n        <li>A faint haze or water staining inside the cavity, sometimes only visible in low sunlight</li>\n        <li>Sealant around the unit edge that has cracked, shrunk or turned sticky</li>\n        <li>A spacer bar that has bowed, rusted or pulled away from the glass</li>\n        <li>Panes that appear slightly distorted, as if the glass has bent inwards</li>\n        <li>Beads or gaskets that have shrunk back, leaving gaps where water can reach the unit edge</li>\n        <li>A unit that rattles or moves when the sash is opened</li>\n    </ul>\n    <p>If you only want to know what the cloudiness will cost to put right, our <a href=\"/guides/misted-double-glazing-replacement-cost/\">misted double glazing cost guide</a> covers the same job from the symptom side, and <a href=\"/guides/double-glazing-problems-explained/\">double glazing problems explained</a> helps you tell a failed unit from other faults.</p>\n\n    <p>Internal moisture can indicate edge-seal failure, but loose beads, rattling glass and distorted reflections can have other causes. A glazier should inspect the complete glazing assembly before deciding which parts need replacement.</p>\n    <h2>Replacement Unit Specifications Explained</h2>\n    <p>A like-for-like unit fits straight back into the frame, but you often have choices within the same overall thickness:</p>\n    <ul>\n        <li><strong>Unit thickness.</strong> Common sizes are 20mm, 24mm and 28mm overall. The new unit must suit the frame's glazing rebate; a larger cavity only works if the beads and gaskets allow it.</li>\n        <li><strong>Low-emissivity glass and gas fill.</strong> A soft-coat low-E inner pane plus argon in the cavity improves heat retention compared with older air-filled units.</li>\n        <li><strong>Warm-edge spacers.</strong> Plastic or composite spacers in place of aluminium reduce heat loss at the edge and make condensation along the bottom of the glass less likely.</li>\n        <li><strong>Safety glass.</strong> Toughened or laminated glass is required in certain low-level and door-adjacent positions, and any unit that is replaced there should comply.</li>\n        <li><strong>Special glass.</strong> Obscure patterns for privacy, acoustic laminates for traffic noise, solar control for south-facing rooms, or self-cleaning coatings for hard-to-reach panes.</li>\n    </ul>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>List each blown unit by location and give its visible glass size, noting whether it sits in an opening sash or a fixed pane. If you can see the beads from inside, say so. Internally beaded windows are quicker and safer to reglaze than externally beaded ones, which on an upper floor may need access equipment. Mention any units with internal Georgian bars, leaded patterns or obscure glass that will need to be copied.</p>\n    <p>State whether you want a straight like-for-like swap or would like prices for upgrades such as warm-edge spacers, acoustic glass or solar control. If the window is next to a door, in a door, or has glass close to the floor, point this out because the glazier will need to supply toughened or laminated glass in those positions.</p>\n    <p>The written quote should list each unit with its dimensions and overall thickness, the glass make-up for each pane, spacer type and gas fill, and the guarantee period on the new units. Check it covers removal of the old glass, new gaskets or beads if the originals are brittle, access equipment where needed, and VAT.</p>\n\n    <h2>How Much Does Blown Unit Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK blown double glazed unit replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>One standard clear unit, internally beaded</td><td>£100 – £200</td></tr>\n            <tr><td>Two or three units, or one large/toughened unit</td><td>£200 – £500</td></tr>\n            <tr><td>Several units with upgrades or upper-floor access</td><td>£500 – £900+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>Unit size, glass type and access are the main price drivers. Laminated, acoustic and patterned glass cost more than standard clear, and externally beaded upstairs windows can add a significant labour charge.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/blown-double-glazed-unit-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The Unit Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Measuring.</strong> The glazier checks the rebate size and unit thickness and notes the glass type and any bars.</li>\n        <li><strong>Specification.</strong> You agree like-for-like or upgraded glass, and the order goes to the unit manufacturer.</li>\n        <li><strong>Removal.</strong> Beads are carefully removed, the blown unit is cut free if bonded, and old packers are cleared out.</li>\n        <li><strong>Glazing.</strong> The new unit is placed on bridging and location packers so the sash is supported and drains correctly.</li>\n        <li><strong>Re-beading.</strong> Beads and gaskets are refitted or renewed, and the sash is checked for smooth operation.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>Changing only a sealed unit in a frame that stays in place is normally regarded as a repair, so neither planning permission nor a building regulations certificate is usually needed. The new glass should still meet the safety glazing requirements for its position. On listed buildings, even glass changes can need consent, so check first. If the glazier finds the frame is too far gone and recommends full replacement, that becomes controlled work covered by building regulations.</p>\n\n    <h2>How to Choose a Glazier for Sealed Unit Work</h2>\n    <ul>\n        <li>Do they measure themselves rather than relying on your sizes?</li>\n        <li>Which unit manufacturer do they use, and what do the product and fitting guarantees cover?</li>\n        <li>Will they quote for warm-edge spacers and low-E glass as standard?</li>\n        <li>How do they reach externally beaded windows above ground level?</li>\n        <li>Will they renew perished gaskets while the unit is out?</li>\n        <li>Are they a member of a recognised body such as the <a href=\"https://www.ggf.org.uk/\" target=\"_blank\" rel=\"nofollow noopener\">Glass and Glazing Federation</a>?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>Is a blown unit the same as misted double glazing?</h3>\n    <p>They describe the same failure. \"Blown\" refers to the broken seal; misting is the most visible symptom. A unit can be blown for some time before condensation shows.</p>\n    <h3>Can I fit a thicker unit to improve insulation?</h3>\n    <p>Only if the frame's rebate and beads can take it. A glazier can check whether an alternative bead allows a slightly thicker unit, but many frames are limited to the original size.</p>\n    <h3>How long do new sealed units last?</h3>\n    <p>Service life varies with manufacture, exposure, drainage and fitting. Ask for the replacement unit guarantee in writing, including exclusions and whether labour is covered if it fails.</p>\n    <h3>Why is externally beaded glazing more expensive to replace?</h3>\n    <p>The glazier may need to work from outside and arrange suitable access equipment. Height, obstacles below the opening and the condition of the beads can increase the labour and material costs.</p>\n    \n\n    <p>Need new sealed units? <a href=\"/free-quotes/\">Send your sizes</a> and up to four local glaziers may quote.</p>\n\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is a blown unit the same as misted double glazing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"They describe the same failure. \\\"Blown\\\" refers to the broken seal; misting is the most visible symptom. A unit can be blown for some time before condensation shows.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I fit a thicker unit to improve insulation?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Only if the frame's rebate and beads can take it. A glazier can check whether an alternative bead allows a slightly thicker unit, but many frames are limited to the original size.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How long do new sealed units last?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Service life varies with manufacture, exposure, drainage and fitting. Ask for the replacement unit guarantee in writing, including exclusions and whether labour is covered if it fails.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Why is externally beaded glazing more expensive to replace?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The glazier may need to work from outside and arrange suitable access equipment. Height, obstacles below the opening and the condition of the beads can increase the labour and material costs.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "double-glazed-door-replacement-county": "<article class=\"double-glazed-door-replacement-county-content\">\n<h2>{Double Glazed Door Replacement across [COUNTY]|Compare double glazed door replacement quotes across [COUNTY]|Arrange double glazed door replacement across [COUNTY]}</h2>\n<p>{A replacement glazed door needs to suit the opening, the way you use it and the weather outside.|Changing a front, back or garden door is a chance to review the locks, glass and threshold together.|If an old doorset is beyond repair, a new one should be surveyed as a complete frame-and-door installation.} {A complete doorset includes the frame, door leaf or leaves, threshold, glazing and hardware.|Full replacement takes out the old door and frame before the new set is secured and weather-sealed.|The survey checks more than the door width: floor levels, opening direction and drainage matter too.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent door installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about double glazed door replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Rotten or distorted frames, split panels or extensive damage that repair will not sensibly resolve.</li>\n<li>Persistent draughts or difficult locking after adjustment and hardware repairs have been considered.</li>\n<li>Replacing French doors or a sliding patio set with a suitable modern equivalent.</li>\n<li>A need to improve access, privacy or the opening arrangement, subject to technical and consent checks.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>uPVC, composite and aluminium doorsets offer different designs, weights and finishes. Compare the performance and tested security of the complete doorset, including glazing and locks. For sliding doors, consider track cleaning and panel weight; for French doors, check swing clearance and the active leaf. A low threshold needs suitable weathering and drainage rather than a promise that it will never leak.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Survey the frame opening, lintel, internal floor and outside step or paving level.|Measure the doorset and check support, access width and the levels on both sides of the threshold.}</li>\n<li>{Agree material, colour, hinge side, opening direction, privacy glass and lock specification.|Record the door design, glazing, handles, cylinder, letterbox and any side panels in the order.}</li>\n<li>{Plan safe removal and temporary security, protect floors and take out the old frame.|Prepare the working area and agree how the opening will be secured if installation takes longer than expected.}</li>\n<li>{Fix and pack the new doorset, weather the threshold and adjust hinges or rollers and locking points.|Install the frame and threshold to the system detail, then align the leaves and locking hardware.}</li>\n<li>{Finish agreed reveals, remove waste and demonstrate keys, locks and maintenance points.|Complete sealing and making good, check smooth operation and explain the guarantee and applicable paperwork.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for double glazed door replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed door replacement is <strong>£900–£4,000</strong>. {A basic single doorset is a different purchase from a wide patio set with side panels.|Door size, frame material and the amount of glazing strongly affect where a quote sits in this range.} Premium hardware, colour choices, drainage alterations and changes to the opening can increase the total beyond the guide.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Say whether this is a front, back, French or sliding door and whether you want to retain the opening size. Describe side lights, steps and access needs. If a flat entrance requires a fire-rated doorset, make that clear before anyone proposes an ordinary glazed domestic door.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>Approval and certification depend on the doorset and the work. Relevant glazed replacement doors in England and Wales may use an appropriate competent person scheme or building control; not every external door falls within the same scope. Scotland and Northern Ireland use separate systems. Confirm safety glazing, access and any fire-door requirements before ordering. The <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a> explains the self-certification route.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how the home will be secured during the changeover and agree contingency arrangements. At handover, try the handles and keys yourself and ask how to clean tracks and drainage routes. Keep the doorset specification and guarantee with any compliance documentation.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 4 hours–2 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about double glazed door replacement.|Before arranging double glazed door replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about double glazed door replacement|Before booking double glazed door replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request double glazed door replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent door installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Does a stiff door always need replacement?</h3>\n<p>No. Hinges, rollers, gaskets or locking parts may be repairable. Ask for the cause to be assessed before committing to a complete doorset.</p>\n<h3>Can I ask for a low threshold?</h3>\n<p>Yes. The installer should check access needs, weather exposure and floor levels, then specify suitable threshold and drainage details for that opening.</p>\n<h3>Will a new door always be fitted in one day?</h3>\n<p>A straightforward replacement may be completed in one day, but larger sets and remedial work can take longer. Agree how the property will be secured if fitting is delayed.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request double glazed door replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent door installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does a stiff door always need replacement?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Hinges, rollers, gaskets or locking parts may be repairable. Ask for the cause to be assessed before committing to a complete doorset.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I ask for a low threshold?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. The installer should check access needs, weather exposure and floor levels, then specify suitable threshold and drainage details for that opening.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will a new door always be fitted in one day?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"A straightforward replacement may be completed in one day, but larger sets and remedial work can take longer. Agree how the property will be secured if fitting is delayed.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request double glazed door replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable door installers covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-door-replacement-town": "<article class=\"double-glazed-door-replacement-town-content\">\n<h2>{Double Glazed Door Replacement in [TOWN]|Compare double glazed door replacement quotes in [TOWN]|Arrange double glazed door replacement in [TOWN]}</h2>\n<p>{A replacement glazed door needs to suit the opening, the way you use it and the weather outside.|Changing a front, back or garden door is a chance to review the locks, glass and threshold together.|If an old doorset is beyond repair, a new one should be surveyed as a complete frame-and-door installation.} {A complete doorset includes the frame, door leaf or leaves, threshold, glazing and hardware.|Full replacement takes out the old door and frame before the new set is secured and weather-sealed.|The survey checks more than the door width: floor levels, opening direction and drainage matter too.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent door installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about double glazed door replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Rotten or distorted frames, split panels or extensive damage that repair will not sensibly resolve.</li>\n<li>Persistent draughts or difficult locking after adjustment and hardware repairs have been considered.</li>\n<li>Replacing French doors or a sliding patio set with a suitable modern equivalent.</li>\n<li>A need to improve access, privacy or the opening arrangement, subject to technical and consent checks.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>uPVC, composite and aluminium doorsets offer different designs, weights and finishes. Compare the performance and tested security of the complete doorset, including glazing and locks. For sliding doors, consider track cleaning and panel weight; for French doors, check swing clearance and the active leaf. A low threshold needs suitable weathering and drainage rather than a promise that it will never leak.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Survey the frame opening, lintel, internal floor and outside step or paving level.|Measure the doorset and check support, access width and the levels on both sides of the threshold.}</li>\n<li>{Agree material, colour, hinge side, opening direction, privacy glass and lock specification.|Record the door design, glazing, handles, cylinder, letterbox and any side panels in the order.}</li>\n<li>{Plan safe removal and temporary security, protect floors and take out the old frame.|Prepare the working area and agree how the opening will be secured if installation takes longer than expected.}</li>\n<li>{Fix and pack the new doorset, weather the threshold and adjust hinges or rollers and locking points.|Install the frame and threshold to the system detail, then align the leaves and locking hardware.}</li>\n<li>{Finish agreed reveals, remove waste and demonstrate keys, locks and maintenance points.|Complete sealing and making good, check smooth operation and explain the guarantee and applicable paperwork.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for double glazed door replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed door replacement is <strong>£900–£4,000</strong>. {A basic single doorset is a different purchase from a wide patio set with side panels.|Door size, frame material and the amount of glazing strongly affect where a quote sits in this range.} Premium hardware, colour choices, drainage alterations and changes to the opening can increase the total beyond the guide.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Say whether this is a front, back, French or sliding door and whether you want to retain the opening size. Describe side lights, steps and access needs. If a flat entrance requires a fire-rated doorset, make that clear before anyone proposes an ordinary glazed domestic door.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>Approval and certification depend on the doorset and the work. Relevant glazed replacement doors in England and Wales may use an appropriate competent person scheme or building control; not every external door falls within the same scope. Scotland and Northern Ireland use separate systems. Confirm safety glazing, access and any fire-door requirements before ordering. The <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a> explains the self-certification route.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how the home will be secured during the changeover and agree contingency arrangements. At handover, try the handles and keys yourself and ask how to clean tracks and drainage routes. Keep the doorset specification and guarantee with any compliance documentation.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 4 hours–2 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about double glazed door replacement.|Before arranging double glazed door replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about double glazed door replacement|Before booking double glazed door replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request double glazed door replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent door installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Does a stiff door always need replacement?</h3>\n<p>No. Hinges, rollers, gaskets or locking parts may be repairable. Ask for the cause to be assessed before committing to a complete doorset.</p>\n<h3>Can I ask for a low threshold?</h3>\n<p>Yes. The installer should check access needs, weather exposure and floor levels, then specify suitable threshold and drainage details for that opening.</p>\n<h3>Will a new door always be fitted in one day?</h3>\n<p>A straightforward replacement may be completed in one day, but larger sets and remedial work can take longer. Agree how the property will be secured if fitting is delayed.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request double glazed door replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent door installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does a stiff door always need replacement?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Hinges, rollers, gaskets or locking parts may be repairable. Ask for the cause to be assessed before committing to a complete doorset.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I ask for a low threshold?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. The installer should check access needs, weather exposure and floor levels, then specify suitable threshold and drainage details for that opening.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will a new door always be fitted in one day?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"A straightforward replacement may be completed in one day, but larger sets and remedial work can take longer. Agree how the property will be secured if fitting is delayed.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request double glazed door replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable door installers covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-door-replacement": "<article class=\"service-overview\">\n    <h2>What Is Double Glazed Door Replacement?</h2>\n    <p>Double glazed door replacement is the removal of an existing external door and frame and the installation of a new, factory-made doorset with double glazed panels: a front door, back door, French doors or a sliding patio door. Unlike swapping a door leaf on existing hinges, a complete doorset replacement includes the outer frame, threshold, hinges, multi-point locking and glass, fitted and sealed as one unit into the opening.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/double-glazed-french-doors-garden-threshold-uk.jpg\" alt=\"White glazed French doors with a low threshold and drainage channel outside\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>{Security and draughts are the usual reasons|Most homeowners are prompted by security worries or cold draughts}: older doors often have worn locks, dropped leaves that no longer seal, and single-glazed or poorly performing panels.</p>\n\n    <h2>Signs You Need a New Door</h2>\n    <ul>\n        <li>The door has dropped and scrapes the threshold or needs lifting to lock</li>\n        <li>Daylight or draughts come through around the edges when it's closed</li>\n        <li>The multi-point lock is stiff, jams or the handle has to be forced up</li>\n        <li>uPVC panels are cracked, discoloured or bowed</li>\n        <li>A timber door has swollen, split or rotted along the bottom rail</li>\n        <li>Patio doors are hard to slide, jump off their track or have worn rollers</li>\n        <li>The glass panels are single glazed or not safety glass</li>\n    </ul>\n    <p>A door that sticks, drops or locks stiffly is not always a replacement job. Our checklist of <a href=\"/guides/signs-your-double-glazing-needs-replacing/\">signs your double glazing needs replacing</a> and <a href=\"/guides/double-glazing-problems-explained/\">double glazing problems explained</a> help you decide.</p>\n\n    <h2>Door Types and Materials Explained</h2>\n    <ul>\n        <li><strong>uPVC doors.</strong> The most affordable option, with a reinforced frame and a panel or glazed design. Good value for back doors and utility rooms.</li>\n        <li><strong>Composite doors.</strong> A solid or foam core with a GRP skin that mimics painted timber. Heavier, more secure and a popular front-door upgrade.</li>\n        <li><strong>Aluminium doors.</strong> Slim, strong frames for contemporary homes, often used for large glazed doors.</li>\n        <li><strong>French doors.</strong> A pair of outward- or inward-opening leaves, usually onto a garden, in uPVC, composite or aluminium.</li>\n        <li><strong>Sliding patio doors.</strong> Large glazed panels on a track, suited to wide openings where swinging doors would get in the way.</li>\n    </ul>\n    <p>Security features to look for include multi-point locking, anti-snap cylinders and doorsets tested to recognised security standards. Low or level thresholds can improve access, but need careful detailing to keep rain out.</p>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>Say which door you want to replace and what it opens onto (a porch, a path, a patio or a step down to the garden), as this affects threshold height and weathering. Measure the overall width and height of the existing frame from inside, and note whether there are side panels or a fanlight above that should be replaced at the same time.</p>\n    <p>Explain which way you want the door to open and hinge, whether you need a letterbox, spyhole, knocker or number, and how much glass you want for light versus privacy. If anyone in the household uses a wheelchair or walking aid, ask about low thresholds and wider openings. For patio and French doors, mention any step or uneven ground outside and whether the old doors are aluminium, timber or uPVC.</p>\n    <p>A clear quote should name the door material and manufacturer, list the lock type and cylinder specification, confirm that glazed panels are toughened or laminated safety glass, and state the energy rating. It should also cover removal of the old door and frame, making good the plaster and brickwork around it, the threshold detail, registration with building control or a competent person scheme, and the length of the guarantee on the door, hardware and glass.</p>\n\n    <h2>How Much Does Double Glazed Door Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK double glazed door replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>uPVC back or side door, fitted</td><td>£900 – £1,500</td></tr>\n            <tr><td>Composite front door, or uPVC French doors</td><td>£1,300 – £2,600</td></tr>\n            <tr><td>Front door with side panels, or sliding patio doors</td><td>£2,600 – £4,000+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>Composite and aluminium doors cost more than uPVC. Side panels, top lights, coloured finishes, premium hardware and security upgrades raise the price, as does any work needed to the opening or step.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/double-glazed-door-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The Door Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Survey.</strong> The installer measures the opening, checks the lintel and step, and confirms style, colour, glass and hardware.</li>\n        <li><strong>Manufacture.</strong> The doorset is made to measure; composite doors in bespoke colours can take several weeks.</li>\n        <li><strong>Removal.</strong> The old door and frame are taken out, usually on the same day as fitting so the home stays secure.</li>\n        <li><strong>Installation.</strong> The new frame is fixed level and plumb, the threshold is bedded, and the door is hung and adjusted.</li>\n        <li><strong>Sealing and trims.</strong> The outside is sealed, trims fitted, and the surrounding plaster made good inside.</li>\n        <li><strong>Handover.</strong> Keys are handed over, the locking is demonstrated, and the certificate follows once registered.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>Replacing an external door on a house with one of a similar appearance generally doesn't need planning permission. Listed buildings, conservation areas, Article 4 directions and flats can be exceptions, and leaseholders should check their lease. Widening an opening or adding new doors where there were none is a bigger change that may need approval.</p>\n    <p>Building regulations and certification requirements depend on the door and the extent of the work. For relevant glazed replacement doors in England and Wales, an applicable competent person scheme or building control provides a route; not every external door has the same notification requirements. Scotland and Northern Ireland have their own systems. Confirm safety glazing, energy performance, access and any fire-door requirements for the actual opening. See <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a>.</p><p>Agree the supply-and-install terms, deposit and cancellation conditions before ordering made-to-measure products. Do not assume all glazing contracts have an identical cooling-off period. Read <a href=\"https://www.citizensadvice.org.uk/consumer/changed-your-mind/cancelling-a-service-youve-arranged/\" target=\"_blank\" rel=\"nofollow noopener\">Citizens Advice on cancelling a service</a> and clarify the terms for your order.</p>\n\n    <h2>How to Choose a Door Installer</h2>\n    <ul>\n        <li>What security standard is the doorset tested to, and which cylinder is fitted?</li>\n        <li>Is the glass in the door toughened or laminated?</li>\n        <li>Will the old frame be fully removed, or is the new door fitted into it?</li>\n        <li>How is the threshold weathered, especially for low or level access?</li>\n        <li>How long are the door leaf, frame, hardware and glass guaranteed?</li>\n        <li>Is the installer registered to self-certify the work?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>Is a composite door better than a uPVC door?</h3>\n    <p>Composite doors are thicker and heavier, with a more solid feel and a painted-timber look. uPVC doors cost less and suit back doors well. Both can be secure if fitted with good locks and cylinders.</p>\n    <h3>Can a new door be fitted in one day?</h3>\n    <p>A straightforward single doorset may be fitted in a day. Larger sets and remedial work can take longer, so agree how the opening will be secured if fitting is delayed.</p>\n    <h3>Can I choose a different colour inside and outside?</h3>\n    <p>Yes. Many uPVC and composite doors are available with a colour outside and white inside, so the door suits the front of the house and the hallway.</p>\n    <h3>Do I need safety glass in my new door?</h3>\n    <p>Safety glazing is needed in critical locations, which commonly include parts of doors and adjacent panels. Ask the installer to assess the height, position and size and specify suitable toughened or laminated glass under the applicable rules.</p>\n    \n\n    <p>Want a new front, back or patio door? <a href=\"/free-quotes/\">Request free quotes</a> from up to four local installers.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is a composite door better than a uPVC door?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Composite doors are thicker and heavier, with a more solid feel and a painted-timber look. uPVC doors cost less and suit back doors well. Both can be secure if fitted with good locks and cylinders.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can a new door be fitted in one day?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"A straightforward single doorset may be fitted in a day. Larger sets and remedial work can take longer, so agree how the opening will be secured if fitting is delayed.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I choose a different colour inside and outside?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Many uPVC and composite doors are available with a colour outside and white inside, so the door suits the front of the house and the hallway.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Do I need safety glass in my new door?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Safety glazing is needed in critical locations, which commonly include parts of doors and adjacent panels. Ask the installer to assess the height, position and size and specify suitable toughened or laminated glass under the applicable rules.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "double-glazed-glass-replacement-county": "<article class=\"double-glazed-glass-replacement-county-content\">\n<h2>{Double Glazed Glass Replacement across [COUNTY]|Compare damaged double-glazed glass replacement quotes across [COUNTY]|Arrange damaged double-glazed glass replacement across [COUNTY]}</h2>\n<p>{A cracked pane needs an assessment of safety and security before a permanent replacement is ordered.|After glass damage, the first question is whether the opening can be left safely and securely.|Broken double glazing can often be replaced while retaining a sound frame, but the damage needs checking first.} {For a damaged double-glazed unit, the usual permanent repair replaces the sealed assembly rather than changing one sheet on site.|The glazier measures and orders a complete replacement sealed unit with glass appropriate to its position.|A replacement unit is made to the required dimensions and specification after the existing frame has been checked.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent glaziers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about damaged double-glazed glass replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>A crack in either sheet of the double-glazed unit, whether from impact or another cause.</li>\n<li>Shattered glass, loose fragments or a damaged opening following an attempted break-in.</li>\n<li>Damaged glazed door panels or large fixed panes needing safe handling.</li>\n<li>A replacement that must match privacy patterns or provide suitable safety or acoustic performance.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>Keep people and pets away from damaged glazing and avoid pressing, taping or trying to remove it yourself. If the opening is insecure or glass may fall, contact a glazier who can confirm urgent attendance. Our enquiry form does not promise emergency dispatch. Boarding can be a temporary measure while glass is manufactured; ask about a separate charge and a removal visit.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Assess loose glass and the condition of the frame, and agree any temporary making-safe work.|Check the damage and discuss whether boarding is needed before the permanent repair.}</li>\n<li>{Measure the unit and identify safety-glazing needs, privacy patterns and any specialist specification.|Survey the opening and specify suitable glass, including toughened or laminated products where appropriate.}</li>\n<li>{Protect floors and furnishings, isolate the work area and remove damaged glass using suitable equipment.|Plan safe handling and protect the occupied room before removing the damaged sealed unit.}</li>\n<li>{Prepare the rebate, fit compatible packers and install and re-bead the new unit.|Check the frame support and drainage, then fit and secure the made-to-size replacement glass.}</li>\n<li>{Remove agreed boarding, collect glass fragments and test the window or door operation.|Clear the work area and waste, clean the new glass and check closing and locking.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for damaged double-glazed glass replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed glass replacement is <strong>£120–£750</strong>. {A small clear unit and a large laminated door panel involve different material and handling costs.|Size, glass type and safe access can matter as much as the damage itself when the job is priced.} Urgent attendance and temporary boarding may be extra. Request an itemised quote rather than assuming a call-out includes the final glass.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Say whether the opening is secure, where the damaged pane is and which floor it is on. Mention door panels, patterned glass and difficult access. Photographs should be taken from a safe distance. If an insurer is involved, check its evidence and approval requirements before committing to non-urgent work.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask the glazier to explain any suspected cause, such as edge damage or pressure from the frame, so it can be addressed when fitting the new unit. Confirm disposal, replacement-unit warranty and the date for removing temporary boarding.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 2 hours–1 day, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about damaged double-glazed glass replacement.|Before arranging damaged double-glazed glass replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about damaged double-glazed glass replacement|Before booking damaged double-glazed glass replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request damaged double-glazed glass replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Can just the broken sheet of a double-glazed unit be changed?</h3>\n<p>The normal on-site repair replaces the complete sealed unit. It is manufactured as an assembly, so replacing one sheet in place is not the usual way to restore the sealed cavity.</p>\n<h3>Does this service guarantee same-day boarding?</h3>\n<p>No. Availability depends on the responding glazier. If the opening is unsafe or insecure, contact a firm that can confirm urgent attendance directly rather than relying on the enquiry form.</p>\n<h3>Must the new glass always be toughened?</h3>\n<p>The required glazing depends on its location, size and applicable rules. Toughened and laminated safety glass have different properties. Ask the glazier to specify a compliant product for the particular opening.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request damaged double-glazed glass replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can just the broken sheet of a double-glazed unit be changed?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The normal on-site repair replaces the complete sealed unit. It is manufactured as an assembly, so replacing one sheet in place is not the usual way to restore the sealed cavity.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does this service guarantee same-day boarding?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Availability depends on the responding glazier. If the opening is unsafe or insecure, contact a firm that can confirm urgent attendance directly rather than relying on the enquiry form.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Must the new glass always be toughened?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The required glazing depends on its location, size and applicable rules. Toughened and laminated safety glass have different properties. Ask the glazier to specify a compliant product for the particular opening.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request damaged double-glazed glass replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable glaziers covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-glass-replacement-town": "<article class=\"double-glazed-glass-replacement-town-content\">\n<h2>{Double Glazed Glass Replacement in [TOWN]|Compare damaged double-glazed glass replacement quotes in [TOWN]|Arrange damaged double-glazed glass replacement in [TOWN]}</h2>\n<p>{A cracked pane needs an assessment of safety and security before a permanent replacement is ordered.|After glass damage, the first question is whether the opening can be left safely and securely.|Broken double glazing can often be replaced while retaining a sound frame, but the damage needs checking first.} {For a damaged double-glazed unit, the usual permanent repair replaces the sealed assembly rather than changing one sheet on site.|The glazier measures and orders a complete replacement sealed unit with glass appropriate to its position.|A replacement unit is made to the required dimensions and specification after the existing frame has been checked.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent glaziers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about damaged double-glazed glass replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>A crack in either sheet of the double-glazed unit, whether from impact or another cause.</li>\n<li>Shattered glass, loose fragments or a damaged opening following an attempted break-in.</li>\n<li>Damaged glazed door panels or large fixed panes needing safe handling.</li>\n<li>A replacement that must match privacy patterns or provide suitable safety or acoustic performance.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>Keep people and pets away from damaged glazing and avoid pressing, taping or trying to remove it yourself. If the opening is insecure or glass may fall, contact a glazier who can confirm urgent attendance. Our enquiry form does not promise emergency dispatch. Boarding can be a temporary measure while glass is manufactured; ask about a separate charge and a removal visit.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Assess loose glass and the condition of the frame, and agree any temporary making-safe work.|Check the damage and discuss whether boarding is needed before the permanent repair.}</li>\n<li>{Measure the unit and identify safety-glazing needs, privacy patterns and any specialist specification.|Survey the opening and specify suitable glass, including toughened or laminated products where appropriate.}</li>\n<li>{Protect floors and furnishings, isolate the work area and remove damaged glass using suitable equipment.|Plan safe handling and protect the occupied room before removing the damaged sealed unit.}</li>\n<li>{Prepare the rebate, fit compatible packers and install and re-bead the new unit.|Check the frame support and drainage, then fit and secure the made-to-size replacement glass.}</li>\n<li>{Remove agreed boarding, collect glass fragments and test the window or door operation.|Clear the work area and waste, clean the new glass and check closing and locking.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for damaged double-glazed glass replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed glass replacement is <strong>£120–£750</strong>. {A small clear unit and a large laminated door panel involve different material and handling costs.|Size, glass type and safe access can matter as much as the damage itself when the job is priced.} Urgent attendance and temporary boarding may be extra. Request an itemised quote rather than assuming a call-out includes the final glass.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Say whether the opening is secure, where the damaged pane is and which floor it is on. Mention door panels, patterned glass and difficult access. Photographs should be taken from a safe distance. If an insurer is involved, check its evidence and approval requirements before committing to non-urgent work.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask the glazier to explain any suspected cause, such as edge damage or pressure from the frame, so it can be addressed when fitting the new unit. Confirm disposal, replacement-unit warranty and the date for removing temporary boarding.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 2 hours–1 day, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about damaged double-glazed glass replacement.|Before arranging damaged double-glazed glass replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about damaged double-glazed glass replacement|Before booking damaged double-glazed glass replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request damaged double-glazed glass replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Can just the broken sheet of a double-glazed unit be changed?</h3>\n<p>The normal on-site repair replaces the complete sealed unit. It is manufactured as an assembly, so replacing one sheet in place is not the usual way to restore the sealed cavity.</p>\n<h3>Does this service guarantee same-day boarding?</h3>\n<p>No. Availability depends on the responding glazier. If the opening is unsafe or insecure, contact a firm that can confirm urgent attendance directly rather than relying on the enquiry form.</p>\n<h3>Must the new glass always be toughened?</h3>\n<p>The required glazing depends on its location, size and applicable rules. Toughened and laminated safety glass have different properties. Ask the glazier to specify a compliant product for the particular opening.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request damaged double-glazed glass replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can just the broken sheet of a double-glazed unit be changed?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The normal on-site repair replaces the complete sealed unit. It is manufactured as an assembly, so replacing one sheet in place is not the usual way to restore the sealed cavity.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does this service guarantee same-day boarding?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Availability depends on the responding glazier. If the opening is unsafe or insecure, contact a firm that can confirm urgent attendance directly rather than relying on the enquiry form.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Must the new glass always be toughened?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The required glazing depends on its location, size and applicable rules. Toughened and laminated safety glass have different properties. Ask the glazier to specify a compliant product for the particular opening.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request damaged double-glazed glass replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable glaziers covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-glass-replacement": "<article class=\"service-overview\">\n    <h2>What Is Double Glazed Glass Replacement?</h2>\n    <p>Double glazed glass replacement covers repairing windows and doors where the glass itself has been cracked, smashed, chipped or scratched, whether from a stray football, a break-in attempt, a slammed door or thermal stress. Unlike a misted unit, the problem is physical damage, which can leave the property insecure or the glass unsafe to touch. The glazier makes the opening safe, then fits a new sealed unit in the existing frame.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/obscure-safety-glass-bathroom-window-uk.jpg\" alt=\"Obscure replacement glass in a white bathroom window with tiled reveals\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>{Because breakages rarely happen at a convenient time|Since broken glass doesn't wait for a good moment}, many glaziers offer an emergency boarding service so the home is secure until a made-to-measure replacement can be fitted.</p>\n\n    <h2>Signs You Need Glass Replacement</h2>\n    <ul>\n        <li>A crack running across one pane, even if the unit hasn't shattered</li>\n        <li>A star-shaped chip or impact mark from a stone or ball</li>\n        <li>Toughened glass that has crazed into small fragments but is still held in the frame</li>\n        <li>A crack starting from the edge of the glass with no obvious impact, often thermal stress</li>\n        <li>Deep scratches or etching that spoil the view or weaken the surface</li>\n        <li>Damage from an attempted break-in around a lock or handle</li>\n    </ul>\n    <p>Cracked glass and failed seals look different but are easy to confuse. <a href=\"/guides/double-glazing-problems-explained/\">Double glazing problems explained</a> sets out how to tell them apart.</p>\n\n    <h2>Glass Types and Emergency Options Explained</h2>\n    <ul>\n        <li><strong>Emergency boarding.</strong> A temporary board or polycarbonate sheet fixed over the opening while the replacement is made. Ask whether this is charged separately and when it will be removed.</li>\n        <li><strong>Toughened glass.</strong> Heat-treated to be much stronger and to break into small fragments that can still cause injury. Toughened or laminated safety glazing may be needed in critical locations; the correct specification depends on the position and applicable rules.</li>\n        <li><strong>Laminated glass.</strong> Two sheets bonded with an interlayer that holds fragments together when broken. A good choice for security on ground-floor windows and for noise reduction.</li>\n        <li><strong>Obscure and decorative glass.</strong> Patterned or frosted glass for bathrooms, front doors and side lights, available in a range of privacy levels.</li>\n        <li><strong>Like-for-like versus upgrade.</strong> Replacing broken glass is a chance to add laminated security glass or a better energy coating without changing the frame.</li>\n    </ul>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>Say straight away whether the opening is currently secure, whether glass has fallen out, and whether anyone could be hurt by loose fragments. That tells the glazier whether you need boarding the same day. Describe where the break is: an inner or outer pane, a window, a front door panel or a patio door, and which floor it's on. Patio doors and large fixed panes are heavy and may need two people to fit.</p>\n    <p>If the damage followed a break-in or an accident, mention it and let the glazier know whether you plan to claim on home insurance, as some insurers want an itemised quote or photos before work starts. Note whether the broken glass is plain, patterned, leaded or has a sticker or kite mark in the corner that shows it was toughened.</p>\n    <p>The quote should separate any emergency boarding charge from the permanent repair, list the new unit's size and glass specification including which panes are toughened or laminated, and state a timescale for fitting. It should also explain how broken glass will be removed and disposed of, whether the cost includes VAT, and the guarantee on the new unit.</p>\n\n    <h2>How Much Does Double Glazed Glass Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK double glazed glass replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>Small cracked window pane, clear glass</td><td>£120 – £220</td></tr>\n            <tr><td>Door panel or larger pane in toughened or obscure glass</td><td>£220 – £450</td></tr>\n            <tr><td>Patio door unit, or emergency boarding plus replacement</td><td>£450 – £750+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>Out-of-hours call-outs, laminated security glass, very large panes and upper-floor access increase the price. If an insurer is paying, check your excess before deciding whether to claim.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/double-glazed-glass-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The Glass Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Making safe.</strong> Loose shards are removed and the opening is boarded if it cannot be left secure.</li>\n        <li><strong>Measuring.</strong> The glazier measures the unit and confirms the glass type needed for that position.</li>\n        <li><strong>Ordering.</strong> The replacement unit is made to size, typically within a few days to two weeks.</li>\n        <li><strong>Removal.</strong> The damaged unit is taken out carefully, with protective sheets down to catch fragments.</li>\n        <li><strong>Glazing.</strong> The new unit is packed and beaded in, and the window or door is checked for smooth operation.</li>\n        <li><strong>Clean-up.</strong> Boarding and broken glass are removed and the area is checked for splinters.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>Putting new glass into an existing frame is normally a repair, so planning permission and building regulations notification aren't usually required. The replacement must still be safety glass wherever the regulations call for it, typically in and around doors and in panes close to floor level, so don't let a broken toughened panel be replaced with ordinary float glass. Listed buildings may need consent before historic glass is changed.</p>\n\n    <h2>How to Choose a Glazier for Broken Glass</h2>\n    <ul>\n        <li>Can they board up the same day, and what does that cost?</li>\n        <li>Will they confirm which panes need toughened or laminated glass?</li>\n        <li>Can they provide an itemised quote suitable for an insurance claim?</li>\n        <li>How quickly can the permanent unit be made and fitted?</li>\n        <li>Do they take away the broken glass and boarding?</li>\n        <li>What guarantee comes with the new unit?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>Can I leave a cracked double glazed pane until later?</h3>\n    <p>A crack can spread, and its safety cannot be judged reliably from appearance alone. Keep people and pets away, avoid touching or taping the glass, and ask a glazier to assess it promptly.</p>\n    <h3>Is broken double glazing covered by home insurance?</h3>\n    <p>Many buildings policies cover accidental or malicious breakage, sometimes subject to an excess or accidental damage cover. Check your policy wording before booking the work.</p>\n    <h3>Why did my glass crack on its own?</h3>\n    <p>Thermal stress is a common cause: uneven heating from sun, blinds or radiators can crack glass from the edge. Tight fitting without proper packers can also put pressure on the pane.</p>\n    <h3>Should I choose laminated glass after a break-in?</h3>\n    <p>Laminated glass holds together when struck, which makes it harder to get through quickly. It is worth considering for ground-floor windows and door panels that face away from the street.</p>\n    \n\n    <p>Broken glass to sort out? <a href=\"/free-quotes/\">Describe the damage</a> and up to four local glaziers may get in touch.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I leave a cracked double glazed pane until later?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"A crack can spread, and its safety cannot be judged reliably from appearance alone. Keep people and pets away, avoid touching or taping the glass, and ask a glazier to assess it promptly.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is broken double glazing covered by home insurance?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Many buildings policies cover accidental or malicious breakage, sometimes subject to an excess or accidental damage cover. Check your policy wording before booking the work.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Why did my glass crack on its own?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Thermal stress is a common cause: uneven heating from sun, blinds or radiators can crack glass from the edge. Tight fitting without proper packers can also put pressure on the pane.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Should I choose laminated glass after a break-in?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Laminated glass holds together when struck, which makes it harder to get through quickly. It is worth considering for ground-floor windows and door panels that face away from the street.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "double-glazed-window-replacement-county": "<article class=\"double-glazed-window-replacement-county-content\">\n<h2>{Double Glazed Window Replacement across [COUNTY]|Compare complete window replacement quotes across [COUNTY]|Arrange complete window replacement across [COUNTY]}</h2>\n<p>{If your frames are worn out as well as the glass, complete replacement lets you address both together.|New windows can be worth considering when repeated repairs no longer keep the frames weatherproof.|Replacing single glazing or damaged frames starts with a survey of the whole opening.} {A complete replacement removes the old frame and sash before a new made-to-measure window is fixed and sealed into the opening.|Unlike a glass-only repair, this work changes the frame, opening lights and glazing as a complete installation.|The survey covers the new window and the brickwork, cill and internal reveals that surround it.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent window installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about complete window replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Rotten timber rails, failed frame joints or cracked profiles that cannot be economically repaired.</li>\n<li>Persistent draughts after sensible hinge, gasket and locking adjustments have been considered.</li>\n<li>Single glazing or poorly performing older windows, with a wish to improve comfort.</li>\n<li>Opening styles that no longer meet household needs, subject to ventilation and escape requirements.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>uPVC, thermally broken aluminium and engineered timber have different costs and maintenance needs. Ask for the whole-window U-value or energy rating. Low-E coatings, gas fill and warm-edge spacers are useful specification details, but the frame and fitting also matter. For road noise, request acoustic performance figures for the proposed system rather than assuming triple glazing is automatically quieter.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Survey every opening, including bay angles, frame support, cills and the condition of lintels and reveals.|Measure flat windows and bays separately and check whether surrounding masonry needs attention before fitting.}</li>\n<li>{Agree frame material, opening direction, glass, colour, handles and ventilation in a written window schedule.|Record the product specification for each room, including safety glass and any required escape opening.}</li>\n<li>{Protect floors and furniture, arrange safe access and remove the old glazing and frames in a planned sequence.|Set out dust protection and an access plan before taking out existing frames and preparing the openings.}</li>\n<li>{Pack, mechanically fix and seal the new frames, then glaze and adjust each opener.|Install the new windows square and level using the system requirements, then check locks and weather seals.}</li>\n<li>{Complete agreed reveal repairs, collect old frames and demonstrate handles, restrictors and vents.|Remove waste, finish the agreed trims and cills, and explain operation and maintenance at handover.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for complete window replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed window replacement is <strong>£550–£12,000</strong>. {The lower figure relates to one straightforward window; a multi-window order takes the budget much further.|This range spans a single standard window through to a larger installation, not a fixed whole-house package.} Bays, timber or aluminium frames, coloured finishes, structural repairs and difficult access can raise the total beyond it.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Count complete windows and identify bays, stone mullions, tiled cills and upper-floor openings over roofs. Say whether you want to replace every window or work in stages. The surveyor should confirm manufacturing sizes and any temporary support requirements.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>For complete replacement windows, confirm the applicable energy, ventilation, safety-glazing and escape provisions with the installer. In England and Wales, an appropriate competent person scheme or building control can provide the compliance route; Scotland and Northern Ireland have separate arrangements. See <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a>. A registered scheme is one route, not a blanket requirement to use a particular brand of scheme.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how rooms will be kept weatherproof during the work and which plaster repairs or decoration are excluded. Keep the product schedule, guarantee and compliance documents after completion.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–4 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about complete window replacement.|Before arranging complete window replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about complete window replacement|Before booking complete window replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request complete window replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent window installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Must every window be replaced at once?</h3>\n<p>No. You can ask for a phased order, for example one elevation first. Discuss how later frames, colours and sightlines can be matched and how separate visits affect the price.</p>\n<h3>Can I keep the frame if only the glass has failed?</h3>\n<p>Often, yes. A glazier should check the frame, sash and hardware before recommending a sealed-unit replacement. A foggy pane alone does not mean the complete window must be removed.</p>\n<h3>Does triple glazing always block more noise?</h3>\n<p>No. Noise reduction depends on pane thicknesses, cavity widths, acoustic layers, frame seals and ventilation openings. Ask for performance evidence for the proposed complete system.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request complete window replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent window installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Must every window be replaced at once?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. You can ask for a phased order, for example one elevation first. Discuss how later frames, colours and sightlines can be matched and how separate visits affect the price.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I keep the frame if only the glass has failed?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Often, yes. A glazier should check the frame, sash and hardware before recommending a sealed-unit replacement. A foggy pane alone does not mean the complete window must be removed.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does triple glazing always block more noise?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Noise reduction depends on pane thicknesses, cavity widths, acoustic layers, frame seals and ventilation openings. Ask for performance evidence for the proposed complete system.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request complete window replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable window installers covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-window-replacement-town": "<article class=\"double-glazed-window-replacement-town-content\">\n<h2>{Double Glazed Window Replacement in [TOWN]|Compare complete window replacement quotes in [TOWN]|Arrange complete window replacement in [TOWN]}</h2>\n<p>{If your frames are worn out as well as the glass, complete replacement lets you address both together.|New windows can be worth considering when repeated repairs no longer keep the frames weatherproof.|Replacing single glazing or damaged frames starts with a survey of the whole opening.} {A complete replacement removes the old frame and sash before a new made-to-measure window is fixed and sealed into the opening.|Unlike a glass-only repair, this work changes the frame, opening lights and glazing as a complete installation.|The survey covers the new window and the brickwork, cill and internal reveals that surround it.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent window installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about complete window replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Rotten timber rails, failed frame joints or cracked profiles that cannot be economically repaired.</li>\n<li>Persistent draughts after sensible hinge, gasket and locking adjustments have been considered.</li>\n<li>Single glazing or poorly performing older windows, with a wish to improve comfort.</li>\n<li>Opening styles that no longer meet household needs, subject to ventilation and escape requirements.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>uPVC, thermally broken aluminium and engineered timber have different costs and maintenance needs. Ask for the whole-window U-value or energy rating. Low-E coatings, gas fill and warm-edge spacers are useful specification details, but the frame and fitting also matter. For road noise, request acoustic performance figures for the proposed system rather than assuming triple glazing is automatically quieter.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Survey every opening, including bay angles, frame support, cills and the condition of lintels and reveals.|Measure flat windows and bays separately and check whether surrounding masonry needs attention before fitting.}</li>\n<li>{Agree frame material, opening direction, glass, colour, handles and ventilation in a written window schedule.|Record the product specification for each room, including safety glass and any required escape opening.}</li>\n<li>{Protect floors and furniture, arrange safe access and remove the old glazing and frames in a planned sequence.|Set out dust protection and an access plan before taking out existing frames and preparing the openings.}</li>\n<li>{Pack, mechanically fix and seal the new frames, then glaze and adjust each opener.|Install the new windows square and level using the system requirements, then check locks and weather seals.}</li>\n<li>{Complete agreed reveal repairs, collect old frames and demonstrate handles, restrictors and vents.|Remove waste, finish the agreed trims and cills, and explain operation and maintenance at handover.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for complete window replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for double glazed window replacement is <strong>£550–£12,000</strong>. {The lower figure relates to one straightforward window; a multi-window order takes the budget much further.|This range spans a single standard window through to a larger installation, not a fixed whole-house package.} Bays, timber or aluminium frames, coloured finishes, structural repairs and difficult access can raise the total beyond it.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>Count complete windows and identify bays, stone mullions, tiled cills and upper-floor openings over roofs. Say whether you want to replace every window or work in stages. The surveyor should confirm manufacturing sizes and any temporary support requirements.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>For complete replacement windows, confirm the applicable energy, ventilation, safety-glazing and escape provisions with the installer. In England and Wales, an appropriate competent person scheme or building control can provide the compliance route; Scotland and Northern Ireland have separate arrangements. See <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a>. A registered scheme is one route, not a blanket requirement to use a particular brand of scheme.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how rooms will be kept weatherproof during the work and which plaster repairs or decoration are excluded. Keep the product schedule, guarantee and compliance documents after completion.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–4 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about complete window replacement.|Before arranging complete window replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about complete window replacement|Before booking complete window replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request complete window replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent window installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Must every window be replaced at once?</h3>\n<p>No. You can ask for a phased order, for example one elevation first. Discuss how later frames, colours and sightlines can be matched and how separate visits affect the price.</p>\n<h3>Can I keep the frame if only the glass has failed?</h3>\n<p>Often, yes. A glazier should check the frame, sash and hardware before recommending a sealed-unit replacement. A foggy pane alone does not mean the complete window must be removed.</p>\n<h3>Does triple glazing always block more noise?</h3>\n<p>No. Noise reduction depends on pane thicknesses, cavity widths, acoustic layers, frame seals and ventilation openings. Ask for performance evidence for the proposed complete system.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request complete window replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent window installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Must every window be replaced at once?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. You can ask for a phased order, for example one elevation first. Discuss how later frames, colours and sightlines can be matched and how separate visits affect the price.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I keep the frame if only the glass has failed?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Often, yes. A glazier should check the frame, sash and hardware before recommending a sealed-unit replacement. A foggy pane alone does not mean the complete window must be removed.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does triple glazing always block more noise?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Noise reduction depends on pane thicknesses, cavity widths, acoustic layers, frame seals and ventilation openings. Ask for performance evidence for the proposed complete system.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request complete window replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable window installers covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "double-glazed-window-replacement": "<article class=\"service-overview\">\n    <h2>What Is Double Glazed Window Replacement?</h2>\n    <p>Double glazed window replacement means removing complete window frames, sashes and glass and fitting new made-to-measure windows in the same openings. It is a bigger job than swapping a pane: the old frame comes out of the brickwork, the new one is fixed, packed and sealed, and the reveals and sills are made good inside and out. Most homeowners consider it when their existing windows are original single glazing, early double glazing from the 1980s or 1990s, or timber frames that have started to rot.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/new-timber-double-glazed-casement-windows-uk.jpg\" alt=\"Cream timber double-glazed casement windows fitted into red-brick openings\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>{The decision usually comes down to|What tips most people towards full replacement is} whether the frames themselves are still worth keeping. If the hinges, locks and profiles are sound and only the glass has failed, a sealed unit swap is far cheaper. If the frames are beyond repair, full replacement can provide improved energy performance and modern locking. Ask the installer to assess repairable faults first and confirm the compliance paperwork for a complete replacement.</p>\n\n    <h2>Signs Your Windows Need Replacing</h2>\n    <ul>\n        <li>Several frames let in noticeable draughts even when shut and locked</li>\n        <li>Timber sills or bottom rails are soft, split or show rot when pressed</li>\n        <li>Old uPVC has discoloured, gone brittle or the corner welds have cracked</li>\n        <li>Casements have dropped on their hinges and have to be lifted to close</li>\n        <li>Windows still have single glazing, or double glazing with wide aluminium spacer bars from decades ago</li>\n        <li>Espagnolette locks are worn and spare parts for the old hardware are no longer made</li>\n        <li>Upstairs bedroom windows are too small or awkward to use as an escape route in a fire</li>\n    </ul>\n    <p>Not sure the frames are beyond saving? Our <a href=\"/guides/signs-your-double-glazing-needs-replacing/\">checklist of signs your double glazing needs replacing</a> helps you score each window, and <a href=\"/guides/double-glazing-problems-explained/\">double glazing problems explained</a> covers faults that only need a glass swap. Buying a house with tired windows? See <a href=\"/guides/buying-a-house-with-old-double-glazing/\">what to check before you complete</a>.</p>\n\n    <h2>Window Materials and Styles Explained</h2>\n    <p>Replacement double glazing is available in three main frame materials, and each suits different homes and budgets:</p>\n    <ul>\n        <li><strong>uPVC.</strong> The most common and usually the least expensive. Multi-chambered profiles insulate well, need little upkeep and come in white, cream, grey and woodgrain foils.</li>\n        <li><strong>Aluminium.</strong> Slimmer sightlines and larger glass areas, popular for modern houses and extensions. Look for a thermally broken profile so the frame doesn't become a cold bridge.</li>\n        <li><strong>Timber.</strong> Often preferred or required for period properties and conservation areas. Engineered, factory-finished timber lasts far longer than older softwood but costs more and needs periodic redecoration.</li>\n    </ul>\n    <p>Within each material you can choose side-hung or top-hung casements, tilt-and-turn windows that open inwards for cleaning, vertical sliding sash replicas, and bay or bow window assemblies. Glass options include low-emissivity coatings, argon gas fill, warm-edge spacer bars and, for noisy roads, acoustic laminated glass. Triple glazing is available but adds weight and cost, so ask whether the extra performance is worth it for your elevation.</p>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>Count the openings and note the type of each one (a flat casement, a three-sided bay, a bow, a small landing window or a large fixed pane), because bays and bows are priced very differently from flat frames. Say which rooms they serve and whether any are upstairs bedrooms, as those may need escape-compliant openings. Mention if the house has stone mullions, rendered reveals, internal timber boards or tiled sills that could be disturbed when the old frames come out.</p>\n    <p>Tell the installer what you want to change rather than just \"new windows\": better sound insulation towards a road, a different opening style, a colour or woodgrain finish, or a sash look to suit a period terrace. If the house is in a conservation area or is a flat, say so up front because it affects which products can be offered.</p>\n    <p>A good written quote should list every window with its size, style, frame material and glass specification, including the U-value or energy rating. It should state whether trickle vents are included, who will register the work with building control or a competent person scheme, how the old frames will be disposed of, what making good inside and out is covered, and how long the frame, glass units and hardware are guaranteed for.</p>\n\n    <h2>How Much Does Double Glazed Window Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK double glazed window replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>Single standard casement window</td><td>£550 – £1,200</td></tr>\n            <tr><td>Several windows or a bay (3–5 openings)</td><td>£2,000 – £5,500</td></tr>\n            <tr><td>Larger window order; premium frames and more openings can exceed this guide</td><td>£5,500 – £12,000+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>These are guide figures for supply and fitting. Frame material has the biggest effect: uPVC sits at the lower end, while aluminium and engineered timber push towards the top of the range. Bays, large fixed panes, coloured finishes, acoustic glass and difficult access all add to the price.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/double-glazed-window-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The Window Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Survey.</strong> The installer measures every opening precisely, checks the condition of the brickwork and lintels, and confirms styles, colours and glass.</li>\n        <li><strong>Manufacture.</strong> Windows are made to order. Lead times are often several weeks, and longer for timber or non-standard colours.</li>\n        <li><strong>Removal.</strong> On fitting day the old sashes and glass are taken out first, then the frames are cut out, working one or two openings at a time so the house isn't left open.</li>\n        <li><strong>Installation.</strong> Each new frame is positioned, packed, fixed into the reveals and checked for level and square before the glass is fitted.</li>\n        <li><strong>Sealing and finishing.</strong> The outside is sealed, internal trims or plaster repairs are completed, and cills are fitted.</li>\n        <li><strong>Handover.</strong> Locks and handles are demonstrated, keys handed over, and the building regulations certificate follows once the work is registered.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>Replacing windows in a house with new ones of a similar appearance is usually permitted development, so planning permission is not normally needed. Listed buildings, homes in conservation areas or under an Article 4 direction, and flats can be different, and leaseholders may also need consent from the freeholder. The <a href=\"https://www.planningportal.co.uk/permission/common-projects/doors-and-windows/planning-permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal guidance on doors and windows</a> covers the main points for England.</p>\n    <p>Building regulations are a separate matter. Whole replacement windows in England and Wales are controlled work: they must meet thermal performance standards, keep or improve ventilation and escape routes, and use safety glass in critical locations. The simplest route is an installer registered with a competent person scheme such as <a href=\"https://www.fensa.org.uk/\" target=\"_blank\" rel=\"nofollow noopener\">FENSA</a>, who can self-certify the job; otherwise building control must be notified. Scotland and Northern Ireland have their own systems, so check locally.</p>\n\n    <h2>How to Choose a Window Replacement Installer</h2>\n    <ul>\n        <li>Is the company registered with a competent person scheme, and will you receive the certificate?</li>\n        <li>Is the guarantee insurance-backed if the firm stops trading?</li>\n        <li>Who manufactures the frames and sealed units, and what energy rating do they carry?</li>\n        <li>Will the same team survey and fit, or is installation subcontracted?</li>\n        <li>How will upstairs escape windows and trickle vents be handled?</li>\n        <li>What deposit is required, and when is the balance due?</li>\n        <li>Can you see recent jobs on similar houses nearby?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>Can I replace just some of my windows?</h3>\n    <p>Yes. Many people replace the worst elevations first. Ask the installer to match the profile, colour and sightlines to your existing frames so a mixed set still looks consistent from the street.</p>\n    <h3>Will new windows stop condensation?</h3>\n    <p>They usually reduce condensation on the glass because the inner pane stays warmer, but a tighter house can trap more moisture in the air. Keep trickle vents open and use extractor fans in kitchens and bathrooms.</p>\n    <h3>How much mess does window replacement make?</h3>\n    <p>Some plaster around the reveals can crack when old frames are cut out, and there is dust at each opening. A careful installer covers floors and furniture and makes good the reveals, but decoration afterwards is usually your responsibility.</p>\n    <h3>Is triple glazing worth it over double glazing?</h3>\n    <p>For most UK homes, a good double glazed window with low-emissivity glass and warm-edge spacers performs well. Triple glazing adds cost and weight, and its value depends on the proposed whole-window performance. For noise, compare tested acoustic performance: an extra pane alone does not guarantee better sound reduction.</p>\n    \n\n    <p>Ready to compare prices? <a href=\"/free-quotes/\">Send one free enquiry</a> and up to four local window installers may be in touch to arrange a survey.</p>\n\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I replace just some of my windows?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Many people replace the worst elevations first. Ask the installer to match the profile, colour and sightlines to your existing frames so a mixed set still looks consistent from the street.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will new windows stop condensation?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"They usually reduce condensation on the glass because the inner pane stays warmer, but a tighter house can trap more moisture in the air. Keep trickle vents open and use extractor fans in kitchens and bathrooms.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How much mess does window replacement make?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Some plaster around the reveals can crack when old frames are cut out, and there is dust at each opening. A careful installer covers floors and furniture and makes good the reveals, but decoration afterwards is usually your responsibility.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is triple glazing worth it over double glazing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"For most UK homes, a good double glazed window with low-emissivity glass and warm-edge spacers performs well. Triple glazing adds cost and weight, and its value depends on the proposed whole-window performance. For noise, compare tested acoustic performance: an extra pane alone does not guarantee better sound reduction.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "free-quotes": "<article class=\"free-quotes-content\">\n<h2>Tell us what needs changing and compare the options</h2>\n<p>Use one online enquiry for replacement windows, glazed doors or new glass in existing frames. Double Glazing Quotes can match the request with up to four independent local specialists. Responses depend on the job and who covers your postcode, so you may receive fewer than four quotations.</p>\n<p>The enquiry is free for homeowners, with no obligation to order. We do not measure, supply or install the products. The company you choose is responsible for its advice, quotation and work. Businesses joining the network are asked for relevant insurance details and references; check current documents before appointing one.</p>\n<img src=\"/sites/double-glazing-quotes-co-uk/images/comparing-window-frame-glass-options-uk.jpg\" alt=\"Homeowner comparing white and grey window frame samples at a kitchen table\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n<h2>Give the installer a useful starting point</h2>\n<ul>\n<li>Count whole windows, individual glass units and doors separately. A three-pane window can need one new unit rather than three.</li>\n<li>Say whether the existing frames are uPVC, timber or aluminium, and describe any rot, damaged hinges or locking problems.</li>\n<li>List bays, sash windows, large fixed panes, side panels and patio doors, since their sizes and fitting requirements differ.</li>\n<li>Mention your preferred frame finish and any privacy, acoustic or solar-control glass.</li>\n<li>Describe access: floor level, a conservatory below, narrow passages, parking restrictions and occupied rooms.</li>\n<li>Include listed-building status, conservation restrictions or leasehold permissions that may affect the order.</li>\n</ul>\n<p>Rough measurements and photographs taken safely from inside are enough for an initial conversation. Do not remove glazing beads or lean out to measure. The installer needs to take the manufacturing dimensions.</p>\n<h2>Indicative UK glazing costs</h2>\n<p>These are broad supply-and-fitting budgets for the six services, rather than local averages or fixed offers. Read the scope beside each figure: some ranges run from a single item to a larger order. Misted and blown unit replacement often cover the same fault and should not be added together.</p>\n<div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative glazing prices\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\">\n<table style=\"min-width:560px;\">\n<caption>Indicative UK replacement glazing costs and common hardware repairs</caption>\n<thead><tr><th scope=\"col\">Service or related work</th><th scope=\"col\">Guide range</th><th scope=\"col\">What the range covers</th></tr></thead>\n<tbody>\n<tr><th scope=\"row\">Double Glazed Window Replacement</th><td>£550–£12,000</td><td>One complete window at the lower end; several openings or a typical whole-house scheme at the upper end. Premium materials and larger homes can exceed this range.</td></tr>\n<tr><th scope=\"row\">Misted Double Glazing Replacement</th><td>£80–£450</td><td>A small standard sealed unit through to a larger pane or a modest group of straightforward units. Frames retained; confirm the pane count.</td></tr>\n<tr><th scope=\"row\">Blown Double Glazed Unit Replacement</th><td>£100–£900</td><td>A simple failed unit through to several units, specialist glass or more difficult access. Not an additional charge on top of misted-unit replacement.</td></tr>\n<tr><th scope=\"row\">Double Glazed Glass Replacement</th><td>£120–£750</td><td>A damaged small unit through to larger safety-glass panels or more involved replacement. Ask for urgent attendance and boarding to be itemised.</td></tr>\n<tr><th scope=\"row\">uPVC Window Replacement</th><td>£400–£8,000</td><td>One basic white casement through to a typical multi-window order. Coloured sash styles, bays and larger houses can cost more.</td></tr>\n<tr><th scope=\"row\">Double Glazed Door Replacement</th><td>£900–£4,000</td><td>A basic fitted doorset through to French, composite or patio configurations. Side panels, size and specification can take a project beyond this range.</td></tr>\n<tr><th scope=\"row\">Window hinge replacement</th><td>£60–£150</td><td>A straightforward hinge repair to one accessible opener, including fitting; specialist hardware or a separate call-out can cost more.</td></tr>\n<tr><th scope=\"row\">Window handle replacement</th><td>£50–£100</td><td>One standard compatible handle fitted. An internal locking gearbox is a different repair and needs its own price.</td></tr>\n</tbody></table></div>\n<p>These are indicative figures, not a guaranteed maximum. Confirm VAT where applicable, minimum visit charges, surveys, old-glass disposal, access equipment and making good in the written total. Related repairs only add to the bill if they are needed and not already included.</p>\n<p>For comparison, published <a href=\"https://www.checkatrade.com/blog/cost-guides/window-glass-replacement-cost/\" target=\"_blank\" rel=\"nofollow noopener\">glass replacement prices</a>, <a href=\"https://www.checkatrade.com/blog/cost-guides/double-glazing-cost/\" target=\"_blank\" rel=\"nofollow noopener\">window installation budgets</a> and <a href=\"https://www.checkatrade.com/blog/cost-guides/window-hinge-repair-cost/\" target=\"_blank\" rel=\"nofollow noopener\">hinge repair estimates</a> illustrate how scope changes the price. A <a href=\"https://ashtondoorandlock.co.uk/windows/handles\" target=\"_blank\" rel=\"nofollow noopener\">published fitted handle price</a> provides a further repair comparison. These are cross-checks, not quotations for your property.</p>\n<h2>Why the final price can change</h2>\n<p>Unit dimensions, frame material, opening style and the number of items matter more than the number of rooms. Plain white uPVC is commonly less expensive than bespoke timber, aluminium or foiled sash designs. Safety glass, acoustic laminates, decorative bars and non-standard shapes also affect manufacturing costs.</p>\n<p>On site, the condition of the opening and safe access can change the labour needed. A heavy patio unit may require an extra pair of hands; an upper-floor opening over a glazed roof may require access equipment. Travel, parking and regional labour rates affect small repairs particularly. Structural alterations and major plaster repairs should be priced separately.</p>\n<h2>Ask for a quotation you can compare line by line</h2>\n<p>Request a schedule showing every opening, the frame system and colour, glass specification, locks and handles, ventilation provision and whole-window or doorset performance. Check whether old frames are completely removed and whether window boards, external cills and internal trims are included.</p>\n<p>For complete replacements, agree the building-control or applicable self-certification route. For a unit swap, confirm that the existing frame is suitable and that the replacement glass meets the requirements for its position. Compare the manufacturer's guarantee with the installer's workmanship cover and ask who deals with a failed seal later.</p>\n<h2>Before confirming the order</h2>\n<p>Get the survey, manufacturing lead time and expected fitting duration separately. Check opening directions, obscure patterns and colours before approving a made-to-measure order. Agree deposits, stage payments and cancellation terms in writing; do not assume every glazing order has the same cooling-off rights. Read <a href=\"https://www.citizensadvice.org.uk/consumer/changed-your-mind/cancelling-a-service-youve-arranged/\" target=\"_blank\" rel=\"nofollow noopener\">Citizens Advice on cancelling a service</a> and ask how the terms apply to your particular supply-and-install contract.</p>\n<h2>Questions homeowners ask</h2>\n<h3>Can I compare a repair with complete window replacement?</h3>\n<p>Yes. Explain that you want both options assessed. A repair quote should name the units or hardware being changed; a replacement quote should include the complete frames and associated finishing work.</p>\n<h3>Is the lowest figure in the table a whole-house price?</h3>\n<p>No. The lower end of the window ranges relates to one basic window. Whole-house totals depend on the number, dimensions and specification of all the openings.</p>\n<h3>Does sending the form book an installer?</h3>\n<p>No. It starts an enquiry. Arrange any survey, charges, order and fitting appointment directly with the responding firm after you have reviewed its terms.</p>\n<h3>Can I stop after receiving the quotations?</h3>\n<p>Yes. You can decide that the timing, specification or price is unsuitable and decline the offers. Receiving a quote does not itself place an order.</p>\n\n<p>Ready to enquire? Include your postcode and a short description of the windows, doors or panes involved in the form.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I compare a repair with complete window replacement?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Explain that you want both options assessed. A repair quote should name the units or hardware being changed; a replacement quote should include the complete frames and associated finishing work.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Is the lowest figure in the table a whole-house price?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. The lower end of the window ranges relates to one basic window. Whole-house totals depend on the number, dimensions and specification of all the openings.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does sending the form book an installer?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. It starts an enquiry. Arrange any survey, charges, order and fitting appointment directly with the responding firm after you have reviewed its terms.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I stop after receiving the quotations?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. You can decide that the timing, specification or price is unsuitable and decline the offers. Receiving a quote does not itself place an order.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "home": "<article class=\"home-content\">\n<h2>New windows, clearer glass or a door that closes properly</h2>\n<p>A cloudy kitchen pane and a draughty set of bedroom windows need different solutions. Double Glazing Quotes gives you a place to describe either job and ask local glazing businesses for a price. You can request help with one opening, several failed units or a larger window and door project.</p>\n<p>Complete one free online enquiry to be matched with up to four independent specialists, subject to the services they offer and availability in your area. Four quotations are not guaranteed, and you can decline any offer. We introduce you to firms; we do not supply the products, employ their fitters or install the glazing.</p>\n<img src=\"/sites/double-glazing-quotes-co-uk/images/replacement-double-glazed-windows-brick-home-uk.jpg\" alt=\"White replacement casement windows on a red-brick semi-detached house\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n<h2>Choose the work you need</h2>\n<ul><li><a href=\"/double-glazed-window-replacement/\">Double Glazed Window Replacement</a>: complete frames and glazing in timber, aluminium or uPVC, with a survey of the openings and surrounding finishes.</li>\n<li><a href=\"/misted-double-glazing-replacement/\">Misted Double Glazing Replacement</a>: cloudy glass units replaced while suitable frames stay in place, including matching patterned bathroom panes.</li>\n<li><a href=\"/blown-double-glazed-unit-replacement/\">Blown Double Glazed Unit Replacement</a>: made-to-size units for failed edge seals, with compatible low-E glass and warm-edge spacer options.</li>\n<li><a href=\"/double-glazed-glass-replacement/\">Double Glazed Glass Replacement</a>: damaged sealed units replaced with the appropriate clear, obscure, toughened or laminated glass.</li>\n<li><a href=\"/upvc-window-replacement/\">uPVC Window Replacement</a>: new casement, tilt-and-turn, flush or sliding sash windows, with colours and hardware chosen for each room.</li>\n<li><a href=\"/double-glazed-door-replacement/\">Double Glazed Door Replacement</a>: front and back doors, French doors and sliding patio doors, including the frame, locks and threshold.</li></ul>\n<h2>Check whether the frame can stay</h2>\n<p>Moisture trapped between the panes usually points to a failed sealed unit. If the frame, opening sash and hardware remain serviceable, a glazier can often replace that unit alone. Misted glazing and blown units are overlapping descriptions of this problem, so you do not need to submit two enquiries for the same pane.</p>\n<p>A draught is different. It can come from worn weather seals, a loose hinge, a dropped sash or a gap around the frame. Ask whether adjustment or a hardware repair would solve it. New glass will not straighten a warped frame or repair rotten timber.</p>\n<p>When frames are beyond repair, full replacement lets you reconsider opening styles and materials. A bay needs careful surveying and support checks; an inward-opening tilt-and-turn window needs room to open past blinds and furniture. These details belong in the survey, not as surprises on fitting day.</p>\n<h2>Choose the glass for the room</h2>\n<p>Low-emissivity coatings, an insulating gas fill and suitable spacer bars can improve thermal performance. Compare the performance of the complete window, rather than a glass-only figure presented as the rating for the whole product. For road noise, ask about a tested acoustic specification: an extra pane alone does not tell you how much sound it will reduce.</p>\n<p>Bathrooms may need obscure glass, while exposed glazed doors and low panes may need safety glazing. Toughened and laminated products do different jobs, and the installer should specify an appropriate product for its position. Large south-facing panes may also benefit from a discussion about solar gain and shading.</p>\n<h2>From enquiry to fitting</h2>\n<ol>\n<li>Tell us your postcode, the number of windows or doors and the problem you want to resolve.</li>\n<li>Responding businesses can discuss photos and arrange a measuring visit. Mention awkward access over an extension or conservatory.</li>\n<li>Compare written quotations that list frames, glass, hardware, ventilation, finishes, disposal and applicable certification.</li>\n<li>Agree the order and installation dates with your chosen firm. Made-to-measure products need manufacturing time before the fitting visit.</li>\n</ol>\n<p>Companies joining the network are asked for relevant insurance details and references. Before ordering, check the firm's current insurance, recent installations and guarantee terms yourself.</p>\n<h2>Ventilation, permissions and finishing</h2>\n<p>New frames can make a room more airtight. The survey should address background ventilation, existing extract fans and any escape opening that must be retained. <a href=\"https://www.gov.uk/government/publications/ventilation-approved-document-f\" target=\"_blank\" rel=\"nofollow noopener\">Approved Document F for England</a> sets out ventilation guidance; the applicable requirements depend on the work and the rules in force for it.</p>\n<p>For complete replacements, ask how building regulations compliance will be documented in your UK nation. If the home is listed, subject to local planning restrictions or leasehold, check consents before ordering. Start with the <a href=\"https://www.planningportal.co.uk/permission/common-projects/doors-and-windows/planning-permission\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal guidance for England</a> for its area of coverage, or your local authority elsewhere.</p>\n<p>Removal can disturb plaster, tiles, blinds and window boards. Agree which surfaces the fitter will make good and which decoration you will arrange. Keep the order, guarantee and any compliance certificate together after handover.</p>\n<h2>Questions homeowners ask</h2>\n<h3>Can I enquire about just one misted pane?</h3>\n<p>Yes. Give the room, floor and approximate pane size. A glazier may have a minimum visit charge, so ask for the full fitted price rather than a glass-only supply price.</p>\n<h3>Will replacement glazing stop all condensation?</h3>\n<p>No. Moisture between the panes and condensation on a room-facing surface have different causes. Surface condensation also depends on indoor moisture, ventilation and temperature, so changing the glass alone may not resolve it.</p>\n<h3>What if I need an urgent broken-glass repair?</h3>\n<p>Keep people and pets away from the damaged opening and contact a glazier who confirms urgent attendance directly. This enquiry service does not guarantee an emergency response or same-day boarding.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I enquire about just one misted pane?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Give the room, floor and approximate pane size. A glazier may have a minimum visit charge, so ask for the full fitted price rather than a glass-only supply price.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will replacement glazing stop all condensation?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Moisture between the panes and condensation on a room-facing surface have different causes. Surface condensation also depends on indoor moisture, ventilation and temperature, so changing the glass alone may not resolve it.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"What if I need an urgent broken-glass repair?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Keep people and pets away from the damaged opening and contact a glazier who confirms urgent attendance directly. This enquiry service does not guarantee an emergency response or same-day boarding.\"\n      }\n    }\n  ]\n}\n</script>\n<p><a href=\"/free-quotes/\">Request your free glazing quotes</a> and explain what would make the biggest difference to your home.</p>\n</article>\n",
    "job-leads": "<article class=\"job-leads-content\">\n<h2>Glazing enquiries that fit the work your business does</h2>\n<p>A two-hour sealed-unit visit and a whole-house window order need different diary space, suppliers and follow-up. Double Glazing Quotes brings in homeowner enquiries for both, alongside glazed doors and damaged glass. Through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"nofollow noopener\">Leads Do Work</a>, you can browse opportunities for the services and areas your business covers.</p>\n<img src=\"/sites/double-glazing-quotes-co-uk/images/glazing-installer-checking-phone-enquiry-uk.jpg\" alt=\"Glazier checking a phone beside a tool case and glass suction lifters\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n<h2>Create an account and review local demand</h2>\n<p>Register a free contractor account, enter your business details and set the relevant trade categories and coverage areas. Companies joining the network are asked for relevant insurance details and references. Use your profile to explain whether you handle glass-only repairs, full installations or both, and include examples of your own completed work.</p>\n<p><a href=\"https://apps.apple.com/gb/app/leadsdowork-for-tradespeople/id1018239423\" target=\"_blank\" rel=\"nofollow noopener\">Download Leads Do Work from the Apple App Store</a>.</p>\n<p><a href=\"https://play.google.com/store/apps/details?id=uk.co.quotatis.quotatisapp\" target=\"_blank\" rel=\"nofollow noopener\">Download Leads Do Work from Google Play</a>.</p>\n<p>You can sign up and browse available enquiries before choosing paid access. Check the account's current prices and conditions before releasing customer details or starting a subscription.</p>\n<h2>Choose services you can survey, supply and fit</h2>\n<ul>\n<li><strong>Replacement windows:</strong> full frame surveys, uPVC, timber or aluminium fabrication, removal, fixing, sealing, making good and the appropriate compliance route.</li>\n<li><strong>uPVC orders:</strong> casements, flush systems, tilt-and-turn and sliding sash designs, with accurate colour and hardware schedules.</li>\n<li><strong>Misted units:</strong> pane counts, thickness checks, pattern matching and glass swaps in serviceable frames.</li>\n<li><strong>Blown units:</strong> edge-seal failure assessment, compatible spacer and coating specifications, drainage checks and re-glazing.</li>\n<li><strong>Damaged glass:</strong> safe assessment, temporary boarding where offered, replacement safety glass and removal of fragments.</li>\n<li><strong>Doors:</strong> front and back doorsets, French doors and patio sliders, including locks, tracks, thresholds and weathering.</li>\n</ul>\n<p>For full replacements, explain whether your business uses an applicable competent person scheme or arranges building control. Do not list emergency attendance unless you can actually provide it. A small repair customer should be able to see whether a minimum call-out applies before a visit is booked.</p>\n<h2>Lead packs and other buying options</h2>\n<p>Check which buying options your account offers. Leads Do Work currently describes individual lead purchases and weekly subscriptions on its public site. If 5, 10 or 20-lead packs are offered in your account, assess them against your measuring and fitting capacity:</p>\n<ul>\n<li><strong>5 leads:</strong> a manageable trial for a sole-trader glazier with time for a few additional surveys.</li>\n<li><strong>10 leads:</strong> more opportunities for a small business that can return measurements and written prices promptly.</li>\n<li><strong>20 leads:</strong> a larger commitment that needs someone available to follow up enquiries while installers are on site.</li>\n</ul>\n<p>These are lead quantities, not numbers of jobs you will win. Confirm current availability, price, VAT, expiry, renewal and any credit policy before purchasing. Include measuring visits, supplier lead times and return fitting visits when deciding how much new work you can take on.</p>\n<h2>Set coverage around the jobs you want</h2>\n<p>A small pane replacement can involve two journeys for a modest invoice. Start with postcodes that make those journeys worthwhile, including parking and travel time. Larger window orders may justify a wider area, provided you can also return for adjustments or aftercare.</p>\n<p>Lead supply varies with homeowner demand and the categories you select. Widening the radius cannot guarantee a full diary. Review which enquiries lead to useful surveys and adjust your settings as your order book changes.</p>\n<h2>Respond with the questions a glazier needs answered</h2>\n<ol>\n<li><strong>Clarify the fault.</strong> Ask whether cloudiness is between the panes, glass is cracked, a sash sticks or the whole frame needs replacing.</li>\n<li><strong>Establish quantities and access.</strong> Count units separately from windows, confirm floor levels and ask about extensions below the opening.</li>\n<li><strong>Request safe photographs.</strong> A view of the full frame and an accessible glass marking can help. Do not ask customers to remove beads or handle damaged glass.</li>\n<li><strong>Arrange measurement.</strong> Explain any visit charge and use your own survey dimensions for manufacturing.</li>\n<li><strong>Issue a clear schedule.</strong> Name the glass make-up, frame system where relevant, locks, vents, finishing, disposal, compliance route and guarantee.</li>\n<li><strong>Agree a follow-up.</strong> Give the customer time to compare specifications and confirm when you will check back.</li>\n</ol>\n<h2>Customer enquiries are opportunities to quote</h2>\n<p>An enquiry may reach up to four suitable companies. Buying access does not guarantee a telephone reply, a survey booking, an accepted quotation or payment for work. The homeowner may choose another business or put the project on hold.</p>\n<p>Your business sets its prices and agrees contracts directly with customers. Double Glazing Quotes does not employ your fitters or carry out the installation. Accurate survey notes, realistic delivery dates and a clear explanation of exclusions help avoid disputes after an order is placed.</p>\n<h2>Contractor account questions</h2>\n<h3>Can a repair-only glazier use the service?</h3>\n<p>Yes. Select relevant glass and sealed-unit categories, state the repairs you undertake and choose a coverage area that works for smaller visits.</p>\n<h3>Are enquiries exclusive to my company?</h3>\n<p>No. Other suitable companies may receive the same enquiry. The customer chooses whether to arrange a visit or accept any quotation.</p>\n<h3>Does buying a larger pack guarantee more installations?</h3>\n<p>No. A larger quantity provides more enquiries to assess, where available. It does not set a conversion rate or guarantee that customers will order.</p>\n<h3>Who specifies and prices the glazing?</h3>\n<p>The responding business does. You assess the opening, agree suitable products with the customer and provide your own survey, quotation and contract.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can a repair-only glazier use the service?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Select relevant glass and sealed-unit categories, state the repairs you undertake and choose a coverage area that works for smaller visits.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Are enquiries exclusive to my company?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Other suitable companies may receive the same enquiry. The customer chooses whether to arrange a visit or accept any quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does buying a larger pack guarantee more installations?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A larger quantity provides more enquiries to assess, where available. It does not set a conversion rate or guarantee that customers will order.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Who specifies and prices the glazing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The responding business does. You assess the opening, agree suitable products with the customer and provide your own survey, quotation and contract.\"\n      }\n    }\n  ]\n}\n</script>\n<p>Use the app links above or visit <a href=\"https://leads.work/\" target=\"_blank\" rel=\"nofollow noopener\">Leads Do Work</a> to create your account and review available glazing enquiries.</p>\n</article>\n",
    "misted-double-glazing-replacement-county": "<article class=\"misted-double-glazing-replacement-county-content\">\n<h2>{Misted Double Glazing Replacement across [COUNTY]|Compare misted glazing replacement quotes across [COUNTY]|Arrange misted glazing replacement across [COUNTY]}</h2>\n<p>{A view that stays cloudy after normal cleaning can point to moisture between the panes.|Fog inside a sealed unit is different from condensation on the room-facing surface.|If one pane keeps misting internally while its neighbours stay clear, ask a glazier to assess that unit.} {The usual repair is a new sealed glass unit inside the existing frame, provided the frame is sound.|A glazier can replace the failed double-glazed unit without taking a serviceable window frame out of the wall.|Replacing the glass unit restores a sealed cavity while retaining suitable frames, sashes and hardware.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent glaziers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about misted glazing replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Cloudiness or droplets inside the cavity that cannot be reached by normal cleaning.</li>\n<li>Persistent streaks left between the panes after trapped moisture dries.</li>\n<li>Several small opening lights or bathroom units becoming foggy over time.</li>\n<li>A wish to replace the affected glass while keeping sound frames and existing decoration.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>First establish which surface carries the moisture. Condensation that wipes off inside a room needs a discussion about moisture, temperature and ventilation; exterior condensation can occur on efficient glass too. Neither observation alone proves that the edge seal has failed. Do not lean out or dismantle a window to investigate.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Check the location of the condensation and inspect the frame, sash and visible seals.|Confirm that moisture is in the cavity before recommending a replacement unit.}</li>\n<li>{Measure the sealed unit accurately and record overall thickness, privacy patterns and decorative bars.|Survey the failed panes and identify glass thickness, pattern orientation and any safety-glazing need.}</li>\n<li>{Order compatible units and agree whether coatings and spacer colours will match adjoining panes.|Specify the new glass within the frame system limits and explain any visible difference from older units.}</li>\n<li>{Protect the room, remove the old units safely and check the glazing rebate and drainage.|Prepare the working area, lift out the failed glass and inspect the support and drainage within the frame.}</li>\n<li>{Fit the new units on appropriate packers, refit beads and gaskets, check the openers and remove waste.|Support and re-bead the replacement glass, clean it and test that the sash still closes and locks.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for misted glazing replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for misted double glazing replacement is <strong>£80–£450</strong>. {A small plain unit is usually cheaper than a large patterned pane or several units ordered together.|The pane count, dimensions and glass specification explain much of the difference within this range.} Ask whether the price includes both measuring and fitting visits. Minimum call-outs and outside access can change the total.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>List each cloudy pane by room and floor. Mention obscure glass, Georgian bars and any existing guarantee. A safe photograph of the complete window helps the glazier distinguish a small top light from a larger fixed unit.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Keep accessible drainage outlets clear in line with the frame maker's instructions and report loose beads or seals. Ask what the new unit guarantee covers. Drying or drilling a failed unit is not equivalent to supplying a new factory-sealed unit, so compare the proposed remedy carefully.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–3 hours, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about misted glazing replacement.|Before arranging misted glazing replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about misted glazing replacement|Before booking misted glazing replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request misted glazing replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Will new sealed units cure condensation inside the room?</h3>\n<p>Not necessarily. Room-side condensation depends on moisture levels, ventilation and surface temperature. A replacement sealed unit addresses failure within the glass cavity; other causes need their own assessment.</p>\n<h3>Do all the panes in a window need changing?</h3>\n<p>No. A glazier can often replace only the failed unit. Ask about matching glass patterns, spacer colours and reflections if other units will stay in the frame.</p>\n<h3>Can I have a misted pane dried out instead?</h3>\n<p>Some firms offer drying or de-misting treatments. Ask how the method works and what performance and guarantee it provides, because improving the view is not the same as restoring a factory-made sealed unit.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request misted glazing replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will new sealed units cure condensation inside the room?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not necessarily. Room-side condensation depends on moisture levels, ventilation and surface temperature. A replacement sealed unit addresses failure within the glass cavity; other causes need their own assessment.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Do all the panes in a window need changing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A glazier can often replace only the failed unit. Ask about matching glass patterns, spacer colours and reflections if other units will stay in the frame.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I have a misted pane dried out instead?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Some firms offer drying or de-misting treatments. Ask how the method works and what performance and guarantee it provides, because improving the view is not the same as restoring a factory-made sealed unit.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request misted glazing replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable glaziers covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "misted-double-glazing-replacement-town": "<article class=\"misted-double-glazing-replacement-town-content\">\n<h2>{Misted Double Glazing Replacement in [TOWN]|Compare misted glazing replacement quotes in [TOWN]|Arrange misted glazing replacement in [TOWN]}</h2>\n<p>{A view that stays cloudy after normal cleaning can point to moisture between the panes.|Fog inside a sealed unit is different from condensation on the room-facing surface.|If one pane keeps misting internally while its neighbours stay clear, ask a glazier to assess that unit.} {The usual repair is a new sealed glass unit inside the existing frame, provided the frame is sound.|A glazier can replace the failed double-glazed unit without taking a serviceable window frame out of the wall.|Replacing the glass unit restores a sealed cavity while retaining suitable frames, sashes and hardware.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent glaziers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about misted glazing replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Cloudiness or droplets inside the cavity that cannot be reached by normal cleaning.</li>\n<li>Persistent streaks left between the panes after trapped moisture dries.</li>\n<li>Several small opening lights or bathroom units becoming foggy over time.</li>\n<li>A wish to replace the affected glass while keeping sound frames and existing decoration.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>First establish which surface carries the moisture. Condensation that wipes off inside a room needs a discussion about moisture, temperature and ventilation; exterior condensation can occur on efficient glass too. Neither observation alone proves that the edge seal has failed. Do not lean out or dismantle a window to investigate.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Check the location of the condensation and inspect the frame, sash and visible seals.|Confirm that moisture is in the cavity before recommending a replacement unit.}</li>\n<li>{Measure the sealed unit accurately and record overall thickness, privacy patterns and decorative bars.|Survey the failed panes and identify glass thickness, pattern orientation and any safety-glazing need.}</li>\n<li>{Order compatible units and agree whether coatings and spacer colours will match adjoining panes.|Specify the new glass within the frame system limits and explain any visible difference from older units.}</li>\n<li>{Protect the room, remove the old units safely and check the glazing rebate and drainage.|Prepare the working area, lift out the failed glass and inspect the support and drainage within the frame.}</li>\n<li>{Fit the new units on appropriate packers, refit beads and gaskets, check the openers and remove waste.|Support and re-bead the replacement glass, clean it and test that the sash still closes and locks.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for misted glazing replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for misted double glazing replacement is <strong>£80–£450</strong>. {A small plain unit is usually cheaper than a large patterned pane or several units ordered together.|The pane count, dimensions and glass specification explain much of the difference within this range.} Ask whether the price includes both measuring and fitting visits. Minimum call-outs and outside access can change the total.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>List each cloudy pane by room and floor. Mention obscure glass, Georgian bars and any existing guarantee. A safe photograph of the complete window helps the glazier distinguish a small top light from a larger fixed unit.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>A sealed-unit swap with the frame retained is normally a repair rather than a full window replacement. It is not normally a FENSA-certificated installation; <a href=\"https://forms.fensa.org.uk/fensa-certificate\" target=\"_blank\" rel=\"nofollow noopener\">FENSA explains what its certificates cover</a>. The glazier still needs to specify suitable safety glazing where the location requires it. Listed buildings and unusual work can need additional checks.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Keep accessible drainage outlets clear in line with the frame maker's instructions and report loose beads or seals. Ask what the new unit guarantee covers. Drying or drilling a failed unit is not equivalent to supplying a new factory-sealed unit, so compare the proposed remedy carefully.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–3 hours, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about misted glazing replacement.|Before arranging misted glazing replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about misted glazing replacement|Before booking misted glazing replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request misted glazing replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Will new sealed units cure condensation inside the room?</h3>\n<p>Not necessarily. Room-side condensation depends on moisture levels, ventilation and surface temperature. A replacement sealed unit addresses failure within the glass cavity; other causes need their own assessment.</p>\n<h3>Do all the panes in a window need changing?</h3>\n<p>No. A glazier can often replace only the failed unit. Ask about matching glass patterns, spacer colours and reflections if other units will stay in the frame.</p>\n<h3>Can I have a misted pane dried out instead?</h3>\n<p>Some firms offer drying or de-misting treatments. Ask how the method works and what performance and guarantee it provides, because improving the view is not the same as restoring a factory-made sealed unit.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request misted glazing replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent glaziers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Will new sealed units cure condensation inside the room?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not necessarily. Room-side condensation depends on moisture levels, ventilation and surface temperature. A replacement sealed unit addresses failure within the glass cavity; other causes need their own assessment.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Do all the panes in a window need changing?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. A glazier can often replace only the failed unit. Ask about matching glass patterns, spacer colours and reflections if other units will stay in the frame.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I have a misted pane dried out instead?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Some firms offer drying or de-misting treatments. Ask how the method works and what performance and guarantee it provides, because improving the view is not the same as restoring a factory-made sealed unit.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request misted glazing replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable glaziers covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "misted-double-glazing-replacement": "<article class=\"service-overview\">\n    <h2>What Is Misted Double Glazing Replacement?</h2>\n    <p>Misted double glazing replacement is the fix for a window that looks foggy or cloudy because moisture has got inside the gap between its two panes. A double glazed pane is a factory-sealed unit; when the seal around its edge breaks down, damp air seeps in, the drying agent in the spacer bar becomes saturated, and condensation forms on the inner faces of the glass where you can't wipe it. The usual remedy is to take out the failed unit and fit a new one in the existing frame.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/clear-replacement-pane-beside-misted-glazing-uk.jpg\" alt=\"Clear kitchen window unit beside a separate pane with trapped condensation\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>{Misting can affect just one pane in an otherwise serviceable window.|A failed unit does not necessarily mean the surrounding frame has worn out.} The good news is that, provided the frame is in decent condition, you don't need a whole new window, just new glass.</p>\n\n    <h2>Signs Your Double Glazing Has Misted</h2>\n    <ul>\n        <li>Fog or droplets that stay visible after you wipe both the inside and outside of the glass</li>\n        <li>Mist that comes and goes with the weather, often worst on sunny mornings after a cold night</li>\n        <li>A white, streaky or rainbow-like residue inside the unit once the moisture dries</li>\n        <li>Water pooling along the bottom edge between the panes</li>\n        <li>A silvery spacer bar that looks stained or corroded</li>\n        <li>That pane feels noticeably colder to the touch than the others in the same room</li>\n    </ul>\n    <p>Not sure the cloudiness is a failed unit? <a href=\"/guides/double-glazing-problems-explained/\">Double glazing problems explained</a> shows how to tell it from ordinary condensation. Misted and blown units are the same fault, and our <a href=\"/guides/blown-double-glazed-unit-replacement-cost/\">blown unit cost guide</a> covers the specification side.</p>\n    <p>Condensation that wipes off the room-facing surface is not, by itself, evidence of a failed sealed unit. It depends on indoor moisture, temperature and ventilation, which should be assessed separately. Check only surfaces you can reach safely without leaning out.</p>\n\n    <h2>Options for Fixing Misted Windows</h2>\n    <ul>\n        <li><strong>Replace the sealed unit.</strong> The standard, lasting fix. A glazier measures the pane, orders a new unit to size and fits it into the existing frame, usually from the inside by removing the glazing beads.</li>\n        <li><strong>De-misting services.</strong> Some firms drill small holes in the glass, clean and dry the cavity and then plug the holes. It can improve appearance, but the unit no longer holds its insulating gas and the result is not the same as a new sealed unit. Ask what guarantee is offered.</li>\n        <li><strong>Replace the whole window.</strong> Worth considering only if the frame is also failing, or if most panes in an old window have already misted.</li>\n    </ul>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>Tell the glazier how many panes are misted and which windows they're in, and measure the visible glass on each one (width × height) as a rough guide. They will take exact sizes themselves. Mention whether the panes are plain, have Georgian bars or leaded designs between the glass, or use patterned obscure glass in a bathroom, because the replacement unit has to match.</p>\n    <p>It helps to say what the frames are made of and roughly how old they are, and whether the windows are on the ground floor or need a ladder or scaffold tower to reach from outside. If there is a manufacturer's sticker or etched mark in the corner of the glass, a photo of it can show the original date and specification, and whether the unit might still be under a guarantee.</p>\n    <p>A clear quote for misted unit replacement should give a price per pane including VAT, state the glass specification (low-emissivity coating, gas fill, spacer type), confirm whether any panes need toughened safety glass because of where they sit, and say how long the new units are guaranteed against misting again. It should also say whether the old units are taken away.</p>\n\n    <h2>How Much Does Misted Double Glazing Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK misted double glazing replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>One small or medium pane</td><td>£80 – £150</td></tr>\n            <tr><td>One large pane or two medium panes</td><td>£150 – £280</td></tr>\n            <tr><td>Three or four panes in one visit</td><td>£280 – £450+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>Most glaziers charge per unit, with a minimum call-out. Toughened glass, obscure patterns, decorative bars and panes that need access from outside above ground floor increase the cost. Ordering several units at once is usually cheaper per pane than separate visits.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/misted-double-glazing-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The Misted Unit Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Measuring visit.</strong> The glazier removes a bead or checks the frame to confirm the exact unit size and thickness.</li>\n        <li><strong>Ordering.</strong> The new sealed unit is made to measure, often within one to two weeks.</li>\n        <li><strong>Removal.</strong> On the return visit the glazing beads are unclipped and the misted unit lifted out.</li>\n        <li><strong>Fitting.</strong> The new unit is set on packers so the sash still opens and closes properly, then the beads and gaskets go back in.</li>\n        <li><strong>Check and clean.</strong> The window is tested for smooth opening and the glass is cleaned before the glazier leaves.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>Replacing a misted sealed unit in an existing frame is generally treated as a repair, so it does not usually need planning permission or a building regulations certificate. Glass in critical locations (such as low panes and glazing in or next to doors) still needs to be safety glass, and a good glazier will check this. If the home is listed, ask the conservation officer before changing historic glazing. Anything that replaces the whole frame is a different matter and falls under building regulations.</p>\n\n    <h2>How to Choose a Glazier for Misted Units</h2>\n    <ul>\n        <li>How long is the new unit guaranteed against misting?</li>\n        <li>Will the replacement match the thickness and appearance of your other panes?</li>\n        <li>Does the price include VAT, the call-out and disposal?</li>\n        <li>Do they check whether toughened glass is needed before ordering?</li>\n        <li>Can they adjust or lubricate the hinges while they are there?</li>\n        <li>Are they a member of a trade body such as the <a href=\"https://www.ggf.org.uk/\" target=\"_blank\" rel=\"nofollow noopener\">Glass and Glazing Federation</a>?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>Why has my double glazing misted up?</h3>\n    <p>The perimeter seal of the unit has failed, letting moist air into the cavity. Age, sunlight, water sitting in the frame rebate and poor drainage all speed this up.</p>\n    <h3>Can misted double glazing be fixed without replacing the glass?</h3>\n    <p>De-misting services can clear the view, but they don't restore the original sealed unit. A new sealed unit is the usual replacement option; ask for the product and fitting guarantee terms before ordering.</p>\n    <h3>Do I need a whole new window if one pane is misted?</h3>\n    <p>Usually not. If the frame, hinges and locks are in good order, the glazier only needs to replace the misted unit, which costs a fraction of a new window.</p>\n    <h3>Does misted glazing make my home colder?</h3>\n    <p>A failed unit has lost its dry, sealed cavity, so it insulates less well than when it was new. The difference per pane is modest, but several misted panes in one room can make it feel colder.</p>\n    \n\n    <p>Got foggy panes? <a href=\"/free-quotes/\">Tell us how many</a> and up to four local glaziers may quote to replace them.</p>\n\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Why has my double glazing misted up?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"The perimeter seal of the unit has failed, letting moist air into the cavity. Age, sunlight, water sitting in the frame rebate and poor drainage all speed this up.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can misted double glazing be fixed without replacing the glass?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"De-misting services can clear the view, but they don't restore the original sealed unit. A new sealed unit is the usual replacement option; ask for the product and fitting guarantee terms before ordering.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Do I need a whole new window if one pane is misted?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Usually not. If the frame, hinges and locks are in good order, the glazier only needs to replace the misted unit, which costs a fraction of a new window.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does misted glazing make my home colder?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"A failed unit has lost its dry, sealed cavity, so it insulates less well than when it was new. The difference per pane is modest, but several misted panes in one room can make it feel colder.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n",
    "privacy": "<article class=\"privacy-content\">\n\n    <p>This privacy policy explains how personal information is collected, used and shared when you visit double-glazing-quotes.co.uk, request double glazing quotes or contact us.</p>\n\n    <p>The double-glazing-quotes.co.uk quote-matching service is provided by <strong>Leads Do Work Ltd</strong>. References in this policy to “we”, “us” or “our” mean Leads Do Work Ltd.</p>\n\n    <p>For questions about this privacy policy, the way we use your personal information or your data protection rights, please contact Leads Do Work Ltd through its website at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>About Our Quote-Matching Service</h2>\n\n    <p>double-glazing-quotes.co.uk helps homeowners, landlords, letting agents and property managers find independent double glazing installers who may be interested in providing a survey or quotation.</p>\n\n    <p>When you submit a quote request, we use the information you provide to identify specialists who may be suitable for the type of work and location you have entered. We may then share your enquiry with one or more relevant specialists so they can contact you directly.</p>\n\n    <p>Our role is to introduce you to independent specialists. We do not normally carry out the double glazing work ourselves, supervise the project or enter into the contract for work. Any agreement you make for a survey, repair, replacement or other service will be directly between you and the specialist you appoint.</p>\n\n    <h2>Information We Collect</h2>\n\n    <p>The information we collect depends on how you use the website and the details you choose to provide.</p>\n\n    <h3>Information provided with a quote request</h3>\n\n    <p>When you request double glazing quotes, we may collect:</p>\n\n    <ul>\n        <li>Your name.</li>\n        <li>Your email address.</li>\n        <li>Your telephone or mobile number.</li>\n        <li>Your postcode and property address.</li>\n        <li>The type of property concerned.</li>\n        <li>Whether you own, rent, manage or are buying the property.</li>\n        <li>Details of the window, door or glazing project or problem.</li>\n        <li>The type of repair, replacement or inspection you require.</li>\n        <li>Your preferred timescale for the work.</li>\n        <li>Photographs or documents you choose to upload.</li>\n        <li>Any other information you include in the enquiry.</li>\n    </ul>\n\n    <p>Please avoid including unnecessary sensitive personal information in your description or uploaded files.</p>\n\n    <h3>Information collected when you contact us</h3>\n\n    <p>If you contact us by telephone, email, online form, text message or another channel, we may retain:</p>\n\n    <ul>\n        <li>Your contact details.</li>\n        <li>The date and time of the communication.</li>\n        <li>The content of your message.</li>\n        <li>Notes made by our customer service team.</li>\n        <li>Information about your enquiry or complaint.</li>\n    </ul>\n\n    <p>Telephone calls to or from Leads Do Work Ltd may be recorded or monitored for quality, training, fraud prevention and dispute-resolution purposes.</p>\n\n    <h3>Information collected automatically</h3>\n\n    <p>When you use the website, we may automatically collect technical and usage information, including:</p>\n\n    <ul>\n        <li>Your Internet Protocol address.</li>\n        <li>Your browser type and version.</li>\n        <li>Your device type and operating system.</li>\n        <li>The pages you visit.</li>\n        <li>The date, time and length of your visit.</li>\n        <li>The website, advertisement or search result that referred you to us.</li>\n        <li>Information about how you use the quote form.</li>\n        <li>Cookie identifiers and similar technical information.</li>\n    </ul>\n\n    <h3>Information received from other sources</h3>\n\n    <p>We may receive your information through another website, advertising platform, social media form, affiliate, publisher or business partner where you have requested double glazing quotes or asked to be contacted.</p>\n\n    <p>Where another organisation collects your details before passing them to us, it should provide its own privacy information explaining how your data will be used.</p>\n\n    <h2>How We Use Your Information</h2>\n\n    <p>We may use your personal information to:</p>\n\n    <ul>\n        <li>Process your request for double glazing quotes.</li>\n        <li>Identify specialists who provide the service you require.</li>\n        <li>Match your enquiry according to the work type, location and specialist availability.</li>\n        <li>Share your enquiry with suitable independent specialists.</li>\n        <li>Contact you to confirm or clarify the details of your request.</li>\n        <li>Help specialists contact you about a survey or quotation.</li>\n        <li>Provide customer service and respond to questions or complaints.</li>\n        <li>Check whether specialists have responded to your enquiry.</li>\n        <li>Invite you to review the service or a specialist.</li>\n        <li>Prevent fraud, misuse and unauthorised access.</li>\n        <li>Maintain records of enquiries, introductions and communications.</li>\n        <li>Improve our websites, forms, matching systems and services.</li>\n        <li>Measure the performance of our advertising and marketing campaigns.</li>\n        <li>Comply with legal, regulatory, tax, accounting and reporting duties.</li>\n        <li>Establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <h2>Published Examples of Enquiries</h2>\n\n    <p>To help homeowners see the kind of double glazing work being requested near them, we publish anonymised examples of past enquiries on trade- and location-specific pages of double-glazing-quotes.co.uk (and any other website operated by Leads Do Work Ltd).</p>\n\n    <p>Before an example is published we remove or mask anything that could reasonably identify you or your home. Your name is reduced to an initial, your exact address is not shown (only a generic street name where one applies, never a house or unit number or a named property), your email address is partially masked, and we remove anything resembling a phone number, email address or postcode from your enquiry description.</p>\n\n    <p>If you have opted out of further contact from us, your enquiry is never used in this way. If you would rather your enquiry is never published as an example, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a> and we will exclude it.</p>\n\n    <p>Our lawful basis for this is legitimate interests — showing genuine local examples helps homeowners trust the quote-matching service. You have the right to object to this processing at any time; see \"Your Data Protection Rights\" below.</p>\n\n    <h2>How We Match Your Enquiry</h2>\n\n    <p>Our technology may automatically assess the information you submit, including your postcode, property type and the double glazing work required.</p>\n\n    <p>This information may be compared with specialists' service areas, selected trades, availability and account settings. The system can then identify which specialists may be suitable to receive the enquiry.</p>\n\n    <p>This automated matching helps us process enquiries efficiently. It does not decide whether you may obtain double glazing services, and you remain free to accept or reject any quotation.</p>\n\n    <h2>Who We Share Your Information With</h2>\n\n    <h3>Double glazing installers</h3>\n\n    <p>To provide the quote-matching service, we may share your enquiry with one or more independent double glazing installers who appear relevant to your location and requested work.</p>\n\n    <p>The information shared may include your:</p>\n\n    <ul>\n        <li>Name.</li>\n        <li>Telephone number.</li>\n        <li>Email address.</li>\n        <li>Address or postcode.</li>\n        <li>Property details.</li>\n        <li>Description of the problem.</li>\n        <li>Preferred timescale.</li>\n        <li>Uploaded photographs or supporting information.</li>\n    </ul>\n\n    <p>Specialists may contact you by telephone, email or text message to discuss the enquiry, arrange a site visit or provide a quotation.</p>\n\n    <p>Each specialist receiving your personal information will normally act as an independent data controller. This means the specialist is responsible for its own use, storage and protection of your data after receiving it.</p>\n\n    <p>If you provide further information directly to a specialist or appoint that specialist, the use of your information will also be governed by the specialist's own privacy policy. You should contact the specialist directly if you wish to exercise your rights regarding information held in its own systems.</p>\n\n    <h3>Companies providing services to us</h3>\n\n    <p>We may share personal information with trusted suppliers that help us operate the website and quote service, including providers of:</p>\n\n    <ul>\n        <li>Website hosting and cloud storage.</li>\n        <li>Email, telephone and text-message services.</li>\n        <li>Customer relationship management systems.</li>\n        <li>Analytics and website-performance tools.</li>\n        <li>Security, fraud prevention and technical support.</li>\n        <li>Customer service and communication systems.</li>\n        <li>Data backup and disaster recovery.</li>\n        <li>Professional legal, accounting and compliance services.</li>\n    </ul>\n\n    <p>These organisations may process information on our behalf and are required to handle it according to their contracts and applicable data protection law.</p>\n\n    <h3>Advertising and analytics providers</h3>\n\n    <p>Subject to your cookie choices and where required by law, information about your use of the website may be shared with analytics and advertising providers. This may include Google, Meta and other platforms used to measure website traffic or advertising performance.</p>\n\n    <p>These providers may use cookies or similar technologies. More information should be available through the cookie settings displayed on the website.</p>\n\n    <h3>Legal and business disclosures</h3>\n\n    <p>We may also disclose information:</p>\n\n    <ul>\n        <li>Where required by law, a court or regulatory authority.</li>\n        <li>To investigate fraud, security incidents or misuse of our services.</li>\n        <li>To protect our rights, property, users or specialists.</li>\n        <li>In connection with a sale, merger, restructuring or transfer of all or part of our business.</li>\n        <li>To establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <h2>We Do Not Sell Your Details for Unrelated Marketing</h2>\n\n    <p>We do not sell, rent or trade the personal information submitted with a double glazing quote request to unrelated organisations for their own marketing without an appropriate lawful basis.</p>\n\n    <p>Sharing your enquiry with relevant specialists is an essential part of the quote service you have requested. This is different from selling your information for unrelated marketing.</p>\n\n    <h2>Our Lawful Bases for Processing</h2>\n\n    <p>Under UK data protection law, we must have a lawful basis for using personal information. The bases we may rely on include:</p>\n\n    <h3>Taking steps at your request or performing a contract</h3>\n\n    <p>We use this basis where processing is necessary to provide the quote-matching service you have requested, including receiving your enquiry, matching it with specialists and helping those specialists contact you.</p>\n\n    <h3>Legitimate interests</h3>\n\n    <p>We may process information where it is necessary for our legitimate business interests, provided those interests are not overridden by your rights. These interests may include:</p>\n\n    <ul>\n        <li>Operating and improving the quote service.</li>\n        <li>Managing our relationship with users and specialists.</li>\n        <li>Checking the quality and effectiveness of introductions.</li>\n        <li>Preventing fraud and protecting the security of our systems.</li>\n        <li>Understanding how our website is used.</li>\n        <li>Handling complaints and resolving disputes.</li>\n        <li>Promoting similar services where permitted by law.</li>\n    </ul>\n\n    <p>We also publish anonymised examples of enquiries on our website, as described under \"Published Examples of Enquiries\" above; our lawful basis for that is legitimate interests.</p>\n\n    <h3>Consent</h3>\n\n    <p>We may rely on your consent for certain marketing communications, non-essential cookies or other processing where consent is legally required. You may withdraw your consent at any time.</p>\n\n    <h3>Legal obligation</h3>\n\n    <p>We may process personal information where necessary to comply with a legal or regulatory requirement.</p>\n\n    <h2>Contacting You About Your Enquiry</h2>\n\n    <p>After you submit an enquiry, Leads Do Work Ltd and relevant specialists may contact you to help process your request and provide quotations.</p>\n\n    <p>Contact may be made by:</p>\n\n    <ul>\n        <li>Telephone.</li>\n        <li>Automated telephone call.</li>\n        <li>Text message or SMS.</li>\n        <li>Email.</li>\n    </ul>\n\n    <p>These communications relate to the double glazing service you requested and may include confirming your details, arranging a site visit, providing a quotation or checking the progress of the enquiry.</p>\n\n    <h2>Marketing Communications</h2>\n\n    <p>We may occasionally contact you about similar home improvement services where we have your consent or where applicable marketing law allows us to do so.</p>\n\n    <p>You can stop receiving marketing messages from Leads Do Work Ltd by:</p>\n\n    <ul>\n        <li>Using the unsubscribe link in an email.</li>\n        <li>Following the opt-out instructions in a text message.</li>\n        <li>Contacting Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</li>\n    </ul>\n\n    <p>Opting out of marketing will not stop service messages that are necessary to process an active enquiry.</p>\n\n    <p>Specialists are independent organisations. If you wish to stop communications from a particular specialist, you should also contact that specialist directly.</p>\n\n    <h2>Uploaded Photographs and Documents</h2>\n\n    <p>You may have the option to upload photographs or other information showing the windows, doors or glazing problem. These files may be shared with relevant specialists to help them understand your enquiry.</p>\n\n    <p>By uploading a file, you confirm that:</p>\n\n    <ul>\n        <li>You are entitled to share it.</li>\n        <li>It does not unlawfully contain another person's private information.</li>\n        <li>It may be used and shared as reasonably necessary to operate the quote service.</li>\n    </ul>\n\n    <p>Uploaded files may remain in backups, audit records and specialists' systems for a reasonable period after the enquiry has ended.</p>\n\n    <h2>Cookies and Similar Technologies</h2>\n\n    <p>We use cookies and similar technologies to operate the website, remember preferences, measure performance and understand how visitors use the service.</p>\n\n    <p>Cookies used on the website may include:</p>\n\n    <ul>\n        <li><strong>Strictly necessary cookies</strong> – required for essential website and form functions.</li>\n        <li><strong>Preference cookies</strong> – used to remember choices and settings.</li>\n        <li><strong>Analytics cookies</strong> – used to understand website traffic and user behaviour.</li>\n        <li><strong>Advertising cookies</strong> – used to measure advertising and, where permitted, deliver more relevant advertising.</li>\n    </ul>\n\n    <p>Non-essential cookies should only be used where permitted by applicable law and in accordance with the choices available through the website's cookie banner or settings.</p>\n\n    <p>You can also control cookies through your browser. Blocking some cookies may affect the way the website or quote form works.</p>\n\n    <h2>Google AdSense Advertising</h2>\n\n    <p>This website displays advertisements served by Google AdSense, an advertising service provided by Google. For visitors in the UK, the European Economic Area and Switzerland, the service is provided by Google Ireland Limited; elsewhere it is provided by Google LLC. Adverts appear in fixed positions on our pages and help to keep the quotation service free to use. We do not choose the individual adverts shown, and an advert appearing on this website does not mean we recommend or endorse the advertiser.</p>\n\n    <h3>How Google's advertising cookies work</h3>\n\n    <ul>\n        <li>Third-party vendors, including Google, use cookies to serve adverts based on your previous visits to this website or to other websites.</li>\n        <li>Google's use of advertising cookies enables it and its partners to serve adverts to you based on your visits to this website and/or other sites on the internet.</li>\n        <li>Google and its partners may also use cookies and similar technologies, such as device identifiers and local storage, to limit how many times you see the same advert, measure how adverts perform, produce aggregated reports for advertisers and publishers, and detect and prevent fraudulent or invalid advertising activity.</li>\n        <li>Cookies used for these purposes may be set on this website's domain (for example <code>__gads</code>, <code>__gpi</code> and <code>__eoi</code>) and on Google-operated domains such as doubleclick.net (for example <code>IDE</code>). Google may change the names and lifespans of these cookies at any time.</li>\n    </ul>\n\n    <p>Information collected through these technologies may include your IP address, browser and device details, the pages you view, the adverts you see and interact with, and your approximate location. Google and its partners use this information in accordance with their own privacy policies. You can learn more in <a href=\"https://policies.google.com/technologies/partner-sites\" target=\"_blank\" rel=\"noopener noreferrer\">How Google uses information from sites or apps that use its services</a>, <a href=\"https://policies.google.com/technologies/ads\" target=\"_blank\" rel=\"noopener noreferrer\">how Google uses cookies in advertising</a> and the <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Google Privacy Policy</a>. Google may process this information outside the UK, including in the United States, subject to the safeguards described in its own policies.</p>\n\n    <h3>Your consent choices</h3>\n\n    <p>When you visit this website from the UK, the European Economic Area or Switzerland, a consent message provided by Google is displayed. Google's consent management platform is certified under the IAB Transparency and Consent Framework. The message explains how cookies and personal data are used for advertising, lists Google and the other advertising partners involved, and lets you accept, reject or manage your choices for each purpose and each partner.</p>\n\n    <ul>\n        <li><strong>If you consent</strong>, Google and its partners may use cookies and similar technologies to show you personalised adverts based on your interests and browsing activity.</li>\n        <li><strong>If you do not consent to personalised advertising</strong>, Google may show non-personalised adverts, which are selected using contextual information such as the content of the page you are viewing and your general location rather than your browsing history. Where you have agreed to information being stored on your device, these adverts may still use cookies for frequency capping, aggregated reporting and fraud prevention.</li>\n        <li><strong>If you do not agree to information being stored on your device</strong>, Google may show limited adverts that do not use cookies or other device identifiers for advertising purposes.</li>\n    </ul>\n\n    <p>You can change or withdraw your consent at any time using the privacy and cookie settings option displayed on the website, usually a small link or button at the bottom of the page, which reopens the consent message. Withdrawing consent does not affect processing that took place before you withdrew it.</p>\n\n    <p>You can also manage personalised advertising by Google through <a href=\"https://myadcenter.google.com/\" target=\"_blank\" rel=\"noopener noreferrer\">My Ad Center</a>, opt out of personalised advertising by many third-party vendors at <a href=\"https://www.youronlinechoices.com/uk/\" target=\"_blank\" rel=\"noopener noreferrer\">youronlinechoices.com</a> or <a href=\"https://optout.aboutads.info/\" target=\"_blank\" rel=\"noopener noreferrer\">aboutads.info</a>, and block or delete cookies through your browser settings.</p>\n\n    <p>We rely on your consent to store and access information on your device for advertising purposes and to use personal data for personalised advertising. Where Google uses information for its own purposes, it does so as an independent controller.</p>\n\n    <h2>Google Maps</h2>\n\n    <p>Some of our location pages include a small embedded map provided by Google Maps, a service of Google LLC (or Google Ireland Limited for visitors in the UK, the European Economic Area and Switzerland), to show the area the page covers. The map is loaded only when you scroll to the part of the page where it appears.</p>\n\n    <p>When the map loads, your browser connects directly to Google's servers. Google may receive your IP address, browser and device details and the address of the page you are viewing, and may set or read cookies on Google-operated domains, particularly if you are signed in to a Google account. We do not receive any information from Google about your use of the map, and we do not send Google any details you enter in our quote form.</p>\n\n    <p>Google uses this information in accordance with the <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\">Google Privacy Policy</a> and the <a href=\"https://cloud.google.com/maps-platform/terms\" target=\"_blank\" rel=\"noopener noreferrer\">Google Maps Platform Terms</a>. If you prefer that Google does not receive this information, you can block third-party content or cookies in your browser; the rest of the page will continue to work normally.</p>\n\n    <h2>Data Retention</h2>\n\n    <p>We keep personal information only for as long as reasonably necessary for the purposes for which it was collected.</p>\n\n    <p>The length of time information is retained may depend on:</p>\n\n    <ul>\n        <li>How long it is needed to provide and administer the quote service.</li>\n        <li>Whether the enquiry remains active.</li>\n        <li>Whether you continue to interact with us.</li>\n        <li>Customer service, complaint or dispute requirements.</li>\n        <li>Fraud prevention and system security.</li>\n        <li>Legal, regulatory, tax, accounting and audit obligations.</li>\n        <li>The need to establish, exercise or defend legal claims.</li>\n    </ul>\n\n    <p>Some information may be retained for longer where there is a legal, compliance, security or dispute-resolution reason to do so.</p>\n\n    <p>Specialists receiving your enquiry will apply their own retention policies to the copies of your information held in their systems.</p>\n\n    <h2>International Transfers</h2>\n\n    <p>Some of the technology and service providers used to operate our websites may process information outside the United Kingdom.</p>\n\n    <p>Where personal information is transferred internationally, we will take appropriate steps required by UK data protection law. These may include using an adequacy regulation, approved contractual safeguards or another lawful transfer mechanism.</p>\n\n    <h2>How We Protect Your Information</h2>\n\n    <p>We use reasonable technical and organisational measures designed to protect personal information from loss, misuse, alteration, unauthorised access or disclosure.</p>\n\n    <p>These measures may include encrypted website connections, access controls, monitoring, backups and security procedures. However, no internet service or storage system can be guaranteed to be completely secure.</p>\n\n    <p>If you believe your personal information may have been compromised, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>Your Data Protection Rights</h2>\n\n    <p>Depending on the circumstances, UK data protection law may give you the right to:</p>\n\n    <ul>\n        <li><strong>Request access</strong> to the personal information we hold about you.</li>\n        <li><strong>Request correction</strong> of inaccurate or incomplete information.</li>\n        <li><strong>Request erasure</strong> of your personal information where there is no lawful reason for us to continue using it.</li>\n        <li><strong>Request restriction</strong> of the way your information is processed.</li>\n        <li><strong>Object to processing</strong> based on legitimate interests.</li>\n        <li><strong>Object to direct marketing</strong> at any time.</li>\n        <li><strong>Request data portability</strong> in certain circumstances.</li>\n        <li><strong>Withdraw consent</strong> where processing is based on consent.</li>\n        <li><strong>Ask for information about automated processing</strong> where applicable.</li>\n        <li><strong>Complain to the Information Commissioner's Office</strong>.</li>\n    </ul>\n\n    <p>These rights are not absolute, and there may be circumstances in which we are legally permitted or required to retain or continue processing some information.</p>\n\n    <p>We may ask for information to confirm your identity before responding to a request. This helps prevent personal information from being disclosed to someone who is not entitled to receive it.</p>\n\n    <p>We normally aim to respond to a valid data protection request within one month. More time may be required for particularly complex requests, in which case we will explain the reason for the delay.</p>\n\n    <p>To exercise any of these rights, please contact Leads Do Work Ltd through <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <h2>Complaints</h2>\n\n    <p>Please contact Leads Do Work Ltd first if you have concerns about the way your personal information has been handled. You can find the appropriate contact options at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <p>You also have the right to complain to the UK Information Commissioner's Office. Information about making a complaint is available on the Information Commissioner's Office website.</p>\n\n    <h2>Links to Other Websites</h2>\n\n    <p>This website may contain links to specialists' websites, social media platforms or other third-party services. We are not responsible for the content, security or privacy practices of websites operated by other organisations.</p>\n\n    <p>You should read the privacy policy of any external website before providing personal information to it.</p>\n\n    <h2>Children's Information</h2>\n\n    <p>This quote service is intended for adults seeking services for a property. It is not intended for children, and we do not knowingly collect personal information from anyone under the age of 18.</p>\n\n    <h2>Changes to This Privacy Policy</h2>\n\n    <p>We may update this privacy policy from time to time to reflect changes to the website, our services, technology or legal requirements.</p>\n\n    <p>The latest version will be published on this page, and the date at the top will show when it was last updated.</p>\n\n    <h2>Contact Leads Do Work Ltd</h2>\n\n    <p>For privacy questions, complaints or requests concerning your personal information, please visit <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a> and use the contact details or contact options provided there.</p>\n\n    <p><strong>Last updated: 27 September 2026</strong></p>\n\n</article>\n",
    "terms": "<article class=\"terms-content\">\n\n    <p>These terms and conditions apply when you visit double-glazing-quotes.co.uk, submit an enquiry or use our double glazing quote-matching service.</p>\n\n    <p>The service is provided by <strong>Leads Do Work Ltd</strong>. References in these terms to “we”, “us” or “our” mean Leads Do Work Ltd.</p>\n\n    <p>By using this website or submitting an enquiry, you confirm that you have read and agree to these terms. Please do not use the service if you do not accept them.</p>\n\n    <h2>About Our Service</h2>\n\n    <p>double-glazing-quotes.co.uk is an introduction and quote-matching service. It helps homeowners, landlords, letting agents, property managers and businesses connect with independent specialists who may be interested in inspecting a property or providing a quotation for double glazing work.</p>\n\n    <p>Our service may cover work such as double glazed window replacement, uPVC window replacement, misted and blown sealed unit replacement, broken or damaged glass replacement, and double glazed door replacement.</p>\n\n    <p>The quote-matching service is free for people requesting quotations. Specialists may pay Leads Do Work Ltd for access to suitable enquiries or participate through another commercial arrangement with us.</p>\n\n    <h2>Our Role Is Limited to Making Introductions</h2>\n\n    <p>Leads Do Work Ltd is not a window or door installer, glazier, glazing contractor, building contractor, surveyor, engineer, architect, insurer or professional adviser.</p>\n\n    <p>We do not:</p>\n\n    <ul>\n        <li>Survey, supply, install, glaze or repair windows, doors or sealed units.</li>\n        <li>Visit or inspect the property.</li>\n        <li>Assess the condition of window or door frames, sealed units, openings or lintels.</li>\n        <li>Prepare specifications or scopes of work.</li>\n        <li>Provide professional, structural or technical advice.</li>\n        <li>Set or approve specialists' prices.</li>\n        <li>Negotiate contracts on behalf of homeowners or specialists.</li>\n        <li>Supervise, manage or inspect work carried out by specialists.</li>\n        <li>Employ the specialists introduced through the service.</li>\n        <li>Act as an agent, partner or representative of a specialist.</li>\n        <li>Guarantee that a specialist will contact you or provide a quotation.</li>\n        <li>Guarantee that any quotation will be suitable or competitive.</li>\n    </ul>\n\n    <p>Our role is limited to receiving your enquiry and attempting to introduce you to independent specialists who may cover your location and type of work.</p>\n\n    <h2>Independent Specialists</h2>\n\n    <p>Every specialist introduced through the service operates as an independent business. Specialists are not employees, workers, subcontractors, agents, partners or representatives of Leads Do Work Ltd.</p>\n\n    <p>Specialists decide independently:</p>\n\n    <ul>\n        <li>Whether to contact you.</li>\n        <li>Whether to inspect your property.</li>\n        <li>What diagnosis or repair method to recommend.</li>\n        <li>Whether to provide a quotation.</li>\n        <li>What price to charge.</li>\n        <li>What terms and payment arrangements to offer.</li>\n        <li>Whether they are willing and available to carry out the work.</li>\n    </ul>\n\n    <p>We do not control how a specialist conducts its business or performs its work.</p>\n\n    <h2>No Recommendation, Endorsement or Guarantee</h2>\n\n    <p>An introduction through our service must not be treated as a recommendation, endorsement, certification or guarantee of a specialist.</p>\n\n    <p>Although we may collect or display information about specialists, we do not guarantee that any specialist:</p>\n\n    <ul>\n        <li>Is suitable for your particular property or project.</li>\n        <li>Has all qualifications, skills or experience required for the work.</li>\n        <li>Holds current or sufficient insurance.</li>\n        <li>Belongs to a particular trade association or accreditation scheme.</li>\n        <li>Is financially stable or creditworthy.</li>\n        <li>Will provide a quotation.</li>\n        <li>Will offer the lowest or best price.</li>\n        <li>Will start or complete work within a particular period.</li>\n        <li>Will perform work to a particular standard.</li>\n        <li>Will provide or honour a guarantee.</li>\n        <li>Will comply with every legal, regulatory or professional requirement.</li>\n    </ul>\n\n    <p>The fact that a specialist appears on our network or receives your enquiry does not mean that Leads Do Work Ltd has approved the specialist for your particular project.</p>\n\n    <h2>Information About Specialists</h2>\n\n    <p>Information about a specialist may include its business name, contact details, service area, experience, qualifications, accreditations, trade memberships, insurance details, reviews and other profile information.</p>\n\n    <p>This information may be:</p>\n\n    <ul>\n        <li>Provided directly by the specialist.</li>\n        <li>Collected from publicly available records.</li>\n        <li>Provided by customers or third parties.</li>\n        <li>Based on documents that were current when checked.</li>\n    </ul>\n\n    <p>We may carry out reasonable checks, but we cannot guarantee that specialist information is always accurate, complete or up to date. Qualifications, memberships, insurance policies, company status and personnel may change after checks have been completed.</p>\n\n    <p>You must verify all important information directly with the specialist before appointing it or allowing work to begin.</p>\n\n    <h2>Your Responsibility to Check the Specialist</h2>\n\n    <p>You are solely responsible for deciding whether a specialist is suitable for your project. Before appointing a specialist, paying any money or allowing work to begin, you should carry out your own checks.</p>\n\n    <p>These checks should include, where relevant:</p>\n\n    <ul>\n        <li>Confirming the specialist's full legal or trading name.</li>\n        <li>Confirming its business address and contact details.</li>\n        <li>Checking how long the business has been trading.</li>\n        <li>Checking Companies House details where the specialist operates through a limited company.</li>\n        <li>Requesting recent references and independently contacting previous customers.</li>\n        <li>Reviewing genuine customer feedback from more than one source.</li>\n        <li>Checking relevant qualifications, training and experience.</li>\n        <li>Checking trade association memberships or accreditations directly with the issuing organisation.</li>\n        <li>Confirming whether working-at-height competence is appropriate for the proposed access method.</li>\n        <li>Requesting a current public liability insurance certificate.</li>\n        <li>Checking the insurer, policy number, expiry date and level of cover.</li>\n        <li>Confirming that the policy covers the specific type of work being proposed.</li>\n        <li>Checking whether employers' liability insurance is held where required.</li>\n        <li>Checking whether planning permission, listed building consent, building regulations approval or another permission is required.</li>\n        <li>Checking whether the specialist will arrange necessary approvals or whether this remains your responsibility.</li>\n        <li>Obtaining a written diagnosis and detailed quotation.</li>\n        <li>Reading all proposed contract terms before signing or paying.</li>\n        <li>Confirming who will actually carry out the work and whether subcontractors will be used.</li>\n        <li>Checking the terms and provider of any guarantee or warranty.</li>\n    </ul>\n\n    <p>You should not rely solely on information displayed on this website or provided by Leads Do Work Ltd when choosing a specialist.</p>\n\n    <h2>Specialist Advice and Structural Assessment</h2>\n\n    <p>Misted panes, draughts, condensation or a door that sticks can have several possible causes, and frames that look similar from inside may be in quite different condition, or sit in openings with quite different structural details. Similar visible symptoms may require different repairs.</p>\n\n    <p>Information on this website is general information only. It is not a diagnosis of your property and must not be treated as professional surveying, structural, engineering, legal, financial, health or safety advice.</p>\n\n    <p>You are responsible for deciding whether you need advice from an appropriately qualified independent professional. This may include a building surveyor, structural engineer, conservation specialist or another suitably qualified adviser.</p>\n\n    <p>Where you are buying a property, arranging a mortgage, dealing with a listed building or planning to alter window or door openings, you should consider obtaining an independent survey rather than relying only on a survey or quotation provided by a specialist seeking to carry out the work.</p>\n\n    <h2>Your Enquiry</h2>\n\n    <p>When submitting an enquiry, you agree to provide information that is accurate, current and complete to the best of your knowledge.</p>\n\n    <p>This may include:</p>\n\n    <ul>\n        <li>Your name and contact details.</li>\n        <li>The property address or postcode.</li>\n        <li>Your relationship to the property.</li>\n        <li>The property type.</li>\n        <li>A description of the window, door or glazing project or problem.</li>\n        <li>The work or inspection you require.</li>\n        <li>Your preferred timescale.</li>\n        <li>Any photographs or documents you upload.</li>\n    </ul>\n\n    <p>You must have permission to submit an enquiry relating to the property and to provide any personal information included in it.</p>\n\n    <p>You must not submit:</p>\n\n    <ul>\n        <li>False, misleading or fraudulent information.</li>\n        <li>Another person's contact details without permission.</li>\n        <li>Enquiries for properties where you have no authority to seek quotations.</li>\n        <li>Offensive, threatening, unlawful or abusive content.</li>\n        <li>Files containing malware or harmful code.</li>\n        <li>Enquiries intended to waste specialists' time.</li>\n        <li>Enquiries intended to gather prices or business information for improper purposes.</li>\n    </ul>\n\n    <p>We may reject, suspend, edit or remove an enquiry that appears incomplete, duplicate, fraudulent, abusive, unlawful or unsuitable for the service.</p>\n\n    <h2>Sharing Your Enquiry</h2>\n\n    <p>By submitting a quote request, you ask us to attempt to match your enquiry with independent specialists who may be able to help.</p>\n\n    <p>Your enquiry and contact details may be shared with one or more relevant specialists. Those specialists may contact you directly by telephone, text message, email or another reasonable communication method to:</p>\n\n    <ul>\n        <li>Discuss the work.</li>\n        <li>Ask for additional information.</li>\n        <li>Arrange a property visit.</li>\n        <li>Provide a quotation.</li>\n        <li>Follow up on the enquiry.</li>\n    </ul>\n\n    <p>Submission of an enquiry does not guarantee that any specialist will be available, contact you, visit the property or provide a quotation.</p>\n\n    <h2>No Obligation to Appoint a Specialist</h2>\n\n    <p>Submitting an enquiry does not require you to:</p>\n\n    <ul>\n        <li>Accept a quotation.</li>\n        <li>Arrange a property visit.</li>\n        <li>Appoint a specialist.</li>\n        <li>Purchase goods or services.</li>\n        <li>Pay Leads Do Work Ltd for the introduction.</li>\n    </ul>\n\n    <p>You may decline any quotation or decide not to proceed.</p>\n\n    <p>Specialists are also free to decline an enquiry, refuse a visit or decide not to provide a quotation.</p>\n\n    <h2>Property Visits</h2>\n\n    <p>Any visit arranged with a specialist is an arrangement between you and that specialist. Leads Do Work Ltd does not attend, supervise or control specialist visits.</p>\n\n    <p>You are responsible for:</p>\n\n    <ul>\n        <li>Checking the identity of anyone attending the property.</li>\n        <li>Ensuring that an adult is present where appropriate.</li>\n        <li>Providing safe and reasonable access, including to any area needed for a ladder, tower or scaffold.</li>\n        <li>Informing the specialist about known hazards.</li>\n        <li>Protecting children, pets, valuables and personal possessions.</li>\n        <li>Deciding whether the specialist may enter or inspect particular areas.</li>\n    </ul>\n\n    <p>You should not allow a person into your property, or onto land needed for access equipment, if you are unable to confirm their identity or do not feel comfortable doing so.</p>\n\n    <h2>Quotations and Estimates</h2>\n\n    <p>Any quotation, estimate, diagnosis, survey, report or recommendation is provided by the specialist and not by Leads Do Work Ltd.</p>\n\n    <p>Before agreeing to work, you should obtain a written quotation that clearly states:</p>\n\n    <ul>\n        <li>The specialist's legal or trading name.</li>\n        <li>The property and areas covered.</li>\n        <li>The specialist's diagnosis of the problem.</li>\n        <li>The proposed repair or replacement method.</li>\n        <li>The access equipment to be used, such as a ladder, tower or scaffold.</li>\n        <li>Whether removal and disposal of old materials is included.</li>\n        <li>Whether making good to render, brickwork or decoration is included.</li>\n        <li>The materials, profile and colour to be used.</li>\n        <li>The total price.</li>\n        <li>Whether VAT is included.</li>\n        <li>Any provisional sums or possible extra costs.</li>\n        <li>The payment schedule and deposit required.</li>\n        <li>The expected start date and duration.</li>\n        <li>What happens if additional damage is discovered once access is in place.</li>\n        <li>Any cancellation rights.</li>\n        <li>Details and limitations of guarantees or warranties.</li>\n    </ul>\n\n    <p>You should obtain more than one quotation where practical and compare them on a like-for-like basis.</p>\n\n    <p>Leads Do Work Ltd is not responsible for errors, omissions, price changes or disagreements relating to a specialist's quotation.</p>\n\n    <h2>Your Contract Is With the Specialist</h2>\n\n    <p>If you appoint a specialist, any contract for surveys, goods, materials, repairs or other services is made directly between you and that specialist.</p>\n\n    <p>Leads Do Work Ltd is not a party to that contract and has no responsibility for negotiating, performing, enforcing, cancelling or refunding it.</p>\n\n    <p>Your contract with the specialist should cover matters such as:</p>\n\n    <ul>\n        <li>The agreed scope of work.</li>\n        <li>The price and payment terms.</li>\n        <li>Start and completion dates.</li>\n        <li>Changes and additional work.</li>\n        <li>Materials, profile and colour specifications.</li>\n        <li>Access to the property and any equipment needed.</li>\n        <li>Insurance and responsibility for damage.</li>\n        <li>Waste removal and cleaning.</li>\n        <li>Guarantees and warranties.</li>\n        <li>Cancellation and termination.</li>\n        <li>Complaints and dispute resolution.</li>\n    </ul>\n\n    <p>You should read the specialist's terms carefully and seek independent advice where necessary before entering into a contract.</p>\n\n    <h2>Deposits and Payments</h2>\n\n    <p>Payments for double glazing work are made directly between you and the specialist. Leads Do Work Ltd does not normally collect, hold or protect money paid to specialists.</p>\n\n    <p>You are responsible for deciding whether a requested deposit or payment schedule is reasonable.</p>\n\n    <p>Before making payment, you should:</p>\n\n    <ul>\n        <li>Confirm the specialist's identity.</li>\n        <li>Check that the bank account details belong to the correct business or person.</li>\n        <li>Obtain a written quotation or contract.</li>\n        <li>Understand what the payment covers.</li>\n        <li>Ask for a written receipt.</li>\n        <li>Be cautious about large advance payments, particularly for materials ordered before work starts.</li>\n        <li>Verify any change of bank details through a trusted contact method.</li>\n    </ul>\n\n    <p>Leads Do Work Ltd is not responsible for deposits, advance payments, payment disputes, specialist insolvency, bank-transfer fraud or money paid for work that is delayed, incomplete or not carried out.</p>\n\n    <h2>Changes and Additional Work</h2>\n\n    <p>If the specialist discovers additional problems after work begins, such as rotten joists hidden beneath the boards, you should request a written explanation and revised price before authorising extra work.</p>\n\n    <p>Leads Do Work Ltd is not responsible for:</p>\n\n    <ul>\n        <li>Changes to the specialist's diagnosis.</li>\n        <li>Unexpected defects or hidden damage.</li>\n        <li>Additional work or increased costs.</li>\n        <li>Delays caused by further investigations.</li>\n        <li>Disagreements about what was included in the original quotation.</li>\n    </ul>\n\n    <h2>Guarantees and Warranties</h2>\n\n    <p>Any guarantee or warranty is offered by the specialist, manufacturer, insurer or separate guarantee provider named in its terms. It is not provided by Leads Do Work Ltd unless we expressly confirm otherwise in writing.</p>\n\n    <p>Before relying on a guarantee, you should check:</p>\n\n    <ul>\n        <li>Who provides and backs the guarantee.</li>\n        <li>How long the guarantee lasts.</li>\n        <li>What work and materials it covers.</li>\n        <li>What exclusions and maintenance requirements apply.</li>\n        <li>Whether it is transferable to a future property owner.</li>\n        <li>Whether it remains valid if the specialist stops trading.</li>\n        <li>How a claim must be made.</li>\n    </ul>\n\n    <p>Leads Do Work Ltd does not guarantee that a specialist will remain trading or that a guarantee provider will accept a future claim.</p>\n\n    <h2>Workmanship, Damage and Delays</h2>\n\n    <p>Leads Do Work Ltd does not carry out, control, supervise or inspect specialists' work. We are not responsible for:</p>\n\n    <ul>\n        <li>Incorrect or incomplete diagnoses.</li>\n        <li>Unsuitable or unnecessary repairs or replacement.</li>\n        <li>Poor, defective or incomplete workmanship.</li>\n        <li>Failure to follow manufacturer instructions or recognised practices.</li>\n        <li>Damage to the property, contents, fixtures or neighbouring property.</li>\n        <li>Rot, movement, algae or other defects continuing or returning.</li>\n        <li>Work that does not comply with planning, building or other legal requirements.</li>\n        <li>Delays, missed appointments or failure to complete work.</li>\n        <li>Noise, dust, disruption or inconvenience.</li>\n        <li>Health and safety failures, including in relation to working at height.</li>\n        <li>Losses caused by a specialist or its employees, workers or subcontractors.</li>\n        <li>Failure to honour a quotation, contract, guarantee or warranty.</li>\n        <li>A specialist becoming insolvent or ceasing to trade.</li>\n    </ul>\n\n    <p>Any concerns about workmanship, damage, delays or the specialist's conduct must be raised directly with the specialist.</p>\n\n    <h2>Disputes With Specialists</h2>\n\n    <p>A dispute concerning a specialist's quotation, diagnosis, conduct, payment, workmanship, delay, damage, guarantee or contract is a dispute between you and the specialist.</p>\n\n    <p>You should normally:</p>\n\n    <ul>\n        <li>Raise the complaint with the specialist in writing.</li>\n        <li>Explain the problem clearly and provide supporting evidence.</li>\n        <li>Give the specialist a reasonable opportunity to inspect and resolve the issue.</li>\n        <li>Keep copies of quotations, contracts, invoices, messages and photographs.</li>\n        <li>Check whether the specialist belongs to a trade association or dispute-resolution scheme.</li>\n        <li>Contact your payment provider, insurer, consumer advice service or legal adviser where appropriate.</li>\n    </ul>\n\n    <p>We may choose to record a complaint, request information from the specialist or review whether the specialist should remain in our network. However, we are not required to mediate, investigate or resolve disputes, and we cannot order a specialist to refund money, return to the property or carry out remedial work.</p>\n\n    <h2>Website Information</h2>\n\n    <p>We try to keep information on double-glazing-quotes.co.uk useful and reasonably current. However, website content is provided for general guidance and may contain errors, omissions or information that is no longer current.</p>\n\n    <p>Prices, repair descriptions, timescales and other examples are illustrative only. They are not quotations or promises that a particular method, price or outcome will apply to your property.</p>\n\n    <p>We may change, remove or update website content without notice.</p>\n\n    <h2>Website Availability</h2>\n\n    <p>We do not guarantee that the website or quote service will always be available, secure or free from errors.</p>\n\n    <p>We may suspend or restrict access for maintenance, security, technical, commercial or legal reasons.</p>\n\n    <p>We are not responsible for delays or failures caused by circumstances beyond our reasonable control, including:</p>\n\n    <ul>\n        <li>Internet or telecommunications failures.</li>\n        <li>Hosting or software problems.</li>\n        <li>Cyberattacks or malicious activity.</li>\n        <li>Power failures.</li>\n        <li>Industrial disputes.</li>\n        <li>Severe weather or natural events.</li>\n        <li>Government action or changes in law.</li>\n    </ul>\n\n    <h2>Acceptable Use</h2>\n\n    <p>You must not use the website:</p>\n\n    <ul>\n        <li>For any unlawful or fraudulent purpose.</li>\n        <li>To impersonate another person or business.</li>\n        <li>To submit false or misleading enquiries.</li>\n        <li>To harass specialists, employees or other users.</li>\n        <li>To send spam or unauthorised advertising.</li>\n        <li>To introduce viruses, malware or harmful code.</li>\n        <li>To attempt unauthorised access to our systems or data.</li>\n        <li>To scrape, copy or extract data using automated tools without permission.</li>\n        <li>To interfere with the website's operation or security.</li>\n        <li>To reproduce or commercially exploit website content without permission.</li>\n    </ul>\n\n    <p>We may block access, remove content or report activity to the relevant authorities where we reasonably believe these terms have been breached.</p>\n\n    <h2>Third-Party Websites</h2>\n\n    <p>The website may contain links to specialists' websites, trade associations, review platforms, social media services and other third-party websites.</p>\n\n    <p>These websites are operated independently. We do not control and are not responsible for their content, availability, security, products, services or privacy practices.</p>\n\n    <p>A link does not mean that we recommend or endorse the third party.</p>\n\n    <h2>Our Liability</h2>\n\n    <p>Nothing in these terms excludes or limits liability where it would be unlawful to do so. This includes liability for death or personal injury caused by our negligence, fraud, fraudulent misrepresentation or any other liability that cannot legally be excluded.</p>\n\n    <p>Subject to the paragraph above, Leads Do Work Ltd is not responsible for losses arising from:</p>\n\n    <ul>\n        <li>The acts or omissions of an independent specialist.</li>\n        <li>A specialist's advice, diagnosis, survey, report or quotation.</li>\n        <li>Work carried out or not carried out by a specialist.</li>\n        <li>Poor, defective, unsuitable, delayed or incomplete workmanship.</li>\n        <li>Property damage caused by a specialist.</li>\n        <li>Payments made to a specialist.</li>\n        <li>A specialist's insolvency or failure to honour a guarantee.</li>\n        <li>Your decision to appoint or not appoint a specialist.</li>\n        <li>Your failure to check qualifications, insurance, references or contract terms.</li>\n        <li>Information provided by a specialist or another third party.</li>\n        <li>Loss of profits, income, business, opportunity, goodwill or anticipated savings.</li>\n        <li>Indirect or consequential losses that were not reasonably foreseeable when you used the service.</li>\n    </ul>\n\n    <p>Our responsibility is limited to operating the introduction service with reasonable care and skill.</p>\n\n    <p>We do not guarantee that using the service will result in:</p>\n\n    <ul>\n        <li>A particular number of specialist contacts.</li>\n        <li>A property inspection.</li>\n        <li>A quotation.</li>\n        <li>A suitable specialist being available.</li>\n        <li>A particular price or saving.</li>\n        <li>A successful repair or replacement.</li>\n    </ul>\n\n    <p>These terms do not affect any rights you have under consumer law that cannot legally be excluded or restricted.</p>\n\n    <h2>Your Responsibility for Losses</h2>\n\n    <p>You may be responsible for reasonable losses or costs suffered by us as a direct result of your fraudulent, unlawful or deliberate misuse of the website, or a serious breach of these terms.</p>\n\n    <h2>Privacy</h2>\n\n    <p>Personal information submitted through the website is handled in accordance with our privacy policy.</p>\n\n    <p>When your enquiry is shared with an independent specialist, that specialist will normally become responsible for its own use of the information it receives. You should read the specialist's privacy policy and contact it directly about information held in its systems.</p>\n\n    <h2>Changes to These Terms</h2>\n\n    <p>We may update these terms to reflect changes to our service, business practices, technology or legal requirements.</p>\n\n    <p>The latest version will be published on this page. The date at the top will show when the terms were last updated.</p>\n\n    <p>The terms in force when you submit an enquiry will normally apply to that use of the quote service. Your continued use of the website after updated terms are published will be treated as acceptance of the updated terms.</p>\n\n    <h2>Transfer of Our Rights</h2>\n\n    <p>We may transfer our rights and obligations under these terms to another organisation, for example as part of a business sale, restructuring or transfer of the website. Where required, we will take reasonable steps to ensure that this does not reduce your rights.</p>\n\n    <p>You may not transfer your rights or obligations under these terms to another person without our written agreement.</p>\n\n    <h2>Severability</h2>\n\n    <p>If any part of these terms is found to be unlawful, invalid or unenforceable, the remaining provisions will continue to apply.</p>\n\n    <h2>No Waiver</h2>\n\n    <p>If we delay or do not enforce a provision of these terms, that does not mean we have waived our right to enforce it later.</p>\n\n    <h2>Third-Party Rights</h2>\n\n    <p>Unless these terms expressly state otherwise, no person other than you and Leads Do Work Ltd has a right to enforce them.</p>\n\n    <h2>Governing Law and Courts</h2>\n\n    <p>These terms and your use of the service are governed by the laws of England and Wales, subject to any mandatory consumer protections that apply where you live.</p>\n\n    <p>If you live in England or Wales, the courts of England and Wales will have jurisdiction over disputes relating to these terms.</p>\n\n    <p>If you live in Scotland, Northern Ireland or another part of the United Kingdom, you may also be entitled to bring proceedings in the courts serving the part of the UK where you live.</p>\n\n    <h2>Contacting Leads Do Work Ltd</h2>\n\n    <p>Questions about these terms or the operation of the quote service should be directed to Leads Do Work Ltd through the contact options available at <a href=\"https://leads.work/\" target=\"_blank\" rel=\"noopener noreferrer\">leads.work</a>.</p>\n\n    <p><strong>Last updated: 14 September 2026</strong></p>\n\n</article>\n",
    "upvc-window-replacement-county": "<article class=\"upvc-window-replacement-county-content\">\n<h2>{uPVC Window Replacement across [COUNTY]|Compare uPVC window replacement quotes across [COUNTY]|Arrange uPVC window replacement across [COUNTY]}</h2>\n<p>{New uPVC windows offer a choice of styles and finishes when existing frames are beyond useful repair.|Replacing ageing windows with uPVC starts with choosing the right openings for each room.|A uPVC window order should cover more than the colour: hardware, glass and ventilation all need specifying.} {This work replaces complete frames and glazed sashes, rather than just renewing a failed glass unit.|The old frames are removed and new made-to-measure uPVC windows are fitted into the surveyed openings.|A full uPVC replacement includes the frame, glass and opening hardware, with agreed finishing around the reveals.}</p>\n<p>{Homeowners across [COUNTY] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work across [COUNTY].|Start with a free description of the work needed at your property in [COUNTY].} Up to four independent uPVC window installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{Give the full postcode so firms can assess the journey to your part of [COUNTY].|Coverage can differ within [COUNTY], so include the property postcode rather than the county name alone.|A county-wide search still needs your postcode to identify a practical survey and fitting area.}</p>\n<h2>{When to ask about uPVC window replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Cracked frame joints, distorted profiles or other damage that cannot be put right by a repair.</li>\n<li>Old timber or metal windows being replaced with a suitable lower-maintenance system.</li>\n<li>A change to flush casements, tilt-and-turn or sash-style windows, where the property permits it.</li>\n<li>Poor closing and weather sealing that remain after repair options have been assessed.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>Compare the complete window rating, profile design, appropriate reinforcement and hardware rather than counting chambers alone. White casements, coloured foils and woodgrain sash designs can differ substantially in price. Tilt-and-turn windows open into the room and need clearance; their ventilation position should not be assumed secure unless the specific product is rated for that use.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Measure openings and inspect existing subframes, cills and surrounding masonry.|Survey the current windows and check what will remain sound once the old frames are removed.}</li>\n<li>{Confirm opening styles, foil colours on each face, handles, glass and ventilation requirements.|Prepare a room-by-room schedule covering frame finish, glazing, hardware and required escape openings.}</li>\n<li>{Protect the home, remove old frames and prepare sound fixings without concealing rotten timber.|Set out safe access and dust protection, take out old windows and assess the exposed reveals.}</li>\n<li>{Fix and pack the frames to the system requirements, glaze them and adjust the sashes.|Install square and level frames with suitable support, then check closing pressure and lock engagement.}</li>\n<li>{Seal the perimeter, finish agreed trims and window boards, remove waste and explain maintenance.|Complete agreed cill and reveal work, demonstrate vents and restrictors and arrange applicable certification.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for uPVC window replacement across [COUNTY]|What affects the price across [COUNTY]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for uPVC window replacement is <strong>£400–£8,000</strong>. {The low end is for one basic casement; a multi-window order uses a much larger budget.|This guide spans one straightforward window and larger uPVC orders, rather than one standard house price.} Foiled sash windows, bays, bigger properties and difficult fitting conditions can exceed the range. Ask for opening-by-opening prices.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [COUNTY].|A property in [COUNTY] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [COUNTY].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>State the number of windows, their current material and whether there are bays. Choose internal and external colours separately if you want a dual finish. Mention blinds, shutters, tiled reveals and any wish to replace the internal window boards.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>For complete replacement windows, confirm the applicable energy, ventilation, safety-glazing and escape provisions with the installer. In England and Wales, an appropriate competent person scheme or building control can provide the compliance route; Scotland and Northern Ireland have separate arrangements. See <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a>. A registered scheme is one route, not a blanket requirement to use a particular brand of scheme.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how old uPVC will be separated for recycling where facilities allow. Follow the supplier's cleaning and lubrication instructions, and keep drainage and ventilators unobstructed. Check guarantee terms for foil finishes as well as frames, glass and hardware.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–3 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [COUNTY]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about uPVC window replacement.|Before arranging uPVC window replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about uPVC window replacement|Before booking uPVC window replacement|Answers for homeowners across [COUNTY]}</h2>\n<h3>How can I request uPVC window replacement quotes across [COUNTY]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent uPVC window installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Can I choose a different finish inside and outside?</h3>\n<p>Many systems offer dual-colour finishes. Confirm the exact foil or colour on each face, including exposed edges, before approving the order because availability and lead times vary.</p>\n<h3>Does every uPVC window contain steel reinforcement?</h3>\n<p>No. Reinforcement depends on the system, window size, colour and design. Ask the supplier to confirm that the proposed window meets its system requirements and stated performance.</p>\n<h3>Does condensation mean I need new uPVC frames?</h3>\n<p>No. Condensation can have several causes. Assess ventilation, indoor moisture and glass condition before deciding whether frames need replacement.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request uPVC window replacement quotes across [COUNTY]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent uPVC window installers covering [COUNTY], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I choose a different finish inside and outside?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Many systems offer dual-colour finishes. Confirm the exact foil or colour on each face, including exposed edges, before approving the order because availability and lead times vary.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does every uPVC window contain steel reinforcement?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Reinforcement depends on the system, window size, colour and design. Ask the supplier to confirm that the proposed window meets its system requirements and stated performance.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does condensation mean I need new uPVC frames?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Condensation can have several causes. Assess ventilation, indoor moisture and glass condition before deciding whether frames need replacement.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request uPVC window replacement quotes across [COUNTY]|Discuss your next step across [COUNTY]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable uPVC window installers covering [COUNTY] may contact you to discuss the work.</p>\n</article>\n",
    "upvc-window-replacement-town": "<article class=\"upvc-window-replacement-town-content\">\n<h2>{uPVC Window Replacement in [TOWN]|Compare uPVC window replacement quotes in [TOWN]|Arrange uPVC window replacement in [TOWN]}</h2>\n<p>{New uPVC windows offer a choice of styles and finishes when existing frames are beyond useful repair.|Replacing ageing windows with uPVC starts with choosing the right openings for each room.|A uPVC window order should cover more than the colour: hardware, glass and ventilation all need specifying.} {This work replaces complete frames and glazed sashes, rather than just renewing a failed glass unit.|The old frames are removed and new made-to-measure uPVC windows are fitted into the surveyed openings.|A full uPVC replacement includes the frame, glass and opening hardware, with agreed finishing around the reveals.}</p>\n<p>{Homeowners in [TOWN] can describe the job once through our free enquiry form.|Use one online enquiry to ask about this work in [TOWN].|Start with a free description of the work needed at your property in [TOWN].} Up to four independent uPVC window installers may respond, depending on the job and availability. There is no obligation to accept a quote.</p>\n<p>{For a property in [TOWN] or elsewhere in [COUNTY], provide the full postcode and any access restrictions.|Your [TOWN] postcode helps firms covering [COUNTY] decide whether they can arrange the necessary visits.|Include the address area in [TOWN] and mention any parking or access issue that could affect the visit.}</p>\n<h2>{When to ask about uPVC window replacement|Problems worth showing a specialist|Reasons to arrange an assessment}</h2>\n<p>{Explain what has changed and which openings are affected.|The symptoms and the condition of the surrounding frame help define the job.|Tell the specialist what you have noticed rather than trying to diagnose it yourself.}</p>\n<ul><li>Cracked frame joints, distorted profiles or other damage that cannot be put right by a repair.</li>\n<li>Old timber or metal windows being replaced with a suitable lower-maintenance system.</li>\n<li>A change to flush casements, tilt-and-turn or sash-style windows, where the property permits it.</li>\n<li>Poor closing and weather sealing that remain after repair options have been assessed.</li></ul>\n<h2>{Check the specification before ordering|Options to discuss at the survey|Getting the proposed work clear}</h2>\n<p>Compare the complete window rating, profile design, appropriate reinforcement and hardware rather than counting chambers alone. White casements, coloured foils and woodgrain sash designs can differ substantially in price. Tilt-and-turn windows open into the room and need clearance; their ventilation position should not be assumed secure unless the specific product is rated for that use.</p>\n<h2>{What the specialist may do|From survey to completion|Work to include in a written quote}</h2>\n<ol><li>{Measure openings and inspect existing subframes, cills and surrounding masonry.|Survey the current windows and check what will remain sound once the old frames are removed.}</li>\n<li>{Confirm opening styles, foil colours on each face, handles, glass and ventilation requirements.|Prepare a room-by-room schedule covering frame finish, glazing, hardware and required escape openings.}</li>\n<li>{Protect the home, remove old frames and prepare sound fixings without concealing rotten timber.|Set out safe access and dust protection, take out old windows and assess the exposed reveals.}</li>\n<li>{Fix and pack the frames to the system requirements, glaze them and adjust the sashes.|Install square and level frames with suitable support, then check closing pressure and lock engagement.}</li>\n<li>{Seal the perimeter, finish agreed trims and window boards, remove waste and explain maintenance.|Complete agreed cill and reveal work, demonstrate vents and restrictors and arrange applicable certification.}</li></ol>\n[IMAGE]\n[YOUTUBE]\n<h2>{Budgeting for uPVC window replacement in [TOWN]|What affects the price in [TOWN]|Compare the scope as well as the cost}</h2>\n<p>The indicative UK range for uPVC window replacement is <strong>£400–£8,000</strong>. {The low end is for one basic casement; a multi-window order uses a much larger budget.|This guide spans one straightforward window and larger uPVC orders, rather than one standard house price.} Foiled sash windows, bays, bigger properties and difficult fitting conditions can exceed the range. Ask for opening-by-opening prices.</p>\n<p>{These figures are a budgeting guide, not a measured local average for [TOWN].|A property in [TOWN] needs its own written quotation; the guide is not a fixed price.|Use the range to plan questions, then ask a specialist to assess the actual job in [TOWN].} Confirm VAT where applicable, travel, safe access, waste removal and making good.</p>\n<h2>{Details to send with your enquiry|Help the firm prepare for a visit|Before someone measures the job}</h2>\n<p>State the number of windows, their current material and whether there are bays. Choose internal and external colours separately if you want a dual finish. Mention blinds, shutters, tiled reveals and any wish to replace the internal window boards.</p>\n<p>{Approximate sizes help with early discussions, but the supplier needs professional survey measurements before manufacturing.|Treat homeowner measurements as a rough guide only; the firm should verify sizes before ordering.|Photos and rough dimensions can start the conversation, while final dimensions belong to the measuring survey.}</p>\n<h2>{Permissions and the right paperwork|Checks before committing to the work|Local consents and installation requirements}</h2>\n<p>For complete replacement windows, confirm the applicable energy, ventilation, safety-glazing and escape provisions with the installer. In England and Wales, an appropriate competent person scheme or building control can provide the compliance route; Scotland and Northern Ireland have separate arrangements. See <a href=\"https://www.gov.uk/building-regulations-approval/use-a-competent-person-scheme\" target=\"_blank\" rel=\"nofollow noopener\">government guidance on competent person schemes</a>. A registered scheme is one route, not a blanket requirement to use a particular brand of scheme.</p>\n<p>{If the property is listed or subject to planning restrictions, check before altering its appearance.|Historic glazing, protected elevations and changes to an opening may need consent before an order is placed.|For a listed home or a restricted elevation, establish the permitted specification before paying a deposit.} Ask <a href=\"[COUNCIL_LINK]\" target=\"_blank\" rel=\"nofollow noopener\">[COUNCIL_NAME]</a> about the relevant local process. Leaseholders should also check any freeholder consent.</p>\n<h2>{Fitting arrangements and aftercare|Agree the finishing details|Questions for the handover}</h2>\n<p>Ask how old uPVC will be separated for recycling where facilities allow. Follow the supplier's cleaning and lubrication instructions, and keep drainage and ventilators unobstructed. Check guarantee terms for foil finishes as well as frames, glass and hardware.</p>\n<p>{Manufacturing lead time is separate from time on site, so ask for both.|Allow for the gap between the measuring visit and fitting; made-to-size products must be ordered first.|Ask when the product is expected and how long fitting should take once it arrives.} The site's guide fitting time is 1–3 days, depending on scope and access.</p>\n<p>Double Glazing Quotes is a matching service and does not carry out the work or employ the specialists. Companies joining the network are asked for relevant insurance details and references. Check current cover, relevant experience and written guarantee terms with the firm you choose.</p>\n<h2>{Enquiries around [TOWN]|Coverage near your property|Other areas to consider}</h2>\n<p>{Coverage is confirmed for each enquiry, rather than guaranteed by an area listing.|An area link helps you explore the service; it does not confirm an installer is available today.|If your property is outside the named area, give its actual postcode so the firm can check coverage.}</p>\n<p>[NEARBY_AREAS]</p>\n<p>{The questions below explain common decisions about uPVC window replacement.|Before arranging uPVC window replacement, these answers may help you prepare.|Use these answers alongside the surveyor's advice about your particular openings.}</p>\n<h2>{Questions about uPVC window replacement|Before booking uPVC window replacement|Answers for homeowners in [TOWN]}</h2>\n<h3>How can I request uPVC window replacement quotes in [TOWN]?</h3>\n<p>Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent uPVC window installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.</p>\n<h3>Can I choose a different finish inside and outside?</h3>\n<p>Many systems offer dual-colour finishes. Confirm the exact foil or colour on each face, including exposed edges, before approving the order because availability and lead times vary.</p>\n<h3>Does every uPVC window contain steel reinforcement?</h3>\n<p>No. Reinforcement depends on the system, window size, colour and design. Ask the supplier to confirm that the proposed window meets its system requirements and stated performance.</p>\n<h3>Does condensation mean I need new uPVC frames?</h3>\n<p>No. Condensation can have several causes. Assess ventilation, indoor moisture and glass condition before deciding whether frames need replacement.</p>\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How can I request uPVC window replacement quotes in [TOWN]?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Use the free enquiry form to give your postcode and describe the affected windows or doors. Double Glazing Quotes can introduce up to four independent uPVC window installers covering [TOWN], depending on service coverage and availability. You do not have to accept a quotation.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can I choose a different finish inside and outside?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Many systems offer dual-colour finishes. Confirm the exact foil or colour on each face, including exposed edges, before approving the order because availability and lead times vary.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does every uPVC window contain steel reinforcement?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Reinforcement depends on the system, window size, colour and design. Ask the supplier to confirm that the proposed window meets its system requirements and stated performance.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Does condensation mean I need new uPVC frames?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"No. Condensation can have several causes. Assess ventilation, indoor moisture and glass condition before deciding whether frames need replacement.\"\n      }\n    }\n  ]\n}\n</script>\n<h2>{Request uPVC window replacement quotes in [TOWN]|Discuss your next step in [TOWN]|Find out what the work could cost}</h2>\n<p>{<a href=\"/free-quotes/\">Describe the affected openings</a> and include your postcode.|<a href=\"/free-quotes/\">Send a free enquiry</a> with the number of windows, units or doors involved.|<a href=\"/free-quotes/\">Ask for local quotations</a> and explain the result you want.} Suitable uPVC window installers covering [TOWN] may contact you to discuss the work.</p>\n</article>\n",
    "upvc-window-replacement": "<article class=\"service-overview\">\n    <h2>What Is uPVC Window Replacement?</h2>\n    <p>uPVC window replacement is the fitting of new windows made from unplasticised polyvinyl chloride, the rigid, weather-resistant plastic used in most UK replacement windows. It may mean swapping ageing timber or aluminium frames for uPVC, or upgrading first-generation uPVC windows whose profiles, hinges and locks have worn out. Modern uPVC systems are far better than the thin, flat profiles of the 1980s, with multiple internal chambers, reinforcement where the system design requires it and a wide choice of finishes.</p>\n    <img src=\"/sites/double-glazing-quotes-co-uk/images/white-upvc-casement-window-installation-result-uk.jpg\" alt=\"White uPVC casement window with handles, top ventilators and a garden view\" width=\"1536\" height=\"1024\" loading=\"lazy\" style=\"max-width:100%;height:auto;display:block;border-radius:8px;margin:16px 0;\">\n    <p>{Low maintenance is the main draw|Most people choose uPVC for its easy upkeep}: there's no sanding or painting, a wipe with soapy water keeps it clean, and hinges only need occasional lubrication.</p>\n\n    <h2>Signs Your uPVC Windows Need Replacing</h2>\n    <ul>\n        <li>White frames that have turned yellow, chalky or grey and won't clean back</li>\n        <li>Cracks at the welded corners of the frame or sash</li>\n        <li>Flat, thin profiles that flex when pushed and let in air along the seal</li>\n        <li>Single-point latches rather than multi-point espagnolette locks</li>\n        <li>Friction hinges that have been adjusted many times and still let the sash drop</li>\n        <li>Persistent draughts after checking repairable hinges, weather seals and locking parts</li>\n        <li>Woodgrain foil peeling away from the edges of the profile</li>\n    </ul>\n    <p>Our checklist of <a href=\"/guides/signs-your-double-glazing-needs-replacing/\">signs your double glazing needs replacing</a> helps you decide whether the frames or only the glass are at fault. If you are buying a property with older uPVC, see <a href=\"/guides/buying-a-house-with-old-double-glazing/\">what to check before you complete</a>.</p>\n\n    <h2>uPVC Window Styles and Finishes Explained</h2>\n    <ul>\n        <li><strong>Casement windows.</strong> The most common style, with side-hung or top-hung openers. Suits most post-war houses and is the most economical option.</li>\n        <li><strong>Tilt-and-turn windows.</strong> Open inwards for cleaning and tilt at the top for ventilation. Security in that position depends on the tested product, so do not assume an open window is secure. Popular for flats, loft rooms and wide openings.</li>\n        <li><strong>uPVC sliding sash.</strong> Replicates the look of traditional timber box sashes for Victorian and Edwardian homes, with far less maintenance. Some conservation areas may still insist on timber.</li>\n        <li><strong>Flush sash.</strong> The sash sits level with the frame for a cleaner, cottage-style look.</li>\n        <li><strong>Finishes.</strong> White remains the cheapest; anthracite grey, black, cream and woodgrain foils such as rosewood or golden oak cost more, and dual-colour options (white inside, colour outside) are widely available.</li>\n    </ul>\n    <p>Profile depth (often 70mm or more on better systems), the number of internal chambers and the energy rating of the complete window are useful ways to compare brands.</p>\n\n    <h2>What to Include When Asking for a Quote</h2>\n    <p>Tell the installer what the current frames are made of, since replacing timber with uPVC often involves more making good around the reveals than swapping old uPVC for new. Give the number of windows, note any bays, and say which style you'd like for each opening, especially if you're considering tilt-and-turn for upstairs rooms or sash-style frames on a period front.</p>\n    <p>Be specific about colour. A woodgrain foil or a grey exterior changes the price and the lead time, and you should say whether you want the colour on one side or both. Mention if you'd like matching uPVC cills, new window boards inside, or cladding to cover old timber sub-frames.</p>\n    <p>The written quote should name the uPVC system and its profile depth, state the energy rating or U-value, list the lock type and handle finish, and confirm trickle vents and any restrictors or fire-escape hinges. It should also say whether the price includes removal and disposal of old frames, internal and external trims, and registration with a competent person scheme.</p>\n\n    <h2>How Much Does uPVC Window Replacement Cost?</h2>\n    <div class=\"cost-table-wrapper\" role=\"region\" aria-label=\"Indicative service costs\" tabindex=\"0\" style=\"max-width:100%;overflow-x:auto;contain:inline-size;\"><table>\n        <caption>Typical UK uPVC window replacement costs</caption>\n        <thead>\n            <tr><th scope=\"col\">Job size</th><th scope=\"col\">Typical cost</th></tr>\n        </thead>\n        <tbody>\n            <tr><td>Single white uPVC casement</td><td>£400 – £900</td></tr>\n            <tr><td>Three to five windows, or one uPVC bay</td><td>£1,500 – £4,500</td></tr>\n            <tr><td>Larger uPVC order; whole-house scope depends on count and specification</td><td>£4,500 – £8,000+</td></tr>\n        </tbody>\n    </table></div>\n    <div class=\"cost-note\">\n        <p>Plain white casements sit at the bottom of the range. Coloured or woodgrain foils, uPVC sliding sashes, tilt-and-turn mechanisms and bays all add to the cost, as do upper-floor access and extensive reveal repairs after removing timber frames.</p>\n    </div>\n    <p>For a full breakdown of what drives the price, read our <a href=\"/guides/upvc-window-replacement-cost/\">cost guide</a>, or get a quick range from the <a href=\"/guides/double-glazing-cost-calculator/\">double glazing cost calculator</a>.</p>\n\n    <h2>The uPVC Window Replacement Process: What to Expect</h2>\n    <ol>\n        <li><strong>Survey and choices.</strong> Openings are measured, and you confirm styles, colours, hardware and glass.</li>\n        <li><strong>Fabrication.</strong> The windows are cut, welded and glazed to size, typically taking a few weeks; foiled colours can take longer.</li>\n        <li><strong>Fitting day.</strong> Old windows are removed one at a time and the openings cleaned back.</li>\n        <li><strong>Fixing.</strong> Each uPVC frame is fixed into the reveals, packed level, and the sealed units are glazed in.</li>\n        <li><strong>Trims and sealing.</strong> Cills, cover trims and exterior silicone are finished, and internal boards or plaster are made good.</li>\n        <li><strong>Demonstration and certificate.</strong> The installer shows you how locks, restrictors and vents work, and registers the job.</li>\n    </ol>\n\n    <h2>Planning Permission and Building Regulations</h2>\n    <p>For most houses, replacement uPVC windows of a similar appearance fall under permitted development. Changing from timber to uPVC can be a problem in conservation areas, on listed buildings, where an Article 4 direction applies, or in flats, so check with the local planning authority before ordering. Leaseholders may need the freeholder's consent too.</p>\n    <p>New uPVC windows must comply with building regulations for energy efficiency, ventilation, safety glazing and means of escape. In England and Wales, an installer registered with an applicable competent person scheme such as <a href=\"https://www.fensa.org.uk/\" target=\"_blank\" rel=\"nofollow noopener\">FENSA</a> can self-certify and issue a certificate; keep it safe, as solicitors ask for it when you sell. The <a href=\"https://www.planningportal.co.uk/permission/common-projects/doors-and-windows/building-regulations\" target=\"_blank\" rel=\"nofollow noopener\">Planning Portal building regulations guide</a> summarises the requirements in England. Building control is an alternative compliance route; Scotland and Northern Ireland have separate arrangements.</p>\n\n    <h2>How to Choose a uPVC Window Installer</h2>\n    <ul>\n        <li>Which uPVC profile system do they fabricate or buy in, and is it a recognised brand?</li>\n        <li>What is the window energy rating, and is it shown on the quote?</li>\n        <li>Are multi-point locks and security-tested hardware included as standard?</li>\n        <li>How long are the frame colour and foil guaranteed not to fade or peel?</li>\n        <li>Will they fit fire-escape hinges on upstairs habitable rooms?</li>\n        <li>Is the guarantee insurance-backed, and are they competent person scheme registered?</li>\n    </ul>\n\n    <h2>Frequently Asked Questions</h2>\n    <h3>How long do uPVC windows last?</h3>\n    <p>Service life varies with the window system, exposure, installation and maintenance. Hinges and locks can need attention before the frames wear out, so inspect repair options rather than replacing windows based on age alone.</p>\n    <h3>Can uPVC windows look like traditional timber?</h3>\n    <p>Woodgrain foils, flush sashes and sliding sash designs can give a traditional appearance. In conservation areas, check whether the planning authority will accept uPVC before you commit.</p>\n    <h3>Are coloured uPVC windows harder to maintain?</h3>\n    <p>Not really. Foiled and coloured frames are cleaned in the same way as white ones, though abrasive cleaners and solvents should be avoided to protect the finish.</p>\n    <h3>Can old uPVC windows be recycled?</h3>\n    <p>Yes. Many installers send old uPVC frames to specialist recyclers, where the plastic is reprocessed into new profiles. Ask how your installer disposes of removed frames.</p>\n    \n\n    <p>Planning new uPVC windows? <a href=\"/free-quotes/\">Send one enquiry</a> and compare up to four local quotes.</p>\n\n<script type=\"application/ld+json\">\n{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"FAQPage\",\n  \"mainEntity\": [\n    {\n      \"@type\": \"Question\",\n      \"name\": \"How long do uPVC windows last?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Service life varies with the window system, exposure, installation and maintenance. Hinges and locks can need attention before the frames wear out, so inspect repair options rather than replacing windows based on age alone.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can uPVC windows look like traditional timber?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Woodgrain foils, flush sashes and sliding sash designs can give a traditional appearance. In conservation areas, check whether the planning authority will accept uPVC before you commit.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Are coloured uPVC windows harder to maintain?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Not really. Foiled and coloured frames are cleaned in the same way as white ones, though abrasive cleaners and solvents should be avoided to protect the finish.\"\n      }\n    },\n    {\n      \"@type\": \"Question\",\n      \"name\": \"Can old uPVC windows be recycled?\",\n      \"acceptedAnswer\": {\n        \"@type\": \"Answer\",\n        \"text\": \"Yes. Many installers send old uPVC frames to specialist recyclers, where the plastic is reprocessed into new profiles. Ask how your installer disposes of removed frames.\"\n      }\n    }\n  ]\n}\n</script>\n</article>\n"
  },
  "svgImageTemplate": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1600\" height=\"900\" viewBox=\"0 0 1600 900\" role=\"img\" aria-labelledby=\"dgq-guide-title dgq-guide-description\" style=\"display:block;max-width:100%;height:auto\">\n  <title id=\"dgq-guide-title\">[SERVICE] in [LOCATION] | Double Glazing Quotes</title>\n  <desc id=\"dgq-guide-description\">Compare free, no-obligation quotes from local double glazing installers for replacement windows and doors, misted or blown sealed units and broken glass across the UK. This illustrated guide distinguishes glass-only replacement in sound frames, complete window replacement and replacement glazed doorsets. Request [SERVICE] in [LOCATION]; the number of quotations depends on specialist availability.</desc>\n  <defs>\n    <linearGradient id=\"dgq-guide-background\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n      <stop stop-color=\"#16212b\"/>\n      <stop offset=\"1\" stop-color=\"#27465b\"/>\n    </linearGradient>\n    <linearGradient id=\"dgq-guide-glass\" x1=\"0\" y1=\"0\" x2=\"1\" y2=\"1\">\n      <stop stop-color=\"#c2e5f3\"/>\n      <stop offset=\"1\" stop-color=\"#edf7fc\"/>\n    </linearGradient>\n    <pattern id=\"dgq-guide-mist\" width=\"26\" height=\"26\" patternUnits=\"userSpaceOnUse\">\n      <rect width=\"26\" height=\"26\" fill=\"#dce7eb\"/>\n      <circle cx=\"6\" cy=\"7\" r=\"2.5\" fill=\"#afc4cd\"/>\n      <circle cx=\"20\" cy=\"18\" r=\"2\" fill=\"#bdcfd6\"/>\n    </pattern>\n  </defs>\n\n  <rect width=\"1600\" height=\"900\" rx=\"24\" fill=\"url(#dgq-guide-background)\"/>\n  <g font-family=\"Arial, Helvetica, sans-serif\">\n    <rect x=\"64\" y=\"48\" width=\"7\" height=\"31\" rx=\"3.5\" fill=\"#e5763a\"/>\n    <text x=\"91\" y=\"72\" fill=\"#ffffff\" font-size=\"25\" font-weight=\"700\" letter-spacing=\"2\">DOUBLE GLAZING QUOTES</text>\n    <text x=\"1536\" y=\"71\" text-anchor=\"end\" fill=\"#c2e5f3\" font-size=\"21\">Free Quotes from Local Double Glazing Installers</text>\n\n    <!-- One wide line per placeholder; no fixed text length that stretches short names. -->\n    <text x=\"64\" y=\"153\" fill=\"#ffffff\" font-size=\"49\" font-weight=\"700\">[SERVICE]</text>\n    <text x=\"64\" y=\"210\" fill=\"#c2e5f3\" font-size=\"34\">In [LOCATION]</text>\n    <text x=\"64\" y=\"255\" fill=\"#ffffff\" font-size=\"23\">Glass, frames or doors: compare the right scope of work.</text>\n\n    <!-- Glass-only replacement: the existing window frame is retained. -->\n    <g transform=\"translate(64 289)\">\n      <rect width=\"472\" height=\"398\" rx=\"18\" fill=\"#f6f9fb\"/>\n      <circle cx=\"40\" cy=\"42\" r=\"19\" fill=\"#27465b\"/>\n      <text x=\"40\" y=\"49\" text-anchor=\"middle\" fill=\"#ffffff\" font-size=\"19\" font-weight=\"700\">1</text>\n      <text x=\"72\" y=\"50\" fill=\"#16212b\" font-size=\"26\" font-weight=\"700\">Glass &amp; sealed units</text>\n      <rect x=\"54\" y=\"86\" width=\"230\" height=\"180\" rx=\"4\" fill=\"#c8d4da\"/>\n      <rect x=\"62\" y=\"94\" width=\"214\" height=\"164\" rx=\"2\" fill=\"#ffffff\" stroke=\"#7d929e\" stroke-width=\"2\"/>\n      <rect x=\"74\" y=\"106\" width=\"87\" height=\"140\" fill=\"url(#dgq-guide-glass)\" stroke=\"#3589b0\" stroke-width=\"2\"/>\n      <rect x=\"177\" y=\"106\" width=\"87\" height=\"140\" fill=\"url(#dgq-guide-mist)\" stroke=\"#7d929e\" stroke-width=\"2\"/>\n      <path d=\"M85 159 130 117M87 188 149 129\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"6\" opacity=\".8\"/>\n      <rect x=\"46\" y=\"266\" width=\"246\" height=\"9\" rx=\"2\" fill=\"#9db0bb\"/>\n      <path d=\"M276 178H327M316 167 327 178 316 189\" fill=\"none\" stroke=\"#bf5a22\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <rect x=\"350\" y=\"109\" width=\"73\" height=\"133\" rx=\"2\" fill=\"#d6eaf3\" stroke=\"#27465b\" stroke-width=\"3\"/>\n      <rect x=\"338\" y=\"122\" width=\"73\" height=\"133\" rx=\"2\" fill=\"url(#dgq-guide-glass)\" fill-opacity=\".85\" stroke=\"#3589b0\" stroke-width=\"3\"/>\n      <path d=\"m350 159 29-26m-29 56 48-45\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"5\"/>\n      <text x=\"375\" y=\"283\" text-anchor=\"middle\" fill=\"#475569\" font-size=\"18\">New unit</text>\n      <text x=\"28\" y=\"326\" fill=\"#16212b\" font-size=\"25\" font-weight=\"700\">Keep sound frames</text>\n      <text x=\"28\" y=\"360\" fill=\"#475569\" font-size=\"21\">Misted, blown or damaged glass</text>\n    </g>\n\n    <!-- Complete replacement: frame, sashes and sealed units. -->\n    <g transform=\"translate(564 289)\">\n      <rect width=\"472\" height=\"398\" rx=\"18\" fill=\"#f6f9fb\"/>\n      <circle cx=\"40\" cy=\"42\" r=\"19\" fill=\"#27465b\"/>\n      <text x=\"40\" y=\"49\" text-anchor=\"middle\" fill=\"#ffffff\" font-size=\"19\" font-weight=\"700\">2</text>\n      <text x=\"72\" y=\"50\" fill=\"#16212b\" font-size=\"26\" font-weight=\"700\">Complete windows</text>\n      <rect x=\"66\" y=\"83\" width=\"340\" height=\"192\" rx=\"3\" fill=\"#e1e8ed\"/>\n      <path d=\"M66 115H406M66 147H406M66 179H406M66 211H406M66 243H406M84 83V115M388 83V115M84 147V179M388 147V179M84 211V243M388 211V243\" fill=\"none\" stroke=\"#c4d0d8\" stroke-width=\"2\"/>\n      <rect x=\"94\" y=\"93\" width=\"284\" height=\"174\" rx=\"3\" fill=\"#ffffff\" stroke=\"#bf5a22\" stroke-width=\"5\"/>\n      <rect x=\"109\" y=\"108\" width=\"115\" height=\"143\" fill=\"url(#dgq-guide-glass)\" stroke=\"#3589b0\" stroke-width=\"3\"/>\n      <rect x=\"247\" y=\"108\" width=\"115\" height=\"143\" fill=\"url(#dgq-guide-glass)\" stroke=\"#3589b0\" stroke-width=\"3\"/>\n      <path d=\"m122 165 42-42m-42 76 82-76m55 42 42-42\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"6\" opacity=\".8\"/>\n      <path d=\"M217 177v20m37-20v20\" stroke=\"#27465b\" stroke-width=\"6\" stroke-linecap=\"round\"/>\n      <path d=\"M101 267H371\" stroke=\"#ffffff\" stroke-width=\"8\"/>\n      <rect x=\"82\" y=\"272\" width=\"308\" height=\"10\" rx=\"2\" fill=\"#9db0bb\"/>\n      <text x=\"28\" y=\"326\" fill=\"#16212b\" font-size=\"25\" font-weight=\"700\">Replace worn frames</text>\n      <text x=\"28\" y=\"360\" fill=\"#475569\" font-size=\"21\">uPVC, aluminium or timber</text>\n    </g>\n\n    <!-- Glazed doorset: two leaves, frame, handle and threshold. -->\n    <g transform=\"translate(1064 289)\">\n      <rect width=\"472\" height=\"398\" rx=\"18\" fill=\"#f6f9fb\"/>\n      <circle cx=\"40\" cy=\"42\" r=\"19\" fill=\"#27465b\"/>\n      <text x=\"40\" y=\"49\" text-anchor=\"middle\" fill=\"#ffffff\" font-size=\"19\" font-weight=\"700\">3</text>\n      <text x=\"72\" y=\"50\" fill=\"#16212b\" font-size=\"26\" font-weight=\"700\">Glazed doors</text>\n      <rect x=\"117\" y=\"83\" width=\"238\" height=\"198\" rx=\"3\" fill=\"#ffffff\" stroke=\"#7d929e\" stroke-width=\"5\"/>\n      <rect x=\"130\" y=\"96\" width=\"98\" height=\"170\" fill=\"#e7f3f9\" stroke=\"#27465b\" stroke-width=\"3\"/>\n      <rect x=\"244\" y=\"96\" width=\"98\" height=\"170\" fill=\"#e7f3f9\" stroke=\"#27465b\" stroke-width=\"3\"/>\n      <rect x=\"140\" y=\"106\" width=\"78\" height=\"111\" fill=\"url(#dgq-guide-glass)\" stroke=\"#3589b0\" stroke-width=\"2\"/>\n      <rect x=\"254\" y=\"106\" width=\"78\" height=\"111\" fill=\"url(#dgq-guide-glass)\" stroke=\"#3589b0\" stroke-width=\"2\"/>\n      <path d=\"m149 151 35-34m79 49 55-49\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"6\"/>\n      <path d=\"M140 229H218V256H140ZM254 229H332V256H254Z\" fill=\"#ffffff\" stroke=\"#becdd5\" stroke-width=\"2\"/>\n      <path d=\"M251 182h17\" stroke=\"#bf5a22\" stroke-width=\"6\" stroke-linecap=\"round\"/>\n      <circle cx=\"252\" cy=\"196\" r=\"3\" fill=\"#27465b\"/>\n      <path d=\"M109 282H363\" stroke=\"#9db0bb\" stroke-width=\"10\" stroke-linecap=\"round\"/>\n      <text x=\"28\" y=\"326\" fill=\"#16212b\" font-size=\"25\" font-weight=\"700\">Replace the complete doorset</text>\n      <text x=\"28\" y=\"360\" fill=\"#475569\" font-size=\"21\">Check locks, thresholds and glass</text>\n    </g>\n\n    <rect x=\"64\" y=\"723\" width=\"1472\" height=\"113\" rx=\"16\" fill=\"#e7f3f9\"/>\n    <rect x=\"64\" y=\"723\" width=\"8\" height=\"113\" rx=\"4\" fill=\"#e5763a\"/>\n    <text x=\"96\" y=\"768\" fill=\"#16212b\" font-size=\"29\" font-weight=\"700\">One enquiry · Up to four quotations</text>\n    <text x=\"96\" y=\"805\" fill=\"#475569\" font-size=\"23\">Independent local specialists. Availability varies.</text>\n    <text x=\"1504\" y=\"778\" text-anchor=\"end\" fill=\"#27465b\" font-size=\"25\" font-weight=\"700\">Free · No obligation</text>\n    <text x=\"64\" y=\"870\" fill=\"#c2e5f3\" font-size=\"19\">Compare the glass specification, fitting, finishing and guarantee before choosing.</text>\n  </g>\n</svg>\n"
};
